
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dZ3U4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $dAuCI = parcelRequire("dAuCI");


var $8gF2o = parcelRequire("8gF2o");


var $8dynS = parcelRequire("8dynS");

const $80a33f9758965064$var$DEFAULT_MAX_CONNECTORS = 3;
// Build the connector list from the static recommendation cascade + canonical
// container map. Connection state comes from outbound-auth ground truth.
const $80a33f9758965064$var$buildConnectors = async (maxConnectors, outboundAuthPayload, recommendedProductKeys, env)=>{
    const mappedProductKeys = recommendedProductKeys// Drop providers without a canonical container mapping in this env —
    // rendering a Connect button for them would either 404 or open the
    // wrong OAuth flow.
    .filter((productKey)=>(0, $8gF2o.hasSmartLinkContainerMapping)(productKey, env)).slice(0, maxConnectors);
    const resolved = await Promise.all(mappedProductKeys.map(async (productKey)=>{
        const staticConfig = await (0, $dAuCI.ThirdPartyConfigs).get(productKey);
        const authUrl = (0, $8gF2o.buildSmartLinkAuthUrl)(productKey, env);
        if (!authUrl) return null;
        return {
            productKey: productKey,
            displayName: String(staticConfig?.displayName || productKey),
            authUrl: authUrl,
            icon: staticConfig?.iconBorderless ?? staticConfig?.icon,
            requiresOauth: staticConfig?.requiresOauth ?? true,
            isAuthenticated: (0, $8gF2o.isAuthenticatedForProduct)(outboundAuthPayload, productKey, env)
        };
    }));
    return resolved.filter((entry)=>entry !== null);
};
const $80a33f9758965064$export$dd138e751e0a384e = ({ cloudId: cloudId, userId: userId, aaId: aaId, maxConnectors: maxConnectors = $80a33f9758965064$var$DEFAULT_MAX_CONNECTORS, smartlinkConnectorRecommendationInputs: smartlinkConnectorRecommendationInputs, productKeys: productKeys })=>{
    const [connectorResources, setConnectorResources] = (0, $cozmU.useState)([]);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [outboundAuthPayload, setOutboundAuthPayload] = (0, $cozmU.useState)(null);
    // Smart Link environment detected from the outbound-auth response. Stored
    // in state so the reconcile useEffect can pass it through to the helpers
    // without having to re-detect on every render.
    const [smartLinkEnv, setSmartLinkEnv] = (0, $cozmU.useState)(undefined);
    const siteWideSmartlinkAppCounts = smartlinkConnectorRecommendationInputs?.siteWideSmartlinkAppCounts;
    const teamTypeSmartlinkAppCounts = smartlinkConnectorRecommendationInputs?.teamTypeSmartlinkAppCounts;
    // Stabilise the override by content so callers can pass an inline
    // `.map(...)` without thrashing downstream deps, while still detecting
    // in-place mutation (same reference, different content).
    const productKeysRef = (0, $cozmU.useRef)(undefined);
    const stableProductKeys = (0, $cozmU.useMemo)(()=>{
        if (!productKeys) {
            productKeysRef.current = undefined;
            return undefined;
        }
        const prev = productKeysRef.current;
        if (prev && prev.length === productKeys.length && prev.every((k, i)=>k === productKeys[i])) return prev;
        productKeysRef.current = productKeys;
        return productKeys;
    }, [
        productKeys
    ]);
    // Caller-provided override wins; otherwise fall back to the 3-tier
    // cascade so cold-start tenants still get a sensible default. Both
    // branches respect `maxConnectors` so downstream consumers can rely on
    // the cap regardless of which path produced the list.
    const recommendedProductKeys = (0, $cozmU.useMemo)(()=>stableProductKeys ? stableProductKeys.slice(0, maxConnectors) : (0, $8dynS.resolveRecommendedProductKeys)({
            siteWideSmartlinkAppCounts: siteWideSmartlinkAppCounts,
            teamTypeSmartlinkAppCounts: teamTypeSmartlinkAppCounts,
            teamTypeKey: smartlinkConnectorRecommendationInputs?.teamTypeKey
        }, maxConnectors), [
        stableProductKeys,
        siteWideSmartlinkAppCounts,
        teamTypeSmartlinkAppCounts,
        smartlinkConnectorRecommendationInputs?.teamTypeKey,
        maxConnectors
    ]);
    (0, $cozmU.useEffect)(()=>{
        setIsLoading(true);
        (async ()=>{
            let fetchedOutboundAuth = null;
            try {
                // `fetchAccountsByAaId` caches by aaId for 30 minutes, so
                // co-mounted callers (e.g. post-office banner + onboarding
                // modal) share a single network request.
                fetchedOutboundAuth = await (0, $8gF2o.fetchOutboundAuthAccounts)(aaId);
                // Detect env from the payload UUIDs (env-scoped). Falls back
                // to hostname inside the helpers when the payload is empty.
                const detectedEnv = (0, $8gF2o.detectEnvFromPayload)(fetchedOutboundAuth) ?? undefined;
                setOutboundAuthPayload(fetchedOutboundAuth);
                setSmartLinkEnv(detectedEnv);
                const connectors_0 = await $80a33f9758965064$var$buildConnectors(maxConnectors, fetchedOutboundAuth, recommendedProductKeys, detectedEnv);
                setConnectorResources(connectors_0);
            } catch  {
                // Defensive — `fetchOutboundAuthAccounts` is non-throwing,
                // but keep the safety net so a render-time error still
                // degrades gracefully instead of stalling the spinner.
                setOutboundAuthPayload(fetchedOutboundAuth);
                const fallbackEnv = (0, $8gF2o.detectEnvFromPayload)(fetchedOutboundAuth) ?? undefined;
                const connectors = await $80a33f9758965064$var$buildConnectors(maxConnectors, fetchedOutboundAuth, recommendedProductKeys, fallbackEnv);
                setConnectorResources(connectors);
            } finally{
                setIsLoading(false);
            }
        })();
    }, [
        aaId,
        maxConnectors,
        recommendedProductKeys
    ]);
    const onConnectorConnected = (0, $cozmU.useCallback)((productKey)=>{
        // Keep our `isAuthenticated` in sync so sibling consumers of
        // this hook (e.g. the post-office banner) reflect the new state.
        setConnectorResources((currentResources)=>currentResources.map((resource)=>resource.productKey === productKey ? {
                    ...resource,
                    isAuthenticated: true
                } : resource));
        // Bypass the 30-min cache so a later re-mount sees the fresh
        // grant instead of the stale pre-OAuth payload.
        if (aaId) (0, $8gF2o.fetchOutboundAuthAccounts)(aaId, {
            forceRefresh: true
        }).then((payload)=>{
            if (payload) setOutboundAuthPayload(payload);
        });
    }, [
        aaId
    ]);
    // Reconcile each row's `isAuthenticated` against outbound-auth ground
    // truth whenever the payload changes. The shallow diff prevents an
    // infinite render loop when nothing actually changed.
    (0, $cozmU.useEffect)(()=>{
        if (!outboundAuthPayload) return;
        setConnectorResources((currentResources_0)=>{
            let didChange = false;
            const next = currentResources_0.map((resource_0)=>{
                if (!(0, $8gF2o.hasSmartLinkContainerMapping)(resource_0.productKey, smartLinkEnv)) return resource_0;
                const groundTruth = (0, $8gF2o.isAuthenticatedForProduct)(outboundAuthPayload, resource_0.productKey, smartLinkEnv);
                if (groundTruth === resource_0.isAuthenticated) return resource_0;
                didChange = true;
                return {
                    ...resource_0,
                    isAuthenticated: groundTruth
                };
            });
            return didChange ? next : currentResources_0;
        });
    }, [
        outboundAuthPayload,
        smartLinkEnv
    ]);
    return {
        connectorResources: connectorResources,
        isLoading: isLoading,
        onConnectorConnected: onConnectorConnected
    };
};
module.exports["use3pConnectorResources"] = $80a33f9758965064$export$dd138e751e0a384e;

});

parcelRegister("g9AoR", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $1ee25c682ddcf6ee$export$6b7fb3a1c8e98eb5 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("j6VNu")));

const $1ee25c682ddcf6ee$export$c0196c29b1811a8e = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("dWH9v")));

const $1ee25c682ddcf6ee$export$ce2899c234bb1e82 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("eVCaj")));

const $1ee25c682ddcf6ee$export$61337663f5eaf5c2 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("5LDaG")));

const $1ee25c682ddcf6ee$export$4bcbb897e0641d3 = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("aGPMF")));



var $8dynS = parcelRequire("8dynS");

const $a7634978e0ddf099$export$a02c2a50480baf7b = [
    'figma',
    'github',
    'slack',
    'google-drive',
    'onedrive'
];
const $a7634978e0ddf099$export$7cd9f89abe222b98 = [
    'design',
    'product_management',
    'marketing',
    'engineering',
    'information_technology',
    'other',
    'operations',
    'finance',
    'legal',
    'human_resources',
    'na',
    'program_management',
    'sales'
];
const $a7634978e0ddf099$var$DEPARTMENTS = new Set($a7634978e0ddf099$export$7cd9f89abe222b98);
const $a7634978e0ddf099$var$PRODUCT_KEY_TO_ANIMATION_APP = {
    figma: 'figma',
    drive: 'google-drive',
    github: 'github',
    onedrive: 'onedrive',
    slack: 'slack'
};
const $a7634978e0ddf099$var$isAnimationProductKey = (productKey)=>Object.prototype.hasOwnProperty.call($a7634978e0ddf099$var$PRODUCT_KEY_TO_ANIMATION_APP, productKey);
const $a7634978e0ddf099$var$filterParsedAppCountsToVisibleProductKeys = (rawAppCounts, visibleProductKeys)=>(0, $8dynS.parseAppCounts)(rawAppCounts).filter((entry)=>{
        const productKey = (0, $8dynS.canonicalizeAppIdToProductKey)(entry.appId);
        return productKey !== undefined && visibleProductKeys.has(productKey);
    });
const $a7634978e0ddf099$var$serializeAppCounts = (parsed)=>parsed.map(({ appId: appId, count: count })=>`${appId}:${count}`).join(',');
const $a7634978e0ddf099$var$resolveVisibleTraitRecommendedProductKeys = ({ siteWideSmartlinkAppCounts: siteWideSmartlinkAppCounts, teamTypeSmartlinkAppCounts: teamTypeSmartlinkAppCounts } = {}, visibleProductKeys)=>{
    const visibleProductKeySet = new Set(visibleProductKeys.map((productKey)=>(0, $8dynS.canonicalizeAppIdToProductKey)(productKey) ?? productKey));
    if (visibleProductKeySet.size === 0) return [];
    // Filtering first lets the existing resolver recompute the team-type
    // threshold on only visible apps while preserving site-wide backfill.
    return (0, $8dynS.resolveRecommendedProductKeys)({
        siteWideSmartlinkAppCounts: $a7634978e0ddf099$var$serializeAppCounts($a7634978e0ddf099$var$filterParsedAppCountsToVisibleProductKeys(siteWideSmartlinkAppCounts, visibleProductKeySet)),
        teamTypeSmartlinkAppCounts: $a7634978e0ddf099$var$serializeAppCounts($a7634978e0ddf099$var$filterParsedAppCountsToVisibleProductKeys(teamTypeSmartlinkAppCounts, visibleProductKeySet))
    }, visibleProductKeySet.size, {
        traitOnly: true
    });
};
const $a7634978e0ddf099$export$5ea506cfb5216de9 = ({ connectorProductKeys: connectorProductKeys, smartlinkConnectorRecommendationInputs: smartlinkConnectorRecommendationInputs, teamTypeKey: teamTypeKey })=>{
    let candidateProductKeys;
    if (connectorProductKeys !== undefined) // Visible connector product keys constrain the animation candidate set,
    // but TAP traits still decide the ranking within that visible set.
    // Tier 3 HARDCODED_DEFAULTS are intentionally excluded so weak or
    // missing visible-app trait data can fall through to department mapping.
    candidateProductKeys = $a7634978e0ddf099$var$resolveVisibleTraitRecommendedProductKeys(smartlinkConnectorRecommendationInputs, connectorProductKeys);
    else // When there is no explicit connector app list, animation picks the
    // highest-priority recommended app ONLY when that app comes from real
    // TAP-trait signal (Tier 1 or Tier 2). We use the `traitOnly` option to
    // opt out of Tier 3 HARDCODED_DEFAULTS, because the department-based
    // animation fallback below already encodes the same team-type-curated
    // mapping in a more visually-coherent way (e.g. engineering animates
    // GitHub directly via the department switch even though Tier 3 would
    // also pick GitHub as the engineering default). Letting Tier 3 fire
    // here would always return non-empty results and rob the department
    // branch of ever running for cold-start tenants.
    candidateProductKeys = (0, $8dynS.resolveRecommendedProductKeys)(smartlinkConnectorRecommendationInputs, undefined, {
        traitOnly: true
    });
    const firstSupportedAnimationProductKey = candidateProductKeys.find($a7634978e0ddf099$var$isAnimationProductKey);
    const topApp = firstSupportedAnimationProductKey ? $a7634978e0ddf099$var$PRODUCT_KEY_TO_ANIMATION_APP[firstSupportedAnimationProductKey] : undefined;
    return {
        topApps: topApp ? [
            topApp
        ] : [],
        department: teamTypeKey && $a7634978e0ddf099$var$DEPARTMENTS.has(teamTypeKey) ? teamTypeKey : undefined
    };
};
function $a7634978e0ddf099$var$getAnimationSvgForApp(app) {
    switch(app){
        case 'figma':
            return 0, $1ee25c682ddcf6ee$export$6b7fb3a1c8e98eb5;
        case 'github':
            return 0, $1ee25c682ddcf6ee$export$ce2899c234bb1e82;
        case 'slack':
            return 0, $1ee25c682ddcf6ee$export$4bcbb897e0641d3;
        case 'google-drive':
            return 0, $1ee25c682ddcf6ee$export$c0196c29b1811a8e;
        case 'onedrive':
            return 0, $1ee25c682ddcf6ee$export$61337663f5eaf5c2;
    }
}
function $a7634978e0ddf099$export$fdb84c48733d7de8({ topApps: topApps, department: department }) {
    // Step 1: return the SVG for the highest-priority app if any are provided.
    // topApps is pre-filtered to AnimationApp values, so every element has a
    // dedicated SVG — we just take the first one.
    if (topApps && topApps.length > 0) return $a7634978e0ddf099$var$getAnimationSvgForApp(topApps[0]);
    // Step 2: department-based fallback
    if (department) switch(department){
        case 'design':
        case 'product_management':
        case 'marketing':
            return 0, $1ee25c682ddcf6ee$export$6b7fb3a1c8e98eb5;
        case 'engineering':
        case 'information_technology':
            return 0, $1ee25c682ddcf6ee$export$ce2899c234bb1e82;
        case 'other':
        case 'operations':
            return 0, $1ee25c682ddcf6ee$export$4bcbb897e0641d3;
        case 'finance':
        case 'legal':
        case 'human_resources':
        case 'na':
        case 'program_management':
        case 'sales':
            return 0, $1ee25c682ddcf6ee$export$c0196c29b1811a8e;
    }
    // Final fallback: Google Drive (matches the original hardcoded SvgTeamUpdate)
    return 0, $1ee25c682ddcf6ee$export$c0196c29b1811a8e;
}
module.exports["ANIMATION_APP_KEYS"] = $a7634978e0ddf099$export$a02c2a50480baf7b;
module.exports["DEPARTMENT_KEYS"] = $a7634978e0ddf099$export$7cd9f89abe222b98;
module.exports["resolveAnimationInputs"] = $a7634978e0ddf099$export$5ea506cfb5216de9;
module.exports["getAnimationSvg"] = $a7634978e0ddf099$export$fdb84c48733d7de8;

});

parcelRegister("j6VNu", function(module, exports) {

let $de9b6934a65f88e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $de9b6934a65f88e6$var$load("8ayby").then(()=>parcelRequire('5pyqx'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("dWH9v", function(module, exports) {

let $a2722a4eed9275ac$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a2722a4eed9275ac$var$load("ktUc9").then(()=>parcelRequire('6iMRo'));

});

parcelRegister("eVCaj", function(module, exports) {

let $ade3fe5fdd7655a1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ade3fe5fdd7655a1$var$load("1NjLt").then(()=>parcelRequire('cZy6a'));

});

parcelRegister("5LDaG", function(module, exports) {

let $432fba2af018942a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $432fba2af018942a$var$load("lqBkZ").then(()=>parcelRequire('7GVxG'));

});

parcelRegister("aGPMF", function(module, exports) {

let $7c85fedc8c197104$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7c85fedc8c197104$var$load("gIF5r").then(()=>parcelRequire('9VnL6'));

});

parcelRegister("f7AuD", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $I7hWB = parcelRequire("I7hWB");


var $bltJZ = parcelRequire("bltJZ");


var $iMnC5 = parcelRequire("iMnC5");

var $3pCca = parcelRequire("3pCca");

var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $2aija = parcelRequire("2aija");

const $653fd1987dfc1e36$var$styles = {
    fullWidth: "_1bsb1osq",
    dynamicComponentEdgeToEdge: "_1reo15vq _18m915vq _1bsb1osq _4t3i1osq _kqswh2mm",
    imageContainer: "_1e0cglyw _nv3915vq _1bv015vq _181n1ule",
    form: "_ca0qoahv _u5f3oahv _n3tdoahv _19bvoahv",
    grid: "_yv0ehkll _4t3i1osq _1j8bwxkt",
    leftSection: "_1tkeidpf _18m91wug",
    headingContainer: "_n3tdu2gc"
};
const $653fd1987dfc1e36$var$stackSpacing = {
    100: 'space.100',
    150: 'space.150',
    200: 'space.200',
    250: 'space.250',
    300: 'space.300',
    400: 'space.400'
};
const $653fd1987dfc1e36$export$c3b4cf34b667dcac = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(32);
    const { applyUpdatedLayout: t1, title: title, subtitle: subtitle, subtitleSize: subtitleSize, screen: screen, imageComponent: Image, dynamicComponent: dynamicComponent, isDynamicComponentEdgeToEdge: t2, imageAlt: imageAlt, footer: footer, children: children, hideLogo: t3, logoVariant: t4, profileRow: profileRow, spacingOverall: t5, spacingLayout: t6, headerLayoutSpacing: t7 } = t0;
    const applyUpdatedLayout = t1 === undefined ? false : t1;
    const isDynamicComponentEdgeToEdge = t2 === undefined ? false : t2;
    const hideLogo = t3 === undefined ? false : t3;
    const logoVariant = t4 === undefined ? "full" : t4;
    const spacingOverall = t5 === undefined ? 400 : t5;
    const spacingLayout = t6 === undefined ? 400 : t6;
    const headerLayoutSpacing = t7 === undefined ? 200 : t7;
    let t8;
    if ($[0] !== children || $[1] !== headerLayoutSpacing || $[2] !== hideLogo || $[3] !== logoVariant || $[4] !== profileRow || $[5] !== screen || $[6] !== spacingLayout || $[7] !== subtitle || $[8] !== subtitleSize || $[9] !== title) {
        t8 = {
            title: title,
            subtitle: subtitle,
            subtitleSize: subtitleSize,
            screen: screen,
            children: children,
            hideLogo: hideLogo,
            logoVariant: logoVariant,
            profileRow: profileRow,
            spacingLayout: spacingLayout,
            headerLayoutSpacing: headerLayoutSpacing
        };
        $[0] = children;
        $[1] = headerLayoutSpacing;
        $[2] = hideLogo;
        $[3] = logoVariant;
        $[4] = profileRow;
        $[5] = screen;
        $[6] = spacingLayout;
        $[7] = subtitle;
        $[8] = subtitleSize;
        $[9] = title;
        $[10] = t8;
    } else t8 = $[10];
    const layoutProps = t8;
    const t9 = $653fd1987dfc1e36$var$stackSpacing[spacingOverall];
    let t10;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $w6R6I.cx)($653fd1987dfc1e36$var$styles.form, $653fd1987dfc1e36$var$styles.leftSection);
        $[11] = t10;
    } else t10 = $[11];
    let t11;
    if ($[12] !== applyUpdatedLayout || $[13] !== layoutProps) {
        t11 = applyUpdatedLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($653fd1987dfc1e36$var$UpdatedLayout, layoutProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($653fd1987dfc1e36$var$OldLayout, layoutProps);
        $[12] = applyUpdatedLayout;
        $[13] = layoutProps;
        $[14] = t11;
    } else t11 = $[14];
    let t12;
    if ($[15] !== footer || $[16] !== t11 || $[17] !== t9) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            grow: "fill",
            spread: "space-between",
            space: t9,
            xcss: t10
        }, t11, footer);
        $[15] = footer;
        $[16] = t11;
        $[17] = t9;
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== Image || $[20] !== imageAlt) {
        t13 = Image && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Image, {
            viewBox: "0 0 565 665",
            title: imageAlt,
            "aria-label": imageAlt,
            preserveAspectRatio: "xMinYMid slice",
            width: "100%",
            height: "100%",
            ...!imageAlt && {
                "aria-hidden": true,
                role: "presentation"
            }
        });
        $[19] = Image;
        $[20] = imageAlt;
        $[21] = t13;
    } else t13 = $[21];
    let t14;
    if ($[22] !== Image || $[23] !== dynamicComponent || $[24] !== isDynamicComponentEdgeToEdge) {
        t14 = !!dynamicComponent && !Image && (isDynamicComponentEdgeToEdge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            testId: "split-screen-dynamic-component-wrapper",
            xcss: $653fd1987dfc1e36$var$styles.dynamicComponentEdgeToEdge
        }, dynamicComponent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            "aria-hidden": "true",
            testId: "split-screen-dynamic-component-wrapper",
            xcss: $653fd1987dfc1e36$var$styles.dynamicComponentEdgeToEdge
        }, dynamicComponent));
        $[22] = Image;
        $[23] = dynamicComponent;
        $[24] = isDynamicComponentEdgeToEdge;
        $[25] = t14;
    } else t14 = $[25];
    let t15;
    if ($[26] !== t13 || $[27] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2aija.Hide), {
            below: "sm",
            xcss: $653fd1987dfc1e36$var$styles.imageContainer
        }, t13, t14);
        $[26] = t13;
        $[27] = t14;
        $[28] = t15;
    } else t15 = $[28];
    let t16;
    if ($[29] !== t12 || $[30] !== t15) {
        t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
            xcss: $653fd1987dfc1e36$var$styles.grid
        }, t12, t15);
        $[29] = t12;
        $[30] = t15;
        $[31] = t16;
    } else t16 = $[31];
    return t16;
} : ({ applyUpdatedLayout: applyUpdatedLayout = false, title: title, subtitle: subtitle, subtitleSize: subtitleSize, screen: screen, imageComponent: Image, dynamicComponent: dynamicComponent, isDynamicComponentEdgeToEdge: isDynamicComponentEdgeToEdge = false, imageAlt: imageAlt, footer: footer, children: children, hideLogo: hideLogo = false, logoVariant: logoVariant = 'full', profileRow: profileRow, spacingOverall: spacingOverall = 400, spacingLayout: spacingLayout = 400, headerLayoutSpacing: headerLayoutSpacing = 200 })=>{
    const layoutProps = {
        title: title,
        subtitle: subtitle,
        subtitleSize: subtitleSize,
        screen: screen,
        children: children,
        hideLogo: hideLogo,
        logoVariant: logoVariant,
        profileRow: profileRow,
        spacingLayout: spacingLayout,
        headerLayoutSpacing: headerLayoutSpacing
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3pCca.Grid), {
        xcss: $653fd1987dfc1e36$var$styles.grid
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        grow: "fill",
        spread: "space-between",
        space: $653fd1987dfc1e36$var$stackSpacing[spacingOverall],
        xcss: (0, $w6R6I.cx)($653fd1987dfc1e36$var$styles.form, $653fd1987dfc1e36$var$styles.leftSection)
    }, applyUpdatedLayout ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($653fd1987dfc1e36$var$UpdatedLayout, layoutProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($653fd1987dfc1e36$var$OldLayout, layoutProps), footer), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2aija.Hide), {
        below: "sm",
        xcss: $653fd1987dfc1e36$var$styles.imageContainer
    }, Image && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Image, {
        viewBox: "0 0 565 665",
        title: imageAlt,
        "aria-label": imageAlt,
        preserveAspectRatio: "xMinYMid slice",
        width: "100%",
        height: "100%",
        ...!imageAlt && {
            'aria-hidden': true,
            role: 'presentation'
        }
    }), !!dynamicComponent && !Image && (isDynamicComponentEdgeToEdge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "split-screen-dynamic-component-wrapper",
        xcss: $653fd1987dfc1e36$var$styles.dynamicComponentEdgeToEdge
    }, dynamicComponent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": "true",
        testId: "split-screen-dynamic-component-wrapper",
        xcss: $653fd1987dfc1e36$var$styles.dynamicComponentEdgeToEdge
    }, dynamicComponent))));
};
const $653fd1987dfc1e36$var$OldLayout = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { title: title, subtitle: subtitle, subtitleSize: t1, screen: screen, children: children, hideLogo: hideLogo, logoVariant: logoVariant, profileRow: profileRow, spacingLayout: spacingLayout, headerLayoutSpacing: headerLayoutSpacing } = t0;
    const subtitleSize = t1 === undefined ? "medium" : t1;
    const t2 = $653fd1987dfc1e36$var$stackSpacing[spacingLayout];
    const t3 = !!profileRow && profileRow;
    let t4;
    if ($[0] !== hideLogo || $[1] !== logoVariant) {
        t4 = !hideLogo && (logoVariant === "icon" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.ConfluenceIcon), {
            appearance: "brand",
            shouldUseNewLogoDesign: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.ConfluenceLogo), {
            appearance: "brand"
        }));
        $[0] = hideLogo;
        $[1] = logoVariant;
        $[2] = t4;
    } else t4 = $[2];
    const t5 = hideLogo ? $653fd1987dfc1e36$var$stackSpacing[headerLayoutSpacing] : "space.100";
    const t6 = `${screen}-heading`;
    const t7 = `${screen}-heading`;
    let t8;
    if ($[3] !== t6 || $[4] !== t7 || $[5] !== title) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xlarge",
            testId: t6,
            id: t7
        }, title);
        $[3] = t6;
        $[4] = t7;
        $[5] = title;
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== subtitle || $[8] !== subtitleSize) {
        t9 = subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: subtitleSize,
            color: "color.text.subtle"
        }, subtitle);
        $[7] = subtitle;
        $[8] = subtitleSize;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== t5 || $[11] !== t8 || $[12] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignInline: "start",
            space: t5
        }, t8, t9);
        $[10] = t5;
        $[11] = t8;
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== children) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $653fd1987dfc1e36$var$styles.fullWidth
        }, children);
        $[14] = children;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t10 || $[17] !== t11 || $[18] !== t2 || $[19] !== t3 || $[20] !== t4) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignInline: "start",
            space: t2
        }, t3, t4, t10, t11));
        $[16] = t10;
        $[17] = t11;
        $[18] = t2;
        $[19] = t3;
        $[20] = t4;
        $[21] = t12;
    } else t12 = $[21];
    return t12;
} : ({ title: title, subtitle: subtitle, subtitleSize: subtitleSize = 'medium', screen: screen, children: children, hideLogo: hideLogo, logoVariant: logoVariant, profileRow: profileRow, spacingLayout: spacingLayout, headerLayoutSpacing: headerLayoutSpacing })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "start",
        space: $653fd1987dfc1e36$var$stackSpacing[spacingLayout]
    }, !!profileRow && profileRow, !hideLogo && (logoVariant === 'icon' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.ConfluenceIcon), {
        appearance: "brand",
        shouldUseNewLogoDesign: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.ConfluenceLogo), {
        appearance: "brand"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "start",
        space: hideLogo ? $653fd1987dfc1e36$var$stackSpacing[headerLayoutSpacing] : 'space.100'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xlarge",
        testId: `${screen}-heading`,
        id: `${screen}-heading`
    }, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: subtitleSize,
        color: "color.text.subtle"
    }, subtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $653fd1987dfc1e36$var$styles.fullWidth
    }, children)));
const $653fd1987dfc1e36$var$UpdatedLayout = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { title: title, subtitle: subtitle, subtitleSize: t1, screen: screen, children: children, hideLogo: hideLogo, logoVariant: logoVariant, profileRow: profileRow, spacingLayout: spacingLayout, headerLayoutSpacing: headerLayoutSpacing } = t0;
    const subtitleSize = t1 === undefined ? "medium" : t1;
    const t2 = $653fd1987dfc1e36$var$stackSpacing[spacingLayout];
    const t3 = !!profileRow && profileRow;
    let t4;
    if ($[0] !== hideLogo || $[1] !== logoVariant) {
        t4 = !hideLogo && (logoVariant === "icon" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.ConfluenceIcon), {
            appearance: "brand",
            shouldUseNewLogoDesign: true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.ConfluenceLogo), {
            appearance: "brand",
            shouldUseNewLogoDesign: true
        }));
        $[0] = hideLogo;
        $[1] = logoVariant;
        $[2] = t4;
    } else t4 = $[2];
    const t5 = hideLogo ? $653fd1987dfc1e36$var$stackSpacing[headerLayoutSpacing] : "space.100";
    const t6 = `${screen}-heading`;
    const t7 = `${screen}-heading`;
    let t8;
    if ($[3] !== t6 || $[4] !== t7 || $[5] !== title) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
            size: "xlarge",
            testId: t6,
            id: t7
        }, title);
        $[3] = t6;
        $[4] = t7;
        $[5] = title;
        $[6] = t8;
    } else t8 = $[6];
    let t9;
    if ($[7] !== subtitle || $[8] !== subtitleSize) {
        t9 = subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            size: subtitleSize,
            color: "color.text.subtle"
        }, subtitle);
        $[7] = subtitle;
        $[8] = subtitleSize;
        $[9] = t9;
    } else t9 = $[9];
    let t10;
    if ($[10] !== t5 || $[11] !== t8 || $[12] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: t5,
            xcss: $653fd1987dfc1e36$var$styles.headingContainer
        }, t8, t9);
        $[10] = t5;
        $[11] = t8;
        $[12] = t9;
        $[13] = t10;
    } else t10 = $[13];
    let t11;
    if ($[14] !== children) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $653fd1987dfc1e36$var$styles.fullWidth
        }, children);
        $[14] = children;
        $[15] = t11;
    } else t11 = $[15];
    let t12;
    if ($[16] !== t10 || $[17] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignInline: "start",
            space: "space.100"
        }, t10, t11);
        $[16] = t10;
        $[17] = t11;
        $[18] = t12;
    } else t12 = $[18];
    let t13;
    if ($[19] !== t12 || $[20] !== t2 || $[21] !== t3 || $[22] !== t4) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            alignInline: "start",
            space: t2
        }, t3, t4, t12));
        $[19] = t12;
        $[20] = t2;
        $[21] = t3;
        $[22] = t4;
        $[23] = t13;
    } else t13 = $[23];
    return t13;
} : ({ title: title, subtitle: subtitle, subtitleSize: subtitleSize = 'medium', screen: screen, children: children, hideLogo: hideLogo, logoVariant: logoVariant, profileRow: profileRow, spacingLayout: spacingLayout, headerLayoutSpacing: headerLayoutSpacing })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "start",
        space: $653fd1987dfc1e36$var$stackSpacing[spacingLayout]
    }, !!profileRow && profileRow, !hideLogo && (logoVariant === 'icon' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.ConfluenceIcon), {
        appearance: "brand",
        shouldUseNewLogoDesign: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.ConfluenceLogo), {
        appearance: "brand",
        shouldUseNewLogoDesign: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        alignInline: "start",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: hideLogo ? $653fd1987dfc1e36$var$stackSpacing[headerLayoutSpacing] : 'space.100',
        xcss: $653fd1987dfc1e36$var$styles.headingContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xlarge",
        testId: `${screen}-heading`,
        id: `${screen}-heading`
    }, title), subtitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: subtitleSize,
        color: "color.text.subtle"
    }, subtitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $653fd1987dfc1e36$var$styles.fullWidth
    }, children))));
module.exports["SplitScreen"] = $653fd1987dfc1e36$export$c3b4cf34b667dcac;

});

parcelRegister("9VQ5f", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $w6R6I = parcelRequire("w6R6I");


var $iMnC5 = parcelRequire("iMnC5");


var $3vzuQ = parcelRequire("3vzuQ");

const $9651cbfa1f69508f$var$styles = {
    container: "_2rko1mok _1reo15vq _18m915vq _189ee4h9 _1dqonqa1 _1h6d1l7x",
    row: "_ca0qutpp _n3tdutpp _19bvpxbi _u5f3pxbi _1doce4h9 _1il9nqa1 _1o3i1l7x",
    rowLast: "_1il9glyw"
};
const $9651cbfa1f69508f$export$136740b583f35b01 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { connectorResources: connectorResources, isPrimaryButton: isPrimaryButton, onConnectorAuthSuccess: onConnectorAuthSuccess, onConnectorConnected: onConnectorConnected, screenName: screenName, showIconTile: t1, touchpoint: touchpoint } = t0;
    const showIconTile = t1 === undefined ? false : t1;
    let T0;
    let t2;
    let t3;
    if ($[0] !== connectorResources || $[1] !== isPrimaryButton || $[2] !== onConnectorAuthSuccess || $[3] !== onConnectorConnected || $[4] !== screenName || $[5] !== showIconTile || $[6] !== touchpoint) {
        let t4;
        if ($[10] !== isPrimaryButton || $[11] !== onConnectorAuthSuccess || $[12] !== onConnectorConnected || $[13] !== screenName || $[14] !== showIconTile || $[15] !== touchpoint) {
            t4 = (resource)=>({
                    key: resource.productKey,
                    props: {
                        connectorInfo: resource,
                        isPrimaryButton: isPrimaryButton,
                        screenName: screenName,
                        showIconTile: showIconTile,
                        onConnected: ()=>{
                            onConnectorAuthSuccess?.(resource.productKey);
                            onConnectorConnected?.(resource.productKey);
                        },
                        touchpoint: touchpoint
                    }
                });
            $[10] = isPrimaryButton;
            $[11] = onConnectorAuthSuccess;
            $[12] = onConnectorConnected;
            $[13] = screenName;
            $[14] = showIconTile;
            $[15] = touchpoint;
            $[16] = t4;
        } else t4 = $[16];
        const connectorItems = connectorResources.map(t4);
        T0 = (0, $iMnC5.Box);
        if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = (0, $w6R6I.cx)($9651cbfa1f69508f$var$styles.container);
            $[17] = t2;
        } else t2 = $[17];
        t3 = connectorItems.map((item, index)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                key: item.key,
                xcss: (0, $w6R6I.cx)($9651cbfa1f69508f$var$styles.row, index === connectorItems.length - 1 && $9651cbfa1f69508f$var$styles.rowLast)
            }, /*#__PURE__*/ $cozmU.createElement((0, $3vzuQ.ThirdPartyConnector), item.props)));
        $[0] = connectorResources;
        $[1] = isPrimaryButton;
        $[2] = onConnectorAuthSuccess;
        $[3] = onConnectorConnected;
        $[4] = screenName;
        $[5] = showIconTile;
        $[6] = touchpoint;
        $[7] = T0;
        $[8] = t2;
        $[9] = t3;
    } else {
        T0 = $[7];
        t2 = $[8];
        t3 = $[9];
    }
    let t4;
    if ($[18] !== T0 || $[19] !== t2 || $[20] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement(T0, {
            xcss: t2
        }, t3);
        $[18] = T0;
        $[19] = t2;
        $[20] = t3;
        $[21] = t4;
    } else t4 = $[21];
    return t4;
} : ({ connectorResources: connectorResources, isPrimaryButton: isPrimaryButton, onConnectorAuthSuccess: onConnectorAuthSuccess, onConnectorConnected: onConnectorConnected, screenName: screenName, showIconTile: showIconTile = false, touchpoint: touchpoint })=>{
    const connectorItems = connectorResources.map((resource)=>({
            key: resource.productKey,
            props: {
                connectorInfo: resource,
                isPrimaryButton: isPrimaryButton,
                screenName: screenName,
                showIconTile: showIconTile,
                onConnected: ()=>{
                    onConnectorAuthSuccess?.(resource.productKey);
                    onConnectorConnected?.(resource.productKey);
                },
                touchpoint: touchpoint
            }
        }));
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($9651cbfa1f69508f$var$styles.container)
    }, connectorItems.map((item, index)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            key: item.key,
            xcss: (0, $w6R6I.cx)($9651cbfa1f69508f$var$styles.row, index === connectorItems.length - 1 && $9651cbfa1f69508f$var$styles.rowLast)
        }, /*#__PURE__*/ $cozmU.createElement((0, $3vzuQ.ThirdPartyConnector), item.props))));
};
module.exports["ThirdPartyConnectorList"] = $9651cbfa1f69508f$export$136740b583f35b01;

});

parcelRegister("eB1TF", function(module, exports) {

var $kBr4q = parcelRequire("kBr4q");

var $8s9DV = parcelRequire("8s9DV");

const $bf0e479659c73d50$var$initialState = {
    isOpen: false,
    openFrom: ''
};
const $bf0e479659c73d50$var$actions = {
    setIsOpen: (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        },
    setOpenFrom: (openFrom)=>({ setState: setState })=>{
            setState({
                openFrom: openFrom
            });
        }
};
const $bf0e479659c73d50$var$Store = (0, $8s9DV.createStore)({
    initialState: $bf0e479659c73d50$var$initialState,
    actions: $bf0e479659c73d50$var$actions,
    name: 'UniversalCreateStore'
});
const $bf0e479659c73d50$export$c7381b2490bb4d36 = (0, $kBr4q.createStateHook)($bf0e479659c73d50$var$Store);
const $bf0e479659c73d50$export$6c5b9a107b000099 = (0, $kBr4q.createActionsHook)($bf0e479659c73d50$var$Store);
module.exports["useUniversalCreateState"] = $bf0e479659c73d50$export$c7381b2490bb4d36;
module.exports["useUniversalCreateActions"] = $bf0e479659c73d50$export$6c5b9a107b000099;

});

parcelRegister("b4fs3", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ivb8S = parcelRequire("ivb8S");


var $dBcar = parcelRequire("dBcar");

const $bf9af6dce6f5d7b7$export$bfcbcdb55d62e500 = 'nav4CollapseReminderSpotlight';
const $bf9af6dce6f5d7b7$export$9ee8fabfb18920e1 = (0, $kSwu1.defineMessages)({
    heading: {
        id: "nav4-onboarding.nav4-collapse-reminder-spotlight.heading",
        defaultMessage: "Want to hide the sidebar?"
    },
    body: {
        id: "nav4-onboarding.nav4-collapse-reminder-spotlight.body",
        defaultMessage: "Select the collapse icon in the top left of your screen. You can expand it again at any time."
    },
    dismissButton: {
        id: "nav4-onboarding.nav4-collapse-reminder-spotlight.dismiss",
        defaultMessage: "OK"
    }
});
const $bf9af6dce6f5d7b7$export$cbddd2e8b88758a2 = (setIsNav4CollapseReminderSpotlightActive)=>{
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const dismissSpotlight = ()=>{
        // Fire analytics event
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'done',
                source: $bf9af6dce6f5d7b7$export$bfcbcdb55d62e500
            }
        }).fire();
        // Hide the spotlight
        setIsNav4CollapseReminderSpotlightActive(false);
        // Mark as dismissed in onboarding state
        setOnboardingState({
            key: (0, $dBcar.IS_NAV_4_COLLAPSE_REMINDER_SPOTLIGHT_DISMISSED),
            value: new Date().toISOString()
        });
    };
    return {
        dismissSpotlight: dismissSpotlight
    };
};
module.exports["NAV_4_COLLAPSE_REMINDER_SOURCE"] = $bf9af6dce6f5d7b7$export$bfcbcdb55d62e500;
module.exports["nav4CollapseReminderI18n"] = $bf9af6dce6f5d7b7$export$9ee8fabfb18920e1;
module.exports["useNav4CollapseReminderDismissal"] = $bf9af6dce6f5d7b7$export$cbddd2e8b88758a2;

});

parcelRegister("eaL9e", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7boqA = parcelRequire("7boqA");


var $8w1c1 = parcelRequire("8w1c1");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");





var $hAiCi = parcelRequire("hAiCi");





var $kSwu1 = parcelRequire("kSwu1");


var $8Iwqw = parcelRequire("8Iwqw");


var $1fHIr = parcelRequire("1fHIr");


var $ldb5c = parcelRequire("ldb5c");


var $jYwSK = parcelRequire("jYwSK");


var $9Y4qw = parcelRequire("9Y4qw");

var $kGTRV = parcelRequire("kGTRV");

var $anG8x = parcelRequire("anG8x");


var $9DHhW = parcelRequire("9DHhW");








var $4aRua = parcelRequire("4aRua");


var $b4fs3 = parcelRequire("b4fs3");


var $2K2hA = parcelRequire("2K2hA");


var $3eYzF = parcelRequire("3eYzF");


var $2Vz7H = parcelRequire("2Vz7H");


var $uyMbP = parcelRequire("uyMbP");


var $l3ydK = parcelRequire("l3ydK");


var $4AC39 = parcelRequire("4AC39");


var $4enp7 = parcelRequire("4enp7");


var $6VFk2 = parcelRequire("6VFk2");


var $gi4qj = parcelRequire("gi4qj");


var $dOlTT = parcelRequire("dOlTT");


var $8jXZv = parcelRequire("8jXZv");


var $9Zall = parcelRequire("9Zall");

const $e0356f01208b13d1$export$6cddb4d20889bca4 = ({ children: children, isVisible: isVisible, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { dismissSpotlight: dismissSpotlight } = (0, $b4fs3.useNav4CollapseReminderDismissal)(setIsNav4CollapseReminderSpotlightActive);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        isVisible: isVisible,
        placement: "right-end",
        dismiss: dismissSpotlight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
        testId: "nav4-collapse-reminder-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage((0, $b4fs3.nav4CollapseReminderI18n).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, formatMessage((0, $b4fs3.nav4CollapseReminderI18n).body))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: dismissSpotlight
    }, formatMessage((0, $b4fs3.nav4CollapseReminderI18n).dismissButton)))))));
};



var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $b3j2Y = parcelRequire("b3j2Y");


var $1uFM6 = parcelRequire("1uFM6");


var $irVI7 = parcelRequire("irVI7");


var $1eaCJ = parcelRequire("1eaCJ");


var $kvJHJ = parcelRequire("kvJHJ");





var $kVysQ = parcelRequire("kVysQ");


var $4NX9d = parcelRequire("4NX9d");


var $de2j9 = parcelRequire("de2j9");


var $4tOXV = parcelRequire("4tOXV");


var $gnkil = parcelRequire("gnkil");








var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


const $1e0f0aa871cc51c1$var$EditionAwarenessLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "v8ebQ",
    name: "EditionAwarenessLoadable",
    loader: async ()=>(await (parcelRequire("3KaC3"))).EditionAwareness
});
const $1e0f0aa871cc51c1$export$a55b02efe3d62583 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).GROWTH_TRANSMUTERS
})(()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1e0f0aa871cc51c1$var$EditionAwarenessLoadable, null);
});



var $9wGTI = parcelRequire("9wGTI");

/* index.tsx generated by @compiled/babel-plugin v0.40.0 */ 



var $hekY6 = parcelRequire("hekY6");











var $d9tcB = parcelRequire("d9tcB");


var $1ytiN = parcelRequire("1ytiN");







// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce6cbe4a9370c72f$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0cglyw _1ydi18uv",
            __cmplp.className
        ])
    });
});

const $ce6cbe4a9370c72f$var$EditionAwarenessUpsellLoadable = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "IlAy6",
    name: "EditionAwarenessUpsellLoadable",
    loader: async ()=>(await (parcelRequire("4wf0z"))).EditionAwarenessUpsell
});
const $ce6cbe4a9370c72f$export$f255ec0f3619af65 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).GROWTH_LUNA
})(({ navVersion: navVersion })=>{
    const { isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $1ytiN.SPAViewContext));
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    if (edition === (0, $d9tcB.ConfluenceEdition).STANDARD && isSiteAdmin && (0, $9wGTI.fg)('standard-to-premium-ea-refactor')) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ce6cbe4a9370c72f$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ce6cbe4a9370c72f$var$EditionAwarenessUpsellLoadable, {
        navVersion: navVersion
    }));
});



var $2vuKf = parcelRequire("2vuKf");


var $bwL2u = parcelRequire("bwL2u");


var $7Sm4c = parcelRequire("7Sm4c");


var $78QFu = parcelRequire("78QFu");


var $1xpoY = parcelRequire("1xpoY");


var $eBBZq = parcelRequire("eBBZq");


var $1B659 = parcelRequire("1B659");








var $bltJZ = parcelRequire("bltJZ");


var $cES0U = parcelRequire("cES0U");

var $ehvof = parcelRequire("ehvof");


var $dPJCf = parcelRequire("dPJCf");


var $epLE5 = parcelRequire("epLE5");


var $1NBp8 = parcelRequire("1NBp8");


const $760ef9e13b699b30$var$useLazyClickAnalytics = (0, $epLE5.createLazyCallbackHook)(async ()=>(await (parcelRequire("eNWR0"))).fireLogoClickedAnalytics);
const $760ef9e13b699b30$export$48df75a983e1f3fb = ({ siteConfiguration: siteConfiguration, siteSettings: siteSettings, siteDescription: siteDescription, onLoadCustomLogo: onLoadCustomLogo })=>{
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const onClick = $760ef9e13b699b30$var$useLazyClickAnalytics(createAnalyticsEvent, routeDataRef.current?.routeName);
    const siteTitle = siteSettings && siteSettings.siteTitle;
    const CustomNavLogo = (0, $cozmU.useMemo)(()=>{
        if (siteConfiguration?.customSiteLogo && siteDescription?.logoUrl) return ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                alt: "",
                src: siteDescription.logoUrl ?? undefined,
                onLoad: onLoadCustomLogo
            });
        return null;
    }, [
        onLoadCustomLogo,
        siteConfiguration?.customSiteLogo,
        siteDescription?.logoUrl
    ]);
    return CustomNavLogo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ehvof.CustomLogo), {
        label: siteTitle ?? 'Confluence',
        logo: CustomNavLogo,
        icon: CustomNavLogo,
        onClick: onClick,
        href: (0, $1NBp8.WIKI).toUrl()
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cES0U.AppLogo), {
        label: siteTitle ?? 'Confluence',
        icon: (0, $bltJZ.ConfluenceIcon),
        name: "Confluence",
        onClick: onClick,
        href: (0, $1NBp8.WIKI).toUrl()
    });
};





/**
 * @generated SignedSource<<5022827b0cf09752cd5776daf30e953d>>
 * @relayHash 07605b0f94d6bfbf5c86ce6f43ee8794
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be24ced784c52f79da3d55ac5f28cc6bfb935162a401321cfc383e982ab1480e
const $4442fad673926b38$var$node = function() {
    var v0 = [
        {
            "kind": "Literal",
            "name": "current",
            "value": true
        }
    ], v1 = {
        "concreteType": "AtlassianUserEmail",
        "kind": "LinkedField",
        "name": "emails",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "value"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "HelpButtonQuery",
            "selections": [
                {
                    "alias": "user",
                    "args": v0 /*: any*/ ,
                    "concreteType": "AtlassianUser",
                    "kind": "LinkedField",
                    "name": "confluence_atlassianUser",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ 
                    ],
                    "storageKey": "confluence_atlassianUser(current:true)"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "HelpButtonQuery",
            "selections": [
                {
                    "alias": "user",
                    "args": v0 /*: any*/ ,
                    "concreteType": "AtlassianUser",
                    "kind": "LinkedField",
                    "name": "confluence_atlassianUser",
                    "plural": false,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ],
                    "storageKey": "confluence_atlassianUser(current:true)"
                }
            ]
        },
        "params": {
            "cacheID": "07605b0f94d6bfbf5c86ce6f43ee8794",
            "id": "be24ced784c52f79da3d55ac5f28cc6bfb935162a401321cfc383e982ab1480e",
            "metadata": {},
            "name": "HelpButtonQuery",
            "operationKind": "query",
            "text": "query HelpButtonQuery{user:confluence_atlassianUser(current:true){emails{value},id}}"
        }
    };
}();
$4442fad673926b38$var$node.hash = "ea68606a14f00f692f5d23a208b10f51";
var $4442fad673926b38$export$2e2bcd8739ae039 = $4442fad673926b38$var$node;












var $aRGok = parcelRequire("aRGok");


var $jov8i = parcelRequire("jov8i");


var $jln20 = parcelRequire("jln20");


var $cLgYq = parcelRequire("cLgYq");


var $14QAi = parcelRequire("14QAi");


var $dIDyF = parcelRequire("dIDyF");


var $56QzY = parcelRequire("56QzY");





var $1kHsc = parcelRequire("1kHsc");





var $6GD8y = parcelRequire("6GD8y");





var $bQIml = parcelRequire("bQIml");


var $eSLr0 = parcelRequire("eSLr0");


var $4vyfK = parcelRequire("4vyfK");


var $lyWac = parcelRequire("lyWac");


var $dYU3e = parcelRequire("dYU3e");


var $bnxm6 = parcelRequire("bnxm6");

const $c7ca3b61d6326579$export$e89f639882b1384b = ()=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $4vyfK.preloadWebItemLocation)({
            location: (0, $eSLr0.SYSTEM_HELP)
        }),
        (0, $dYU3e.query)({
            query: (0, $bnxm6.default),
            __callerPackage__: "in-product-help"
        })
    ]);
};



var $efvKr = parcelRequire("efvKr");








var $3fBqY = parcelRequire("3fBqY");


var $8aF6s = parcelRequire("8aF6s");


var $6wrL8 = parcelRequire("6wrL8");

const $48d2632049a03f8d$var$HelpButtonQuery = (0, $4442fad673926b38$export$2e2bcd8739ae039);
const $48d2632049a03f8d$export$78bddedbcf2939ac = ()=>{
    const $ = (0, $bDgLe.c)(38);
    const triggerButtonRef = (0, $cozmU.useRef)(null);
    const rightSidebarContext = (0, $jln20.useRightSidebarContext)();
    const inProductHelp = (0, $cLgYq.useInProductHelpActions)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const routeData = (0, $dPJCf.useRouteDataRef)();
    const intl = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== rightSidebarContext) {
        t0 = rightSidebarContext.getCurrent()?.panelId;
        $[0] = rightSidebarContext;
        $[1] = t0;
    } else t0 = $[1];
    const isHelpPanelOpen = t0 === (0, $dIDyF.HELP_PANEL_ID);
    const [t1] = (0, $efvKr.useLivePageMode)();
    const { isEditMode: isLiveEditMode } = t1;
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { data: data } = (0, $jMyy4.useQueryInterop)($48d2632049a03f8d$var$HelpButtonQuery, {
        __callerPackage__: "app-navigation"
    });
    let t2;
    if ($[2] !== data) {
        t2 = (0, $3fBqY.isAtlassianStaff)(data);
        $[2] = data;
        $[3] = t2;
    } else t2 = $[3];
    const isInternalAtlassianUser = t2;
    const [activeDialog, setActiveDialog] = (0, $cozmU.useState)(null);
    let t3;
    if ($[4] !== createAnalyticsEvent || $[5] !== experienceTracker || $[6] !== inProductHelp || $[7] !== isHelpPanelOpen || $[8] !== rightSidebarContext || $[9] !== routeData.current?.href || $[10] !== routeData.current?.routeName) {
        t3 = ()=>{
            if (isHelpPanelOpen) rightSidebarContext.close((0, $dIDyF.HELP_PANEL_ID));
            else {
                experienceTracker.start({
                    name: (0, $irVI7.VIEW_IN_PRODUCT_HELP_EXPERIENCE),
                    attributes: {
                        navVersion: "4"
                    }
                });
                rightSidebarContext.open((0, $dIDyF.HELP_PANEL_ID), (0, $dIDyF.HELP_PANEL_WIDTH));
                rightSidebarContext.setTriggerButtonRef?.(triggerButtonRef);
                const { routeName: routeName, routeGroup: routeGroup } = (0, $14QAi.getRouteData)(routeData.current?.href || "");
                inProductHelp.setRouteName(routeName);
                inProductHelp.setRouteGroup(routeGroup);
            }
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "globalNavigation",
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "help",
                    attributes: {
                        selectedItemPageContext: routeData.current?.routeName,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    }
                }
            }).fire();
        };
        $[4] = createAnalyticsEvent;
        $[5] = experienceTracker;
        $[6] = inProductHelp;
        $[7] = isHelpPanelOpen;
        $[8] = rightSidebarContext;
        $[9] = routeData.current?.href;
        $[10] = routeData.current?.routeName;
        $[11] = t3;
    } else t3 = $[11];
    const onClick = t3;
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = ()=>{
            setActiveDialog(null);
        };
        $[12] = t4;
    } else t4 = $[12];
    const closeDialog = t4;
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (dialog)=>{
            setActiveDialog(dialog(closeDialog));
        };
        $[13] = t5;
    } else t5 = $[13];
    const openDialog = t5;
    let t6;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = ()=>openDialog($48d2632049a03f8d$var$_temp);
        $[14] = t6;
    } else t6 = $[14];
    const openShortcutsDialog = t6;
    let t7;
    if ($[15] !== showModal) {
        t7 = ()=>{
            showModal((0, $6wrL8.DevToolsDialog), {});
        };
        $[15] = showModal;
        $[16] = t7;
    } else t7 = $[16];
    const openDevToolsDialog = t7;
    const preloadMenu = $48d2632049a03f8d$var$_temp2;
    let t8;
    if ($[17] !== intl) {
        t8 = intl.formatMessage($48d2632049a03f8d$var$i18n.help);
        $[17] = intl;
        $[18] = t8;
    } else t8 = $[18];
    let t9;
    if ($[19] !== isHelpPanelOpen || $[20] !== onClick || $[21] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onMouseEnter: preloadMenu,
            onFocus: preloadMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jov8i.Help), {
            onClick: onClick,
            label: t8,
            isSelected: isHelpPanelOpen,
            ref: triggerButtonRef
        }));
        $[19] = isHelpPanelOpen;
        $[20] = onClick;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    let t10;
    if ($[23] !== isLiveEditMode || $[24] !== isOnEditRoute) {
        t10 = isLiveEditMode || isOnEditRoute ? (0, $gnkil.UNIVERSAL_HELP_SHORTCUT) : [
            (0, $gnkil.HELP_SHORTCUT),
            (0, $gnkil.UNIVERSAL_HELP_SHORTCUT)
        ];
        $[23] = isLiveEditMode;
        $[24] = isOnEditRoute;
        $[25] = t10;
    } else t10 = $[25];
    let t11;
    if ($[26] !== t10) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: t10,
            listener: openShortcutsDialog,
            isAppNavigationShortcut: true
        });
        $[26] = t10;
        $[27] = t11;
    } else t11 = $[27];
    let t12;
    if ($[28] !== isInternalAtlassianUser || $[29] !== openDevToolsDialog) {
        t12 = isInternalAtlassianUser && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
            accelerator: (0, $gnkil.UNIVERSAL_OPEN_DEVTOOLS_SHORTCUT),
            listener: openDevToolsDialog,
            isAppNavigationShortcut: true,
            allowInDialog: true
        });
        $[28] = isInternalAtlassianUser;
        $[29] = openDevToolsDialog;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== activeDialog) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, activeDialog);
        $[31] = activeDialog;
        $[32] = t13;
    } else t13 = $[32];
    let t14;
    if ($[33] !== t11 || $[34] !== t12 || $[35] !== t13 || $[36] !== t9) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t9, t11, t12, t13);
        $[33] = t11;
        $[34] = t12;
        $[35] = t13;
        $[36] = t9;
        $[37] = t14;
    } else t14 = $[37];
    return t14;
};
const $48d2632049a03f8d$var$i18n = (0, $kSwu1.defineMessages)({
    help: {
        id: "app-navigation.top-navigation.help",
        defaultMessage: "Help"
    }
});
function $48d2632049a03f8d$var$_temp(onClose) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bQIml.KeyboardShortcutsDialog), {
        onClose: onClose
    });
}
function $48d2632049a03f8d$var$_temp2() {
    (0, $c7ca3b61d6326579$export$e89f639882b1384b)();
}



var $9MAeh = parcelRequire("9MAeh");














var $fmilS = parcelRequire("fmilS");


























var $6m3nS = parcelRequire("6m3nS");

const $f31df34f0e245783$export$d5e80b5916277837 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { id: id, children: children } = t0;
    let t1;
    if ($[0] !== id) {
        t1 = {
            triggerId: id
        };
        $[0] = id;
        $[1] = t1;
    } else t1 = $[1];
    const { fireTrigger: fireTrigger } = (0, $6m3nS.useFirePostOfficeTrigger)(t1);
    let t2;
    let t3;
    if ($[2] !== fireTrigger) {
        t2 = ()=>{
            fireTrigger({
                isActive: true
            });
            return ()=>{
                fireTrigger({
                    isActive: false
                });
            };
        };
        t3 = [
            fireTrigger
        ];
        $[2] = fireTrigger;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[5] !== children || $[6] !== id) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            id: id
        }, children);
        $[5] = children;
        $[6] = id;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};


const $5f8faa2e47e4a6d0$export$e2457e1974c298c3 = ()=>{
    const $ = (0, $bDgLe.c)(7);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const routeData = (0, $dPJCf.useRouteDataRef)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== push || $[2] !== routeData.current?.routeName) {
        t0 = (e)=>{
            const url = (0, $1NBp8.ADMIN_SETTINGS).toUrl();
            if (e.metaKey) window.open(url, "_blank", "noreferrer");
            else push(url);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: "globalNavigation",
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "settings",
                    attributes: {
                        selectedItemPageContext: routeData.current?.routeName,
                        navigationLayer: "global",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START_TOUCH)
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = push;
        $[2] = routeData.current?.routeName;
        $[3] = t0;
    } else t0 = $[3];
    const onClick = t0;
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isAdmin = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
    let t1;
    if ($[4] !== isAdmin || $[5] !== onClick) {
        t1 = isAdmin ? (0, $9wGTI.fg)("post-office_ep_migration_inapp_715_nav4") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f31df34f0e245783$export$d5e80b5916277837), {
            id: "ep-migration-inapp-715-target"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fmilS.Settings), {
            onClick: onClick,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $5f8faa2e47e4a6d0$var$i18n.settings)
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fmilS.Settings), {
            onClick: onClick,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $5f8faa2e47e4a6d0$var$i18n.settings)
        }) : null;
        $[4] = isAdmin;
        $[5] = onClick;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
const $5f8faa2e47e4a6d0$var$i18n = (0, $kSwu1.defineMessages)({
    settings: {
        id: "app-navigation.top-navigation.settings",
        defaultMessage: "Confluence administration"
    }
});

















const $c0dbaa4ed1720915$export$5ca34e43e28ce619 = ()=>{
    return (0, $4vyfK.preloadWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_USER)
    });
};


/**
 * @generated SignedSource<<57c5456b44c4685017c2496e39bf21a0>>
 * @relayHash 8a5f88c31eae893c420fe6862fbb6c53
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f77347333701fe87bd5d5826802613eb72156f033169fd478f3327314f14b9c3
const $9d6b1a9db83da49f$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "creatorAccountIds"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "creatorAccountIds",
                    "variableName": "creatorAccountIds"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": "TRASHED"
                },
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "PERSONAL"
                }
            ],
            "concreteType": "PaginatedSpaceList",
            "kind": "LinkedField",
            "name": "spaces",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "alias"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "key"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "AccountMenuTrashedPersonalSpacesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "AccountMenuTrashedPersonalSpacesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "8a5f88c31eae893c420fe6862fbb6c53",
            "id": "f77347333701fe87bd5d5826802613eb72156f033169fd478f3327314f14b9c3",
            "metadata": {},
            "name": "AccountMenuTrashedPersonalSpacesQuery",
            "operationKind": "query",
            "text": "query AccountMenuTrashedPersonalSpacesQuery($creatorAccountIds:[String!]){spaces(type:\"PERSONAL\",creatorAccountIds:$creatorAccountIds,status:\"TRASHED\"){nodes{alias,key,id}}}"
        }
    };
}();
$9d6b1a9db83da49f$var$node.hash = "441235242490f35c2f56b55ed716011d";
var $9d6b1a9db83da49f$export$2e2bcd8739ae039 = $9d6b1a9db83da49f$var$node;






var $kNIYN = parcelRequire("kNIYN");





var $8FgJC = parcelRequire("8FgJC");








var $aDfUy = parcelRequire("aDfUy");


var $5db0E = parcelRequire("5db0E");


var $7T8Gs = parcelRequire("7T8Gs");

const $cd633d7921aba6f7$export$f03eabcc4a75d4f3 = ({ testId: testId, logInLink: logInLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aDfUy.LogIn), {
        testId: testId,
        href: logInLink,
        onClick: (event, analytics)=>{
            analytics.update({
                actionSubjectId: 'logInLink'
            }).fire((0, $5db0E.NAVIGATION_CHANNEL));
        },
        label: (0, $7T8Gs.logInTooltip)
    });









var $2kkx9 = parcelRequire("2kkx9");


var $3G59f = parcelRequire("3G59f");


var $5lAlH = parcelRequire("5lAlH");

const $5cdece1b432ef120$export$83537fb6d03c400d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ picture: picture, email: email, trustPicture: trustPicture = false, ...props }, ref)=>{
    const intl = (0, $kSwu1.useIntl)();
    const state = (0, $3G59f.useImageState)(picture || '');
    const tooltip = intl.formatMessage((0, $5lAlH.messages).triggerTooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2kkx9.Profile), {
        ...props,
        isSelected: props['aria-expanded'],
        ref: ref,
        label: email || tooltip,
        src: trustPicture || state === 'loaded' ? picture : undefined
    });
});



var $dbxd9 = parcelRequire("dbxd9");

const $6c4929546710fc52$export$a63b6ac98b2ba9a8 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dbxd9.AccountMenu), {
        ...props,
        AccountMenuLoggedOutState: (0, $cd633d7921aba6f7$export$f03eabcc4a75d4f3),
        AccountMenuTrigger: (0, $5cdece1b432ef120$export$83537fb6d03c400d)
    });
};



var $i3S9F = parcelRequire("i3S9F");





var $6ld6a = parcelRequire("6ld6a");





var $3u0dr = parcelRequire("3u0dr");














var $hSqtY = parcelRequire("hSqtY");


var $euL71 = parcelRequire("euL71");


var $fcF01 = parcelRequire("fcF01");

/* eslint-disable check-file/filename-blocklist */ var $7faba016ec71910a$export$5f48252a98452965 = /*#__PURE__*/ function(PERSISTENT_UPGRADE_EDITION_TRIAL_TYPES) {
    PERSISTENT_UPGRADE_EDITION_TRIAL_TYPES["NOT_SUPPORTED"] = "not-supported";
    PERSISTENT_UPGRADE_EDITION_TRIAL_TYPES["PRE_TRIAL"] = "pre-trial";
    return PERSISTENT_UPGRADE_EDITION_TRIAL_TYPES;
}({});
const $7faba016ec71910a$export$e54a73280ddbd89 = 'persistentUpgradeBanner';
const $7faba016ec71910a$export$bebf43b5d37dab0 = 'persistentUpgrade';
const $7faba016ec71910a$export$2a064af61b9d478a = 'persistent-upgrade';
const $7faba016ec71910a$export$d6b0a8b694d349bf = 'upgradeFlow';
const $7faba016ec71910a$export$30c8df1fa0e8fecf = 'persistent-upgrade-button';



const $d3462440acba7541$export$a1562d08625f5d7e = 'sendUIEvent';
const $d3462440acba7541$export$12346a674644c156 = 'sendOperationalEvent';
const $d3462440acba7541$export$e0a4e20835d53012 = ({ eventAction: eventAction, touchpointSubject: touchpointSubject, currentEdition: currentEdition, touchpointId: touchpointId, flowId: flowId, experimentAttributes: experimentAttributes })=>{
    return {
        type: $d3462440acba7541$export$a1562d08625f5d7e,
        data: {
            action: eventAction,
            actionSubject: touchpointSubject,
            source: (0, $7faba016ec71910a$export$bebf43b5d37dab0),
            attributes: {
                currentEdition: currentEdition,
                touchpointId: touchpointId,
                flowId: flowId,
                growthFeature: (0, $7faba016ec71910a$export$bebf43b5d37dab0),
                ...experimentAttributes
            }
        }
    };
};





















var $9KSWX = parcelRequire("9KSWX");






const $295ae67a78108eac$export$a1562d08625f5d7e = 'sendUIEvent';
const $295ae67a78108eac$export$12346a674644c156 = 'sendOperationalEvent';
const $295ae67a78108eac$export$318bf6d071b9c12a = 'persistentUpgradeMenu';
const $295ae67a78108eac$export$3be04a6bfdd40c53 = 'preTrialMenu';
const $295ae67a78108eac$export$87e7aba52331cd4 = {
    [(0, $7faba016ec71910a$export$5f48252a98452965).PRE_TRIAL]: $295ae67a78108eac$export$3be04a6bfdd40c53
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $295ae67a78108eac$var$MenuItemContent = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1e0c1txw _1n261q9c",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1e0c1txw _1n261q9c",
            __cmplp.className
        ])
    });
});
const $295ae67a78108eac$var$LozengeContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $3u0dr.isReactCompilerActiveV2)() ? (t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_18s817e2",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
} : ({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_18s817e2",
            __cmplp.className
        ])
    });
});
const $295ae67a78108eac$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    persistentUpgradeMenuItemFreePlanTitle: {
        id: "persistent-upgrade.section.message.persistent-upgrade.menuitem.freeplan.title",
        defaultMessage: "UPGRADE"
    },
    persistentUpgradeMenuItemFreePlanTitleUpdated: {
        id: "persistent-upgrade.section.message.persistent-upgrade.menuitem.freeplan.title.updated",
        defaultMessage: "Upgrade"
    },
    persistentUpgradeMenuItemFreePlanLabelExperiment: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.label",
        defaultMessage: "Try Standard or Premium"
    },
    persistentUpgradeMenuItemFreePlanLozengeExperiment: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.lozenge",
        defaultMessage: "FREE TRIAL"
    },
    persistentUpgradeMenuItemFreePlanLozengeExperimentUpdated: {
        id: "persistent-upgrade.trial-plan-comparison.section.message.persistent-upgrade.menuitem.freeplan.lozenge.updated",
        defaultMessage: "Free trial"
    }
});
const $295ae67a78108eac$export$130fb52e75130e77 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(6);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { currentEdition: currentEdition } = (0, $cozmU.useContext)((0, $fcF01.UpFlowContext));
    let t0;
    let t1;
    if ($[0] !== createAnalyticsEvent || $[1] !== currentEdition) {
        t0 = ()=>{
            if (currentEdition) createAnalyticsEvent((0, $d3462440acba7541$export$e0a4e20835d53012)({
                eventAction: "viewed",
                ...$295ae67a78108eac$export$1b1d874427f720f9(currentEdition)
            })).fire();
        };
        t1 = [
            createAnalyticsEvent,
            currentEdition
        ];
        $[0] = createAnalyticsEvent;
        $[1] = currentEdition;
        $[2] = t0;
        $[3] = t1;
    } else {
        t0 = $[2];
        t1 = $[3];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $295ae67a78108eac$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanLabelExperiment);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($295ae67a78108eac$var$MenuItemContent, null, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($295ae67a78108eac$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "information",
            isBold: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $295ae67a78108eac$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanLozengeExperimentUpdated))));
        $[5] = t3;
    } else t3 = $[5];
    return t3;
} : ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { currentEdition: currentEdition } = (0, $cozmU.useContext)((0, $fcF01.UpFlowContext));
    (0, $cozmU.useEffect)(()=>{
        if (currentEdition) createAnalyticsEvent((0, $d3462440acba7541$export$e0a4e20835d53012)({
            eventAction: 'viewed',
            ...$295ae67a78108eac$export$1b1d874427f720f9(currentEdition)
        })).fire();
    }, [
        createAnalyticsEvent,
        currentEdition
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($295ae67a78108eac$var$MenuItemContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $295ae67a78108eac$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanLabelExperiment), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($295ae67a78108eac$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: "information",
        isBold: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $295ae67a78108eac$export$defe85febe8b728c.persistentUpgradeMenuItemFreePlanLozengeExperimentUpdated))));
};
const $295ae67a78108eac$export$1b1d874427f720f9 = (currentEdition)=>({
        touchpointSubject: $295ae67a78108eac$export$318bf6d071b9c12a,
        currentEdition: currentEdition,
        touchpointId: $295ae67a78108eac$export$87e7aba52331cd4[(0, $7faba016ec71910a$export$5f48252a98452965).PRE_TRIAL],
        flowId: (0, $7faba016ec71910a$export$d6b0a8b694d349bf)
    });



var $BHGIm = parcelRequire("BHGIm");

const $55c779eece50e78c$export$17da940073c80266 = (0, $3u0dr.isReactCompilerActiveV2)() ? ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [renderFailed, setRenderFailed] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { currentEdition: currentEdition, cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $fcF01.UpFlowContext));
    const { showModal: showTrialComparisonModal } = (0, $BHGIm.useTrialPlanComparisonModalActions)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== currentEdition || $[2] !== showTrialComparisonModal) {
        t0 = ()=>{
            createAnalyticsEvent((0, $d3462440acba7541$export$e0a4e20835d53012)({
                eventAction: "clicked",
                ...(0, $295ae67a78108eac$export$1b1d874427f720f9)(currentEdition)
            })).fire();
            showTrialComparisonModal({
                touchpointId: (0, $295ae67a78108eac$export$87e7aba52331cd4)[(0, $7faba016ec71910a$export$5f48252a98452965).PRE_TRIAL]
            });
        };
        $[0] = createAnalyticsEvent;
        $[1] = currentEdition;
        $[2] = showTrialComparisonModal;
        $[3] = t0;
    } else t0 = $[3];
    const onUpgradeMenuItemClick = t0;
    const shouldRenderPersistentUpgradeMenuSection = currentEdition === (0, $euL71.ConfluenceEdition).FREE && Boolean(isSiteAdmin) && Boolean(cloudId) && !renderFailed;
    if (shouldRenderPersistentUpgradeMenuSection) {
        let t1;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
                attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
                onError: ()=>setRenderFailed(true)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $295ae67a78108eac$export$130fb52e75130e77), null));
            $[4] = t1;
        } else t1 = $[4];
        let t2;
        if ($[5] !== onUpgradeMenuItemClick) {
            const menuSection = {
                heading: (0, $295ae67a78108eac$export$defe85febe8b728c).persistentUpgradeMenuItemFreePlanTitleUpdated,
                items: [
                    {
                        action: onUpgradeMenuItemClick,
                        content: t1
                    }
                ]
            };
            t2 = [
                menuSection
            ];
            $[5] = onUpgradeMenuItemClick;
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    } else {
        let t1;
        if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = [];
            $[7] = t1;
        } else t1 = $[7];
        return t1;
    }
} : ()=>{
    const [renderFailed, setRenderFailed] = (0, $cozmU.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { currentEdition: currentEdition, cloudId: cloudId, isSiteAdmin: isSiteAdmin } = (0, $cozmU.useContext)((0, $fcF01.UpFlowContext));
    const { showModal: showTrialComparisonModal } = (0, $BHGIm.useTrialPlanComparisonModalActions)();
    const onUpgradeMenuItemClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent((0, $d3462440acba7541$export$e0a4e20835d53012)({
            eventAction: 'clicked',
            ...(0, $295ae67a78108eac$export$1b1d874427f720f9)(currentEdition)
        })).fire();
        showTrialComparisonModal({
            touchpointId: (0, $295ae67a78108eac$export$87e7aba52331cd4)[(0, $7faba016ec71910a$export$5f48252a98452965).PRE_TRIAL]
        });
    }, [
        createAnalyticsEvent,
        currentEdition,
        showTrialComparisonModal
    ]);
    const shouldRenderPersistentUpgradeMenuSection = currentEdition === (0, $euL71.ConfluenceEdition).FREE && Boolean(isSiteAdmin) && Boolean(cloudId) && !renderFailed;
    if (shouldRenderPersistentUpgradeMenuSection) {
        const menuSection = {
            heading: (0, $295ae67a78108eac$export$defe85febe8b728c).persistentUpgradeMenuItemFreePlanTitleUpdated,
            items: [
                {
                    action: onUpgradeMenuItemClick,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
                        attribution: (0, $3IBnw.Attribution).GROWTH_LUNA,
                        onError: ()=>setRenderFailed(true)
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $295ae67a78108eac$export$130fb52e75130e77), null))
                }
            ]
        };
        return [
            menuSection
        ];
    } else return [];
};



var $kRW4Y = parcelRequire("kRW4Y");


var $gqqjz = parcelRequire("gqqjz");


var $awSMG = parcelRequire("awSMG");

function $7567c74a2233d8d4$export$1fe43c489c085f15() {
    if ('indexedDB' in window && indexedDB.databases) indexedDB.databases().then((databases)=>{
        const offlineStepsDatabases = databases.filter((db)=>db.name && db.name.startsWith((0, $awSMG.OFFLINE_STEPS_DATABASE_NAME_PREFIX)));
        offlineStepsDatabases.forEach((db)=>{
            if (!db.name) return;
            const openReq = indexedDB.open(db.name);
            openReq.onsuccess = (event)=>{
                const req = event.target;
                const idb = req.result;
                try {
                    const tx = idb.transaction([
                        'steps',
                        'meta'
                    ], 'readwrite');
                    tx.objectStore('steps').clear();
                    tx.objectStore('meta').clear();
                    tx.oncomplete = ()=>{
                        idb.close();
                    };
                    tx.onerror = ()=>{
                        idb.close();
                    };
                } catch  {
                    idb.close();
                }
            };
        });
    });
}


/**
 * @generated SignedSource<<42415b7186a4f6f1325d61971fbe0485>>
 * @relayHash 7cebb6100267d8ac81b652ebb261dbf2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID adf3712d019249638034f594a86b0c15f44172d208ecd84609fe0197d0949a64
const $30a6006f81533dde$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "HardDeleteSpacePayload",
            "kind": "LinkedField",
            "name": "hardDeleteSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "taskId"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTrashedSpaceHardDeleteSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTrashedSpaceHardDeleteSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7cebb6100267d8ac81b652ebb261dbf2",
            "id": "adf3712d019249638034f594a86b0c15f44172d208ecd84609fe0197d0949a64",
            "metadata": {},
            "name": "useTrashedSpaceHardDeleteSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation useTrashedSpaceHardDeleteSpaceMutation($spaceKey:String!){hardDeleteSpace(spaceKey:$spaceKey){taskId,success}}"
        }
    };
}();
$30a6006f81533dde$var$node.hash = "795f694b982fb4bd1390300de6001133";
var $30a6006f81533dde$export$2e2bcd8739ae039 = $30a6006f81533dde$var$node;


/**
 * @generated SignedSource<<87fab6fb9fcd04cbaf62ff133c29bb87>>
 * @relayHash 1986e4071459ef825acb60fb30fd9e0f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c07d50afa6e876d6016581845c7c1f40166322035db1118041411e7c542f3603
const $c483e9485a6240f5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "RestoreSpacePayload",
            "kind": "LinkedField",
            "name": "restoreSpace",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTrashedSpaceRestoreSpaceMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTrashedSpaceRestoreSpaceMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "1986e4071459ef825acb60fb30fd9e0f",
            "id": "c07d50afa6e876d6016581845c7c1f40166322035db1118041411e7c542f3603",
            "metadata": {},
            "name": "useTrashedSpaceRestoreSpaceMutation",
            "operationKind": "mutation",
            "text": "mutation useTrashedSpaceRestoreSpaceMutation($spaceKey:String!){restoreSpace(spaceKey:$spaceKey){success}}"
        }
    };
}();
$c483e9485a6240f5$var$node.hash = "81c7e77af145a944ec2ee17a6ddeb1af";
var $c483e9485a6240f5$export$2e2bcd8739ae039 = $c483e9485a6240f5$var$node;


/**
 * @generated SignedSource<<aa3954198e79a45124be3517ffa23b74>>
 * @relayHash 5415582d46c1093ed99dc8b056690f92
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 77fe39eba17aa5cafc28b38ad0a6075f2201f7aa0c5bc9ae2ae583fd26445071
const $1c05e71164dfb2a4$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = [
        {
            "concreteType": "ConfluenceQueryApi",
            "kind": "LinkedField",
            "name": "confluence",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "id"
                        }
                    ],
                    "concreteType": "ConfluenceLongTask",
                    "kind": "LinkedField",
                    "name": "longTask",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "elapsedTime"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useTrashedSpaceHardDeleteSpaceLongTaskQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useTrashedSpaceHardDeleteSpaceLongTaskQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "5415582d46c1093ed99dc8b056690f92",
            "id": "77fe39eba17aa5cafc28b38ad0a6075f2201f7aa0c5bc9ae2ae583fd26445071",
            "metadata": {},
            "name": "useTrashedSpaceHardDeleteSpaceLongTaskQuery",
            "operationKind": "query",
            "text": "query useTrashedSpaceHardDeleteSpaceLongTaskQuery($id:ID!){confluence{longTask(id:$id){id,state{elapsedTime,name,__typename}}}}"
        }
    };
}();
$1c05e71164dfb2a4$var$node.hash = "d91db87dfbba3e56df610cf732a702b0";
var $1c05e71164dfb2a4$export$2e2bcd8739ae039 = $1c05e71164dfb2a4$var$node;









var $ig7dg = parcelRequire("ig7dg");





var $3oFAV = parcelRequire("3oFAV");





var $7zgzO = parcelRequire("7zgzO");














var $iEfsZ = parcelRequire("iEfsZ");


var $lvOsp = parcelRequire("lvOsp");


var $308Wd = parcelRequire("308Wd");


var $gW6rh = parcelRequire("gW6rh");


var $4eIcx = parcelRequire("4eIcx");


var $4H4Pj = parcelRequire("4H4Pj");

const $471b21c5f758aa1c$var$i18n = (0, $kSwu1.defineMessages)({
    errorTitle: {
        id: "space-directory.space.restore.error-title",
        defaultMessage: "Something went wrong"
    },
    errorDescription: {
        id: "space-directory.space.restore.error-description",
        defaultMessage: "Refresh and try again."
    },
    successTitle: {
        id: "space-directory.space.delete.success-title",
        defaultMessage: "Space successfully deleted"
    },
    deletingProgressTitle: {
        id: "space-directory.space.delete.progress.title",
        defaultMessage: "Deleting space"
    },
    deletingProgress: {
        id: "space-directory.space.delete.progress",
        defaultMessage: "Deleting..."
    }
});
const $471b21c5f758aa1c$var$POLL_INTERVAL_MS = 500;
const $471b21c5f758aa1c$var$POLL_TIMEOUT_MS = 80000;

const $471b21c5f758aa1c$export$3773e9c668f3a570 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Z_hkD",
    name: "DeleteSpaceDialogLoader",
    loader: async ()=>(await (parcelRequire("fMDig"))).DeleteSpaceDialog
});
const $471b21c5f758aa1c$export$9d49f71132b637a1 = ({ spaceKey: spaceKey, spaceAlias: spaceAlias, spaceId: spaceId, source: source, flags: flags, modifyTrashedCache: modifyTrashedCache })=>{
    const { toUrl: toUrl, push: push } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const intl = (0, $kSwu1.useIntl)();
    const timeoutRef = (0, $cozmU.useRef)();
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [hardDeleteLongTaskQuery, { data: longTaskData, error: longTaskError, stopPolling: stopPolling }] = (0, $lvOsp.useLazyQueryInterop)((0, $1c05e71164dfb2a4$export$2e2bcd8739ae039), {
        fetchPolicy: 'network-only',
        pollInterval: $471b21c5f758aa1c$var$POLL_INTERVAL_MS,
        __callerPackage__: "space-directory"
    });
    const onError = (0, $cozmU.useCallback)((action, experience, error)=>{
        flags.hideFlag('deleting-space-progress');
        flags.showErrorFlag({
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $471b21c5f758aa1c$var$i18n.errorTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $471b21c5f758aa1c$var$i18n.errorDescription),
            isAutoDismiss: true
        });
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: action,
                actionSubject: 'space',
                source: source,
                containerType: 'space',
                containerId: spaceId
            }
        }).fire();
        experience && experienceTracker.fail({
            name: experience,
            error: new Error(error || 'An unknown error has occurred'),
            attributes: {
                spaceId: spaceId
            }
        });
    }, [
        flags,
        createAnalyticsEvent,
        spaceId,
        source,
        experienceTracker
    ]);
    const [mutateRestoreSpace] = (0, $308Wd.useMutationInterop)((0, $c483e9485a6240f5$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey
        },
        onError: ()=>onError('restoreError', (0, $irVI7.RESTORE_SPACE_EXPERIENCE), 'Restore space mutation failed'),
        onCompleted: ()=>{
            experienceTracker.succeed({
                name: (0, $irVI7.RESTORE_SPACE_EXPERIENCE),
                attributes: {
                    spaceId: spaceId
                }
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'restored',
                    actionSubject: 'space',
                    source: source,
                    containerType: 'space',
                    containerId: spaceId
                }
            }).fire();
            //go to the restored space
            push(toUrl((0, $1NBp8.SPACE_OVERVIEW).name, {
                spaceKey: spaceAlias || spaceKey
            }));
        },
        awaitRefetchQueries: true,
        refetchQueries: [
            {
                query: (0, $gW6rh.default)
            },
            {
                query: (0, $4eIcx.default),
                variables: {
                    selectedSpaceKey: spaceKey
                }
            },
            {
                query: (0, $4H4Pj.default)
            },
            {
                query: (0, $iEfsZ.default),
                variables: {
                    location: 'system.user'
                }
            }
        ],
        __callerPackage__: "space-directory"
    });
    const [hardDeleteSpace] = (0, $308Wd.useMutationInterop)((0, $30a6006f81533dde$export$2e2bcd8739ae039), {
        variables: {
            spaceKey: spaceKey
        },
        onError: ()=>onError('deleteError', (0, $irVI7.HARD_DELETE_SPACE_EXPERIENCE), 'Hard delete space mutation failed'),
        onCompleted: (data)=>{
            if (data?.hardDeleteSpace?.taskId) {
                // poll the long task's progress
                const taskIdAri = (0, $3oFAV.ConfluenceLongRunningTaskAri).create({
                    siteId: cloudId,
                    activationId: activationId,
                    taskId: data.hardDeleteSpace.taskId
                });
                hardDeleteLongTaskQuery({
                    variables: {
                        id: taskIdAri.toString()
                    }
                });
                // show the progress flag
                flags.showInfoFlag({
                    id: 'deleting-space-progress',
                    title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $471b21c5f758aa1c$var$i18n.deletingProgressTitle),
                    description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ig7dg.default), {
                        ariaLabel: intl.formatMessage($471b21c5f758aa1c$var$i18n.deletingProgress),
                        isIndeterminate: true
                    })
                });
            }
        },
        __callerPackage__: "space-directory"
    });
    (0, $cozmU.useEffect)(()=>{
        // if the long task is still in progress after 60 seconds, show an error flag
        if (longTaskData?.confluence?.longTask?.state?.__typename === 'ConfluenceLongTaskInProgress' && stopPolling) timeoutRef.current = setTimeout(()=>{
            stopPolling();
            onError('deleteTimeout', (0, $irVI7.HARD_DELETE_SPACE_EXPERIENCE), 'Long task timeout');
        }, $471b21c5f758aa1c$var$POLL_TIMEOUT_MS);
    }, [
        longTaskData?.confluence?.longTask?.state?.__typename,
        stopPolling,
        onError,
        spaceKey,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (longTaskError) {
            onError('deleteError', (0, $irVI7.HARD_DELETE_SPACE_EXPERIENCE), longTaskError);
            stopPolling();
            clearTimeout(timeoutRef.current);
        } else if (longTaskData?.confluence?.longTask?.state?.__typename === 'ConfluenceLongTaskSuccess') {
            // long task completed successfully, stop polling and show success flag
            stopPolling();
            clearTimeout(timeoutRef.current);
            flags.hideFlag('deleting-space-progress');
            flags.showSuccessFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $471b21c5f758aa1c$var$i18n.successTitle),
                isAutoDismiss: true
            });
            experienceTracker.succeed({
                name: (0, $irVI7.HARD_DELETE_SPACE_EXPERIENCE),
                attributes: {
                    spaceId: spaceId
                }
            });
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'space',
                    source: source,
                    containerType: 'space',
                    containerId: spaceId
                }
            }).fire();
            // remove the space from the cache
            modifyTrashedCache && modifyTrashedCache(spaceKey);
        }
    }, [
        flags,
        longTaskData,
        longTaskError,
        stopPolling,
        onError,
        modifyTrashedCache,
        spaceKey,
        spaceId,
        source,
        experienceTracker,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        return ()=>clearTimeout(timeoutRef.current);
    }, []);
    const handleStartDelete = (0, $cozmU.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.HARD_DELETE_SPACE_EXPERIENCE),
            attributes: {
                spaceId: spaceId
            }
        });
        hardDeleteSpace();
    }, [
        hardDeleteSpace,
        experienceTracker,
        spaceId
    ]);
    const handleRestoreClick = (0, $cozmU.useCallback)(()=>{
        experienceTracker.start({
            name: (0, $irVI7.RESTORE_SPACE_EXPERIENCE),
            attributes: {
                spaceId: spaceId
            }
        });
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'restoreSpaceButton',
                source: source
            }
        }).fire();
        mutateRestoreSpace();
    }, [
        mutateRestoreSpace,
        createAnalyticsEvent,
        source,
        spaceId,
        experienceTracker
    ]);
    const handleDeleteClick = (0, $cozmU.useCallback)((dialogs)=>{
        dialogs.showModal($471b21c5f758aa1c$export$3773e9c668f3a570, {
            handleStartDelete: handleStartDelete
        });
    }, [
        handleStartDelete
    ]);
    return {
        handleRestoreClick: handleRestoreClick,
        handleDeleteClick: handleDeleteClick,
        handleStartDelete: handleStartDelete
    };
};






var $jEeDd = parcelRequire("jEeDd");


var $7J5Uc = parcelRequire("7J5Uc");


var $ictHB = parcelRequire("ictHB");


var $2YyKb = parcelRequire("2YyKb");


var $6mKj3 = parcelRequire("6mKj3");


var $kcIQr = parcelRequire("kcIQr");





var $gAlT6 = parcelRequire("gAlT6");







/* eslint-disable no-console */ 
var $jiJCD = parcelRequire("jiJCD");





var $hHL57 = parcelRequire("hHL57");


var $6Jphz = parcelRequire("6Jphz");


var $9GVkD = parcelRequire("9GVkD");








var $jlIaF = parcelRequire("jlIaF");


var $hjhCz = parcelRequire("hjhCz");


var $cMvQV = parcelRequire("cMvQV");





const $3577c171740792d7$export$66c678344942e78 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "l42Eo",
    name: "LazyAboutConfluenceDialog",
    loader: async ()=>(await (parcelRequire("jPTYm"))).AboutConfluenceDialog
});






const $70f1925d36f87de3$export$833e3c61be5fbc6f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "pg4P3",
    name: "LazyGiveFeedbackDialog",
    loader: async ()=>(await (parcelRequire("7cRcO"))).GiveFeedbackDialog
});









var $aDSIl = parcelRequire("aDSIl");


var $8oBbn = parcelRequire("8oBbn");





const $900853aff92d6b38$export$687b3538513cb3cc = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "sW558",
    name: "ThemePopupMenu",
    loader: async ()=>(await (parcelRequire("8r4wU"))).ThemePopupMenu
});


const $86397fec8483a8db$var$ThemeMenuItemComponent = ({ item: item, isSelected: isSelected, closeMenu: closeMenu, ...linkItemProps })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $900853aff92d6b38$export$687b3538513cb3cc), {
        isOpen: isSelected,
        onSelected: closeMenu,
        closeMenu: linkItemProps.onClick,
        trigger: ({ triggerRef: triggerRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
                ...triggerProps,
                ...linkItemProps,
                isSelected: isSelected,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                    spacing: "spacious",
                    label: "",
                    size: "small"
                }),
                ref: triggerRef
            }, item.content)
    });
};
const $86397fec8483a8db$export$d11c29d48d32448a = (0, $kSwu1.injectIntl)($86397fec8483a8db$var$ThemeMenuItemComponent);


(0, $cMvQV.setUserAgent)();
const $ce34965c368cb83e$var$addQueryParamsToUrl = function addQueryParamsToUrl(params, url) {
    const parsedUrl = {
        ...(0, $jiJCD.parse)(url, true),
        search: undefined
    };
    parsedUrl.query = Object.assign({}, parsedUrl.query, params);
    return (0, $jiJCD.format)(parsedUrl);
};
const $ce34965c368cb83e$var$cleanURL = (url, userId)=>url.replace('$generalUtil.doubleUrlEncode($helper.action.authenticatedUser.name)', userId);
/**
 * A connect add-on web-item with `ap-dialog` or `ap-inline-dialog` class name will trigger opening Connect Dialog.
 * @param styleClass
 * @returns {boolean}
 */ const $ce34965c368cb83e$var$isConnectWebItemWillTriggerDialog = (styleClass)=>styleClass.indexOf('ap-dialog') >= 0 || styleClass.indexOf('ap-inline-dialog') >= 0;
/**
 * Add `action` for a Atlaskit dropdown menu item so that when dropdown menu item is selected, `action` is called and trigger click event on anchor element automatically.
 * @param {Object} item - dropdown menu object. A new `action` attribute will be added.
 * @returns {Function} a callback function which is used to pass `ref` prop.
 */ const $ce34965c368cb83e$var$createClickActionHandlerForProxyAnchor = (item)=>{
    return (anchorEl)=>{
        item.action = ()=>anchorEl.click();
    };
};
/**
 * createFakeWebDriverTarget will add an invisible dom element in the dropdown item, which allows old pageobjects of
 * AUIDropdown to target atlaskit dropdowns. Hopefully it's temporary.
 *
 * @param id
 */ const $ce34965c368cb83e$var$createFakeWebDriverTarget = (id)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-primitives-text, @atlassian/i18n/no-literal-string-in-jsx -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        id: id,
        style: {
            opacity: 0
        },
        "aria-hidden": true
    }, "-");
const $ce34965c368cb83e$var$createAboutConfluenceDialog = (onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3577c171740792d7$export$66c678344942e78), {
        onClose: onClose
    });
const $ce34965c368cb83e$var$createGiveFeedbackDialog = (onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70f1925d36f87de3$export$833e3c61be5fbc6f), {
        onClose: onClose
    });
const $ce34965c368cb83e$var$createAddPesonalSpaceDialog = (onClose)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hjhCz.LazyAddPersonalSpaceDialog), {
        onClose: onClose
    });
const $ce34965c368cb83e$export$62ed5eb75de5c4d9 = ({ url: url, params: params, label: label, moduleKey: moduleKey, id: id = '', tooltip: tooltip = '', styleClass: styleClass = '' }, push, userId, callbackAction)=>{
    label = (0, (/*@__PURE__*/$parcel$interopDefault($hHL57)))(label);
    switch(moduleKey){
        case 'confluence-about':
            const about = {
                key: moduleKey,
                getDialog: $ce34965c368cb83e$var$createAboutConfluenceDialog,
                iconAfter: $ce34965c368cb83e$var$createFakeWebDriverTarget('confluence-about-link'),
                content: label
            };
            return about;
        //we are removing gadgets
        case 'gadget-directory':
            const gadget = null;
            return gadget;
        case 'user-history':
            const userHistory = {
                key: moduleKey,
                action: ()=>console.log('open ViewRecentsModalContainer'),
                content: label
            };
            return userHistory;
        case 'user-profile':
            const additionalQueryParamsForAnalytics = 'src=usermenu';
            const userProfileUrl = `${(0, $jlIaF.CONTEXT_PATH)}/people/${userId}?${additionalQueryParamsForAnalytics}`;
            return {
                key: moduleKey,
                href: userProfileUrl,
                content: label,
                title: tooltip
            };
        case 'keyboard-shortcuts-dialog-help-menu':
            const keyboardShortcuts = {
                key: moduleKey,
                action: callbackAction,
                iconAfter: $ce34965c368cb83e$var$createFakeWebDriverTarget('keyboard-shortcuts-link'),
                content: label
            };
            return keyboardShortcuts;
        case 'create-personal-space':
            const createPersonalSpace = {
                key: moduleKey,
                getDialog: $ce34965c368cb83e$var$createAddPesonalSpaceDialog,
                content: label
            };
            return createPersonalSpace;
        case 'personal-space':
            const personalSpace = {
                key: moduleKey,
                content: label,
                target: '_self',
                href: url,
                title: tooltip,
                action: callbackAction
            };
            if ((0, $6mKj3.expVal)('confluence_profile_menu_personal_space_icon', 'isEnabled', false)) personalSpace.iconBefore = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6Jphz))), {
                label: ""
            });
            return personalSpace;
        case 'admin-restore-personal-space':
            const adminRestorePersonalSpace = {
                key: moduleKey,
                action: callbackAction,
                content: label,
                title: tooltip
            };
            return adminRestorePersonalSpace;
        case 'my-tasks-menu-item':
            const task = {
                key: moduleKey,
                content: label,
                target: '_self',
                href: `${(0, $jlIaF.CONTEXT_PATH)}/home/tasks`,
                title: tooltip
            };
            return task;
        case 'adg3-give-feedback':
            const giveFeedback = {
                key: moduleKey,
                getDialog: $ce34965c368cb83e$var$createGiveFeedbackDialog,
                content: label
            };
            return giveFeedback;
        case 'user-favourites':
            const userFavourites = {
                key: moduleKey,
                content: label,
                target: '_self',
                href: (0, $1NBp8.MY_SAVED_FOR_LATER).toUrl(),
                title: tooltip
            };
            return userFavourites;
        case 'user-theme':
            const userThemePreference = {
                key: moduleKey,
                component: (0, $86397fec8483a8db$export$d11c29d48d32448a),
                content: label,
                title: tooltip,
                action: callbackAction,
                closeAction: ()=>{} // No-op, don't close
            };
            return userThemePreference;
        case 'login':
            const { pathname: pathname, search: search, hash: hash } = window.location;
            let currentLocation = pathname + search + hash;
            if (currentLocation.startsWith((0, $jlIaF.CONTEXT_PATH))) currentLocation = currentLocation.slice((0, $jlIaF.CONTEXT_PATH).length);
            const login = {
                key: moduleKey,
                href: $ce34965c368cb83e$var$addQueryParamsToUrl({
                    os_destination: currentLocation
                }, url),
                content: label
            };
            return login;
        case 'logout':
            const logout = {
                key: moduleKey,
                action: ()=>{
                    push(url);
                },
                content: label
            };
            return logout;
        default:
            const item = {
                key: moduleKey,
                href: $ce34965c368cb83e$var$cleanURL(url, userId),
                target: params && params.target || '_self',
                content: label,
                title: tooltip
            };
            const shouldRenderProxyAnchor = $ce34965c368cb83e$var$isConnectWebItemWillTriggerDialog(styleClass);
            item.iconAfter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", null, id ? $ce34965c368cb83e$var$createFakeWebDriverTarget(id) : null, shouldRenderProxyAnchor ? // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("a", {
                href: item.href,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: styleClass,
                ref: $ce34965c368cb83e$var$createClickActionHandlerForProxyAnchor(item),
                "aria-hidden": "true",
                tabIndex: -1
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), null, item.title ?? '')) : null);
            if (shouldRenderProxyAnchor) {
                // `item.action` value will be overridden by `ref` callback.
                // prevent rendering anchor element for dropdown menu item because there is a above proxy anchor
                // which helps to trigger a click event when dropdown menu item is selected.
                item.href = '';
                item.target = '';
            }
            return item;
    }
};


const $9abf739da8d121fb$var$CONFLUENCE_SECTION = 'system.user/user-content';
const $9abf739da8d121fb$var$HELP_US_IMPROVE_SECTION = 'system.user/adg3-section';
/**
 * When the `confluence_profile_menu_personal_space_icon` experiment is enabled, move the
 * "Confluence" section (`system.user/user-content`) above the "Help us improve" section
 * (`system.user/adg3-section`) in the profile dropdown.
 *
 * The default (unenrolled) order is preserved when the experiment is disabled.
 */ const $9abf739da8d121fb$var$reorderConfluenceAboveHelpUsImprove = (webSections)=>{
    const helpIndex = webSections.indexOf($9abf739da8d121fb$var$HELP_US_IMPROVE_SECTION);
    const confluenceIndex = webSections.indexOf($9abf739da8d121fb$var$CONFLUENCE_SECTION);
    if (helpIndex === -1 || confluenceIndex === -1 || confluenceIndex < helpIndex) return webSections;
    const reordered = webSections.slice();
    const [confluenceSection] = reordered.splice(confluenceIndex, 1);
    const insertAt = reordered.indexOf($9abf739da8d121fb$var$HELP_US_IMPROVE_SECTION);
    reordered.splice(insertAt, 0, confluenceSection);
    return reordered;
};
// eslint-disable-next-line check-i18n-id-prefix/i18n-id-prefix-with-package-name-defineMessages
const $9abf739da8d121fb$var$i18n = (0, $kSwu1.defineMessages)({
    'system.user/adg3-section': {
        id: "navigation.help.us.improve",
        defaultMessage: "Help us improve"
    },
    'system.user/user-content': {
        id: "navigation.adg3.user.profile.user-content",
        defaultMessage: "Confluence"
    },
    'system.help/pages': {
        id: "navigation.help.name",
        defaultMessage: "Help"
    },
    'system.help/pages/legal-section': {
        id: "navigation.system.help.legal",
        defaultMessage: "Legal"
    }
});
const $9abf739da8d121fb$export$fb03cba5560d3c7b = (webItems, webSections, options)=>{
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const items = [];
    if (webItems && webItems.length) {
        const groupedSections = (0, (/*@__PURE__*/$parcel$interopDefault($gAlT6)))(webItems, 'section');
        const orderedWebSections = (0, $6mKj3.expVal)('confluence_profile_menu_personal_space_icon', 'isEnabled', false) ? $9abf739da8d121fb$var$reorderConfluenceAboveHelpUsImprove(webSections) : webSections;
        orderedWebSections.forEach((sectionName)=>{
            if (!sectionName) return;
            const webItemRecords = groupedSections[sectionName];
            if (!webItemRecords) return;
            const tempItems = webItemRecords.map((webItemRecord)=>(0, $ce34965c368cb83e$export$62ed5eb75de5c4d9)(webItemRecord, push, options?.userId, webItemRecord.moduleKey && options?.callbackActions ? options?.callbackActions[webItemRecord.moduleKey] : undefined)).filter((item)=>!!item);
            items.push({
                heading: $9abf739da8d121fb$var$i18n.hasOwnProperty(sectionName) ? {
                    ...$9abf739da8d121fb$var$i18n[sectionName]
                } : null,
                items: tempItems
            });
        });
    }
    return items;
};


/* PopupMenuItem.tsx generated by @compiled/babel-plugin v0.40.0 */ 








const $76b9de0c86704e7a$var$styles = null;
const $76b9de0c86704e7a$export$d84e735b83737942 = ({ item: item, onClickHandler: onClickHandler, closeMenu: closeMenu, isSelected: isSelected })=>{
    const ItemComponent = item.component;
    const onKeyPress = (0, $cozmU.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === 'Space') onClickHandler();
    }, [
        onClickHandler
    ]);
    const commonProps = (0, $cozmU.useMemo)(()=>{
        const tabIndex = item.href ? undefined : 0;
        const role = item.href ? undefined : 'link';
        return {
            onClick: onClickHandler,
            closeMenu: closeMenu,
            isSelected: isSelected,
            onKeyPress: // The following 3 attributes are needed for accessibility
            // Otherwise, a link item's onClick is not usable by keyboard
            onKeyPress,
            tabIndex: // Only needed if the href attribute is missing, for accessibility
            tabIndex,
            role: role
        };
    }, [
        onClickHandler,
        isSelected,
        onKeyPress,
        item,
        closeMenu
    ]);
    return ItemComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ItemComponent, {
        item: item,
        ...commonProps
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8oBbn.default), {
        testId: "default-popup-menu-item",
        ...item.href && {
            href: item.href
        },
        target: item.target || undefined,
        iconBefore: item.iconBefore || null,
        iconAfter: item.iconAfter || null,
        ...commonProps,
        className: (0, $hekY6.default)([
            "_1nrm1r31 _1ydc1r31 _c2waglyw _1x28glyw _1iohnqa1 _1726nqa1 _9h8hi7uo _1053i7uo"
        ])
    }, item.content);
};





const $22e97f2cae5620a3$var$AccountMenuTrashedPersonalSpacesQuery = (0, $9d6b1a9db83da49f$export$2e2bcd8739ae039);
/* Excluded web items include 'confluence.user.menu:user-favourites' (carried over from ProfileMenu)
 * as well as web items that are already supported by the platform Account Menu.
 * We are passing in an excluded list instead of an included list to avoid missing any web items.
 * Currently expected web items include the following:
 * - com.atlassian.confluence.plugins.confluence-frontend-support:adg3-give-feedback
 * - confluence.user.menu:create-personal-space
 * - confluence.user.menu:personal-space
 * - confluence.user.menu:admin-restore-personal-space
 * - com.atlassian.confluence.plugins.confluence-inline-tasks:my-tasks-menu-item
 * - confluence.user.menu:settings
 * - com.atlassian.plugins.atlassian-connect-plugin:confluence-chats-integration__profile
 * - extension points (begin with com.atlassian.plugins.atlassian-connect-plugin:connect-playground-confluence)
 */ const $22e97f2cae5620a3$var$EXCLUDED_WEB_ITEMS = [
    'confluence.user.menu:user-favourites',
    'confluence.user.menu:user-profile',
    'confluence.user.menu:user-theme',
    'confluence.user.menu:logout'
];
const $22e97f2cae5620a3$var$getManageAccountUrl = (destinationAccountEmail, environment)=>{
    const loginLink = (0, $jEeDd.getLoginLink)($22e97f2cae5620a3$var$getAtlassianPersonalSettingsLink(environment));
    return `${loginLink}&login_hint=${encodeURIComponent(destinationAccountEmail)}&prompt=none`;
};
const $22e97f2cae5620a3$var$getSwitchAccountUrl = ()=>{
    const loginLink = (0, $jEeDd.getLoginLink)();
    return `${loginLink}&prompt=select_account`;
};
const $22e97f2cae5620a3$var$manageProfileUrlSuffix = 'manage-profile/profile-and-visibility';
const $22e97f2cae5620a3$var$getAtlassianPersonalSettingsLink = (environment)=>{
    if ((0, $i3S9F.isIsolatedCloud)()) // dynamically generate identity URL based on IC shard (defined in /confluence/next/tools/config/env/)
    return `https://${"id.atlassian.com"}/${$22e97f2cae5620a3$var$manageProfileUrlSuffix}`;
    else return environment === 'PRODUCTION' ? `https://id.atlassian.com/${$22e97f2cae5620a3$var$manageProfileUrlSuffix}` : `https://id.stg.internal.atlassian.com/${$22e97f2cae5620a3$var$manageProfileUrlSuffix}`;
};
const $22e97f2cae5620a3$var$AccountMenuComponent = /*#__PURE__*/ (0, $cozmU.memo)(({ user: user, webItems: webItems, webSections: webSections, dialogFn: dialogFn, flags: flags })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    const getThemePreference = (0, $cozmU.useCallback)(()=>(0, $ictHB.fetchGlobalColorMode)(user?.id), [
        user?.id
    ]);
    const [globalColorMode, loadGlobalColorModeOnce] = (0, $2YyKb.useColorModeState)(getThemePreference, user?.id);
    const userId = user?.id || '';
    const profileIconUrl = user?.photos?.[0]?.value || '';
    const accountEmail = user?.emails?.[0]?.value || '';
    const accountDisplayName = user?.displayName || '';
    const manageAccountUrl = $22e97f2cae5620a3$var$getManageAccountUrl(accountEmail, environment);
    const switchAccountUrl = $22e97f2cae5620a3$var$getSwitchAccountUrl();
    const [themeState, themingActions] = (0, $7J5Uc.useThemingState)();
    const persistentUpgradeMenuSection = (0, $55c779eece50e78c$export$17da940073c80266)();
    const [itemSelected, setItemSelected] = (0, $cozmU.useState)(undefined);
    // if webItems has 'admin-restore-personal-space', then we need to call the query to get the trashed personal space data
    const hasTrashedPersonalSpace = webItems.some((obj)=>obj.completeKey === 'confluence.user.menu:admin-restore-personal-space');
    const { data: data } = (0, $jMyy4.useQueryInterop)($22e97f2cae5620a3$var$AccountMenuTrashedPersonalSpacesQuery, {
        skip: !hasTrashedPersonalSpace,
        variables: {
            creatorAccountIds: [
                userId || ''
            ]
        },
        __callerPackage__: "nav-menus"
    });
    const node = data?.spaces?.nodes?.[0];
    const spaceKey = node?.key || '';
    const spaceId = node?.id || '';
    const spaceAlias = node?.alias || '';
    const { handleRestoreClick: handleRestoreClick } = (0, $471b21c5f758aa1c$export$9d49f71132b637a1)({
        spaceKey: spaceKey,
        spaceAlias: spaceAlias,
        spaceId: spaceId,
        flags: flags,
        source: 'profileMenu'
    });
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const callbackActions = {
        'user-theme': ()=>{
            itemSelected === 'user-theme' ? setItemSelected(undefined) : setItemSelected('user-theme');
        },
        'admin-restore-personal-space': ()=>handleRestoreClick(),
        'personal-space': ()=>{
            createEvent({
                type: 'sendUIEvent',
                data: {
                    source: 'profileMenu',
                    action: 'clicked',
                    actionSubject: 'menuItem',
                    actionSubjectId: 'personalSpace'
                }
            }).fire();
        }
    };
    const menuItems = (0, $9abf739da8d121fb$export$fb03cba5560d3c7b)(webItems, webSections, {
        userId: userId,
        callbackActions: callbackActions
    });
    const accountMenuItems = [
        ...persistentUpgradeMenuSection,
        ...menuItems
    ];
    const getSectionTitle = (group)=>{
        if (group.heading) {
            if (typeof group.heading === 'string') return group.heading;
            else return formatMessage(group.heading);
        } else return undefined;
    };
    const onLogoutClickCallback = (_event, _analyticsEvent)=>{
        if ((0, $6mKj3.expVal)('platform_editor_offline_editing_web', 'isEnabled', false)) (0, $7567c74a2233d8d4$export$1fe43c489c085f15)();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c4929546710fc52$export$a63b6ac98b2ba9a8), {
        globalColorMode: (0, $9wGTI.fg)('shared-user-preferences') ? globalColorMode : undefined,
        onThemeSwitcherOpenChange: loadGlobalColorModeOnce,
        testId: "confluence-account-menu",
        name: accountDisplayName,
        picture: profileIconUrl,
        trustPicture: true,
        email: accountEmail,
        viewProfileLink: "/wiki/users/viewmyprofile.action",
        manageProfileLink: manageAccountUrl,
        logOutLink: "/wiki/logout.action",
        currentTheme: themeState?.theme?.colorMode,
        onThemeChange: themingActions.setColorModePreference,
        switchAccountLink: switchAccountUrl,
        onLogoutClick: onLogoutClickCallback,
        extraMenuItems: accountMenuItems.map((group)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), {
                key: getSectionTitle(group),
                hasSeparator: true,
                title: getSectionTitle(group)
            }, group.items.map((item)=>{
                const itemGetDialog = item.hasOwnProperty('getDialog') ? item.getDialog : null;
                const dialogHandler = itemGetDialog ? ()=>{
                    dialogFn(itemGetDialog);
                } : null;
                const onClick = item.action || dialogHandler;
                const closeAction = item.closeAction;
                const onClickHandler = ()=>{
                    if (closeAction) closeAction();
                    if (onClick) onClick();
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $76b9de0c86704e7a$export$d84e735b83737942), {
                    key: item.key,
                    item: item,
                    onClickHandler: onClickHandler,
                    closeMenu: closeAction || (()=>{}),
                    isSelected: itemSelected === item.key
                });
            })))
    });
});
const $22e97f2cae5620a3$export$ff20d75d5eda4388 = /*#__PURE__*/ (0, $cozmU.memo)(({ user: user, dialogFn: dialogFn })=>{
    const { webItems: webItems, webSections: webSections } = (0, $6ld6a.useWebItemLocation)({
        location: (0, $eSLr0.SYSTEM_USER),
        notAllowedWebItems: $22e97f2cae5620a3$var$EXCLUDED_WEB_ITEMS
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $kRW4Y.DialogsStateContainer),
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (dialogs, flags)=>{
        const accountMenuProps = {
            user: user,
            dialogFn: dialogFn,
            webItems: webItems,
            webSections: webSections,
            dialogs: dialogs,
            flags: flags
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22e97f2cae5620a3$var$AccountMenuComponent, accountMenuProps));
    });
});


const $e40e4f4e333d3274$export$6d6e8f8ac62271dd = (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { user: user } = t0;
    const [activeDialog, setActiveDialog] = (0, $cozmU.useState)(null);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            setActiveDialog(null);
        };
        $[0] = t1;
    } else t1 = $[0];
    const closeDialog = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (dialog)=>{
            setActiveDialog(dialog(closeDialog));
        };
        $[1] = t2;
    } else t2 = $[1];
    const openDialog = t2;
    const preloadMenu = $e40e4f4e333d3274$var$_temp;
    const t3 = user.id ?? null;
    const t4 = user.displayName ?? null;
    let t5;
    if ($[2] !== user.emails) {
        t5 = user.emails?.map($e40e4f4e333d3274$var$_temp2) || null;
        $[2] = user.emails;
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== user.photos) {
        t6 = user.photos?.map($e40e4f4e333d3274$var$_temp3) || null;
        $[4] = user.photos;
        $[5] = t6;
    } else t6 = $[5];
    let t7;
    if ($[6] !== t3 || $[7] !== t4 || $[8] !== t5 || $[9] !== t6) {
        t7 = {
            id: t3,
            displayName: t4,
            emails: t5,
            photos: t6
        };
        $[6] = t3;
        $[7] = t4;
        $[8] = t5;
        $[9] = t6;
        $[10] = t7;
    } else t7 = $[10];
    const accountMenuUser = t7;
    let t8;
    if ($[11] !== accountMenuUser) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onMouseEnter: preloadMenu,
            onFocus: preloadMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22e97f2cae5620a3$export$ff20d75d5eda4388), {
            user: accountMenuUser,
            dialogFn: openDialog
        }));
        $[11] = accountMenuUser;
        $[12] = t8;
    } else t8 = $[12];
    let t9;
    if ($[13] !== activeDialog) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aRGok.default), null, activeDialog);
        $[13] = activeDialog;
        $[14] = t9;
    } else t9 = $[14];
    let t10;
    if ($[15] !== t8 || $[16] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t8, t9);
        $[15] = t8;
        $[16] = t9;
        $[17] = t10;
    } else t10 = $[17];
    return t10;
};
function $e40e4f4e333d3274$var$_temp() {
    (0, $c0dbaa4ed1720915$export$5ca34e43e28ce619)();
}
function $e40e4f4e333d3274$var$_temp2(email) {
    return {
        value: email?.value || null
    };
}
function $e40e4f4e333d3274$var$_temp3(photo) {
    return {
        value: photo?.value || null
    };
}



var $3yPEN = parcelRequire("3yPEN");

/* CreateComponent.tsx generated by @compiled/babel-plugin v0.40.0 */ 












var $lpNn5 = parcelRequire("lpNn5");








var $4ri4I = parcelRequire("4ri4I");


var $7NoF3 = parcelRequire("7NoF3");





var $fZAJP = parcelRequire("fZAJP");








var $dkIiA = parcelRequire("dkIiA");














var $gtMdU = parcelRequire("gtMdU");








var $jN02e = parcelRequire("jN02e");











var $5Dlqn = parcelRequire("5Dlqn");


var $7akNQ = parcelRequire("7akNQ");


var $3ePvn = parcelRequire("3ePvn");

var $iBJls = parcelRequire("iBJls");


var $cOW5t = parcelRequire("cOW5t");





var $a1L5E = parcelRequire("a1L5E");


var $fAint = parcelRequire("fAint");

function $36b931e3f96158c0$export$a546442f39c56898({ id: id, children: children }) {
    const experienceObj = (0, $fAint.NavigationExperienceId)[id];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: experienceObj.experienceId
    }, children);
}



var $d5gEx = parcelRequire("d5gEx");


var $8s4b7 = parcelRequire("8s4b7");


var $2Po8s = parcelRequire("2Po8s");











var $eq1BO = parcelRequire("eq1BO");

const $42b04d9ecb159817$export$63b55d605f8a2340 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function AnalyticsWrapper(t0) {
    const $ = (0, $bDgLe.c)(3);
    const { children: children } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "topNav"
        };
        $[0] = t1;
    } else t1 = $[0];
    let t2;
    if ($[1] !== children) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $eq1BO.NavigationAnalyticsContext), {
            data: t1
        }, children);
        $[1] = children;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
} : function AnalyticsWrapper({ children: children }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $eq1BO.NavigationAnalyticsContext), {
        data: {
            source: 'topNav'
        }
    }, children);
};












var $6SsN4 = parcelRequire("6SsN4");


var $4nIKB = parcelRequire("4nIKB");


var $5wHqn = parcelRequire("5wHqn");


var $ghNlj = parcelRequire("ghNlj");


var $bPFqZ = parcelRequire("bPFqZ");








var $57EeW = parcelRequire("57EeW");














var $cbY7C = parcelRequire("cbY7C");

const $2d9f02b381e5e3ee$export$46ec6629f411921d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useClickToCloseRef(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { isOpen: isOpen, handleClose: handleClose } = t0;
    const ref = (0, $cozmU.useRef)(null);
    let t1;
    let t2;
    if ($[0] !== handleClose || $[1] !== isOpen) {
        t1 = ()=>{
            const el = ref.current;
            if (!el) return;
            const unbind = (0, $cbY7C.bind)(el, {
                type: "click",
                listener: (e)=>{
                    if (isOpen) {
                        e.stopPropagation();
                        handleClose(e);
                    }
                }
            });
            return unbind;
        };
        t2 = [
            isOpen,
            handleClose
        ];
        $[0] = handleClose;
        $[1] = isOpen;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return ref;
} : function useClickToCloseRef({ isOpen: isOpen, handleClose: handleClose }) {
    const ref = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        const el = ref.current;
        if (!el) return;
        const unbind = (0, $cbY7C.bind)(el, {
            type: 'click',
            listener: (e)=>{
                if (isOpen) {
                    e.stopPropagation();
                    handleClose(e);
                }
            }
        });
        return unbind;
    }, [
        isOpen,
        handleClose
    ]);
    return ref;
};















var $6pXoc = parcelRequire("6pXoc");





var $gSwt1 = parcelRequire("gSwt1");








var $fhY2W = parcelRequire("fhY2W");




var $eSVwn = parcelRequire("eSVwn");

const $5ffeac46c0386cde$export$61de563e38fe014d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFetchUser() {
    const $ = (0, $bDgLe.c)(3);
    const { user: currentUser } = (0, $iBJls.useUserContext)();
    const { fetchUser: fetchUser } = (0, $fhY2W.useFetchUser)();
    let t0;
    if ($[0] !== currentUser || $[1] !== fetchUser) {
        const fetchUserIfNeeded = (t1)=>{
            const { items: items, sections: sections } = t1;
            if (currentUser) return;
            if (items) {
                const willNeedUser = items.some($5ffeac46c0386cde$var$_temp);
                if (willNeedUser) fetchUser();
            }
            if (sections && Array.isArray(sections)) {
                const willNeedUser_0 = sections.some($5ffeac46c0386cde$var$_temp3);
                if (willNeedUser_0) fetchUser();
            }
        };
        t0 = {
            fetchUserIfNeeded: fetchUserIfNeeded
        };
        $[0] = currentUser;
        $[1] = fetchUser;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
} : function useFetchUser() {
    const { user: currentUser } = (0, $iBJls.useUserContext)();
    const { fetchUser: fetchUser } = (0, $fhY2W.useFetchUser)();
    /**
   * Conditionally fetches user data if menu items require it.
   * Supports both V1 (flat items array) and V2 (sections with items) data structures.
   *
   * @param params - Object containing either items array or sections array
   */ const fetchUserIfNeeded = ({ items: items, sections: sections })=>{
        // Skip if user already available
        if (currentUser) return;
        // Check V1 format (flat items array)
        if (items) {
            const willNeedUser = items.some((item)=>{
                return item.ati && (0, $eSVwn.REQUIRED_USER_ITEMS).includes(item.ati);
            });
            if (willNeedUser) fetchUser();
        }
        // Check V2 format (sections with items)
        if (sections && Array.isArray(sections)) {
            const willNeedUser_0 = sections.some((section)=>Array.isArray(section.items) && section.items.some((item_0)=>item_0 && item_0.ati && (0, $eSVwn.REQUIRED_USER_ITEMS).includes(item_0.ati)));
            if (willNeedUser_0) fetchUser();
        }
    };
    return {
        fetchUserIfNeeded: fetchUserIfNeeded
    };
};
function $5ffeac46c0386cde$var$_temp3(section) {
    return Array.isArray(section.items) && section.items.some($5ffeac46c0386cde$var$_temp2);
}
function $5ffeac46c0386cde$var$_temp2(item_0) {
    return item_0 && item_0.ati && (0, $eSVwn.REQUIRED_USER_ITEMS).includes(item_0.ati);
}
function $5ffeac46c0386cde$var$_temp(item) {
    return item.ati && (0, $eSVwn.REQUIRED_USER_ITEMS).includes(item.ati);
}






var $fULE8 = parcelRequire("fULE8");









function $f63b28152646dbae$export$c1b17113cb5b0556() {
    const loadPromiseRef = (0, $cozmU.useRef)(null);
    const experienceTracker = (0, $cozmU.useContext)((0, $fULE8.ExperienceTrackerContext));
    const { product: product, suggestionConfig: suggestionConfig, crossAppCreationConfig: crossAppCreationConfig } = (0, $8s4b7.useMenuStateContext)();
    const triggerPrefetch = (0, $cozmU.useCallback)(()=>{
        if (loadPromiseRef.current) return;
        // Only load if either suggestion config or cross-app creation is enabled
        if (!suggestionConfig.enabled && !crossAppCreationConfig?.enabled) return;
        const { cloudId: cloudId, environment: environment } = crossAppCreationConfig?.enabled ? crossAppCreationConfig : suggestionConfig.enabled ? suggestionConfig : {};
        const finalEnvironment = environment || 'prod';
        const loadingPromise = (async ()=>{
            try {
                if (cloudId) {
                    const [{ initLoomSDK: initLoomSDK }, { convertSourceProductToProductType: convertSourceProductToProductType }] = await Promise.all([
                        (parcelRequire("8xBhK")),
                        (parcelRequire("9Mf9v"))
                    ]);
                    await initLoomSDK({
                        environment: finalEnvironment,
                        cloudId: cloudId,
                        productName: convertSourceProductToProductType(product),
                        experienceTracker: experienceTracker,
                        entryPointLocation: (0, $eSVwn.SOURCE_LOCATION)
                    });
                }
            } catch  {
            // ignore
            }
        })();
        loadPromiseRef.current = loadingPromise;
    }, [
        experienceTracker,
        product,
        suggestionConfig,
        crossAppCreationConfig
    ]);
    return {
        triggerPrefetch: triggerPrefetch
    };
}


const $14d3a4da86131298$export$4dcd17e50290e364 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function usePrefetch() {
    const $ = (0, $bDgLe.c)(25);
    const { sections: sections, product: product, subProduct: subProduct, crossAppCreationConfig: crossAppCreationConfig } = (0, $8s4b7.useMenuStateContext)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const shouldSkip = !crossAppCreationConfig.enabled;
    const shouldFetchData = !shouldSkip && crossAppCreationConfig.enabled && crossAppCreationConfig.prefetch === true;
    const { triggerPrefetch: triggerPrefetchLoom } = (0, $f63b28152646dbae$export$c1b17113cb5b0556)();
    let t0;
    if ($[0] !== sections) {
        t0 = (0, $gSwt1.sectionsToAppMenuConfig)(sections);
        $[0] = sections;
        $[1] = t0;
    } else t0 = $[1];
    const appMenuConfig = t0;
    const { fetchUserIfNeeded: fetchUserIfNeeded } = (0, $5ffeac46c0386cde$export$61de563e38fe014d)();
    const t1 = crossAppCreationConfig.enabled ? crossAppCreationConfig.cloudId : "";
    const t2 = crossAppCreationConfig.enabled ? crossAppCreationConfig.orgId : "";
    const t3 = crossAppCreationConfig.enabled ? crossAppCreationConfig.accountId : "";
    const t4 = !shouldFetchData;
    let t5;
    if ($[2] !== appMenuConfig || $[3] !== locale || $[4] !== product || $[5] !== subProduct || $[6] !== t1 || $[7] !== t2 || $[8] !== t3 || $[9] !== t4) {
        t5 = {
            cloudId: t1,
            orgId: t2,
            userId: t3,
            product: product,
            locale: locale,
            subProduct: subProduct,
            appMenuConfig: appMenuConfig,
            skipInitialization: t4
        };
        $[2] = appMenuConfig;
        $[3] = locale;
        $[4] = product;
        $[5] = subProduct;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    const { data: data, fetchUCMenuItems: fetchUCMenuItems } = (0, $6pXoc.useUCMenuItems)(t5);
    const prefetchTriggered = (0, $cozmU.useRef)(false);
    const userFetchTriggered = (0, $cozmU.useRef)(false);
    let t6;
    if ($[11] !== fetchUCMenuItems || $[12] !== shouldFetchData || $[13] !== triggerPrefetchLoom) {
        t6 = ()=>{
            if (prefetchTriggered.current || !shouldFetchData) return;
            prefetchTriggered.current = true;
            triggerPrefetchLoom();
            fetchUCMenuItems();
        };
        $[11] = fetchUCMenuItems;
        $[12] = shouldFetchData;
        $[13] = triggerPrefetchLoom;
        $[14] = t6;
    } else t6 = $[14];
    const triggerPrefetch = t6;
    let t7;
    if ($[15] !== data || $[16] !== fetchUserIfNeeded || $[17] !== shouldFetchData) {
        t7 = function fetchUserWhenDataReady() {
            if (!shouldFetchData || !data?.sections || userFetchTriggered.current) return;
            userFetchTriggered.current = true;
            fetchUserIfNeeded({
                sections: data.sections
            });
        };
        $[15] = data;
        $[16] = fetchUserIfNeeded;
        $[17] = shouldFetchData;
        $[18] = t7;
    } else t7 = $[18];
    const t8 = data?.sections;
    let t9;
    if ($[19] !== fetchUserIfNeeded || $[20] !== shouldFetchData || $[21] !== t8) {
        t9 = [
            shouldFetchData,
            t8,
            fetchUserIfNeeded
        ];
        $[19] = fetchUserIfNeeded;
        $[20] = shouldFetchData;
        $[21] = t8;
        $[22] = t9;
    } else t9 = $[22];
    (0, $cozmU.useEffect)(t7, t9);
    let t10;
    if ($[23] !== triggerPrefetch) {
        t10 = {
            triggerPrefetch: triggerPrefetch
        };
        $[23] = triggerPrefetch;
        $[24] = t10;
    } else t10 = $[24];
    return t10;
} : function usePrefetch() {
    const { sections: sections, product: product, subProduct: subProduct, crossAppCreationConfig: crossAppCreationConfig } = (0, $8s4b7.useMenuStateContext)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const shouldSkip = !crossAppCreationConfig.enabled;
    const shouldFetchData = !shouldSkip && crossAppCreationConfig.enabled && crossAppCreationConfig.prefetch === true;
    const { triggerPrefetch: triggerPrefetchLoom } = (0, $f63b28152646dbae$export$c1b17113cb5b0556)();
    const appMenuConfig = (0, $cozmU.useMemo)(()=>(0, $gSwt1.sectionsToAppMenuConfig)(sections), [
        sections
    ]);
    const { fetchUserIfNeeded: fetchUserIfNeeded } = (0, $5ffeac46c0386cde$export$61de563e38fe014d)();
    /**
   * Fetching menu items
   */ const { data: data, fetchUCMenuItems: fetchUCMenuItems } = (0, $6pXoc.useUCMenuItems)({
        cloudId: crossAppCreationConfig.enabled ? crossAppCreationConfig.cloudId : '',
        orgId: crossAppCreationConfig.enabled ? crossAppCreationConfig.orgId : '',
        userId: crossAppCreationConfig.enabled ? crossAppCreationConfig.accountId : '',
        product: product,
        locale: locale,
        subProduct: subProduct,
        appMenuConfig: appMenuConfig,
        skipInitialization: !shouldFetchData
    });
    const prefetchTriggered = (0, $cozmU.useRef)(false);
    const userFetchTriggered = (0, $cozmU.useRef)(false);
    const triggerPrefetch = (0, $cozmU.useCallback)(()=>{
        if (prefetchTriggered.current || !shouldFetchData) return;
        prefetchTriggered.current = true;
        triggerPrefetchLoom();
        fetchUCMenuItems();
    }, [
        shouldFetchData,
        fetchUCMenuItems,
        triggerPrefetchLoom
    ]);
    // Reactively fetch user data when sections become available
    (0, $cozmU.useEffect)(function fetchUserWhenDataReady() {
        if (!shouldFetchData || !data?.sections || userFetchTriggered.current) return;
        userFetchTriggered.current = true;
        fetchUserIfNeeded({
            sections: data.sections
        });
    }, [
        shouldFetchData,
        data?.sections,
        fetchUserIfNeeded
    ]);
    return {
        triggerPrefetch: triggerPrefetch
    };
};


const $90a8b778380ea711$var$emptyEntryPointParams = {};
const $90a8b778380ea711$var$noop = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
function $90a8b778380ea711$var$EntryPointPopupInner({ trigger: trigger, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, onError: onError, forcedReportErrorUFO: forcedReportErrorUFO, isOpen: isOpen, onClose: onClose, ...popupProps }) {
    const environmentProvider = (0, $d5gEx.useRelayEnvironmentProvider)();
    const { preventClose: preventClose, product: product, crossAppCreationConfig: crossAppCreationConfig } = (0, $8s4b7.useMenuStateContext)();
    const isPrefetchEnabled = crossAppCreationConfig.enabled && Boolean(crossAppCreationConfig.prefetch);
    const { triggerPrefetch: triggerPrefetch } = (0, $14d3a4da86131298$export$4dcd17e50290e364)();
    const id = (0, $cozmU.useMemo)(()=>entryPoint.root.getModuleName() || 'unknown', [
        entryPoint
    ]);
    const [content, setContent] = (0, $cozmU.useState)(()=>$90a8b778380ea711$var$noop);
    const contentLoadedRef = (0, $cozmU.useRef)(false);
    const handleClose = (0, $cozmU.useCallback)((event, currentLevel)=>{
        if (product === 'confluence' && preventClose) return;
        onClose?.(event, currentLevel);
        setContent(()=>$90a8b778380ea711$var$noop);
        contentLoadedRef.current = false;
    }, [
        preventClose,
        product,
        onClose
    ]);
    // Compute effective isOpen state based on feature gate
    const isPopupOpen = isOpen ?? false;
    const triggerCloseRef = (0, $2d9f02b381e5e3ee$export$46ec6629f411921d)({
        isOpen: isPopupOpen,
        handleClose: handleClose
    });
    const prevIsOpenRef = (0, $cozmU.useRef)(isPopupOpen);
    const entryPointLoadTriggeredRef = (0, $cozmU.useRef)(false);
    const { fireMenuStateChanged: fireMenuStateChanged, fireEntryPointLoadTriggered: fireEntryPointLoadTriggered } = (0, $57EeW.useUniversalCreateAnalytics)();
    (0, $cozmU.useEffect)(function fireMenuStateChangedEffect() {
        const prevIsOpen = prevIsOpenRef.current;
        // Only fire analytics on actual state transitions (use displayed state)
        if (isPopupOpen !== prevIsOpen) fireMenuStateChanged({
            itemState: isPopupOpen ? 'expanded' : 'collapsed',
            version: 'v2'
        });
        prevIsOpenRef.current = isPopupOpen;
    }, [
        isPopupOpen,
        fireMenuStateChanged,
        prevIsOpenRef
    ]);
    const version = 'v2';
    // on hover callback
    const load = (0, $cozmU.useCallback)((trigger = 'hover')=>{
        if (!entryPointLoadTriggeredRef.current) {
            entryPointLoadTriggeredRef.current = true;
            fireEntryPointLoadTriggered({
                trigger: trigger,
                version: version
            });
        }
        if (isPrefetchEnabled) triggerPrefetch();
        return (0, $6SsN4.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $90a8b778380ea711$var$emptyEntryPointParams);
    }, [
        entryPoint,
        entryPointParams,
        environmentProvider,
        fireEntryPointLoadTriggered,
        isPrefetchEnabled,
        triggerPrefetch,
        version
    ]);
    // on menu loaded callback
    const onLoad = (0, $cozmU.useCallback)(({ reference: entryPointReference })=>{
        // avoid re-loading entry-point when already loaded
        if (contentLoadedRef.current) return;
        contentLoadedRef.current = true;
        setContent(()=>(contentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bPFqZ.InternalEntryPointContainer), {
                    id: id,
                    entryPointReference: entryPointReference,
                    fallback: fallback || null,
                    errorFallback: errorFallback,
                    runtimeProps: {
                        entryPointProps: entryPointProps,
                        onClose: handleClose,
                        contentProps: contentProps
                    },
                    onError: onError,
                    forcedError: forcedReportErrorUFO
                }));
    }, [
        setContent,
        id,
        entryPointProps,
        fallback,
        forcedReportErrorUFO,
        errorFallback,
        onError,
        handleClose
    ]);
    const triggerRef = (0, $ghNlj.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    // Primary button onLoad - preload but don't open popup
    const onLoadPrimary = (0, $cozmU.useCallback)(()=>{
    // Primary button should only preload, NOT open the popup
    // The preloaded reference will be disposed automatically by usePressablePreloadRef
    // The actual click behavior is handled by primaryActionItem.onClick
    }, []);
    // Separate ref for the primary button with ONLY preload functionality (no popup opening)
    const primaryButtonRef = (0, $ghNlj.usePressablePreloadRef)({
        load: load,
        onLoad: onLoadPrimary
    });
    const popupTrigger = (0, $cozmU.useCallback)((triggerProps)=>{
        const mergedRef = (0, $4nIKB.mergeRefs)([
            triggerRef,
            triggerProps.ref,
            triggerCloseRef
        ]);
        return trigger({
            ...triggerProps,
            ref: mergedRef,
            splitButtonPrimaryRef: primaryButtonRef
        });
    }, [
        trigger,
        triggerRef,
        triggerCloseRef,
        primaryButtonRef
    ]);
    const popupContent = (0, $cozmU.useCallback)((contentProps)=>content(contentProps), [
        content
    ]);
    // Track previous values to detect prop changes
    // Initialize as undefined to detect initial render with isOpen={true}
    const prevIsOpenPropRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(function preloadWithControlledOpenState() {
        const isOpenPropChanged = isOpen !== prevIsOpenPropRef.current;
        prevIsOpenPropRef.current = isOpen;
        if (isOpen && isOpenPropChanged && !contentLoadedRef.current) {
            const triggerLoading = ()=>{
                const preloadedRef = load('controlled');
                if (preloadedRef) onLoad({
                    reference: preloadedRef
                });
            };
            const timeoutId = setTimeout(triggerLoading, 0);
            return ()=>clearTimeout(timeoutId);
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5wHqn.Popup), {
        ...popupProps,
        isOpen: isPopupOpen,
        onClose: handleClose,
        trigger: popupTrigger,
        content: popupContent
    });
}
const $90a8b778380ea711$export$8f8a5b7d7394d1f8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EntryPointPopup(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jN02e.GenericErrorBoundary), {
            name: "entry-point-popup"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90a8b778380ea711$var$EntryPointPopupInner, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function EntryPointPopup(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jN02e.GenericErrorBoundary), {
        name: "entry-point-popup"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($90a8b778380ea711$var$EntryPointPopupInner, props));
};



var $cJDAh = parcelRequire("cJDAh");

















var $5SGpQ = parcelRequire("5SGpQ");


var $iV65j = parcelRequire("iV65j");


var $gFEZF = parcelRequire("gFEZF");


var $7sJoX = parcelRequire("7sJoX");


var $l3wuH = parcelRequire("l3wuH");


var $fk0Hw = parcelRequire("fk0Hw");

var $bZTfQ = parcelRequire("bZTfQ");


var $gWLTH = parcelRequire("gWLTH");




var $iDrrr = parcelRequire("iDrrr");


var $2aija = parcelRequire("2aija");

var $kawxu = parcelRequire("kawxu");

var $gm2vG = parcelRequire("gm2vG");














var $6cTr1 = parcelRequire("6cTr1");

const $65a14bf80cc88d67$var$triggerButton = null; /**
                             * Clean up nav3 button once Confluence has cleaned up nav3
                             * https://jplat.atlassian.net/browse/BLU-7401
                             */ 
const $65a14bf80cc88d67$var$nav3ButtonTextStyles = null;
const $65a14bf80cc88d67$var$messages = (0, $kSwu1.defineMessages)({
    secondaryButtonTooltipText: {
        id: "platform.navigation-experiences.universal-create.secondary-tooltip-text",
        defaultMessage: "More create options"
    }
});
const $65a14bf80cc88d67$var$TooltipWrapper = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TooltipWrapper(t0) {
    const $ = (0, $bDgLe.c)(4);
    const { children: children, text: text, isScreenReaderAnnouncementDisabled: t1 } = t0;
    const isScreenReaderAnnouncementDisabled = t1 === undefined ? true : t1;
    let t2;
    if ($[0] !== children || $[1] !== isScreenReaderAnnouncementDisabled || $[2] !== text) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
            content: text,
            tag: "span",
            isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled,
            position: "bottom",
            ignoreTooltipPointerEvents: true
        }, children);
        $[0] = children;
        $[1] = isScreenReaderAnnouncementDisabled;
        $[2] = text;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
} : function TooltipWrapper({ children: children, text: text, isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled = true }) {
    return /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
        content: text,
        tag: "span",
        isScreenReaderAnnouncementDisabled: isScreenReaderAnnouncementDisabled,
        position: "bottom",
        ignoreTooltipPointerEvents: true
    }, children);
};
const $65a14bf80cc88d67$var$TriggerButtonInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function TriggerButtonInner(t0) {
    const $ = (0, $bDgLe.c)(84);
    const { triggerProps: triggerProps, testId: testId, onClick: onClick, children: children, isOpen: t1, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, enableTriggerPulse: enableTriggerPulse, isNav4Enabled: t2, buttonTheme: buttonTheme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, primaryActionItem: primaryActionItem, isEntryPointEnabled: t3, buttonOnly: t4 } = t0;
    const isOpen = t1 === undefined ? false : t1;
    const isNav4Enabled = t2 === undefined ? true : t2;
    const isEntryPointEnabled = t3 === undefined ? false : t3;
    const buttonOnly = t4 === undefined ? false : t4;
    const isButtonOnly = buttonOnly;
    const { product: product, sections: sections } = (0, $8s4b7.useUniversalCreateState)();
    const { fireCreateButtonClicked: fireCreateButtonClicked, fireCreateButtonHovered: fireCreateButtonHovered, fireCreateButtonViewed: fireCreateButtonViewed } = (0, $57EeW.useUniversalCreateAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isDesktop = (0, $gm2vG.UNSAFE_useMediaQuery)("above.sm")?.matches ?? false;
    const version = sections?.length ? "v2" : "v1";
    const hasHoveredRef = (0, $cozmU.useRef)(false);
    const isSplitButton = Boolean(primaryActionItem);
    const buttonVariant = isSplitButton ? "split" : "standard";
    const hasFiredViewEvent = (0, $cozmU.useRef)(false);
    let t5;
    let t6;
    if ($[0] !== buttonVariant || $[1] !== fireCreateButtonViewed || $[2] !== isButtonOnly || $[3] !== version) {
        t5 = function fireButtonViewEvent() {
            if (hasFiredViewEvent.current) return;
            hasFiredViewEvent.current = true;
            fireCreateButtonViewed({
                buttonVariant: buttonVariant,
                version: version,
                isButtonOnly: isButtonOnly
            });
        };
        t6 = [
            fireCreateButtonViewed,
            buttonVariant,
            version,
            isButtonOnly
        ];
        $[0] = buttonVariant;
        $[1] = fireCreateButtonViewed;
        $[2] = isButtonOnly;
        $[3] = version;
        $[4] = t5;
        $[5] = t6;
    } else {
        t5 = $[4];
        t6 = $[5];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[6] !== triggerProps) {
        t7 = triggerProps ?? {};
        $[6] = triggerProps;
        $[7] = t7;
    } else t7 = $[7];
    let restTriggerProps;
    let splitButtonPrimaryRef;
    if ($[8] !== t7) {
        ({ splitButtonPrimaryRef: splitButtonPrimaryRef, ...restTriggerProps } = t7);
        $[8] = t7;
        $[9] = restTriggerProps;
        $[10] = splitButtonPrimaryRef;
    } else {
        restTriggerProps = $[9];
        splitButtonPrimaryRef = $[10];
    }
    let t8;
    if ($[11] !== fireCreateButtonClicked || $[12] !== isButtonOnly || $[13] !== isEntryPointEnabled || $[14] !== isOpen || $[15] !== isSplitButton || $[16] !== onClick) {
        t8 = ()=>{
            const itemState = isButtonOnly ? "button-only" : isEntryPointEnabled === isOpen ? "expanded" : "collapsed";
            const clickedButtonPart = isSplitButton ? "dropdown" : "full";
            const clickedButtonVariant = isSplitButton ? "split" : "standard";
            fireCreateButtonClicked({
                itemState: itemState,
                buttonPart: clickedButtonPart,
                buttonVariant: clickedButtonVariant
            });
            onClick();
        };
        $[11] = fireCreateButtonClicked;
        $[12] = isButtonOnly;
        $[13] = isEntryPointEnabled;
        $[14] = isOpen;
        $[15] = isSplitButton;
        $[16] = onClick;
        $[17] = t8;
    } else t8 = $[17];
    const onButtonClick = t8;
    const primaryItemOnClick = primaryActionItem?.onClick;
    let t9;
    if ($[18] !== fireCreateButtonClicked || $[19] !== isEntryPointEnabled || $[20] !== isOpen || $[21] !== primaryItemOnClick) {
        t9 = (event)=>{
            const itemState_0 = isEntryPointEnabled === isOpen ? "expanded" : "collapsed";
            fireCreateButtonClicked({
                itemState: itemState_0,
                buttonPart: "primary",
                buttonVariant: "split"
            });
            primaryItemOnClick?.(event);
        };
        $[18] = fireCreateButtonClicked;
        $[19] = isEntryPointEnabled;
        $[20] = isOpen;
        $[21] = primaryItemOnClick;
        $[22] = t9;
    } else t9 = $[22];
    const onPrimaryButtonClick = t9;
    const CreateIcon = isButtonOnly ? (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))) : isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))) : (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF)));
    let t10;
    if ($[23] !== buttonVariant || $[24] !== fireCreateButtonHovered || $[25] !== isButtonOnly || $[26] !== isEntryPointEnabled || $[27] !== isOpen || $[28] !== onMouseEnter || $[29] !== version) {
        t10 = (t11)=>{
            const { buttonPart: buttonPart, shouldTriggerMouseEnterProp: t12 } = t11;
            const shouldTriggerMouseEnterProp = t12 === undefined ? true : t12;
            return (event_0)=>{
                if (!hasHoveredRef.current) {
                    hasHoveredRef.current = true;
                    const itemState_1 = isButtonOnly ? "button-only" : isEntryPointEnabled === isOpen ? "expanded" : "collapsed";
                    fireCreateButtonHovered({
                        buttonPart: buttonPart,
                        buttonVariant: buttonVariant,
                        itemState: itemState_1,
                        version: version
                    });
                }
                if (shouldTriggerMouseEnterProp) onMouseEnter?.(event_0);
            };
        };
        $[23] = buttonVariant;
        $[24] = fireCreateButtonHovered;
        $[25] = isButtonOnly;
        $[26] = isEntryPointEnabled;
        $[27] = isOpen;
        $[28] = onMouseEnter;
        $[29] = version;
        $[30] = t10;
    } else t10 = $[30];
    const createEnterEvent = t10;
    let t11;
    if ($[31] !== createEnterEvent) {
        t11 = createEnterEvent({
            buttonPart: "full"
        });
        $[31] = createEnterEvent;
        $[32] = t11;
    } else t11 = $[32];
    const enterEvent = t11;
    let t12;
    if ($[33] !== createEnterEvent) {
        t12 = createEnterEvent({
            buttonPart: "primary"
        });
        $[33] = createEnterEvent;
        $[34] = t12;
    } else t12 = $[34];
    const enterEventPrimary = t12;
    let t13;
    if ($[35] !== createEnterEvent) {
        t13 = createEnterEvent({
            buttonPart: "dropdown"
        });
        $[35] = createEnterEvent;
        $[36] = t13;
    } else t13 = $[36];
    const enterEventDropdown = t13;
    let t14;
    if ($[37] !== onMouseLeave) {
        t14 = (event_1)=>{
            onMouseLeave?.(event_1);
        };
        $[37] = onMouseLeave;
        $[38] = t14;
    } else t14 = $[38];
    const leaveEvent = t14;
    let t15;
    if ($[39] !== CreateIcon || $[40] !== buttonTheme || $[41] !== children || $[42] !== enterEvent || $[43] !== isNav4Enabled || $[44] !== isOpen || $[45] !== leaveEvent || $[46] !== onButtonClick || $[47] !== product || $[48] !== restTriggerProps || $[49] !== testId) {
        t15 = !isNav4Enabled ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_12y21ule _uis9u2gc _1rrju2gc _15nzidpf _dlu2idpf"
            ])
        }, product === "confluence" ? /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_x0l4u2gc _19ywu2gc _1xc3idpf _pj60idpf _muvxglyw"
            ])
        }, /*#__PURE__*/ $cozmU.createElement((0, $5SGpQ.default), {
            ...restTriggerProps,
            appearance: "primary",
            theme: buttonTheme,
            onMouseEnter: enterEvent,
            onMouseLeave: leaveEvent,
            onClick: onButtonClick,
            iconBefore: /*#__PURE__*/ $cozmU.createElement(CreateIcon, {
                label: "",
                "data-vc": "global-content-create-button"
            }),
            testId: testId || (0, $eSVwn.TRIGGER_BUTTON_TEST_ID),
            "aria-label": children,
            isSelected: isOpen
        }, /*#__PURE__*/ $cozmU.createElement((0, $kawxu.Show), {
            above: "sm",
            as: "span"
        }, children))) : /*#__PURE__*/ $cozmU.createElement($65a14bf80cc88d67$var$TooltipWrapper, {
            text: children
        }, /*#__PURE__*/ $cozmU.createElement((0, $fk0Hw.Button), {
            ...restTriggerProps,
            appearance: "primary",
            onClick: onButtonClick,
            onMouseEnter: enterEvent,
            onMouseLeave: leaveEvent,
            isSelected: isOpen,
            iconBefore: CreateIcon,
            testId: testId || (0, $eSVwn.TRIGGER_BUTTON_TEST_ID),
            "aria-label": children
        }, /*#__PURE__*/ $cozmU.createElement((0, $kawxu.Show), {
            above: "sm",
            as: "span"
        }, children)))) : null;
        $[39] = CreateIcon;
        $[40] = buttonTheme;
        $[41] = children;
        $[42] = enterEvent;
        $[43] = isNav4Enabled;
        $[44] = isOpen;
        $[45] = leaveEvent;
        $[46] = onButtonClick;
        $[47] = product;
        $[48] = restTriggerProps;
        $[49] = testId;
        $[50] = t15;
    } else t15 = $[50];
    const nav3Button = t15;
    let t16;
    if ($[51] !== CreateIcon || $[52] !== children || $[53] !== enterEvent || $[54] !== isDesktop || $[55] !== isNav4Enabled || $[56] !== isOpen || $[57] !== leaveEvent || $[58] !== onButtonClick || $[59] !== restTriggerProps || $[60] !== testId) {
        t16 = isNav4Enabled ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $kawxu.Show), {
            above: (0, $eSVwn.RESPONSIVE_BREAKPOINT),
            as: "span"
        }, /*#__PURE__*/ $cozmU.createElement($65a14bf80cc88d67$var$TooltipWrapper, {
            text: children
        }, /*#__PURE__*/ $cozmU.createElement((0, $fk0Hw.Button), {
            ...isDesktop ? restTriggerProps : {},
            appearance: "primary",
            onClick: onButtonClick,
            onMouseEnter: enterEvent,
            onMouseLeave: leaveEvent,
            isSelected: isOpen,
            iconBefore: CreateIcon,
            testId: testId || (0, $eSVwn.TRIGGER_BUTTON_TEST_ID),
            "aria-label": children,
            "data-responsive-variant": "desktop"
        }, children))), /*#__PURE__*/ $cozmU.createElement((0, $2aija.Hide), {
            above: (0, $eSVwn.RESPONSIVE_BREAKPOINT),
            as: "span"
        }, /*#__PURE__*/ $cozmU.createElement($65a14bf80cc88d67$var$TooltipWrapper, {
            text: children
        }, /*#__PURE__*/ $cozmU.createElement((0, $bZTfQ.IconButton), {
            ...!isDesktop ? restTriggerProps : {},
            appearance: "primary",
            onClick: onButtonClick,
            onMouseEnter: enterEvent,
            onMouseLeave: leaveEvent,
            isSelected: isOpen,
            icon: CreateIcon,
            testId: `${testId || (0, $eSVwn.TRIGGER_BUTTON_TEST_ID)}-mobile`,
            label: children,
            "data-responsive-variant": "mobile"
        })))) : null;
        $[51] = CreateIcon;
        $[52] = children;
        $[53] = enterEvent;
        $[54] = isDesktop;
        $[55] = isNav4Enabled;
        $[56] = isOpen;
        $[57] = leaveEvent;
        $[58] = onButtonClick;
        $[59] = restTriggerProps;
        $[60] = testId;
        $[61] = t16;
    } else t16 = $[61];
    const responsiveSafeButton = t16;
    let t17;
    if ($[62] !== CreateIcon || $[63] !== children || $[64] !== enterEvent || $[65] !== enterEventDropdown || $[66] !== enterEventPrimary || $[67] !== formatMessage || $[68] !== isDesktop || $[69] !== isOpen || $[70] !== leaveEvent || $[71] !== onButtonClick || $[72] !== onPrimaryButtonClick || $[73] !== primaryActionItem || $[74] !== restTriggerProps || $[75] !== splitButtonPrimaryRef || $[76] !== testId) {
        t17 = primaryActionItem ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $kawxu.Show), {
            above: (0, $eSVwn.RESPONSIVE_BREAKPOINT)
        }, /*#__PURE__*/ $cozmU.createElement((0, $iV65j.SplitButton), {
            appearance: "primary"
        }, /*#__PURE__*/ $cozmU.createElement($65a14bf80cc88d67$var$TooltipWrapper, {
            text: children
        }, /*#__PURE__*/ $cozmU.createElement((0, $fk0Hw.Button), {
            ref: splitButtonPrimaryRef,
            appearance: "primary",
            onClick: onPrimaryButtonClick,
            onMouseEnter: enterEventPrimary,
            "aria-label": children,
            testId: "uc-trigger-button-primary"
        }, children)), /*#__PURE__*/ $cozmU.createElement($65a14bf80cc88d67$var$TooltipWrapper, {
            text: formatMessage($65a14bf80cc88d67$var$messages.secondaryButtonTooltipText),
            isScreenReaderAnnouncementDisabled: false
        }, /*#__PURE__*/ $cozmU.createElement((0, $bZTfQ.IconButton), {
            ...isDesktop ? restTriggerProps : {},
            appearance: "primary",
            onClick: onButtonClick,
            isSelected: isOpen,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
            "data-responsive-variant": "desktop",
            label: children,
            testId: `${testId || (0, $eSVwn.TRIGGER_BUTTON_TEST_ID)}-split`,
            onMouseEnter: enterEventDropdown,
            onMouseLeave: leaveEvent
        })))), /*#__PURE__*/ $cozmU.createElement((0, $2aija.Hide), {
            above: "sm"
        }, /*#__PURE__*/ $cozmU.createElement($65a14bf80cc88d67$var$TooltipWrapper, {
            text: children
        }, /*#__PURE__*/ $cozmU.createElement((0, $bZTfQ.IconButton), {
            ...!isDesktop ? restTriggerProps : {},
            appearance: "primary",
            onClick: onButtonClick,
            onMouseEnter: enterEvent,
            onMouseLeave: leaveEvent,
            isSelected: isOpen,
            icon: CreateIcon,
            testId: `${testId || (0, $eSVwn.TRIGGER_BUTTON_TEST_ID)}-mobile`,
            label: children,
            "data-responsive-variant": "mobile"
        })))) : null;
        $[62] = CreateIcon;
        $[63] = children;
        $[64] = enterEvent;
        $[65] = enterEventDropdown;
        $[66] = enterEventPrimary;
        $[67] = formatMessage;
        $[68] = isDesktop;
        $[69] = isOpen;
        $[70] = leaveEvent;
        $[71] = onButtonClick;
        $[72] = onPrimaryButtonClick;
        $[73] = primaryActionItem;
        $[74] = restTriggerProps;
        $[75] = splitButtonPrimaryRef;
        $[76] = testId;
        $[77] = t17;
    } else t17 = $[77];
    const splitButtonVariant = t17;
    const buttonToRender = primaryActionItem ? splitButtonVariant : isNav4Enabled ? responsiveSafeButton : nav3Button;
    if (!(0, $iDrrr.fg)("navx_uc_spotlight_upgrade") && triggerButtonSpotlightTarget) {
        let t18;
        if ($[78] !== buttonToRender || $[79] !== enableTriggerPulse) {
            t18 = /*#__PURE__*/ $cozmU.createElement((0, $gWLTH.Pulse), {
                radius: 3,
                pulse: enableTriggerPulse
            }, buttonToRender);
            $[78] = buttonToRender;
            $[79] = enableTriggerPulse;
            $[80] = t18;
        } else t18 = $[80];
        let t19;
        if ($[81] !== t18 || $[82] !== triggerButtonSpotlightTarget) {
            t19 = /*#__PURE__*/ $cozmU.createElement((0, $8Iwqw.default), {
                name: triggerButtonSpotlightTarget
            }, t18);
            $[81] = t18;
            $[82] = triggerButtonSpotlightTarget;
            $[83] = t19;
        } else t19 = $[83];
        return t19;
    }
    return buttonToRender;
} : function TriggerButtonInner({ triggerProps: triggerProps, testId: testId, onClick: onClick, children: children, isOpen: isOpen = false, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, enableTriggerPulse: enableTriggerPulse, isNav4Enabled: isNav4Enabled = true, buttonTheme: buttonTheme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, primaryActionItem: primaryActionItem, isEntryPointEnabled: isEntryPointEnabled = false, buttonOnly: buttonOnly = false }) {
    const isButtonOnly = buttonOnly;
    const { product: product, sections: sections } = (0, $8s4b7.useUniversalCreateState)();
    const { fireCreateButtonClicked: fireCreateButtonClicked, fireCreateButtonHovered: fireCreateButtonHovered, fireCreateButtonViewed: fireCreateButtonViewed } = (0, $57EeW.useUniversalCreateAnalytics)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isDesktop = (0, $gm2vG.UNSAFE_useMediaQuery)('above.sm')?.matches ?? false;
    const version = sections?.length ? 'v2' : 'v1';
    const hasHoveredRef = (0, $cozmU.useRef)(false);
    const isSplitButton = Boolean(primaryActionItem);
    const buttonVariant = isSplitButton ? 'split' : 'standard';
    const hasFiredViewEvent = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(function fireButtonViewEvent() {
        if (hasFiredViewEvent.current) return;
        hasFiredViewEvent.current = true;
        fireCreateButtonViewed({
            buttonVariant: buttonVariant,
            version: version,
            isButtonOnly: isButtonOnly
        });
    }, [
        fireCreateButtonViewed,
        buttonVariant,
        version,
        isButtonOnly
    ]); // Extract splitPrimaryRef from triggerProps for split button variant
    const { splitButtonPrimaryRef: splitButtonPrimaryRef, ...restTriggerProps } = triggerProps ?? {};
    const onButtonClick = (0, $cozmU.useCallback)(()=>{
        /// For entrypoint path (isEntryPointEnabled is true), set to expanded when isOpen is true
        // For non-entrypoint path (isEntryPointEnabled is false), set to expanded when isOpen is false (current state), as in the legacy mode, the event is fired before menu opens.
        const itemState = isButtonOnly ? 'button-only' : isEntryPointEnabled === isOpen ? 'expanded' : 'collapsed';
        const clickedButtonPart = isSplitButton ? 'dropdown' : 'full';
        const clickedButtonVariant = isSplitButton ? 'split' : 'standard';
        fireCreateButtonClicked({
            itemState: itemState,
            buttonPart: clickedButtonPart,
            buttonVariant: clickedButtonVariant
        });
        onClick();
    }, [
        fireCreateButtonClicked,
        isOpen,
        onClick,
        isEntryPointEnabled,
        isButtonOnly,
        isSplitButton
    ]);
    const primaryItemOnClick = primaryActionItem?.onClick;
    const onPrimaryButtonClick = (0, $cozmU.useCallback)((event)=>{
        const itemState_0 = isEntryPointEnabled === isOpen ? 'expanded' : 'collapsed';
        fireCreateButtonClicked({
            itemState: itemState_0,
            buttonPart: 'primary',
            buttonVariant: 'split'
        });
        primaryItemOnClick?.(event);
    }, [
        fireCreateButtonClicked,
        isEntryPointEnabled,
        isOpen,
        primaryItemOnClick
    ]);
    const CreateIcon = isButtonOnly ? (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF))) : isOpen ? (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))) : (0, (/*@__PURE__*/$parcel$interopDefault($gFEZF)));
    const createEnterEvent = (0, $cozmU.useCallback)(({ buttonPart: buttonPart, shouldTriggerMouseEnterProp: shouldTriggerMouseEnterProp = true })=>(event_0)=>{
            if (!hasHoveredRef.current) {
                hasHoveredRef.current = true;
                const itemState_1 = isButtonOnly ? 'button-only' : isEntryPointEnabled === isOpen ? 'expanded' : 'collapsed';
                fireCreateButtonHovered({
                    buttonPart: buttonPart,
                    buttonVariant: buttonVariant,
                    itemState: itemState_1,
                    version: version
                });
            }
            if (shouldTriggerMouseEnterProp) onMouseEnter?.(event_0);
        }, [
        onMouseEnter,
        fireCreateButtonHovered,
        isOpen,
        isEntryPointEnabled,
        version,
        buttonVariant,
        isButtonOnly
    ]);
    const enterEvent = createEnterEvent({
        buttonPart: 'full'
    });
    const enterEventPrimary = createEnterEvent({
        buttonPart: 'primary'
    });
    const enterEventDropdown = createEnterEvent({
        buttonPart: 'dropdown'
    });
    const leaveEvent = (0, $cozmU.useCallback)((event_1)=>{
        onMouseLeave?.(event_1);
    }, [
        onMouseLeave
    ]);
    const nav3Button = !isNav4Enabled ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_12y21ule _uis9u2gc _1rrju2gc _15nzidpf _dlu2idpf"
        ])
    }, product === 'confluence' ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_x0l4u2gc _19ywu2gc _1xc3idpf _pj60idpf _muvxglyw"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $5SGpQ.default), {
        ...restTriggerProps,
        appearance: "primary",
        theme: buttonTheme,
        onMouseEnter: enterEvent,
        onMouseLeave: leaveEvent,
        onClick: onButtonClick,
        iconBefore: /*#__PURE__*/ $cozmU.createElement(CreateIcon, {
            label: "",
            "data-vc": "global-content-create-button"
        }),
        testId: testId || (0, $eSVwn.TRIGGER_BUTTON_TEST_ID),
        "aria-label": children,
        isSelected: isOpen
    }, /*#__PURE__*/ $cozmU.createElement((0, $kawxu.Show), {
        above: "sm",
        as: "span"
    }, children))) : /*#__PURE__*/ $cozmU.createElement($65a14bf80cc88d67$var$TooltipWrapper, {
        text: children
    }, /*#__PURE__*/ $cozmU.createElement((0, $fk0Hw.Button), {
        ...restTriggerProps,
        appearance: "primary",
        onClick: onButtonClick,
        onMouseEnter: enterEvent,
        onMouseLeave: leaveEvent,
        isSelected: isOpen,
        iconBefore: CreateIcon,
        testId: testId || (0, $eSVwn.TRIGGER_BUTTON_TEST_ID),
        "aria-label": children
    }, /*#__PURE__*/ $cozmU.createElement((0, $kawxu.Show), {
        above: "sm",
        as: "span"
    }, children)))) : null;
    const responsiveSafeButton = isNav4Enabled ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $kawxu.Show), {
        above: (0, $eSVwn.RESPONSIVE_BREAKPOINT),
        as: "span"
    }, /*#__PURE__*/ $cozmU.createElement($65a14bf80cc88d67$var$TooltipWrapper, {
        text: children
    }, /*#__PURE__*/ $cozmU.createElement((0, $fk0Hw.Button), {
        ...isDesktop ? restTriggerProps : {},
        appearance: "primary",
        onClick: onButtonClick,
        onMouseEnter: enterEvent,
        onMouseLeave: leaveEvent,
        isSelected: isOpen,
        iconBefore: CreateIcon,
        testId: testId || (0, $eSVwn.TRIGGER_BUTTON_TEST_ID),
        "aria-label": children,
        "data-responsive-variant": "desktop"
    }, children))), /*#__PURE__*/ $cozmU.createElement((0, $2aija.Hide), {
        above: (0, $eSVwn.RESPONSIVE_BREAKPOINT),
        as: "span"
    }, /*#__PURE__*/ $cozmU.createElement($65a14bf80cc88d67$var$TooltipWrapper, {
        text: children
    }, /*#__PURE__*/ $cozmU.createElement((0, $bZTfQ.IconButton), {
        ...!isDesktop ? restTriggerProps : {},
        appearance: "primary",
        onClick: onButtonClick,
        onMouseEnter: enterEvent,
        onMouseLeave: leaveEvent,
        isSelected: isOpen,
        icon: CreateIcon,
        testId: `${testId || (0, $eSVwn.TRIGGER_BUTTON_TEST_ID)}-mobile`,
        label: children,
        "data-responsive-variant": "mobile"
    })))) : null;
    const splitButtonVariant = primaryActionItem ? /*#__PURE__*/ $cozmU.createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ $cozmU.createElement((0, $kawxu.Show), {
        above: (0, $eSVwn.RESPONSIVE_BREAKPOINT)
    }, /*#__PURE__*/ $cozmU.createElement((0, $iV65j.SplitButton), {
        appearance: "primary"
    }, /*#__PURE__*/ $cozmU.createElement($65a14bf80cc88d67$var$TooltipWrapper, {
        text: children
    }, /*#__PURE__*/ $cozmU.createElement((0, $fk0Hw.Button), {
        ref: splitButtonPrimaryRef,
        appearance: "primary",
        onClick: onPrimaryButtonClick,
        onMouseEnter: enterEventPrimary,
        "aria-label": children,
        testId: "uc-trigger-button-primary"
    }, children)), /*#__PURE__*/ $cozmU.createElement($65a14bf80cc88d67$var$TooltipWrapper, {
        text: formatMessage($65a14bf80cc88d67$var$messages.secondaryButtonTooltipText),
        isScreenReaderAnnouncementDisabled: false
    }, /*#__PURE__*/ $cozmU.createElement((0, $bZTfQ.IconButton), {
        ...isDesktop ? restTriggerProps : {},
        appearance: "primary",
        onClick: onButtonClick,
        isSelected: isOpen,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))),
        "data-responsive-variant": "desktop",
        label: children,
        testId: `${testId || (0, $eSVwn.TRIGGER_BUTTON_TEST_ID)}-split`,
        onMouseEnter: enterEventDropdown,
        onMouseLeave: leaveEvent
    })))), /*#__PURE__*/ $cozmU.createElement((0, $2aija.Hide), {
        above: "sm"
    }, /*#__PURE__*/ $cozmU.createElement($65a14bf80cc88d67$var$TooltipWrapper, {
        text: children
    }, /*#__PURE__*/ $cozmU.createElement((0, $bZTfQ.IconButton), {
        ...!isDesktop ? restTriggerProps : {},
        appearance: "primary",
        onClick: onButtonClick,
        onMouseEnter: enterEvent,
        onMouseLeave: leaveEvent,
        isSelected: isOpen,
        icon: CreateIcon,
        testId: `${testId || (0, $eSVwn.TRIGGER_BUTTON_TEST_ID)}-mobile`,
        label: children,
        "data-responsive-variant": "mobile"
    })))) : null;
    const buttonToRender = primaryActionItem ? splitButtonVariant : isNav4Enabled ? responsiveSafeButton : nav3Button;
    if (!(0, $iDrrr.fg)('navx_uc_spotlight_upgrade') && triggerButtonSpotlightTarget) return /*#__PURE__*/ $cozmU.createElement((0, $8Iwqw.default), {
        name: triggerButtonSpotlightTarget
    }, /*#__PURE__*/ $cozmU.createElement((0, $gWLTH.Pulse), {
        radius: 3,
        pulse: enableTriggerPulse
    }, buttonToRender));
    return buttonToRender;
};
const $65a14bf80cc88d67$export$4129321aecd13375 = (0, $6cTr1.withIntlProvider)($65a14bf80cc88d67$var$TriggerButtonInner);















var $dZaA2 = parcelRequire("dZaA2");

function $ab425030cac59be4$export$7080b3e976bc91ab(eventName, subscriber) {
    (0, $cozmU.useEffect)(()=>{
        return (0, $dZaA2.eventEmitter).on(eventName, subscriber);
    }, [
        eventName,
        subscriber
    ]);
}





const $44c67543755be129$var$MODULE_ID = 'universal-create-popup-content';
const $44c67543755be129$export$1fd7afacc69597bb = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useJsChunkLoadTrack() {
    const $ = (0, $bDgLe.c)(4);
    const { fireJSChunkLoadTime: fireJSChunkLoadTime } = (0, $57EeW.useUniversalCreateAnalytics)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = new Map();
        $[0] = t0;
    } else t0 = $[0];
    const loadStartTimesRef = (0, $cozmU.useRef)(t0);
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (event)=>{
            if (event.moduleId === $44c67543755be129$var$MODULE_ID && !hasFiredRef.current) loadStartTimesRef.current.set(event.transactionId, performance.now());
        };
        $[1] = t1;
    } else t1 = $[1];
    const handleLoadStart = t1;
    let t2;
    if ($[2] !== fireJSChunkLoadTime) {
        t2 = (event_0)=>{
            const startTime = loadStartTimesRef.current.get(event_0.transactionId);
            if (startTime !== undefined) loadStartTimesRef.current.delete(event_0.transactionId);
            if (event_0.moduleId === $44c67543755be129$var$MODULE_ID && startTime !== undefined && !hasFiredRef.current) {
                const loadTime = performance.now() - startTime;
                hasFiredRef.current = true;
                fireJSChunkLoadTime({
                    durationInMs: loadTime,
                    hasError: Boolean(event_0.error)
                });
            }
        };
        $[2] = fireJSChunkLoadTime;
        $[3] = t2;
    } else t2 = $[3];
    const handleLoadCompleteOrError = t2;
    (0, $ab425030cac59be4$export$7080b3e976bc91ab)("jsresource.load.start", handleLoadStart);
    (0, $ab425030cac59be4$export$7080b3e976bc91ab)("jsresource.load.complete", handleLoadCompleteOrError);
    (0, $ab425030cac59be4$export$7080b3e976bc91ab)("jsresource.load.error", handleLoadCompleteOrError);
} : function useJsChunkLoadTrack() {
    const { fireJSChunkLoadTime: fireJSChunkLoadTime } = (0, $57EeW.useUniversalCreateAnalytics)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    const loadStartTimesRef = (0, $cozmU.useRef)(new Map());
    const handleLoadStart = (0, $cozmU.useCallback)((event)=>{
        if (event.moduleId === $44c67543755be129$var$MODULE_ID && !hasFiredRef.current) loadStartTimesRef.current.set(event.transactionId, performance.now());
    }, []);
    const handleLoadCompleteOrError = (0, $cozmU.useCallback)((event_0)=>{
        const startTime = loadStartTimesRef.current.get(event_0.transactionId);
        if (startTime !== undefined) loadStartTimesRef.current.delete(event_0.transactionId);
        if (event_0.moduleId === $44c67543755be129$var$MODULE_ID && startTime !== undefined && !hasFiredRef.current) {
            const loadTime = performance.now() - startTime;
            hasFiredRef.current = true;
            fireJSChunkLoadTime({
                durationInMs: loadTime,
                hasError: Boolean(event_0.error)
            });
        }
    }, [
        fireJSChunkLoadTime
    ]);
    (0, $ab425030cac59be4$export$7080b3e976bc91ab)('jsresource.load.start', handleLoadStart);
    (0, $ab425030cac59be4$export$7080b3e976bc91ab)('jsresource.load.complete', handleLoadCompleteOrError);
    (0, $ab425030cac59be4$export$7080b3e976bc91ab)('jsresource.load.error', handleLoadCompleteOrError);
};



var $7qZTr = parcelRequire("7qZTr");


var $ONTtp = parcelRequire("ONTtp");


const $2b774f2d444ec47b$export$8970f497f10bcb6 = (0, $ONTtp.createEntryPoint)({
    root: (0, $7qZTr.JSResourceForInteraction)(()=>(parcelRequire("7dznL")).then((module)=>({
                default: module.PopupContent
            })), {
        moduleId: "e062cabf",
        moduleName: "PopupContent",
        priority: "interaction",
        moduleId: 'universal-create-popup-content'
    }),
    getPreloadProps: (_params)=>({
            queries: {},
            entryPoints: {},
            extraProps: {}
        })
});


const $2cb19392829cdc9d$var$UniversalCreateButtonLazyInner = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UniversalCreateButtonLazyInner(props) {
    const $ = (0, $bDgLe.c)(48);
    const { children: children, testId: testId, onClick: onClick, onClose: onClose, isOpen: isOpen, enableTriggerPulse: t0, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, isNav4Enabled: t1, buttonTheme: buttonTheme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, shouldRenderToParent: shouldRenderToParent, buttonOnly: t2 } = props;
    const enableTriggerPulse = t0 === undefined ? false : t0;
    const isNav4Enabled = t1 === undefined ? true : t1;
    const buttonOnly = t2 === undefined ? false : t2;
    const isButtonOnly = buttonOnly;
    const primaryActionItem = "primaryActionItem" in props ? props.primaryActionItem : undefined;
    const isResponsive = (0, $2Po8s.useIsResponsiveView)();
    (0, $44c67543755be129$export$1fd7afacc69597bb)();
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpen, $2cb19392829cdc9d$var$_temp);
    let t3;
    if ($[0] !== isLocalOpen || $[1] !== onClick || $[2] !== setLocalIsOpen) {
        t3 = ()=>{
            setLocalIsOpen(!isLocalOpen);
            onClick?.();
        };
        $[0] = isLocalOpen;
        $[1] = onClick;
        $[2] = setLocalIsOpen;
        $[3] = t3;
    } else t3 = $[3];
    const handleTriggerButtonClick = t3;
    let t4;
    if ($[4] !== onClose || $[5] !== setLocalIsOpen) {
        t4 = ()=>{
            setLocalIsOpen(false);
            onClose?.();
        };
        $[4] = onClose;
        $[5] = setLocalIsOpen;
        $[6] = t4;
    } else t4 = $[6];
    const handleClose = t4;
    let t5;
    if ($[7] !== onMouseEnter) {
        t5 = (event)=>{
            onMouseEnter?.(event);
        };
        $[7] = onMouseEnter;
        $[8] = t5;
    } else t5 = $[8];
    const handleMouseEnter = t5;
    const [growthRecommendationsSessionId, setGrowthRecommendationsSessionId] = (0, $cozmU.useState)(undefined);
    let t6;
    if ($[9] !== props) {
        t6 = "sections" in props && props.sections ? props.sections : [];
        $[9] = props;
        $[10] = t6;
    } else t6 = $[10];
    const sections = t6;
    let t7;
    if ($[11] !== props) {
        t7 = "crossAppCreationConfig" in props ? props.crossAppCreationConfig ?? {
            enabled: false
        } : {
            enabled: false
        };
        $[11] = props;
        $[12] = t7;
    } else t7 = $[12];
    const crossAppCreationConfig = t7;
    const selectedItem = "selectedItem" in props ? props.selectedItem : undefined;
    let t8;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = [];
        $[13] = t8;
    } else t8 = $[13];
    const t9 = props.product ?? "unknown";
    let t10;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = {
            enabled: false
        };
        $[14] = t10;
    } else t10 = $[14];
    let t11;
    if ($[15] !== crossAppCreationConfig || $[16] !== growthRecommendationsSessionId || $[17] !== isNav4Enabled || $[18] !== primaryActionItem || $[19] !== props.preventClose || $[20] !== props.subProduct || $[21] !== sections || $[22] !== selectedItem || $[23] !== t9) {
        t11 = {
            items: t8,
            product: t9,
            subProduct: props.subProduct,
            isNav4Enabled: isNav4Enabled,
            sections: sections,
            crossAppCreationConfig: crossAppCreationConfig,
            suggestionConfig: t10,
            selectedItem: selectedItem,
            preventClose: props.preventClose,
            primaryActionItem: primaryActionItem,
            growthRecommendationsSessionId: growthRecommendationsSessionId,
            setGrowthRecommendationsSessionId: setGrowthRecommendationsSessionId
        };
        $[15] = crossAppCreationConfig;
        $[16] = growthRecommendationsSessionId;
        $[17] = isNav4Enabled;
        $[18] = primaryActionItem;
        $[19] = props.preventClose;
        $[20] = props.subProduct;
        $[21] = sections;
        $[22] = selectedItem;
        $[23] = t9;
        $[24] = t11;
    } else t11 = $[24];
    const menuStateContextValue = t11;
    let t12;
    if ($[25] !== buttonTheme || $[26] !== enableTriggerPulse || $[27] !== handleMouseEnter || $[28] !== handleTriggerButtonClick || $[29] !== isNav4Enabled || $[30] !== onMouseLeave || $[31] !== testId || $[32] !== triggerButtonSpotlightTarget) {
        t12 = {
            testId: testId,
            triggerButtonSpotlightTarget: triggerButtonSpotlightTarget,
            enableTriggerPulse: enableTriggerPulse,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: handleTriggerButtonClick,
            isNav4Enabled: isNav4Enabled,
            buttonTheme: buttonTheme
        };
        $[25] = buttonTheme;
        $[26] = enableTriggerPulse;
        $[27] = handleMouseEnter;
        $[28] = handleTriggerButtonClick;
        $[29] = isNav4Enabled;
        $[30] = onMouseLeave;
        $[31] = testId;
        $[32] = triggerButtonSpotlightTarget;
        $[33] = t12;
    } else t12 = $[33];
    const sharedTriggerButtonProps = t12;
    let t13;
    if ($[34] !== children || $[35] !== handleClose || $[36] !== isButtonOnly || $[37] !== isLocalOpen || $[38] !== isNav4Enabled || $[39] !== isResponsive || $[40] !== primaryActionItem || $[41] !== props || $[42] !== sharedTriggerButtonProps || $[43] !== shouldRenderToParent) {
        t13 = isButtonOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65a14bf80cc88d67$export$4129321aecd13375), {
            ...sharedTriggerButtonProps,
            buttonOnly: true
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90a8b778380ea711$export$8f8a5b7d7394d1f8), {
            isOpen: isLocalOpen,
            placement: isResponsive && isNav4Enabled || primaryActionItem ? "bottom-end" : "bottom-start",
            shouldRenderToParent: shouldRenderToParent,
            onClose: handleClose,
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65a14bf80cc88d67$export$4129321aecd13375), {
                    ...sharedTriggerButtonProps,
                    buttonOnly: undefined,
                    isEntryPointEnabled: true,
                    triggerProps: triggerProps,
                    isOpen: triggerProps["aria-expanded"],
                    primaryActionItem: primaryActionItem
                }, children),
            entryPoint: (0, $2b774f2d444ec47b$export$8970f497f10bcb6),
            entryPointProps: props,
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJDAh.LoadingMenu), {
                padded: true
            })
        });
        $[34] = children;
        $[35] = handleClose;
        $[36] = isButtonOnly;
        $[37] = isLocalOpen;
        $[38] = isNav4Enabled;
        $[39] = isResponsive;
        $[40] = primaryActionItem;
        $[41] = props;
        $[42] = sharedTriggerButtonProps;
        $[43] = shouldRenderToParent;
        $[44] = t13;
    } else t13 = $[44];
    let t14;
    if ($[45] !== menuStateContextValue || $[46] !== t13) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8s4b7.MenuStateContext).Provider, {
            value: menuStateContextValue
        }, t13);
        $[45] = menuStateContextValue;
        $[46] = t13;
        $[47] = t14;
    } else t14 = $[47];
    return t14;
} : function UniversalCreateButtonLazyInner(props) {
    const { children: children, testId: testId, onClick: onClick, onClose: onClose, isOpen: isOpen, enableTriggerPulse: enableTriggerPulse = false, triggerButtonSpotlightTarget: triggerButtonSpotlightTarget, isNav4Enabled: isNav4Enabled = true, buttonTheme: buttonTheme, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, shouldRenderToParent: shouldRenderToParent, buttonOnly: buttonOnly = false } = props;
    const isButtonOnly = buttonOnly;
    const primaryActionItem = 'primaryActionItem' in props ? props.primaryActionItem : undefined;
    const isResponsive = (0, $2Po8s.useIsResponsiveView)(); // Track JS chunk load time - must be called before the lazy chunk loads
    (0, $44c67543755be129$export$1fd7afacc69597bb)();
    const [isLocalOpen, setLocalIsOpen] = (0, $5Dlqn.default)(isOpen, ()=>false);
    const handleTriggerButtonClick = (0, $cozmU.useCallback)(()=>{
        setLocalIsOpen(!isLocalOpen); // Notify parent
        onClick?.();
    }, [
        isLocalOpen,
        setLocalIsOpen,
        onClick
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setLocalIsOpen(false);
        onClose?.();
    }, [
        setLocalIsOpen,
        onClose
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)((event)=>{
        onMouseEnter?.(event);
    }, [
        onMouseEnter
    ]);
    const [growthRecommendationsSessionId, setGrowthRecommendationsSessionId] = (0, $cozmU.useState)(undefined);
    const menuStateContextValue = (0, $cozmU.useMemo)(()=>{
        const sections = 'sections' in props && props.sections ? props.sections : [];
        const crossAppCreationConfig = 'crossAppCreationConfig' in props ? props.crossAppCreationConfig ?? {
            enabled: false
        } : {
            enabled: false
        };
        const selectedItem = 'selectedItem' in props ? props.selectedItem : undefined;
        return {
            items: [],
            // to be removed
            product: props.product ?? 'unknown',
            subProduct: props.subProduct,
            isNav4Enabled: isNav4Enabled,
            sections: sections,
            crossAppCreationConfig: crossAppCreationConfig,
            suggestionConfig: {
                enabled: false
            },
            selectedItem: // to be removed
            selectedItem,
            preventClose: props.preventClose,
            primaryActionItem: primaryActionItem,
            growthRecommendationsSessionId: growthRecommendationsSessionId,
            setGrowthRecommendationsSessionId: setGrowthRecommendationsSessionId
        };
    }, [
        props,
        isNav4Enabled,
        primaryActionItem,
        growthRecommendationsSessionId
    ]);
    const sharedTriggerButtonProps = (0, $cozmU.useMemo)(()=>({
            testId: testId,
            triggerButtonSpotlightTarget: triggerButtonSpotlightTarget,
            enableTriggerPulse: enableTriggerPulse,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: handleTriggerButtonClick,
            isNav4Enabled: isNav4Enabled,
            buttonTheme: buttonTheme
        }), [
        testId,
        triggerButtonSpotlightTarget,
        enableTriggerPulse,
        handleMouseEnter,
        onMouseLeave,
        handleTriggerButtonClick,
        isNav4Enabled,
        buttonTheme
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8s4b7.MenuStateContext).Provider, {
        value: menuStateContextValue
    }, isButtonOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65a14bf80cc88d67$export$4129321aecd13375), {
        ...sharedTriggerButtonProps,
        buttonOnly: true
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $90a8b778380ea711$export$8f8a5b7d7394d1f8), {
        isOpen: isLocalOpen,
        placement: isResponsive && isNav4Enabled || primaryActionItem ? 'bottom-end' : 'bottom-start',
        shouldRenderToParent: shouldRenderToParent,
        onClose: handleClose,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $65a14bf80cc88d67$export$4129321aecd13375), {
                ...sharedTriggerButtonProps,
                buttonOnly: undefined,
                isEntryPointEnabled: true,
                triggerProps: triggerProps,
                isOpen: triggerProps['aria-expanded'],
                primaryActionItem: primaryActionItem
            }, children),
        entryPoint: (0, $2b774f2d444ec47b$export$8970f497f10bcb6),
        entryPointProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJDAh.LoadingMenu), {
            padded: true
        })
    }));
};
function $2cb19392829cdc9d$var$_temp() {
    return false;
}
const $2cb19392829cdc9d$export$3739611c05de95f9 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UniversalCreateButtonLazy(props) {
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $36b931e3f96158c0$export$a546442f39c56898), {
            id: "universalCreateComponentLoad"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.ConditionalRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iBJls.BFFProvider), {
            consumer: (0, $3ePvn.BFFConsumerEnum).UNIVERSAL_CREATE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOW5t.UniversalCreateBFFProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $42b04d9ecb159817$export$63b55d605f8a2340), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cb19392829cdc9d$var$UniversalCreateButtonLazyInner, props)))))));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function UniversalCreateButtonLazy(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $36b931e3f96158c0$export$a546442f39c56898), {
        id: "universalCreateComponentLoad"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d5gEx.ConditionalRelayEnvironmentProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iBJls.BFFProvider), {
        consumer: (0, $3ePvn.BFFConsumerEnum).UNIVERSAL_CREATE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cOW5t.UniversalCreateBFFProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $42b04d9ecb159817$export$63b55d605f8a2340), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2cb19392829cdc9d$var$UniversalCreateButtonLazyInner, props)))))));
};


const $7039f178a77e2273$export$5c89068caaa33f77 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function UniversalCreateButton(props) {
    const $ = (0, $bDgLe.c)(5);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2cb19392829cdc9d$export$3739611c05de95f9), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] !== props.product || $[3] !== t0) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jN02e.GenericErrorBoundary), {
            name: "universal-create-button-lazy",
            app: props.product
        }, t0);
        $[2] = props.product;
        $[3] = t0;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : function UniversalCreateButton(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jN02e.GenericErrorBoundary), {
        name: "universal-create-button-lazy",
        app: props.product
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2cb19392829cdc9d$export$3739611c05de95f9), props));
};



var $7aRa9 = parcelRequire("7aRa9");








var $lBYCH = parcelRequire("lBYCH");














var $ep3mz = parcelRequire("ep3mz");








var $3jwuS = parcelRequire("3jwuS");





var $e4o8D = parcelRequire("e4o8D");


var $ftFOj = parcelRequire("ftFOj");


var $bpufi = parcelRequire("bpufi");


var $eB1TF = parcelRequire("eB1TF");


























var $1KBSi = parcelRequire("1KBSi");


var $yuLaV = parcelRequire("yuLaV");





var $kDja4 = parcelRequire("kDja4");








var $8cKgI = parcelRequire("8cKgI");





var $7EIq6 = parcelRequire("7EIq6");


var $fSDMD = parcelRequire("fSDMD");
















function $74f584384b392485$export$ac119ad1f3e15167() {
    const $ = (0, $bDgLe.c)(7);
    const { accessStatus: accessStatus, edition: edition, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    const isStandardUser = edition === (0, $d9tcB.ConfluenceEdition).STANDARD;
    if (!isAnonymousUser && (0, $9wGTI.fg)("navx_uc_cwr_split_button_internal_release")) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {
                cohort: "variant_2",
                isEnabled: true
            };
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    let t0;
    if ($[1] !== isAnonymousUser || $[2] !== isStandardUser) {
        t0 = isStandardUser && !isAnonymousUser ? (0, $6mKj3.expVal)("navx_universal_create_cwr_split_button", "cohort", "control") : "not-enrolled";
        $[1] = isAnonymousUser;
        $[2] = isStandardUser;
        $[3] = t0;
    } else t0 = $[3];
    const cohort = t0;
    const isEnabled = cohort === "variant_1" || cohort === "variant_2";
    let t1;
    if ($[4] !== cohort || $[5] !== isEnabled) {
        t1 = {
            cohort: cohort,
            isEnabled: isEnabled
        };
        $[4] = cohort;
        $[5] = isEnabled;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
}





parcelRequire("cozmU");





var $kLlYX = parcelRequire("kLlYX");


var $59jY5 = parcelRequire("59jY5");


var $lqy4C = parcelRequire("lqy4C");











var $jyA9t = parcelRequire("jyA9t");


var $bZSO8 = parcelRequire("bZSO8");


var $bBaUQ = parcelRequire("bBaUQ");




const $27cf2e1d8d21e923$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.liveDoc.title",
        defaultMessage: "Live Doc"
    }
});
const $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM = 'create-live-doc-popover-item';
function $27cf2e1d8d21e923$export$5af7ed73ba9cf3af(t0) {
    const $ = (0, $bDgLe.c)(28);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: $27cf2e1d8d21e923$var$CREATE_LIVE_DOC_POPOVER_ITEM
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "page",
            subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t3;
    if ($[5] !== createHref || $[6] !== hybridLinkClick || $[7] !== isRovoLLMEnabled || $[8] !== onClick || $[9] !== openModal || $[10] !== push || $[11] !== source || $[12] !== spaceKey) {
        t3 = (e)=>{
            onClick("createLiveDocPopoverItem");
            if (isRovoLLMEnabled && (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "cohort", "variant3")) {
                e?.preventDefault();
                openModal({
                    entryPoint: `${source}-cwrBlankObject`,
                    spaceKey: spaceKey,
                    initialOutcomeType: "liveDoc",
                    lockInitialOutcomeType: true,
                    onCloseCallback: ()=>push(createHref)
                });
                return;
            }
            hybridLinkClick(e);
        };
        $[5] = createHref;
        $[6] = hybridLinkClick;
        $[7] = isRovoLLMEnabled;
        $[8] = onClick;
        $[9] = openModal;
        $[10] = push;
        $[11] = source;
        $[12] = spaceKey;
        $[13] = t3;
    } else t3 = $[13];
    const handleClick = t3;
    let t4;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $59jY5.Ati).parse("ati:cloud:confluence:livedoc");
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== formatMessage) {
        t5 = formatMessage($27cf2e1d8d21e923$var$messages.title);
        $[15] = formatMessage;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== enforceStorageLimit || $[18] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[17] = enforceStorageLimit;
        $[18] = handleClick;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== createHref || $[21] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[20] = createHref;
        $[21] = shouldBlockCreate;
        $[22] = t7;
    } else t7 = $[22];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($kLlYX))),
            ...t7,
            testId: t8
        };
        $[23] = t5;
        $[24] = t6;
        $[25] = t7;
        $[26] = t8;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
}









var $hMaHH = parcelRequire("hMaHH");

























const $f6498381976d168b$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.title",
        defaultMessage: "Page"
    }
});
function $f6498381976d168b$export$e324b86258d66a8f(t0) {
    const $ = (0, $bDgLe.c)(28);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-page-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "page",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    let t3;
    if ($[5] !== createHref || $[6] !== hybridPageLinkClick || $[7] !== isRovoLLMEnabled || $[8] !== onClick || $[9] !== openModal || $[10] !== push || $[11] !== source || $[12] !== spaceKey) {
        t3 = (e)=>{
            onClick("createPagePopoverItem");
            if (isRovoLLMEnabled && (0, $6mKj3.expValEquals)("cwr_blank_object_experiment", "cohort", "variant3")) {
                e.preventDefault();
                openModal({
                    entryPoint: `${source}-cwrBlankObject`,
                    spaceKey: spaceKey,
                    initialOutcomeType: "page",
                    lockInitialOutcomeType: true,
                    onCloseCallback: ()=>push(createHref)
                });
                return;
            }
            hybridPageLinkClick(e);
        };
        $[5] = createHref;
        $[6] = hybridPageLinkClick;
        $[7] = isRovoLLMEnabled;
        $[8] = onClick;
        $[9] = openModal;
        $[10] = push;
        $[11] = source;
        $[12] = spaceKey;
        $[13] = t3;
    } else t3 = $[13];
    const handleClick = t3;
    let t4;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $59jY5.Ati).parse("ati:cloud:confluence:page");
        $[14] = t4;
    } else t4 = $[14];
    let t5;
    if ($[15] !== formatMessage) {
        t5 = formatMessage($f6498381976d168b$var$messages.title);
        $[15] = formatMessage;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== enforceStorageLimit || $[18] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[17] = enforceStorageLimit;
        $[18] = handleClick;
        $[19] = t6;
    } else t6 = $[19];
    let t7;
    if ($[20] !== createHref || $[21] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[20] = createHref;
        $[21] = shouldBlockCreate;
        $[22] = t7;
    } else t7 = $[22];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($hMaHH))),
            ...t7,
            testId: t8
        };
        $[23] = t5;
        $[24] = t6;
        $[25] = t7;
        $[26] = t8;
        $[27] = t9;
    } else t9 = $[27];
    return t9;
}















var $bDjVc = parcelRequire("bDjVc");





var $cJ0FD = parcelRequire("cJ0FD");








var $gfIPU = parcelRequire("gfIPU");

var $ln0hx = parcelRequire("ln0hx");







var $eVXGa = parcelRequire("eVXGa");























var $5nX81 = parcelRequire("5nX81");


var $fCfQ7 = parcelRequire("fCfQ7");


var $98wxI = parcelRequire("98wxI");


var $a23yL = parcelRequire("a23yL");

const $0f054d45c9ec8df7$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.whiteboard.title",
        defaultMessage: "Whiteboard"
    },
    toolTipTextAnonymous: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-anonymous",
        defaultMessage: "Log in to create a whiteboard"
    },
    toolTipTextUnlicensed: {
        id: "create-blank-fabric-page.universal-create.whiteboard.tooltip.text-unlicensed",
        defaultMessage: "Sign up to Confluence to create a whiteboard"
    }
});
const $0f054d45c9ec8df7$var$PAYWALL_EXPERIENCE_ATTRIBUTES = {
    contentType: 'whiteboard',
    paywallFlow: 'upfront'
};
const $0f054d45c9ec8df7$var$f1GameStyles = {
    itemWrapper: "_4cvr1h6o _1bah1yb4 _1e0c1txw _kqswh2mm",
    childrenWrapper: "_16jlkb7n",
    rightIcon: "_4t3idlk8 _kqswstnw _1xi2pxbi _lcxvglyw"
};
const $0f054d45c9ec8df7$var$F1GameWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(13);
    const { children: children } = t0;
    const [showRacecarIcon, setShowRacecarIcon] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (_)=>{
            (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && setShowRacecarIcon(true);
        };
        $[0] = t1;
    } else t1 = $[0];
    const handleOnMouseEnter = t1;
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (__0)=>{
            (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && setShowRacecarIcon(false);
        };
        $[1] = t2;
    } else t2 = $[1];
    const handleOnMouseLeave = t2;
    let t3;
    let t4;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $hekY6.default)([
            $0f054d45c9ec8df7$var$f1GameStyles.itemWrapper
        ]);
        t4 = (0, $hekY6.default)([
            $0f054d45c9ec8df7$var$f1GameStyles.childrenWrapper
        ]);
        $[2] = t3;
        $[3] = t4;
    } else {
        t3 = $[2];
        t4 = $[3];
    }
    let t5;
    if ($[4] !== children) {
        t5 = children();
        $[4] = children;
        $[5] = t5;
    } else t5 = $[5];
    let t6;
    if ($[6] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            className: t4
        }, t5);
        $[6] = t5;
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== showRacecarIcon) {
        t7 = showRacecarIcon && (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($a23yL))),
            srcDark: (0, (/*@__PURE__*/$parcel$interopDefault($a23yL))),
            alt: "",
            testId: "confluence-whiteboards-car-icon",
            className: (0, $hekY6.default)([
                $0f054d45c9ec8df7$var$f1GameStyles.rightIcon
            ])
        });
        $[8] = showRacecarIcon;
        $[9] = t7;
    } else t7 = $[9];
    let t8;
    if ($[10] !== t6 || $[11] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onMouseEnter: handleOnMouseEnter,
            onFocus: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
            onBlur: handleOnMouseLeave,
            className: t3
        }, t6, t7);
        $[10] = t6;
        $[11] = t7;
        $[12] = t8;
    } else t8 = $[12];
    return t8;
};
function $0f054d45c9ec8df7$export$15c9136e9dd6e3b5(t0) {
    const $ = (0, $bDgLe.c)(41);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const shouldShowCreateWithRovo = isRovoLLMEnabled && (0, $6mKj3.isExperimentEnabled)("cwr_canvas_blank_object_experiment");
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const isAllowedToCreateWhiteboard = (0, $eVXGa.useIsAllowedToCreateWhiteboard)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    if ($[0] !== isOpen) {
        t1 = (0, $9wGTI.fg)("load-whiteboards-paywall-query-when-menu-is-open") && !isOpen;
        $[0] = isOpen;
        $[1] = t1;
    } else t1 = $[1];
    const skipPaywallQuery = t1;
    const { deactivationIdentifier: deactivationIdentifier, error: creationPaywallError, paywallStatus: paywallStatus, showPaywallBeforeCreate: showPaywallBeforeCreate } = (0, $5nX81.useWhiteboardCreationPaywall)(skipPaywallQuery);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            source: "create-whiteboard-popover-item"
        };
        $[2] = t2;
    } else t2 = $[2];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t2);
    let t3;
    if ($[3] !== deactivationIdentifier || $[4] !== parentId || $[5] !== paywallStatus || $[6] !== source || $[7] !== spaceKey) {
        t3 = (t4, t5)=>{
            const creationOverrides = t4 === undefined ? {} : t4;
            const sourceSuffix = t5 === undefined ? "" : t5;
            return (0, $bZSO8.buildCreationLink)({
                contentType: "whiteboard",
                parentPageId: parentId,
                withFallback: true,
                source: source + sourceSuffix,
                spaceKey: spaceKey,
                deactivationIdentifier: deactivationIdentifier,
                paywallStatus: paywallStatus,
                ...creationOverrides
            });
        };
        $[3] = deactivationIdentifier;
        $[4] = parentId;
        $[5] = paywallStatus;
        $[6] = source;
        $[7] = spaceKey;
        $[8] = t3;
    } else t3 = $[8];
    const buildWhiteboardCreationLink = t3;
    const createHref = buildWhiteboardCreationLink({
        showCreateWithRovo: shouldShowCreateWithRovo,
        openTemplatePicker: !shouldShowCreateWithRovo
    });
    const hybridLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t4;
    if ($[9] !== buildWhiteboardCreationLink || $[10] !== createAnalyticsEvent || $[11] !== creationPaywallError || $[12] !== experienceTracker || $[13] !== hybridLinkClick || $[14] !== onClick || $[15] !== paywallStatus || $[16] !== showModal || $[17] !== showPaywallBeforeCreate || $[18] !== source) {
        t4 = (e)=>{
            onClick("createWhiteboardPopoverItem");
            if ((0, $9wGTI.fg)("confluence_content_creation_paywall_fix_enabled")) {
                experienceTracker.start({
                    name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
                    attributes: $0f054d45c9ec8df7$var$PAYWALL_EXPERIENCE_ATTRIBUTES,
                    collect: (0, $5nX81.collectStartCreateWhiteboardExperience)
                });
                if (creationPaywallError) experienceTracker.fail({
                    name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
                    error: creationPaywallError
                });
            }
            if (showPaywallBeforeCreate) {
                e.stopPropagation();
                e.preventDefault();
                showModal((0, $fCfQ7.WhiteboardCreationPaywallDialog), {
                    buildWhiteboardCreationLink: buildWhiteboardCreationLink
                });
            } else {
                if (paywallStatus === (0, $98wxI.PaywallStatus).UNSET) createAnalyticsEvent({
                    type: "sendOperationalEvent",
                    data: {
                        action: "clicked",
                        actionSubject: "createUnsetWhiteboardLink",
                        source: source,
                        attributes: {
                            reason: creationPaywallError ? "error" : "loading"
                        }
                    }
                }).fire();
                hybridLinkClick(e);
            }
        };
        $[9] = buildWhiteboardCreationLink;
        $[10] = createAnalyticsEvent;
        $[11] = creationPaywallError;
        $[12] = experienceTracker;
        $[13] = hybridLinkClick;
        $[14] = onClick;
        $[15] = paywallStatus;
        $[16] = showModal;
        $[17] = showPaywallBeforeCreate;
        $[18] = source;
        $[19] = t4;
    } else t4 = $[19];
    const handleClick = t4;
    let t5;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $59jY5.Ati).parse("ati:cloud:confluence:whiteboard");
        $[20] = t5;
    } else t5 = $[20];
    let t6;
    if ($[21] !== creationPaywallError) {
        t6 = !(0, $9wGTI.fg)("confluence_content_creation_paywall_fix_enabled") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            collect: (0, $5nX81.collectStartCreateWhiteboardExperience),
            attributes: $0f054d45c9ec8df7$var$PAYWALL_EXPERIENCE_ATTRIBUTES
        }), creationPaywallError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.CONTENT_CREATION_PAYWALL_EXPERIENCE),
            error: creationPaywallError
        }));
        $[21] = creationPaywallError;
        $[22] = t6;
    } else t6 = $[22];
    let t7;
    if ($[23] !== formatMessage) {
        t7 = formatMessage($0f054d45c9ec8df7$var$messages.title);
        $[23] = formatMessage;
        $[24] = t7;
    } else t7 = $[24];
    let t8;
    if ($[25] !== t6 || $[26] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, t6, t7);
        $[25] = t6;
        $[26] = t7;
        $[27] = t8;
    } else t8 = $[27];
    let t9;
    if ($[28] !== enforceStorageLimit || $[29] !== handleClick) {
        t9 = enforceStorageLimit(handleClick);
        $[28] = enforceStorageLimit;
        $[29] = handleClick;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $6mKj3.isExperimentEnabled)("confluence_race_mode") && {
            Wrapper: $0f054d45c9ec8df7$var$F1GameWrapper
        };
        $[31] = t10;
    } else t10 = $[31];
    let t11;
    if ($[32] !== createHref || $[33] !== isAllowedToCreateWhiteboard || $[34] !== shouldBlockCreate) {
        t11 = !shouldBlockCreate && isAllowedToCreateWhiteboard && {
            href: createHref
        };
        $[32] = createHref;
        $[33] = isAllowedToCreateWhiteboard;
        $[34] = shouldBlockCreate;
        $[35] = t11;
    } else t11 = $[35];
    const t12 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t13;
    if ($[36] !== t11 || $[37] !== t12 || $[38] !== t8 || $[39] !== t9) {
        t13 = {
            ati: t5,
            children: t8,
            onClick: t9,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($bDjVc))),
            ...t10,
            ...t11,
            testId: t12
        };
        $[36] = t11;
        $[37] = t12;
        $[38] = t8;
        $[39] = t9;
        $[40] = t13;
    } else t13 = $[40];
    return t13;
}









var $lBKFk = parcelRequire("lBKFk");













const $6d2d546fa6596ac4$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.page.database",
        defaultMessage: "Database"
    }
});
function $6d2d546fa6596ac4$export$c03ba1b69410a0fd(t0) {
    const $ = (0, $bDgLe.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-database-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        const createContentOptions = {
            contentType: "database",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        };
        t2 = (0, $bZSO8.buildCreationLink)(createContentOptions);
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridPageLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createDatabasePopoverItem");
            hybridPageLinkClick(e);
        };
        $[5] = hybridPageLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $59jY5.Ati).parse("ati:cloud:confluence:database");
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($6d2d546fa6596ac4$var$messages.title);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== enforceStorageLimit || $[12] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[11] = enforceStorageLimit;
        $[12] = handleClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== createHref || $[15] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[14] = createHref;
        $[15] = shouldBlockCreate;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($lBKFk))),
            ...t7,
            testId: t8
        };
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
}









var $d4GYd = parcelRequire("d4GYd");













const $b66cd3653b467139$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.blog.title",
        defaultMessage: "Blog"
    }
});
function $b66cd3653b467139$export$1850e31ba3eb45b0(t0) {
    const $ = (0, $bDgLe.c)(21);
    const { source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-blog-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== source || $[2] !== spaceKey) {
        t2 = (0, $bZSO8.buildCreationLink)({
            contentType: "blog",
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        });
        $[1] = source;
        $[2] = spaceKey;
        $[3] = t2;
    } else t2 = $[3];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[4] !== hybridPageLinkClick || $[5] !== onClick) {
        t3 = (e)=>{
            onClick("createBlogPopoverItem");
            hybridPageLinkClick(e);
        };
        $[4] = hybridPageLinkClick;
        $[5] = onClick;
        $[6] = t3;
    } else t3 = $[6];
    const handleClick = t3;
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $59jY5.Ati).parse("ati:cloud:confluence:blogpost");
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== formatMessage) {
        t5 = formatMessage($b66cd3653b467139$var$messages.title);
        $[8] = formatMessage;
        $[9] = t5;
    } else t5 = $[9];
    let t6;
    if ($[10] !== enforceStorageLimit || $[11] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[10] = enforceStorageLimit;
        $[11] = handleClick;
        $[12] = t6;
    } else t6 = $[12];
    let t7;
    if ($[13] !== createHref || $[14] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[13] = createHref;
        $[14] = shouldBlockCreate;
        $[15] = t7;
    } else t7 = $[15];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[16] !== t5 || $[17] !== t6 || $[18] !== t7 || $[19] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($d4GYd))),
            ...t7,
            testId: t8
        };
        $[16] = t5;
        $[17] = t6;
        $[18] = t7;
        $[19] = t8;
        $[20] = t9;
    } else t9 = $[20];
    return t9;
}









var $cSGyR = parcelRequire("cSGyR");













const $5c0768c746cc7929$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.smart-link-embed.title",
        defaultMessage: "Smart Link"
    }
});
function $5c0768c746cc7929$export$da2a30a64353a280(t0) {
    const $ = (0, $bDgLe.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            source: "create-smart-link-embed-popover-item"
        };
        $[0] = t1;
    } else t1 = $[0];
    const { enforceStorageLimit: enforceStorageLimit, shouldBlockCreate: shouldBlockCreate } = (0, $lqy4C.useHardStorageEnforcement)(t1);
    let t2;
    if ($[1] !== parentId || $[2] !== source || $[3] !== spaceKey) {
        const createContentOptions = {
            contentType: "smartLinkEmbed",
            parentPageId: parentId,
            withFallback: true,
            source: source,
            spaceKey: spaceKey
        };
        t2 = (0, $bZSO8.buildCreationLink)(createContentOptions);
        $[1] = parentId;
        $[2] = source;
        $[3] = spaceKey;
        $[4] = t2;
    } else t2 = $[4];
    const createHref = t2;
    const hybridPageLinkClick = (0, $bBaUQ.useHybridLinkClick)(createHref);
    let t3;
    if ($[5] !== hybridPageLinkClick || $[6] !== onClick) {
        t3 = (e)=>{
            onClick("createSmartLinkEmbedPopoverItem");
            hybridPageLinkClick(e);
        };
        $[5] = hybridPageLinkClick;
        $[6] = onClick;
        $[7] = t3;
    } else t3 = $[7];
    const handleClick = t3;
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $59jY5.Ati).parse("ati:cloud:confluence:embed");
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== formatMessage) {
        t5 = formatMessage($5c0768c746cc7929$var$messages.title);
        $[9] = formatMessage;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== enforceStorageLimit || $[12] !== handleClick) {
        t6 = enforceStorageLimit(handleClick);
        $[11] = enforceStorageLimit;
        $[12] = handleClick;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== createHref || $[15] !== shouldBlockCreate) {
        t7 = !shouldBlockCreate && {
            href: createHref
        };
        $[14] = createHref;
        $[15] = shouldBlockCreate;
        $[16] = t7;
    } else t7 = $[16];
    const t8 = `create-menu-${shouldBlockCreate ? "button" : "link"}-item`;
    let t9;
    if ($[17] !== t5 || $[18] !== t6 || $[19] !== t7 || $[20] !== t8) {
        t9 = {
            ati: t4,
            children: t5,
            onClick: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($cSGyR))),
            ...t7,
            testId: t8
        };
        $[17] = t5;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
        $[21] = t9;
    } else t9 = $[21];
    return t9;
}









var $krxYo = parcelRequire("krxYo");


var $aOjGz = parcelRequire("aOjGz");





var $iMnC5 = parcelRequire("iMnC5");











var $bAyaS = parcelRequire("bAyaS");



















const $293cf5b691bb25ab$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.space.title",
        defaultMessage: "Space"
    }
});
function $293cf5b691bb25ab$export$4adf07b2777336fa({ source: source, onClick: onClick }) {
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { openDrawer: openDrawer } = (0, $bAyaS.useCreateSpaceStoreActions)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-space-button'
    });
    const { resetStickySearchRef: resetStickySearchRef, createContentPopoverButtonRef: createContentPopoverButtonRef } = (0, $cozmU.useContext)((0, $lBYCH.AppNavigationContext));
    const createSpaceButtonRef = (0, $cozmU.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)((e)=>{
        resetStickySearchRef?.current?.();
        const location = 'topCreateNav';
        if (isRovoLLMEnabled && (0, $9wGTI.fg)('aifc_space_creation_enabled')) openModal({
            entryPoint: 'globalCreateSpaceButton',
            spaceKey: ''
        });
        else openDrawer(createContentPopoverButtonRef || createSpaceButtonRef, location);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createSpaceButton',
                source: source,
                attributes: {
                    location: location
                }
            }
        }).fire();
        onClick('createSpacePopoverItem');
        e.stopPropagation();
    }, [
        createAnalyticsEvent,
        createContentPopoverButtonRef,
        openDrawer,
        onClick,
        openModal,
        resetStickySearchRef,
        source,
        isRovoLLMEnabled
    ]);
    const preloadCreateSpace = ()=>{
        (0, $4vyfK.preloadWebItemLocation)({
            location: (0, $eSLr0.CREATE_SPACE_DIALOG)
        });
    };
    const PreloadSpaceWrap = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            onMouseDown: preloadCreateSpace
        }, children());
    return {
        ati: (0, $59jY5.Ati).parse('ati:cloud:confluence:space'),
        children: formatMessage($293cf5b691bb25ab$var$messages.title),
        onClick: enforceStorageLimit(handleClick),
        elemBefore: (0, $6mKj3.expVal)('confluence_space_icon_update', 'isEnabled', false) ? (0, (/*@__PURE__*/$parcel$interopDefault($aOjGz))) : (0, (/*@__PURE__*/$parcel$interopDefault($krxYo))),
        testId: 'create-menu-button-item',
        Wrapper: PreloadSpaceWrap
    };
}















var $60Yxm = parcelRequire("60Yxm");


var $bK5Dy = parcelRequire("bK5Dy");





var $4R3wx = parcelRequire("4R3wx");


var $9uAPw = parcelRequire("9uAPw");


var $8Q0mA = parcelRequire("8Q0mA");








var $7QM6o = parcelRequire("7QM6o");











var $3izAL = parcelRequire("3izAL");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");





var $iCisl = parcelRequire("iCisl");

const $925aeaac5c2ec2fe$var$titleSpacingStyles = (0, $buxP3.xcss)({
    marginRight: 'space.075'
});
const $925aeaac5c2ec2fe$export$32629a9f34b6d093 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { children: children, lozenge: lozenge, useLabsLozenge: useLabsLozenge } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $925aeaac5c2ec2fe$var$titleSpacingStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== lozenge || $[3] !== useLabsLozenge) {
        t2 = useLabsLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iCisl.AILabsLozenge), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
            appearance: "discovery"
        }, lozenge);
        $[2] = lozenge;
        $[3] = useLabsLozenge;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== t1 || $[6] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            justifyContent: "space-between"
        }, t1, t2);
        $[5] = t1;
        $[6] = t2;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};


const $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE = 'globalCreateContentPopover';
const $3e0600a499c498b6$var$CROSS_JOIN = 'CROSS_JOIN';
const $3e0600a499c498b6$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.loom.title",
        defaultMessage: "Loom video"
    },
    crossJoinPopupTitle: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupTitle",
        defaultMessage: "Share your work with a video"
    },
    crossJoinPopupDescription: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinPopupDescription",
        defaultMessage: "Save time and engage your team with a video walkthrough, demo, update, and more."
    },
    crossJoinCTA: {
        id: "create-blank-fabric-page.universal-create.loom.crossJoinCTA",
        defaultMessage: "Try now"
    },
    crossJoinLozenge: {
        id: "create-blank-fabric-page.universal-create.loom.cross-join-lozenge",
        defaultMessage: "Join"
    }
});
function $3e0600a499c498b6$export$5c18cb5d6208bad4(flags, loading, source) {
    const $ = (0, $bDgLe.c)(16);
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t0;
    if ($[0] !== flags || $[1] !== formatMessage || $[2] !== source) {
        t0 = (t1)=>{
            const { children: children } = t1;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Q0mA.LoomCrossJoinPopupCard), {
                description: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupDescription),
                entryPointId: "loom-confluence-create-menu",
                sourceComponent: source,
                shouldRenderToParent: false,
                title: formatMessage($3e0600a499c498b6$var$messages.crossJoinPopupTitle),
                sourceActionSubjectId: "createLoomPopoverItem",
                triggerLink: (_, triggerProps)=>children({
                        triggerProps: triggerProps
                    }),
                flags: flags
            });
        };
        $[0] = flags;
        $[1] = formatMessage;
        $[2] = source;
        $[3] = t0;
    } else t0 = $[3];
    const PopupWrapper = t0;
    let t1;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $59jY5.Ati).parse("ati:cloud:loom:video");
        $[4] = t1;
    } else t1 = $[4];
    let t2;
    if ($[5] !== formatMessage) {
        t2 = formatMessage($3e0600a499c498b6$var$messages.crossJoinLozenge);
        $[5] = formatMessage;
        $[6] = t2;
    } else t2 = $[6];
    let t3;
    if ($[7] !== formatMessage) {
        t3 = formatMessage($3e0600a499c498b6$var$messages.title);
        $[7] = formatMessage;
        $[8] = t3;
    } else t3 = $[8];
    let t4;
    if ($[9] !== t2 || $[10] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
            lozenge: t2
        }, t3);
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
    } else t4 = $[11];
    let t5;
    if ($[12] !== PopupWrapper || $[13] !== loading || $[14] !== t4) {
        t5 = {
            ati: t1,
            isLoading: loading,
            target: "_blank",
            testId: "create-menu-link-item",
            children: t4,
            Wrapper: PopupWrapper,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($60Yxm)))
        };
        $[12] = PopupWrapper;
        $[13] = loading;
        $[14] = t4;
        $[15] = t5;
    } else t5 = $[15];
    return t5;
}
const $3e0600a499c498b6$export$3bdf8358f565b3a3 = (t0)=>{
    const $ = (0, $bDgLe.c)(22);
    const { parentId: parentId, source: source, spaceKey: spaceKey, onClick: onClick, flags: flags } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    const { push: push } = (0, $dPJCf.useRouteActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== flags) {
        t1 = {
            entryPointLocation: $3e0600a499c498b6$var$ANALYTICS_EVENT_SOURCE,
            flags: flags
        };
        $[0] = flags;
        $[1] = t1;
    } else t1 = $[1];
    const { openLoomRecorder: openLoomRecorder, isLoomRecorderInitialized: isLoomRecorderInitialized } = (0, $9uAPw.useLoomRecorderEntryPoint)(t1);
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = {
            source: "record-loom-popover-item"
        };
        $[2] = t2;
    } else t2 = $[2];
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)(t2);
    let t3;
    if ($[3] !== createAnalyticsEvent || $[4] !== onClick || $[5] !== openLoomRecorder || $[6] !== parentId || $[7] !== push || $[8] !== source || $[9] !== spaceId || $[10] !== spaceKey) {
        t3 = ()=>{
            onClick("createLoomPopoverItem");
            openLoomRecorder({
                onInsert: (videoUrl)=>{
                    const createUrl = (0, $bZSO8.buildCreationLink)({
                        contentType: "smartLinkEmbed",
                        parentPageId: parentId,
                        withFallback: true,
                        smartLinkCreateSource: "loomRecordSDK",
                        smartLinkEmbedUrl: videoUrl,
                        source: source,
                        spaceKey: spaceKey
                    });
                    push(createUrl);
                    (0, $bK5Dy.getHashedLoomVideoIdFromUrl)(videoUrl).then((hashedVideoId)=>{
                        createAnalyticsEvent({
                            type: "sendTrackEvent",
                            data: {
                                action: "insertVideo",
                                actionSubject: "loom",
                                source: source,
                                objectType: "embed",
                                containerType: "space",
                                containerId: spaceId,
                                attributes: {
                                    location: "contentTreeItem",
                                    video_id: hashedVideoId
                                }
                            }
                        }).fire();
                    });
                },
                insertButtonText: "Insert video",
                location: "topNav"
            });
        };
        $[3] = createAnalyticsEvent;
        $[4] = onClick;
        $[5] = openLoomRecorder;
        $[6] = parentId;
        $[7] = push;
        $[8] = source;
        $[9] = spaceId;
        $[10] = spaceKey;
        $[11] = t3;
    } else t3 = $[11];
    const handleClick = t3;
    let t4;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $59jY5.Ati).parse("ati:cloud:loom:video");
        $[12] = t4;
    } else t4 = $[12];
    let t5;
    if ($[13] !== formatMessage) {
        t5 = formatMessage($3e0600a499c498b6$var$messages.title);
        $[13] = formatMessage;
        $[14] = t5;
    } else t5 = $[14];
    const t6 = !isLoomRecorderInitialized;
    let t7;
    if ($[15] !== enforceStorageLimit || $[16] !== handleClick) {
        t7 = enforceStorageLimit(handleClick);
        $[15] = enforceStorageLimit;
        $[16] = handleClick;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== t5 || $[19] !== t6 || $[20] !== t7) {
        t8 = {
            ati: t4,
            children: t5,
            isLoading: t6,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($60Yxm))),
            testId: "create-menu-button-item",
            onClick: t7
        };
        $[18] = t5;
        $[19] = t6;
        $[20] = t7;
        $[21] = t8;
    } else t8 = $[21];
    return t8;
};
function $3e0600a499c498b6$export$2c423d86f10c527b(props) {
    const { entryPointVariant: entryPointVariant, loading: loading } = (0, $4R3wx.useLoomEntryPointVariant)();
    const recordItem = $3e0600a499c498b6$export$3bdf8358f565b3a3(props);
    const crossJoinItem = $3e0600a499c498b6$export$5c18cb5d6208bad4(props.flags, loading, props.source);
    return entryPointVariant === $3e0600a499c498b6$var$CROSS_JOIN ? crossJoinItem : recordItem;
}






var $2YLrg = parcelRequire("2YLrg");











var $jC4nA = parcelRequire("jC4nA");





var $2lkdI = parcelRequire("2lkdI");


var $1wMTi = parcelRequire("1wMTi");

const $7c0a3d67e1b4e126$var$CREATE_AGENT_ATI = 'ati:cloud:rovo:agent';
const $7c0a3d67e1b4e126$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.inline-create-agent.title",
        defaultMessage: "Agent"
    },
    prompt: {
        id: "create-blank-fabric-page.universal-create.inline-create-agent.prompt",
        defaultMessage: "Help me build a Rovo agent {buildAgentSkill}"
    }
});
const $7c0a3d67e1b4e126$var$InlineCreateAgentMenuItem = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { source: source } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    (0, $1wMTi.useInlineCreateAgentItemScreenEvent)(source);
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($7c0a3d67e1b4e126$var$messages.title);
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1);
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
};
function $7c0a3d67e1b4e126$export$a0f710f8ec74092e(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { onClick: onClick, source: source } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== formatMessage) {
        t1 = formatMessage($7c0a3d67e1b4e126$var$messages.prompt, {
            buildAgentSkill: (0, $2lkdI.INLINE_CREATE_AGENT_SKILL_TOKEN)
        });
        $[0] = formatMessage;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== onClick || $[3] !== source || $[4] !== t1) {
        t2 = {
            onClick: onClick,
            promptText: t1,
            source: source
        };
        $[2] = onClick;
        $[3] = source;
        $[4] = t1;
        $[5] = t2;
    } else t2 = $[5];
    const handleClick = (0, $2lkdI.useInlineCreateAgentItemClickHandler)(t2);
    let t3;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $59jY5.Ati).parse($7c0a3d67e1b4e126$var$CREATE_AGENT_ATI);
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== source) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7c0a3d67e1b4e126$var$InlineCreateAgentMenuItem, {
            source: source
        });
        $[7] = source;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== handleClick || $[10] !== t4) {
        t5 = {
            ati: t3,
            children: t4,
            onClick: handleClick,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
            testId: "create-menu-link-item"
        };
        $[9] = handleClick;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
}


















var $88DFk = parcelRequire("88DFk");





var $fa8WQ = parcelRequire("fa8WQ");









var $fwr8U = parcelRequire("fwr8U");

const $ff1212ebd34dd2ed$var$CREATE_AGENT_ACTION_SUBJECT_ID = 'createAgentPopoverItem';
const $ff1212ebd34dd2ed$var$CREATE_AGENT_ATI = 'ati:cloud:rovo:agent';
const $ff1212ebd34dd2ed$var$CONNIE_CREATE_SOURCE = 'connie-create';
const $ff1212ebd34dd2ed$var$messages = (0, $kSwu1.defineMessages)({
    title: {
        id: "create-blank-fabric-page.universal-create.agent.title.v2",
        defaultMessage: "Agent"
    },
    newLozenge: {
        id: "create-blank-fabric-page.universal-create.agent.new-lozenge",
        defaultMessage: "New"
    },
    newLozengeUpdated: {
        id: "create-blank-fabric-page.universal-create.agent.new-lozenge.updated",
        defaultMessage: "New"
    }
});
const $ff1212ebd34dd2ed$var$StudioRedirectCreateAgentMenuItem = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { source: source } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            isEnabled: (0, $9wGTI.fg)("cc_fd_agent_creation_connie_lozenge")
        };
        $[0] = t1;
    } else t1 = $[0];
    const shouldShowNewLozenge = (0, $fwr8U.useAgentNewLozenge)(t1);
    let t2;
    let t3;
    if ($[1] !== createAnalyticsEvent || $[2] !== source) {
        t2 = ()=>{
            createAnalyticsEvent({
                type: "sendScreenEvent",
                data: {
                    name: "createAgentPopoverItem",
                    attributes: {
                        source: source
                    }
                }
            }).fire();
        };
        t3 = [
            createAnalyticsEvent,
            source
        ];
        $[1] = createAnalyticsEvent;
        $[2] = source;
        $[3] = t2;
        $[4] = t3;
    } else {
        t2 = $[3];
        t3 = $[4];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[5] !== formatMessage || $[6] !== shouldShowNewLozenge) {
        t4 = shouldShowNewLozenge ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
            lozenge: formatMessage($ff1212ebd34dd2ed$var$messages.newLozengeUpdated)
        }, formatMessage($ff1212ebd34dd2ed$var$messages.title)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formatMessage($ff1212ebd34dd2ed$var$messages.title));
        $[5] = formatMessage;
        $[6] = shouldShowNewLozenge;
        $[7] = t4;
    } else t4 = $[7];
    return t4;
};
function $ff1212ebd34dd2ed$export$eb5bbc1171dbb0a7(t0) {
    const $ = (0, $bDgLe.c)(14);
    const { onClick: onClick, source: source } = t0;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            touchPoint: $ff1212ebd34dd2ed$var$CONNIE_CREATE_SOURCE
        };
        $[0] = t1;
    } else t1 = $[0];
    const [csid, t2] = (0, $88DFk.useRovoAgentCreateAnalytics)(t1);
    const { trackCreateSessionStart: trackCreateSessionStart } = t2;
    let t3;
    if ($[1] !== cloudId || $[2] !== csid) {
        t3 = (0, $fa8WQ.getAtlassianStudioNLCreateUrl)(cloudId, $ff1212ebd34dd2ed$var$CONNIE_CREATE_SOURCE, csid);
        $[1] = cloudId;
        $[2] = csid;
        $[3] = t3;
    } else t3 = $[3];
    const createAgentUrl = t3;
    let t4;
    if ($[4] !== onClick || $[5] !== trackCreateSessionStart) {
        t4 = ()=>{
            trackCreateSessionStart();
            onClick($ff1212ebd34dd2ed$var$CREATE_AGENT_ACTION_SUBJECT_ID);
        };
        $[4] = onClick;
        $[5] = trackCreateSessionStart;
        $[6] = t4;
    } else t4 = $[6];
    const handleClick = t4;
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $59jY5.Ati).parse($ff1212ebd34dd2ed$var$CREATE_AGENT_ATI);
        $[7] = t5;
    } else t5 = $[7];
    let t6;
    if ($[8] !== source) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ff1212ebd34dd2ed$var$StudioRedirectCreateAgentMenuItem, {
            source: source
        });
        $[8] = source;
        $[9] = t6;
    } else t6 = $[9];
    let t7;
    if ($[10] !== createAgentUrl || $[11] !== handleClick || $[12] !== t6) {
        t7 = {
            ati: t5,
            children: t6,
            href: createAgentUrl,
            target: "_blank",
            onClick: handleClick,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
            testId: "create-menu-link-item"
        };
        $[10] = createAgentUrl;
        $[11] = handleClick;
        $[12] = t6;
        $[13] = t7;
    } else t7 = $[13];
    return t7;
}


const $1ebf3304fd03762d$var$CREATE_AGENT_SOURCE = 'globalCreateDropdown';
const $1ebf3304fd03762d$var$INLINE_CREATE_AGENT_SOURCE = `${$1ebf3304fd03762d$var$CREATE_AGENT_SOURCE}-inlineCreateAgent`;
const $1ebf3304fd03762d$var$STUDIO_REDIRECT_CREATE_AGENT_SOURCE = `${$1ebf3304fd03762d$var$CREATE_AGENT_SOURCE}-createAgent`;
function $1ebf3304fd03762d$export$b09c351e9082b606(t0) {
    const $ = (0, $bDgLe.c)(15);
    let isMenuOpen;
    let menuItemProps;
    if ($[0] !== t0) {
        ({ isMenuOpen: isMenuOpen, ...menuItemProps } = t0);
        $[0] = t0;
        $[1] = isMenuOpen;
        $[2] = menuItemProps;
    } else {
        isMenuOpen = $[1];
        menuItemProps = $[2];
    }
    let t1;
    if ($[3] !== menuItemProps) {
        t1 = {
            ...menuItemProps,
            source: $1ebf3304fd03762d$var$INLINE_CREATE_AGENT_SOURCE
        };
        $[3] = menuItemProps;
        $[4] = t1;
    } else t1 = $[4];
    const inlineCreateAgent = (0, $7c0a3d67e1b4e126$export$a0f710f8ec74092e)(t1);
    let t2;
    if ($[5] !== menuItemProps) {
        t2 = {
            ...menuItemProps,
            source: $1ebf3304fd03762d$var$STUDIO_REDIRECT_CREATE_AGENT_SOURCE
        };
        $[5] = menuItemProps;
        $[6] = t2;
    } else t2 = $[6];
    const studioRedirectCreateAgent = (0, $ff1212ebd34dd2ed$export$eb5bbc1171dbb0a7)(t2);
    let t3;
    if ($[7] !== isMenuOpen) {
        t3 = {
            isMenuOpen: isMenuOpen,
            source: $1ebf3304fd03762d$var$CREATE_AGENT_SOURCE
        };
        $[7] = isMenuOpen;
        $[8] = t3;
    } else t3 = $[8];
    const { shouldRenderInlineCreateAgentItem: shouldRenderInlineCreateAgentItem, shouldRenderStudioRedirectCreateAgentItem: shouldRenderStudioRedirectCreateAgentItem } = (0, $2YLrg.useCreateAgentEntryPoint)(t3);
    if (shouldRenderInlineCreateAgentItem && inlineCreateAgent) {
        let t4;
        if ($[9] !== inlineCreateAgent) {
            t4 = [
                inlineCreateAgent,
                true
            ];
            $[9] = inlineCreateAgent;
            $[10] = t4;
        } else t4 = $[10];
        return t4;
    }
    if (shouldRenderStudioRedirectCreateAgentItem && studioRedirectCreateAgent) {
        let t4;
        if ($[11] !== studioRedirectCreateAgent) {
            t4 = [
                studioRedirectCreateAgent,
                true
            ];
            $[11] = studioRedirectCreateAgent;
            $[12] = t4;
        } else t4 = $[12];
        return t4;
    }
    let t4;
    if ($[13] !== studioRedirectCreateAgent) {
        t4 = [
            studioRedirectCreateAgent,
            false
        ];
        $[13] = studioRedirectCreateAgent;
        $[14] = t4;
    } else t4 = $[14];
    return t4;
}












var $9V507 = parcelRequire("9V507");





var $irnO2 = parcelRequire("irnO2");

var $bjY3F = parcelRequire("bjY3F");





var $dDAsV = parcelRequire("dDAsV");








var $cSCao = parcelRequire("cSCao");

const $a873bb1c9107ef25$export$8432db7340d3c5cd = ({ onClick: onClick, isLoading: isLoading, source: source, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cSCao.AISmartCreateSpotlight), {
        onClick: onClick,
        offset: [
            0,
            16
        ],
        placement: "left-end",
        source: source,
        isLoading: isLoading
    }, children);
};














var $gGhWO = parcelRequire("gGhWO");











var $cbBHq = parcelRequire("cbBHq");

function $bbf9a31d260032f2$export$22e3b23b85c78fe8(t0) {
    const $ = (0, $bDgLe.c)(9);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { isDisabled: t2, includePromptSuggestions: t3 } = t1;
    const isDisabled = t2 === undefined ? false : t2;
    const includePromptSuggestions = t3 === undefined ? true : t3;
    const preloadSmartCreationModal = (0, $cbBHq.usePreloadSmartCreationModal)();
    const { loadSuggestions: loadSuggestions } = $bbf9a31d260032f2$var$useOptionalPromptSuggestions(includePromptSuggestions);
    let t4;
    if ($[2] !== includePromptSuggestions || $[3] !== isDisabled || $[4] !== loadSuggestions || $[5] !== preloadSmartCreationModal) {
        t4 = ()=>{
            preloadSmartCreationModal();
            if (!includePromptSuggestions) return;
            if (!isDisabled && (0, $9wGTI.fg)("confluence_personalized_prompts_header_preload") && (0, $6mKj3.expValEquals)("confluence_personalized_prompt_suggestions", "isEnabled", true)) loadSuggestions?.();
        };
        $[2] = includePromptSuggestions;
        $[3] = isDisabled;
        $[4] = loadSuggestions;
        $[5] = preloadSmartCreationModal;
        $[6] = t4;
    } else t4 = $[6];
    const preload = t4;
    let t5;
    if ($[7] !== preload) {
        t5 = {
            preload: preload
        };
        $[7] = preload;
        $[8] = t5;
    } else t5 = $[8];
    return t5;
}
function $bbf9a31d260032f2$var$useOptionalPromptSuggestions(includePromptSuggestions) {
    const $ = (0, $bDgLe.c)(4);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    let t0;
    if ($[0] !== cloudId) {
        t0 = {
            assistanceServiceParams: {
                product: "confluence",
                experienceId: "confluence-smart-create",
                touchpointSource: "smart-create-preload-prompt-suggestions",
                siteId: cloudId
            }
        };
        $[0] = cloudId;
        $[1] = t0;
    } else t0 = $[1];
    const promptSuggestionsParams = t0;
    const { loadSuggestions: loadSuggestions } = (0, $gGhWO.usePromptSuggestions)(promptSuggestionsParams);
    const t1 = includePromptSuggestions ? loadSuggestions : undefined;
    let t2;
    if ($[2] !== t1) {
        t2 = {
            loadSuggestions: t1
        };
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    return t2;
}





const $03068ae1a528f6bf$var$i18n = (0, $kSwu1.defineMessages)({
    smartCreateTitle: {
        id: "create-blank-fabric-page.create.content.smart-create-with-ai.title",
        defaultMessage: "Create with Rovo"
    }
});
const $03068ae1a528f6bf$var$getSpaceKeyForCreation = async ()=>{
    const spaceKeyRequest = {
        promotedSpaceKey: undefined
    };
    const spaceKeyResponse = (await (0, $dDAsV.experimentalPromotedSpacesQuery)({
        variables: {
            ...spaceKeyRequest,
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1
        }
    })).data;
    return spaceKeyResponse?.experimentalPromotedSpaces?.nodes?.[0]?.id ?? '';
};
function $03068ae1a528f6bf$export$57669fd702f839a2(t0) {
    const $ = (0, $bDgLe.c)(34);
    const { spaceKey: spaceKey, onClick: onClick, source: source, isDisabled: t1 } = t0;
    const isDisabled = t1 === undefined ? false : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const [fetchedSpaceKey, setFetchedSpaceKey] = (0, $cozmU.useState)("");
    const [spaceKeyLoading, setSpaceKeyLoading] = (0, $cozmU.useState)(true);
    const { isEnabled: isCwrSplitButtonEnabled } = (0, $74f584384b392485$export$ac119ad1f3e15167)();
    let t2;
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            setSpaceKeyLoading(true);
            $03068ae1a528f6bf$var$getSpaceKeyForCreation().then(setFetchedSpaceKey).finally(()=>setSpaceKeyLoading(false));
        };
        t3 = [];
        $[0] = t2;
        $[1] = t3;
    } else {
        t2 = $[0];
        t3 = $[1];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[2] !== isDisabled) {
        t4 = {
            isDisabled: isDisabled
        };
        $[2] = isDisabled;
        $[3] = t4;
    } else t4 = $[3];
    const { preload: smartCreatePreload } = (0, $bbf9a31d260032f2$export$22e3b23b85c78fe8)(t4);
    let t5;
    let t6;
    if ($[4] !== isCwrSplitButtonEnabled || $[5] !== isOpen || $[6] !== smartCreatePreload) {
        t5 = ()=>{
            if (isCwrSplitButtonEnabled || !isOpen) return;
            smartCreatePreload();
        };
        t6 = [
            isCwrSplitButtonEnabled,
            isOpen,
            smartCreatePreload
        ];
        $[4] = isCwrSplitButtonEnabled;
        $[5] = isOpen;
        $[6] = smartCreatePreload;
        $[7] = t5;
        $[8] = t6;
    } else {
        t5 = $[7];
        t6 = $[8];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[9] !== experienceTracker || $[10] !== fetchedSpaceKey || $[11] !== openModal || $[12] !== source || $[13] !== spaceKey) {
        t7 = ()=>{
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                id: (0, $irnO2.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                attributes: {
                    product: "confluence",
                    source: source
                }
            });
            openModal({
                entryPoint: source,
                spaceKey: spaceKey ?? fetchedSpaceKey
            });
        };
        $[9] = experienceTracker;
        $[10] = fetchedSpaceKey;
        $[11] = openModal;
        $[12] = source;
        $[13] = spaceKey;
        $[14] = t7;
    } else t7 = $[14];
    const handleOpenCreateWithRovoExperience = t7;
    let t8;
    if ($[15] !== handleOpenCreateWithRovoExperience || $[16] !== onClick) {
        t8 = (e, actionSubjectId, attributes)=>{
            onClick(actionSubjectId, attributes);
            if (e?.metaKey || e?.ctrlKey) return;
            e.preventDefault();
            handleOpenCreateWithRovoExperience();
        };
        $[15] = handleOpenCreateWithRovoExperience;
        $[16] = onClick;
        $[17] = t8;
    } else t8 = $[17];
    const handleItemOnClick = t8;
    let t9;
    if ($[18] !== handleOpenCreateWithRovoExperience || $[19] !== source || $[20] !== spaceKeyLoading) {
        t9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a873bb1c9107ef25$export$8432db7340d3c5cd), {
                onClick: ()=>handleOpenCreateWithRovoExperience(),
                isLoading: spaceKeyLoading,
                source: source
            }, props.children && props.children());
        $[18] = handleOpenCreateWithRovoExperience;
        $[19] = source;
        $[20] = spaceKeyLoading;
        $[21] = t9;
    } else t9 = $[21];
    const CreateWithRovoSpotlightWrapper = t9;
    let t10;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = (0, $1NBp8.HOME).toUrl({}, {
            query: {
                openCreateWithRovo: "true"
            }
        });
        $[22] = t10;
    } else t10 = $[22];
    const href = t10;
    let t11;
    if ($[23] !== formatMessage) {
        t11 = ()=>{
            if ((0, $9wGTI.fg)("aifc_onboarding_ga_enabled")) {
                if ((0, $6mKj3.expValEquals)("cc-aifc-databases-experiment", "isEnabled", true)) return formatMessage($03068ae1a528f6bf$var$i18n.smartCreateTitle);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
                useLabsLozenge: true
            }, formatMessage($03068ae1a528f6bf$var$i18n.smartCreateTitle));
        };
        $[23] = formatMessage;
        $[24] = t11;
    } else t11 = $[24];
    const getChildren = t11;
    let t12;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $59jY5.Ati).parse("ati:cloud:confluence:rovo");
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== getChildren) {
        t13 = getChildren();
        $[26] = getChildren;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== handleItemOnClick) {
        t14 = (e_0)=>handleItemOnClick(e_0, "createAISmartCreatePopoverItem");
        $[28] = handleItemOnClick;
        $[29] = t14;
    } else t14 = $[29];
    let t15;
    if ($[30] !== CreateWithRovoSpotlightWrapper || $[31] !== t13 || $[32] !== t14) {
        t15 = {
            ati: t12,
            children: t13,
            Wrapper: CreateWithRovoSpotlightWrapper,
            onClick: t14,
            href: href,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($9V507))),
            testId: "create-menu-link-item"
        };
        $[30] = CreateWithRovoSpotlightWrapper;
        $[31] = t13;
        $[32] = t14;
        $[33] = t15;
    } else t15 = $[33];
    return t15;
}












var $kWSTb = parcelRequire("kWSTb");



























const $6bc7537bf6fb1efd$var$i18n = (0, $kSwu1.defineMessages)({
    slideTitle: {
        id: "create-blank-fabric-page.create.content.slides.title",
        defaultMessage: "Slides"
    },
    labsLozenge: {
        id: "create-blank-fabric-page.create.content.slides.labs-lozenge",
        defaultMessage: "LABS"
    },
    labsLozengeUpdated: {
        id: "create-blank-fabric-page.create.content.slides.labs-lozenge.updated",
        defaultMessage: "Labs"
    }
});
const $6bc7537bf6fb1efd$var$getSpaceKeyForCreation = async ()=>{
    const spaceKeyRequest = {
        promotedSpaceKey: undefined
    };
    const spaceKeyResponse = (await (0, $dDAsV.experimentalPromotedSpacesQuery)({
        variables: {
            ...spaceKeyRequest,
            promotedSpacesLimit: 1,
            otherSpacesLimit: 1
        }
    })).data;
    return spaceKeyResponse?.experimentalPromotedSpaces?.nodes?.[0]?.id ?? '';
};
function $6bc7537bf6fb1efd$export$d71a131cfb663e9a(t0) {
    const $ = (0, $bDgLe.c)(31);
    const { spaceKey: spaceKey, onClick: onClick, source: source } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { openModal: openModal } = (0, $jyA9t.useSmartCreationModalActions)();
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const experienceTracker = (0, $bjY3F.useAIMateExperienceTracker)();
    const { isEnabled: isCwrSplitButtonEnabled } = (0, $74f584384b392485$export$ac119ad1f3e15167)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            includePromptSuggestions: false
        };
        $[0] = t1;
    } else t1 = $[0];
    const { preload: preloadSmartCreate } = (0, $bbf9a31d260032f2$export$22e3b23b85c78fe8)(t1);
    const [fetchedSpaceKey, setFetchedSpaceKey] = (0, $cozmU.useState)("");
    let t2;
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = ()=>{
            $6bc7537bf6fb1efd$var$getSpaceKeyForCreation().then(setFetchedSpaceKey);
        };
        t3 = [];
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    let t5;
    if ($[3] !== isCwrSplitButtonEnabled || $[4] !== isOpen || $[5] !== preloadSmartCreate) {
        t4 = ()=>{
            if (isCwrSplitButtonEnabled || !isOpen) return;
            preloadSmartCreate();
        };
        t5 = [
            isCwrSplitButtonEnabled,
            isOpen,
            preloadSmartCreate
        ];
        $[3] = isCwrSplitButtonEnabled;
        $[4] = isOpen;
        $[5] = preloadSmartCreate;
        $[6] = t4;
        $[7] = t5;
    } else {
        t4 = $[6];
        t5 = $[7];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[8] !== experienceTracker || $[9] !== fetchedSpaceKey || $[10] !== openModal || $[11] !== source || $[12] !== spaceKey) {
        t6 = ()=>{
            experienceTracker.start({
                name: (0, $irnO2.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                id: (0, $irnO2.ExperienceName).AIFC_LOAD_STAGING_AREA_MODAL,
                attributes: {
                    product: "confluence",
                    source: source
                }
            });
            openModal({
                entryPoint: source,
                spaceKey: spaceKey ?? fetchedSpaceKey,
                initialOutcomeType: "slides"
            });
        };
        $[8] = experienceTracker;
        $[9] = fetchedSpaceKey;
        $[10] = openModal;
        $[11] = source;
        $[12] = spaceKey;
        $[13] = t6;
    } else t6 = $[13];
    const handleOpenSlideCreation = t6;
    let t7;
    if ($[14] !== handleOpenSlideCreation || $[15] !== onClick) {
        t7 = (e, actionSubjectId, attributes)=>{
            onClick(actionSubjectId, attributes);
            if (e?.metaKey || e?.ctrlKey) return;
            e.preventDefault();
            handleOpenSlideCreation();
        };
        $[14] = handleOpenSlideCreation;
        $[15] = onClick;
        $[16] = t7;
    } else t7 = $[16];
    const handleItemOnClick = t7;
    let t8;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = (0, $1NBp8.HOME).toUrl({}, {
            query: {
                openCreateWithRovo: "true"
            }
        });
        $[17] = t8;
    } else t8 = $[17];
    const href = t8;
    const labsLozengeMessage = (0, $6mKj3.expValEquals)("cc_slides_labs_lozenge_ui_fix", "isEnabled", true) ? $6bc7537bf6fb1efd$var$i18n.labsLozengeUpdated : $6bc7537bf6fb1efd$var$i18n.labsLozenge;
    let t9;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = (0, $59jY5.Ati).parse("ati:cloud:confluence:slide");
        $[18] = t9;
    } else t9 = $[18];
    let t10;
    if ($[19] !== formatMessage) {
        t10 = formatMessage(labsLozengeMessage);
        $[19] = formatMessage;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== formatMessage) {
        t11 = formatMessage($6bc7537bf6fb1efd$var$i18n.slideTitle);
        $[21] = formatMessage;
        $[22] = t11;
    } else t11 = $[22];
    let t12;
    if ($[23] !== t10 || $[24] !== t11) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $925aeaac5c2ec2fe$export$32629a9f34b6d093), {
            lozenge: t10
        }, t11);
        $[23] = t10;
        $[24] = t11;
        $[25] = t12;
    } else t12 = $[25];
    let t13;
    if ($[26] !== handleItemOnClick) {
        t13 = (e_0)=>handleItemOnClick(e_0, "createSlidePopoverItem");
        $[26] = handleItemOnClick;
        $[27] = t13;
    } else t13 = $[27];
    let t14;
    if ($[28] !== t12 || $[29] !== t13) {
        t14 = {
            ati: t9,
            children: t12,
            onClick: t13,
            href: href,
            elemBefore: (0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))),
            testId: "create-menu-slide-link-item"
        };
        $[28] = t12;
        $[29] = t13;
        $[30] = t14;
    } else t14 = $[30];
    return t14;
}



var $kvDd7 = parcelRequire("kvDd7");

const $279d18c421fdc96b$export$9131280d9d18988b = 'globalCreateContentPopover';
const $279d18c421fdc96b$export$9c9b6bde1131681e = 5;
const $279d18c421fdc96b$var$messages = (0, $kSwu1.defineMessages)({
    moreFromAtlassian: {
        id: "create-blank-fabric-page.universal-create.suggestions",
        defaultMessage: "Suggestions"
    }
});
const $279d18c421fdc96b$var$toAppDefinedSection = (section)=>({
        type: 'appDefinedSection',
        ...section
    });
function $279d18c421fdc96b$export$aad046bd9909db8f(flags, closeMenu, openFrom, isMenuOpen) {
    const $ = (0, $bDgLe.c)(133);
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const { cohort: cwrSplitButtonCohort, isEnabled: splitButtonExperimentEnabled } = (0, $74f584384b392485$export$ac119ad1f3e15167)();
    let t0;
    if ($[0] !== createAnalyticsEvent || $[1] !== isLivePage || $[2] !== isOnEditRoute || $[3] !== openFrom || $[4] !== routeDataRef) {
        t0 = (actionSubjectId, attributes)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: actionSubjectId,
                    source: $279d18c421fdc96b$export$9131280d9d18988b,
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        isOnEditRoute: isOnEditRoute,
                        currentRouteName: routeDataRef?.current?.routeName,
                        currentRouteIsLive: isLivePage,
                        openFrom: openFrom,
                        ...attributes
                    }
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = isLivePage;
        $[2] = isOnEditRoute;
        $[3] = openFrom;
        $[4] = routeDataRef;
        $[5] = t0;
    } else t0 = $[5];
    const handleAnalyticsAndResetStickySearch = t0;
    let t1;
    if ($[6] !== closeMenu || $[7] !== handleAnalyticsAndResetStickySearch) {
        t1 = (actionSubjectId_0, attributes_0)=>{
            handleAnalyticsAndResetStickySearch(actionSubjectId_0, attributes_0);
            closeMenu?.();
        };
        $[6] = closeMenu;
        $[7] = handleAnalyticsAndResetStickySearch;
        $[8] = t1;
    } else t1 = $[8];
    const onClick = t1;
    const { canCreateSpace: canCreateSpace } = (0, $1KBSi.useCanCreateSpace)();
    const isLoomEntryPointEnabled = (0, $fSDMD.useIsCreateMenuLoomRecorderEntryPointEnabled)();
    const { isCreateWhiteboardEnabled: isCreateWhiteboardEnabled, isCreateBlogEnabled: isCreateBlogEnabled, isCreateLiveDocEnabled: isCreateLiveDocEnabled, isCreateDatabaseEnabled: isCreateDatabaseEnabled, isCreateSmartLinkEnabled: isCreateSmartLinkEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const t2 = !isMenuOpen;
    let t3;
    if ($[9] !== t2) {
        t3 = {
            skip: t2
        };
        $[9] = t2;
        $[10] = t3;
    } else t3 = $[10];
    const { isEnabled: isTemplateTouchpointEnabled } = (0, $8cKgI.useCfind5291TemplateTouchpoint)(t3);
    let t4;
    if ($[11] !== contentId || $[12] !== onClick || $[13] !== spaceKey) {
        t4 = {
            source: "globalCreateDropdown-startFromTemplate",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[11] = contentId;
        $[12] = onClick;
        $[13] = spaceKey;
        $[14] = t4;
    } else t4 = $[14];
    const startFromTemplate = (0, $kvDd7.useStartFromTemplateItem)(t4);
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    let t5;
    if ($[15] !== isAnonymousUser || $[16] !== isRovoLLMEnabled) {
        t5 = isRovoLLMEnabled && !isAnonymousUser && (0, $9wGTI.fg)("aifc_create_enabled");
        $[15] = isAnonymousUser;
        $[16] = isRovoLLMEnabled;
        $[17] = t5;
    } else t5 = $[17];
    const isAifcEnabled = t5;
    const t6 = !isAifcEnabled;
    let t7;
    if ($[18] !== onClick || $[19] !== openFrom || $[20] !== spaceKey || $[21] !== t6) {
        t7 = {
            source: "globalCreateDropdown-smartCreate",
            spaceKey: spaceKey,
            onClick: onClick,
            openFrom: openFrom,
            isDisabled: t6
        };
        $[18] = onClick;
        $[19] = openFrom;
        $[20] = spaceKey;
        $[21] = t6;
        $[22] = t7;
    } else t7 = $[22];
    const smartCreate = (0, $03068ae1a528f6bf$export$57669fd702f839a2)(t7);
    let t8;
    if ($[23] !== onClick || $[24] !== spaceKey) {
        t8 = {
            source: "globalCreateDropdown-slide",
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[23] = onClick;
        $[24] = spaceKey;
        $[25] = t8;
    } else t8 = $[25];
    const slide = (0, $6bc7537bf6fb1efd$export$d71a131cfb663e9a)(t8);
    let t9;
    if ($[26] !== contentId || $[27] !== onClick || $[28] !== spaceKey) {
        t9 = {
            source: "globalCreateDropdown-liveDoc",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[26] = contentId;
        $[27] = onClick;
        $[28] = spaceKey;
        $[29] = t9;
    } else t9 = $[29];
    const liveDoc = (0, $27cf2e1d8d21e923$export$5af7ed73ba9cf3af)(t9);
    let t10;
    if ($[30] !== contentId || $[31] !== onClick || $[32] !== spaceKey) {
        t10 = {
            source: "globalCreateDropdown-page",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[30] = contentId;
        $[31] = onClick;
        $[32] = spaceKey;
        $[33] = t10;
    } else t10 = $[33];
    const page = (0, $f6498381976d168b$export$e324b86258d66a8f)(t10);
    let t11;
    if ($[34] !== contentId || $[35] !== onClick || $[36] !== spaceKey) {
        t11 = {
            source: "globalCreateDropdown-whiteboard",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[34] = contentId;
        $[35] = onClick;
        $[36] = spaceKey;
        $[37] = t11;
    } else t11 = $[37];
    const whiteboard = (0, $0f054d45c9ec8df7$export$15c9136e9dd6e3b5)(t11);
    let t12;
    if ($[38] !== contentId || $[39] !== onClick || $[40] !== spaceKey) {
        t12 = {
            source: "globalCreateDropdown-database",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[38] = contentId;
        $[39] = onClick;
        $[40] = spaceKey;
        $[41] = t12;
    } else t12 = $[41];
    const database = (0, $6d2d546fa6596ac4$export$c03ba1b69410a0fd)(t12);
    let t13;
    if ($[42] !== contentId || $[43] !== onClick || $[44] !== spaceKey) {
        t13 = {
            source: "globalCreateDropdown-blog",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[42] = contentId;
        $[43] = onClick;
        $[44] = spaceKey;
        $[45] = t13;
    } else t13 = $[45];
    const blog = (0, $b66cd3653b467139$export$1850e31ba3eb45b0)(t13);
    let t14;
    if ($[46] !== contentId || $[47] !== onClick || $[48] !== spaceKey) {
        t14 = {
            source: "globalCreateDropdown-smartLinkEmbed",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[46] = contentId;
        $[47] = onClick;
        $[48] = spaceKey;
        $[49] = t14;
    } else t14 = $[49];
    const embed = (0, $5c0768c746cc7929$export$da2a30a64353a280)(t14);
    let t15;
    if ($[50] !== contentId || $[51] !== flags || $[52] !== onClick || $[53] !== spaceKey) {
        t15 = {
            source: "globalCreateDropdown-smartLinkEmbed",
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick,
            flags: flags
        };
        $[50] = contentId;
        $[51] = flags;
        $[52] = onClick;
        $[53] = spaceKey;
        $[54] = t15;
    } else t15 = $[54];
    const loom = (0, $3e0600a499c498b6$export$2c423d86f10c527b)(t15);
    let t16;
    if ($[55] !== contentId || $[56] !== isMenuOpen || $[57] !== onClick || $[58] !== spaceKey) {
        t16 = {
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick,
            isMenuOpen: isMenuOpen
        };
        $[55] = contentId;
        $[56] = isMenuOpen;
        $[57] = onClick;
        $[58] = spaceKey;
        $[59] = t16;
    } else t16 = $[59];
    const [agentItem, shouldRenderAgentItem] = (0, $1ebf3304fd03762d$export$b09c351e9082b606)(t16);
    let t17;
    if ($[60] !== contentId || $[61] !== onClick || $[62] !== spaceKey) {
        t17 = {
            source: $279d18c421fdc96b$export$9131280d9d18988b,
            parentId: contentId,
            spaceKey: spaceKey,
            onClick: onClick
        };
        $[60] = contentId;
        $[61] = onClick;
        $[62] = spaceKey;
        $[63] = t17;
    } else t17 = $[63];
    const space = (0, $293cf5b691bb25ab$export$4adf07b2777336fa)(t17);
    const { isWhiteboardFeatureEnabled: isWhiteboardFeatureEnabled } = (0, $kDja4.useIsWhiteboardFeatureEnabled)();
    let t18;
    if ($[64] !== isWhiteboardFeatureEnabled) {
        t18 = isWhiteboardFeatureEnabled("whiteboardOptOut");
        $[64] = isWhiteboardFeatureEnabled;
        $[65] = t18;
    } else t18 = $[65];
    const isOptedOutedOfWhiteboards = t18;
    let t19;
    if ($[66] !== isWhiteboardFeatureEnabled) {
        t19 = isWhiteboardFeatureEnabled("whiteboardsEnabled");
        $[66] = isWhiteboardFeatureEnabled;
        $[67] = t19;
    } else t19 = $[67];
    const isWhiteboardsEnabled = t19;
    const whiteboardOptIn = !isOptedOutedOfWhiteboards && isWhiteboardsEnabled;
    let t20;
    if ($[68] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("database") && !(0, $9wGTI.fg)("confluence_frontend_databases_opt-out");
        $[68] = t20;
    } else t20 = $[68];
    const databaseOptIn = t20;
    let t21;
    if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = (0, $yuLaV.isContentTypeEnabledInCurrentEnv)("slide");
        $[69] = t21;
    } else t21 = $[69];
    const slideOptIn = t21;
    const isSlideBaseEnabled = slideOptIn && isRovoLLMEnabled && !isAnonymousUser;
    let t22;
    if ($[70] !== isSlideBaseEnabled || $[71] !== slide) {
        t22 = ()=>isSlideBaseEnabled && (0, $6mKj3.expValEquals)("confluence_frontend_cwr_outcome_type_picker", "isEnabled", true) ? [
                slide
            ] : [];
        $[70] = isSlideBaseEnabled;
        $[71] = slide;
        $[72] = t22;
    } else t22 = $[72];
    const getSlideItem = t22;
    let t23;
    if ($[73] !== blog || $[74] !== database || $[75] !== embed || $[76] !== getSlideItem || $[77] !== isCreateBlogEnabled || $[78] !== isCreateDatabaseEnabled || $[79] !== isCreateSmartLinkEnabled || $[80] !== isCreateWhiteboardEnabled || $[81] !== whiteboard || $[82] !== whiteboardOptIn) {
        t23 = ()=>[
                ...getSlideItem(),
                ...isCreateWhiteboardEnabled && whiteboardOptIn ? [
                    whiteboard
                ] : [],
                ...isCreateDatabaseEnabled && databaseOptIn ? [
                    database
                ] : [],
                ...isCreateBlogEnabled ? [
                    blog
                ] : [],
                ...isCreateSmartLinkEnabled ? [
                    embed
                ] : []
            ];
        $[73] = blog;
        $[74] = database;
        $[75] = embed;
        $[76] = getSlideItem;
        $[77] = isCreateBlogEnabled;
        $[78] = isCreateDatabaseEnabled;
        $[79] = isCreateSmartLinkEnabled;
        $[80] = isCreateWhiteboardEnabled;
        $[81] = whiteboard;
        $[82] = whiteboardOptIn;
        $[83] = t23;
    } else t23 = $[83];
    const getCommonItems = t23;
    let t24;
    if ($[84] !== canCreateSpace || $[85] !== getCommonItems || $[86] !== isCreateLiveDocEnabled || $[87] !== liveDoc || $[88] !== page || $[89] !== space) {
        t24 = ()=>[
                ...isCreateLiveDocEnabled ? [
                    liveDoc
                ] : [],
                page,
                ...getCommonItems(),
                ...canCreateSpace ? [
                    space
                ] : []
            ];
        $[84] = canCreateSpace;
        $[85] = getCommonItems;
        $[86] = isCreateLiveDocEnabled;
        $[87] = liveDoc;
        $[88] = page;
        $[89] = space;
        $[90] = t24;
    } else t24 = $[90];
    const getRemainingItems = t24;
    let t25;
    if ($[91] !== canCreateSpace || $[92] !== getCommonItems || $[93] !== isAifcEnabled || $[94] !== isCreateLiveDocEnabled || $[95] !== liveDoc || $[96] !== page || $[97] !== smartCreate || $[98] !== space || $[99] !== splitButtonExperimentEnabled) {
        t25 = ()=>[
                ...isAifcEnabled && !splitButtonExperimentEnabled ? [
                    smartCreate
                ] : [],
                ...isCreateLiveDocEnabled ? [
                    liveDoc
                ] : [],
                page,
                ...getCommonItems(),
                ...canCreateSpace ? [
                    space
                ] : []
            ];
        $[91] = canCreateSpace;
        $[92] = getCommonItems;
        $[93] = isAifcEnabled;
        $[94] = isCreateLiveDocEnabled;
        $[95] = liveDoc;
        $[96] = page;
        $[97] = smartCreate;
        $[98] = space;
        $[99] = splitButtonExperimentEnabled;
        $[100] = t25;
    } else t25 = $[100];
    const getNativeItems = t25;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t26;
    let t27;
    if ($[101] !== agentItem || $[102] !== blog || $[103] !== canCreateSpace || $[104] !== cwrSplitButtonCohort || $[105] !== database || $[106] !== embed || $[107] !== formatMessage || $[108] !== getNativeItems || $[109] !== getRemainingItems || $[110] !== getSlideItem || $[111] !== isAifcEnabled || $[112] !== isCreateBlogEnabled || $[113] !== isCreateDatabaseEnabled || $[114] !== isCreateLiveDocEnabled || $[115] !== isCreateSmartLinkEnabled || $[116] !== isCreateWhiteboardEnabled || $[117] !== isLoomEntryPointEnabled || $[118] !== isTemplateTouchpointEnabled || $[119] !== liveDoc || $[120] !== loom || $[121] !== page || $[122] !== shouldRenderAgentItem || $[123] !== smartCreate || $[124] !== space || $[125] !== splitButtonExperimentEnabled || $[126] !== startFromTemplate || $[127] !== whiteboard || $[128] !== whiteboardOptIn) {
        t27 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const firstSectionItems = [
                ...isAifcEnabled && !splitButtonExperimentEnabled ? [
                    smartCreate
                ] : [],
                ...isTemplateTouchpointEnabled ? [
                    startFromTemplate
                ] : []
            ];
            const companionItems = [
                ...shouldRenderAgentItem ? [
                    agentItem
                ] : [],
                ...isCreateSmartLinkEnabled && isLoomEntryPointEnabled ? [
                    loom
                ] : []
            ];
            if (splitButtonExperimentEnabled) {
                const isVariant2 = cwrSplitButtonCohort === "variant_2";
                const cwrDropdownItems = [
                    ...isCreateLiveDocEnabled ? [
                        liveDoc
                    ] : [],
                    page,
                    ...getSlideItem(),
                    ...isCreateWhiteboardEnabled && whiteboardOptIn ? [
                        whiteboard
                    ] : [],
                    ...isCreateDatabaseEnabled && databaseOptIn ? [
                        database
                    ] : [],
                    ...shouldRenderAgentItem ? [
                        agentItem
                    ] : [],
                    ...canCreateSpace ? [
                        space
                    ] : [],
                    ...isCreateSmartLinkEnabled ? [
                        embed
                    ] : [],
                    ...isCreateSmartLinkEnabled && isLoomEntryPointEnabled ? [
                        loom
                    ] : [],
                    ...isCreateBlogEnabled ? [
                        blog
                    ] : []
                ];
                const cwrFoldableThreshold = isVariant2 ? 6 : $279d18c421fdc96b$export$9c9b6bde1131681e;
                t27 = [
                    ...isTemplateTouchpointEnabled ? [
                        $279d18c421fdc96b$var$toAppDefinedSection({
                            items: [
                                startFromTemplate
                            ]
                        })
                    ] : [],
                    $279d18c421fdc96b$var$toAppDefinedSection({
                        items: cwrDropdownItems,
                        foldable: cwrFoldableThreshold,
                        ...(0, $9wGTI.fg)("navx_enable_overflow_evaluation_for_cwr") ? {
                            personalize: "overflow"
                        } : {}
                    })
                ];
                break bb0;
            }
            if (isTemplateTouchpointEnabled) {
                t27 = [
                    ...firstSectionItems.length > 0 ? [
                        $279d18c421fdc96b$var$toAppDefinedSection({
                            items: firstSectionItems
                        })
                    ] : [],
                    $279d18c421fdc96b$var$toAppDefinedSection({
                        items: getRemainingItems(),
                        foldable: $279d18c421fdc96b$export$9c9b6bde1131681e
                    }),
                    ...companionItems.length > 0 ? [
                        $279d18c421fdc96b$var$toAppDefinedSection({
                            heading: formatMessage($279d18c421fdc96b$var$messages.moreFromAtlassian),
                            items: companionItems
                        })
                    ] : []
                ];
                break bb0;
            }
            let t28;
            if ($[131] !== getNativeItems) {
                t28 = $279d18c421fdc96b$var$toAppDefinedSection({
                    items: getNativeItems()
                });
                $[131] = getNativeItems;
                $[132] = t28;
            } else t28 = $[132];
            t26 = [
                t28,
                ...companionItems.length > 0 ? [
                    $279d18c421fdc96b$var$toAppDefinedSection({
                        heading: formatMessage($279d18c421fdc96b$var$messages.moreFromAtlassian),
                        items: companionItems
                    })
                ] : []
            ];
        }
        $[101] = agentItem;
        $[102] = blog;
        $[103] = canCreateSpace;
        $[104] = cwrSplitButtonCohort;
        $[105] = database;
        $[106] = embed;
        $[107] = formatMessage;
        $[108] = getNativeItems;
        $[109] = getRemainingItems;
        $[110] = getSlideItem;
        $[111] = isAifcEnabled;
        $[112] = isCreateBlogEnabled;
        $[113] = isCreateDatabaseEnabled;
        $[114] = isCreateLiveDocEnabled;
        $[115] = isCreateSmartLinkEnabled;
        $[116] = isCreateWhiteboardEnabled;
        $[117] = isLoomEntryPointEnabled;
        $[118] = isTemplateTouchpointEnabled;
        $[119] = liveDoc;
        $[120] = loom;
        $[121] = page;
        $[122] = shouldRenderAgentItem;
        $[123] = smartCreate;
        $[124] = space;
        $[125] = splitButtonExperimentEnabled;
        $[126] = startFromTemplate;
        $[127] = whiteboard;
        $[128] = whiteboardOptIn;
        $[129] = t26;
        $[130] = t27;
    } else {
        t26 = $[129];
        t27 = $[130];
    }
    if (t27 !== Symbol.for("react.early_return_sentinel")) return t27;
    return t26;
}








var $9kbTQ = parcelRequire("9kbTQ");




const $a52e0e6bf8a40dbe$export$a558e476d93d8da8 = (0, $kSwu1.defineMessages)({
    commonConfirm: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.common.confirm",
        defaultMessage: "OK"
    },
    commonConfirmSecond: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.common.confirm-second",
        defaultMessage: "Got it"
    },
    commonCreateWithRovo: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.common.create-with-rovo",
        defaultMessage: "Create with Rovo"
    },
    commonTitle: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.common.title",
        defaultMessage: "We\u2019re evolving how work starts"
    },
    cwrModalBodyFirst: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.cwr-modal.body-first",
        defaultMessage: "Choose <b>Create</b> to get started instantly with Rovo\u2019s help."
    },
    cwrModalBodySecond: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.cwr-modal.body-second",
        defaultMessage: "Or select the dropdown to start a new doc, whiteboard, database, or slides."
    },
    ucDropdownBodyFirst: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.uc-dropdown.body-first",
        defaultMessage: "Use the dropdown for a new doc, whiteboard, database, or slides."
    },
    ucDropdownBodySecond: {
        id: "create-blank-fabric-page.universal-create.split-button-spotlight.uc-dropdown.body-second",
        defaultMessage: "Or choose <b>Create</b> to get started instantly with Rovo\u2019s help."
    }
});






var $1UApO = parcelRequire("1UApO");


var $17wUi = parcelRequire("17wUi");

const $68762274af90cc37$var$SPOTLIGHT_SEEN_LOCAL_STORAGE_KEY = (0, $1UApO.keys).NAVX_UC_CWR_EXPERIMENT_SPOTLIGHT_SEEN;
const $68762274af90cc37$var$hasSeen = {
    current: false
};
const $68762274af90cc37$var$listeners = new Set();
const $68762274af90cc37$var$markSessionHasSeenSpotlight = ()=>{
    if ($68762274af90cc37$var$hasSeen.current) return false;
    $68762274af90cc37$var$hasSeen.current = true;
    return true;
};
const $68762274af90cc37$var$notifySpotlightSeen = ()=>{
    $68762274af90cc37$var$listeners.forEach((listener)=>{
        try {
            listener(true);
        } catch  {
        // ignore — a throwing listener must not prevent remaining instances from being notified
        }
    });
};
const $68762274af90cc37$export$99a178eaddf8b36f = ()=>{
    $68762274af90cc37$var$hasSeen.current = false;
    $68762274af90cc37$var$listeners.clear();
};
const $68762274af90cc37$export$f62f78e205629f77 = ()=>$68762274af90cc37$var$listeners;
const $68762274af90cc37$export$523e463438887ddd = ()=>{
    const [hasSeenSpotlight, setHasSeenSpotlight] = (0, $cozmU.useState)(true);
    (0, $cozmU.useEffect)(function syncFromStorage() {
        if (!$68762274af90cc37$var$hasSeen.current) try {
            $68762274af90cc37$var$hasSeen.current = (0, $17wUi.confluenceLocalStorageInstance)?.getItem($68762274af90cc37$var$SPOTLIGHT_SEEN_LOCAL_STORAGE_KEY) === 'true';
        } catch  {
            $68762274af90cc37$var$hasSeen.current = false;
        }
        if (!$68762274af90cc37$var$hasSeen.current) setHasSeenSpotlight(false);
        const listener = (nextHasSeenSpotlight)=>{
            setHasSeenSpotlight(nextHasSeenSpotlight);
        };
        $68762274af90cc37$var$listeners.add(listener);
        return ()=>{
            $68762274af90cc37$var$listeners.delete(listener);
        };
    }, []);
    const markSpotlightSeen = (0, $cozmU.useCallback)(()=>{
        if (!$68762274af90cc37$var$markSessionHasSeenSpotlight()) return;
        $68762274af90cc37$var$notifySpotlightSeen();
        try {
            (0, $17wUi.confluenceLocalStorageInstance)?.setItem($68762274af90cc37$var$SPOTLIGHT_SEEN_LOCAL_STORAGE_KEY, 'true');
        } catch  {
        // storage errors are ignored — in-memory flag prevents re-showing
        }
    }, []);
    return {
        hasSeenSpotlight: hasSeenSpotlight,
        markSpotlightSeen: markSpotlightSeen
    };
};


/* useRenderCwRSpotlight.tsx generated by @compiled/babel-plugin v0.40.0 */ 












var $cK21K = parcelRequire("cK21K");





var $dinVW = parcelRequire("dinVW");








var $lsxnT = parcelRequire("lsxnT");


var $4UYoK = parcelRequire("4UYoK");


var $ivb8S = parcelRequire("ivb8S");




var $f65fefd7ad449631$exports = {};
$f65fefd7ad449631$exports = new URL("SplitButton.fc5c11e3.gif", import.meta.url).toString();










var $8EsbU = parcelRequire("8EsbU");

function $2bd5ea936eebb583$export$59e7f2eafb999a15(selector, t0) {
    const $ = (0, $bDgLe.c)(6);
    let t1;
    if ($[0] !== t0) {
        t1 = t0 === undefined ? {} : t0;
        $[0] = t0;
        $[1] = t1;
    } else t1 = $[1];
    const { disabled: t2 } = t1;
    const disabled = t2 === undefined ? false : t2;
    const [element, setElement] = (0, $cozmU.useState)(null);
    let t3;
    let t4;
    if ($[2] !== disabled || $[3] !== selector) {
        t3 = ()=>{
            if (!(0, $8EsbU.isClientSide)()) return;
            if (disabled) return;
            const resolve = ()=>{
                const next = document.querySelector(selector);
                setElement((current)=>current === next ? current : next);
            };
            resolve();
            const observer = new MutationObserver(resolve);
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
                setElement(null);
            };
        };
        t4 = [
            selector,
            disabled
        ];
        $[2] = disabled;
        $[3] = selector;
        $[4] = t3;
        $[5] = t4;
    } else {
        t3 = $[4];
        t4 = $[5];
    }
    (0, $cozmU.useEffect)(t3, t4);
    return element;
}



var $9chzr = parcelRequire("9chzr");





var $6OwHS = parcelRequire("6OwHS");


































const $d1559ad272a98aae$var$ONBOARDING_STATE_KEYS_TO_FETCH = Object.values((0, $4UYoK.UNIVERSAL_CREATE_CWR_EXPERIMENT_SPOTLIGHT_ONBOARDING_STATE_KEYS));
const $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID = 'universalCreateCwRExperimentSpotlight';
const $d1559ad272a98aae$var$CHOREOGRAPHER_BLOCKED_STATUS = 'blocked';
const $d1559ad272a98aae$var$spotlightAnchorStyles = {
    menuAnchorWrapper: "_1e0c1ule _kqswstnw _154ixy5q _1ltvx0bf _1bsbt94y _4t3it94y",
    buttonAnchorWrapper: "_1e0c1ule _kqswstnw _94n5x0bf _1ltv1ssb _t9eczr6s _1bsbt94y _4t3it94y"
};
const $d1559ad272a98aae$var$RICH_TEXT_VALUES = {
    b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            weight: "bold"
        }, chunks)
};
const $d1559ad272a98aae$var$isKeyboardDismissEvent = (event)=>'key' in event;
const $d1559ad272a98aae$var$isDismissButtonEvent = (event)=>'nativeEvent' in event && typeof HTMLButtonElement !== 'undefined' && event.currentTarget instanceof HTMLButtonElement;
const $d1559ad272a98aae$export$59afd03a8f79b543 = (event)=>{
    if ($d1559ad272a98aae$var$isKeyboardDismissEvent(event)) return 'escape';
    return $d1559ad272a98aae$var$isDismissButtonEvent(event) ? 'dismissButton' : 'blanket';
};
const $d1559ad272a98aae$export$2b0a29a923d36d62 = ({ anchorSelector: anchorSelector, choreographerMessageId: choreographerMessageId, spotlightTarget: spotlightTarget, messages: messages, placement: placement, isEnabled: isEnabled, requireAnchorForStart: requireAnchorForStart = false, onCtaClick: onCtaClick, onClosed: onClosed, onBlocked: onBlocked })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const { useChoreographer: useChoreographer } = (0, $lsxnT.useChoreographerAssets)();
    const { hasSeenSpotlight: hasSeenSpotlightInStorage, markSpotlightSeen: markSpotlightSeenInStorage } = (0, $68762274af90cc37$export$523e463438887ddd)();
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const [isSpotlightActive, setIsSpotlightActive] = (0, $cozmU.useState)(false);
    const skipOnboardingStateQuery = hasSeenSpotlightInStorage || !isEnabled || isServerPlaceholder;
    const { data: onboardingStateData, loading: isOnboardingStateLoading, error: isOnboardingStateError } = (0, $ivb8S.useGetOnboardingState)($d1559ad272a98aae$var$ONBOARDING_STATE_KEYS_TO_FETCH, skipOnboardingStateQuery);
    const { hasSeenUniversalCreateCwRExperimentSpotlight: hasSeenUniversalCreateCwRExperimentSpotlight } = (0, $ivb8S.deserializeState)(onboardingStateData);
    const shouldSuppressSpotlight = Boolean(hasSeenUniversalCreateCwRExperimentSpotlight) || hasSeenSpotlightInStorage; // When the backend onboarding state reports the spotlight has been seen but local storage has
    // not been updated yet, mirror it into local storage so subsequent renders short-circuit the
    // `useGetOnboardingState` query (which is otherwise re-run on every render).
    (0, $cozmU.useEffect)(()=>{
        if (hasSeenUniversalCreateCwRExperimentSpotlight && !hasSeenSpotlightInStorage) markSpotlightSeenInStorage();
    }, [
        hasSeenUniversalCreateCwRExperimentSpotlight,
        hasSeenSpotlightInStorage,
        markSpotlightSeenInStorage
    ]);
    const anchorEl = (0, $2bd5ea936eebb583$export$59e7f2eafb999a15)(anchorSelector, {
        disabled: isServerPlaceholder || shouldSuppressSpotlight || Boolean(isOnboardingStateError)
    });
    const hasStoppedRef = (0, $cozmU.useRef)(false);
    const handleSpotlightStart = (0, $cozmU.useCallback)(()=>{
        setIsSpotlightActive(true);
        hasStoppedRef.current = false;
        createEvent({
            type: 'sendScreenEvent',
            data: {
                name: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                attributes: {
                    source: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                    spotlightTarget: spotlightTarget
                }
            }
        }).fire();
    }, [
        createEvent,
        spotlightTarget
    ]);
    const markSpotlightSeen = (0, $cozmU.useCallback)(()=>{
        markSpotlightSeenInStorage();
        setOnboardingState({
            key: (0, $4UYoK.UNIVERSAL_CREATE_CWR_EXPERIMENT_SPOTLIGHT_ONBOARDING_STATE_KEYS).hasSeenUniversalCreateCwRExperimentSpotlight,
            value: 'true'
        });
    }, [
        markSpotlightSeenInStorage,
        setOnboardingState
    ]);
    const handleSpotlightStop = (0, $cozmU.useCallback)(()=>{
        setIsSpotlightActive(false);
    }, []); // eslint-disable-next-line -- useChoreographer is the stable hook exposed by choreographer context.
    const choreographer = useChoreographer(choreographerMessageId, {
        start: handleSpotlightStart,
        stop: handleSpotlightStop
    });
    const fireSpotlightDisplayRequestedEvent = (0, $cozmU.useCallback)(()=>{
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'requested',
                actionSubject: 'spotlight',
                actionSubjectId: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                source: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                attributes: {
                    spotlightTarget: spotlightTarget
                }
            }
        }).fire();
    }, [
        createEvent,
        spotlightTarget
    ]);
    const fireSpotlightNotDisplayedEvent = (0, $cozmU.useCallback)((reason)=>{
        createEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'notDisplayed',
                actionSubject: 'spotlight',
                actionSubjectId: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                source: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                attributes: {
                    choreographerMessageId: choreographerMessageId,
                    reason: reason,
                    spotlightTarget: spotlightTarget
                }
            }
        }).fire();
    }, [
        choreographerMessageId,
        createEvent,
        spotlightTarget
    ]);
    const startSpotlight = (0, $cozmU.useCallback)(()=>{
        if (isOnboardingStateLoading || isOnboardingStateError || shouldSuppressSpotlight || requireAnchorForStart && anchorEl === null) return false;
        fireSpotlightDisplayRequestedEvent();
        choreographer.startMessage().then((status)=>{
            if (status === $d1559ad272a98aae$var$CHOREOGRAPHER_BLOCKED_STATUS) {
                fireSpotlightNotDisplayedEvent('choreographerBlocked');
                onBlocked?.(spotlightTarget);
            }
        }).catch(()=>{
            fireSpotlightNotDisplayedEvent('choreographerError');
        });
        return true;
    }, [
        choreographer,
        fireSpotlightNotDisplayedEvent,
        fireSpotlightDisplayRequestedEvent,
        onBlocked,
        spotlightTarget,
        shouldSuppressSpotlight,
        requireAnchorForStart,
        isOnboardingStateError,
        isOnboardingStateLoading,
        anchorEl
    ]);
    const stopSpotlight = (0, $cozmU.useCallback)(()=>{
        if (hasStoppedRef.current) return;
        hasStoppedRef.current = true;
        choreographer.stopMessage();
    }, [
        choreographer
    ]);
    const closeSpotlight = (0, $cozmU.useCallback)((action, interactionType)=>{
        markSpotlightSeen();
        createEvent({
            type: 'sendUIEvent',
            data: {
                action: action,
                actionSubject: 'spotlight',
                actionSubjectId: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                source: $d1559ad272a98aae$var$SPOTLIGHT_ANALYTICS_ID,
                attributes: {
                    interactionType: interactionType,
                    spotlightTarget: spotlightTarget
                }
            }
        }).fire();
        stopSpotlight();
        onClosed?.();
    }, [
        createEvent,
        markSpotlightSeen,
        spotlightTarget,
        stopSpotlight,
        onClosed
    ]);
    const handleDismiss = (0, $cozmU.useCallback)((event)=>closeSpotlight('dismissed', $d1559ad272a98aae$export$59afd03a8f79b543(event)), [
        closeSpotlight
    ]);
    const handleCtaClick = (0, $cozmU.useCallback)((event_0)=>{
        closeSpotlight('clicked', 'cta');
        onCtaClick?.(event_0);
    }, [
        closeSpotlight,
        onCtaClick
    ]);
    const canRender = !isServerPlaceholder && isEnabled && anchorEl !== null && !isOnboardingStateLoading && !shouldSuppressSpotlight;
    const spotlight = canRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Zall.PopoverProvider), null, /*#__PURE__*/ (0, $9kbTQ.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": true,
        testId: "hidden-mounting-target",
        xcss: placement === 'left-end' ? $d1559ad272a98aae$var$spotlightAnchorStyles.menuAnchorWrapper : $d1559ad272a98aae$var$spotlightAnchorStyles.buttonAnchorWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8jXZv.PopoverTarget), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span"
    }))), anchorEl), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cK21K.default), {
        zIndex: 600
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dOlTT.PopoverContent), {
        dismiss: handleDismiss,
        isVisible: isSpotlightActive,
        placement: placement
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9chzr.UNSAFE_UpdateOnChange), {
        selectors: [
            anchorSelector
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gi4qj.SpotlightCard), {
        testId: "universal-create-cwr-experiment-spotlight"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6VFk2.SpotlightHeader), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4enp7.SpotlightHeadline), null, formatMessage(messages.title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4AC39.SpotlightControls), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l3ydK.SpotlightDismissControl), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6OwHS.SpotlightMedia), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($f65fefd7ad449631$exports))),
        alt: "",
        width: 295,
        height: 135
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $uyMbP.SpotlightBody), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...messages.bodyLine1,
        values: $d1559ad272a98aae$var$RICH_TEXT_VALUES
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...messages.bodyLine2,
        values: $d1559ad272a98aae$var$RICH_TEXT_VALUES
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2Vz7H.SpotlightFooter), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3eYzF.SpotlightActions), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2K2hA.SpotlightPrimaryAction), {
        onClick: handleCtaClick
    }, formatMessage(messages.cta)))))))) : null;
    return {
        spotlight: spotlight,
        startSpotlight: startSpotlight,
        stopSpotlight: stopSpotlight,
        isSpotlightActive: isSpotlightActive
    };
};


const $d6b7fe885cb9ec2d$var$MENU_ANCHOR_SELECTOR = '[data-testid="global-create-content-popover-menu--hidden"]';
const $d6b7fe885cb9ec2d$var$BUTTON_ANCHOR_SELECTOR = '[data-testid="uc-trigger-button-primary"]';
const $d6b7fe885cb9ec2d$var$SHARED_CHOREOGRAPHER_MESSAGE_ID = 'UniversalCreateCwRExperimentSpotlight';
const $d6b7fe885cb9ec2d$var$MENU_VARIANT_CONFIG = {
    anchorSelector: $d6b7fe885cb9ec2d$var$MENU_ANCHOR_SELECTOR,
    messages: {
        title: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).commonTitle,
        bodyLine1: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).ucDropdownBodyFirst,
        bodyLine2: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).ucDropdownBodySecond,
        cta: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).commonConfirm
    },
    placement: 'left-end',
    requireAnchorForStart: false
};
const $d6b7fe885cb9ec2d$var$BUTTON_VARIANT_CONFIG = {
    anchorSelector: $d6b7fe885cb9ec2d$var$BUTTON_ANCHOR_SELECTOR,
    messages: {
        title: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).commonTitle,
        bodyLine1: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).cwrModalBodyFirst,
        bodyLine2: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).cwrModalBodySecond,
        cta: (0, $a52e0e6bf8a40dbe$export$a558e476d93d8da8).commonCreateWithRovo
    },
    placement: 'bottom-start',
    requireAnchorForStart: true
};
const $d6b7fe885cb9ec2d$var$SPOTLIGHT_VARIANT_CONFIGS = {
    button: $d6b7fe885cb9ec2d$var$BUTTON_VARIANT_CONFIG,
    menu: $d6b7fe885cb9ec2d$var$MENU_VARIANT_CONFIG
};
function $d6b7fe885cb9ec2d$export$98e75a504ceeacc2({ isMenuOpen: isMenuOpen, onCloseMenu: onCloseMenu, onClick: dropdownOnClick, primaryActionItem: primaryActionItem, enabled: enabled = true }) {
    const { hasSeenSpotlight: hasSeenSpotlight } = (0, $68762274af90cc37$export$523e463438887ddd)();
    const [spotlightVariant, setSpotlightVariant] = (0, $cozmU.useState)('button');
    const [hasInteracted, setHasInteracted] = (0, $cozmU.useState)(false);
    const pendingVariantRef = (0, $cozmU.useRef)(null);
    const pendingOnClickRef = (0, $cozmU.useRef)(undefined);
    const startSpotlightRef = (0, $cozmU.useRef)(()=>false);
    const stopSpotlightRef = (0, $cozmU.useRef)(()=>{});
    const flushPendingOnClick = (0, $cozmU.useCallback)(()=>{
        const pending = pendingOnClickRef.current;
        pendingOnClickRef.current = undefined;
        pending?.();
    }, []);
    const spotlightVariantRef = (0, $cozmU.useRef)(spotlightVariant);
    spotlightVariantRef.current = spotlightVariant;
    const handleMenuClosed = (0, $cozmU.useCallback)(()=>{
        const variantActiveOrPending = spotlightVariantRef.current === 'menu' || pendingVariantRef.current === 'menu';
        if (variantActiveOrPending) {
            stopSpotlightRef.current();
            pendingVariantRef.current = null;
        }
        onCloseMenu?.();
    }, [
        onCloseMenu
    ]);
    const handleCtaClick = (0, $cozmU.useCallback)((event)=>{
        if (spotlightVariantRef.current === 'menu') {
            // Prevent the click from bubbling to the underlying popup/menu
            // (e.g. as a click-outside) so the dropdown stays open when the
            // spotlight's primary action is pressed. Mirrors the reference
            // example at
            // platform/packages/navigation/universal-create/examples/29-menu-dropdown-spotlight-selector-only.tsx.
            event.preventDefault();
            event.stopPropagation();
            // Stop the spotlight but keep the menu dropdown open.
            stopSpotlightRef.current();
            pendingVariantRef.current = null;
        }
    }, []);
    const handleSpotlightClosed = (0, $cozmU.useCallback)(()=>{
        if (spotlightVariantRef.current === 'button') flushPendingOnClick();
    }, [
        flushPendingOnClick
    ]);
    const handleSpotlightBlocked = (0, $cozmU.useCallback)((blockedVariant)=>{
        // Ignore stale blocked callbacks from older start attempts.
        if (pendingVariantRef.current !== blockedVariant) return;
        pendingVariantRef.current = null;
        if (blockedVariant === 'button') flushPendingOnClick();
    }, [
        flushPendingOnClick
    ]);
    const activeSpotlightConfig = $d6b7fe885cb9ec2d$var$SPOTLIGHT_VARIANT_CONFIGS[spotlightVariant];
    const { spotlight: spotlight, startSpotlight: startSpotlight, stopSpotlight: stopSpotlight } = (0, $d1559ad272a98aae$export$2b0a29a923d36d62)({
        ...activeSpotlightConfig,
        choreographerMessageId: $d6b7fe885cb9ec2d$var$SHARED_CHOREOGRAPHER_MESSAGE_ID,
        isEnabled: enabled && (spotlightVariant === 'button' || isMenuOpen),
        spotlightTarget: spotlightVariant,
        onCtaClick: handleCtaClick,
        onClosed: handleSpotlightClosed,
        onBlocked: handleSpotlightBlocked
    });
    startSpotlightRef.current = startSpotlight;
    stopSpotlightRef.current = stopSpotlight;
    const scheduleSpotlightStart = (0, $cozmU.useCallback)((variant)=>{
        pendingVariantRef.current = variant;
        if (spotlightVariantRef.current !== variant || !hasInteracted) (0, $9kbTQ.flushSync)(()=>{
            setHasInteracted(true);
            setSpotlightVariant(variant);
        });
        const didStart = startSpotlightRef.current();
        if (!didStart) {
            pendingVariantRef.current = null;
            if (variant === 'button') flushPendingOnClick();
        }
    }, [
        flushPendingOnClick,
        hasInteracted
    ]);
    const interceptedDropdownOnClick = (0, $cozmU.useCallback)(()=>{
        dropdownOnClick?.();
        if (hasSeenSpotlight || pendingVariantRef.current !== null) return;
        scheduleSpotlightStart('menu');
    }, [
        hasSeenSpotlight,
        dropdownOnClick,
        scheduleSpotlightStart
    ]);
    const interceptedPrimaryActionItem = (0, $cozmU.useMemo)(()=>{
        if (!primaryActionItem || hasSeenSpotlight) return primaryActionItem;
        const originalPrimaryOnClick = primaryActionItem.onClick;
        const interceptedPrimaryOnClick = (event_0)=>{
            pendingOnClickRef.current = originalPrimaryOnClick ? ()=>originalPrimaryOnClick(event_0) : undefined;
            scheduleSpotlightStart('button');
        };
        return {
            ...primaryActionItem,
            onClick: interceptedPrimaryOnClick
        };
    }, [
        hasSeenSpotlight,
        primaryActionItem,
        scheduleSpotlightStart
    ]);
    if (!enabled) return {
        onClick: dropdownOnClick,
        onCloseMenu: onCloseMenu ?? (()=>{}),
        primaryActionItem: primaryActionItem,
        spotlight: null
    };
    return {
        onClick: hasSeenSpotlight ? dropdownOnClick : interceptedDropdownOnClick,
        onCloseMenu: handleMenuClosed,
        primaryActionItem: interceptedPrimaryActionItem,
        spotlight: hasInteracted ? spotlight : null
    };
}



const $f44feda85e5453ef$var$messages = (0, $kSwu1.defineMessages)({
    create: {
        id: "create-blank-fabric-page.universal-create.create.text",
        defaultMessage: "Create"
    },
    managedFolderCreateErrorTitle: {
        id: "create-blank-fabric-page.universal-create.managed-folder-create-error.title",
        defaultMessage: "We\u2019re unable to create here"
    },
    managedFolderCreateErrorDescription: {
        id: "create-blank-fabric-page.universal-create.managed-folder-create-error.description",
        defaultMessage: "This folder is synced from another app. Choose another location to create content."
    }
});
const $f44feda85e5453ef$export$256eebed8e934f30 = (createButtonTheme)=>(current, props)=>{
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = current(props);
        return {
            buttonStyles: {
                ...buttonStyles,
                ...createButtonTheme.default,
                margin: 0,
                fontWeight: "var(--ds-font-weight-medium, 500)",
                ':hover': createButtonTheme.hover,
                ':focus': createButtonTheme.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': {
                    ...props.state === 'active' && createButtonTheme.active
                }
            },
            spinnerStyles: spinnerStyles
        };
    };
const $f44feda85e5453ef$var$Create = (t0)=>{
    const $ = (0, $bDgLe.c)(76);
    const { flags: flags } = t0;
    const { isOpen: isOpen } = (0, $eB1TF.useUniversalCreateState)();
    const { setIsOpen: setIsOpen, setOpenFrom: setOpenFrom } = (0, $eB1TF.useUniversalCreateActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const { theme: theme } = (0, $cozmU.useContext)((0, $lBYCH.AppNavigationContext));
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { isRovoLLMEnabled: isRovoLLMEnabled, accessStatus: accessStatus, isLoggedIn: isLoggedIn } = (0, $bQm3c.useSessionData)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { isSmartFoldersEnabled: isSmartFoldersEnabled, loading: isSmartFoldersEnabledLoading } = (0, $ftFOj.useIsSmartFoldersEnabled)(spaceKey);
    const { isInSmartFolderTree: isInSmartFolderTree, loading: isSmartFolderTreeLoading } = (0, $bpufi.useIsInSmartFolderTree)(isSmartFoldersEnabled ? contentId : undefined);
    const isSmartFolderCheckPending = !!contentId && (isSmartFoldersEnabledLoading || isSmartFolderTreeLoading);
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { isEnabled: isCwrSplitButtonEnabled } = (0, $74f584384b392485$export$ac119ad1f3e15167)();
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t1;
    if ($[0] !== setIsOpen) {
        t1 = ()=>setIsOpen(false);
        $[0] = setIsOpen;
        $[1] = t1;
    } else t1 = $[1];
    const menuItems = (0, $279d18c421fdc96b$export$aad046bd9909db8f)(flags, t1, undefined, isOpen);
    let t2;
    if ($[2] !== theme) {
        t2 = theme?.mode?.create ? $f44feda85e5453ef$export$256eebed8e934f30(theme.mode.create) : undefined;
        $[2] = theme;
        $[3] = t2;
    } else t2 = $[3];
    const buttonTheme = t2;
    const isAnonymousUser = accessStatus === (0, $d9tcB.AccessStatus).ANONYMOUS_ACCESS || !isLoggedIn;
    let t3;
    if ($[4] !== isAnonymousUser || $[5] !== isRovoLLMEnabled) {
        t3 = isRovoLLMEnabled && !isAnonymousUser && (0, $9wGTI.fg)("aifc_create_enabled");
        $[4] = isAnonymousUser;
        $[5] = isRovoLLMEnabled;
        $[6] = t3;
    } else t3 = $[6];
    const isAIFCCreateEnabled = t3;
    let t4;
    if ($[7] !== isAIFCCreateEnabled || $[8] !== isCwrSplitButtonEnabled || $[9] !== isServerPlaceholder) {
        t4 = !isServerPlaceholder && isAIFCCreateEnabled && isCwrSplitButtonEnabled && (0, $9wGTI.fg)("navx_uc_cwr_experiment_spotlight_enabled");
        $[7] = isAIFCCreateEnabled;
        $[8] = isCwrSplitButtonEnabled;
        $[9] = isServerPlaceholder;
        $[10] = t4;
    } else t4 = $[10];
    const experimentSpotlightEnabled = t4;
    let t5;
    if ($[11] !== flags) {
        t5 = ()=>{
            flags.showErrorFlag({
                id: "global-create-managed-folder-tree-error",
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f44feda85e5453ef$var$messages.managedFolderCreateErrorTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $f44feda85e5453ef$var$messages.managedFolderCreateErrorDescription)
            });
        };
        $[11] = flags;
        $[12] = t5;
    } else t5 = $[12];
    const showManagedFolderCreateError = t5;
    let t6;
    if ($[13] !== createAnalyticsEvent || $[14] !== isInSmartFolderTree || $[15] !== isOnEditRoute || $[16] !== isOpen || $[17] !== isSmartFolderCheckPending || $[18] !== match?.name || $[19] !== setIsOpen || $[20] !== showManagedFolderCreateError) {
        t6 = ()=>{
            const willOpen = !isOpen;
            const isBlockedByManagedFolderTree = willOpen && (isInSmartFolderTree || isSmartFolderCheckPending);
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "navigationItem",
                    actionSubjectId: "globalCreateContentPopover",
                    source: "globalNavigation",
                    attributes: {
                        selectedItemPageContext: match?.name,
                        navigationLayer: "global",
                        navigationContainer: "top",
                        navVersion: "4",
                        navdexPointType: (0, $56QzY.START),
                        isOnEditRoute: isOnEditRoute,
                        ...isBlockedByManagedFolderTree && {
                            blockedReason: "managedFolderTree"
                        }
                    }
                }
            }).fire();
            if (isBlockedByManagedFolderTree) {
                showManagedFolderCreateError();
                return;
            }
            setIsOpen(willOpen);
        };
        $[13] = createAnalyticsEvent;
        $[14] = isInSmartFolderTree;
        $[15] = isOnEditRoute;
        $[16] = isOpen;
        $[17] = isSmartFolderCheckPending;
        $[18] = match?.name;
        $[19] = setIsOpen;
        $[20] = showManagedFolderCreateError;
        $[21] = t6;
    } else t6 = $[21];
    const onCreateClick = t6;
    let t7;
    if ($[22] !== createAnalyticsEvent || $[23] !== isLivePage || $[24] !== isOnEditRoute || $[25] !== routeDataRef) {
        t7 = (actionSubjectId, attributes)=>{
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: actionSubjectId,
                    source: (0, $279d18c421fdc96b$export$9131280d9d18988b),
                    attributes: {
                        navdexPointType: (0, $56QzY.END),
                        isOnEditRoute: isOnEditRoute,
                        currentRouteName: routeDataRef?.current?.routeName,
                        currentRouteIsLive: isLivePage,
                        ...attributes
                    }
                }
            }).fire();
        };
        $[22] = createAnalyticsEvent;
        $[23] = isLivePage;
        $[24] = isOnEditRoute;
        $[25] = routeDataRef;
        $[26] = t7;
    } else t7 = $[26];
    const handleAnalyticsAndResetStickySearch = t7;
    let t8;
    if ($[27] !== handleAnalyticsAndResetStickySearch || $[28] !== setIsOpen) {
        t8 = (actionSubjectId_0, attributes_0)=>{
            handleAnalyticsAndResetStickySearch(actionSubjectId_0, attributes_0);
            setIsOpen(false);
        };
        $[27] = handleAnalyticsAndResetStickySearch;
        $[28] = setIsOpen;
        $[29] = t8;
    } else t8 = $[29];
    const onSmartCreateClick = t8;
    const t9 = !isAIFCCreateEnabled;
    let t10;
    if ($[30] !== onSmartCreateClick || $[31] !== spaceKey || $[32] !== t9) {
        t10 = {
            source: "globalCreateDropdown-smartCreate",
            spaceKey: spaceKey,
            onClick: onSmartCreateClick,
            isDisabled: t9
        };
        $[30] = onSmartCreateClick;
        $[31] = spaceKey;
        $[32] = t9;
        $[33] = t10;
    } else t10 = $[33];
    const smartCreateItem = (0, $03068ae1a528f6bf$export$57669fd702f839a2)(t10);
    const t11 = !isAIFCCreateEnabled;
    let t12;
    if ($[34] !== t11) {
        t12 = {
            isDisabled: t11,
            includePromptSuggestions: false
        };
        $[34] = t11;
        $[35] = t12;
    } else t12 = $[35];
    const { preload: preloadSmartCreate } = (0, $bbf9a31d260032f2$export$22e3b23b85c78fe8)(t12);
    const hasPreloadedSmartCreateRef = (0, $cozmU.useRef)(false);
    let t13;
    if ($[36] !== isAIFCCreateEnabled || $[37] !== isCwrSplitButtonEnabled || $[38] !== preloadSmartCreate) {
        t13 = ()=>{
            if (hasPreloadedSmartCreateRef.current || !isAIFCCreateEnabled || !isCwrSplitButtonEnabled) return;
            hasPreloadedSmartCreateRef.current = true;
            preloadSmartCreate();
        };
        $[36] = isAIFCCreateEnabled;
        $[37] = isCwrSplitButtonEnabled;
        $[38] = preloadSmartCreate;
        $[39] = t13;
    } else t13 = $[39];
    const onTriggerMouseEnter = t13;
    let t14;
    if ($[40] !== setIsOpen || $[41] !== setOpenFrom) {
        t14 = ()=>{
            setIsOpen(false);
            setOpenFrom("");
        };
        $[40] = setIsOpen;
        $[41] = setOpenFrom;
        $[42] = t14;
    } else t14 = $[42];
    const onClose = t14;
    let t15;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = {
            enabled: false
        };
        $[43] = t15;
    } else t15 = $[43];
    const crossAppCreationConfig = t15;
    const originalPrimaryActionItem = isAIFCCreateEnabled && isCwrSplitButtonEnabled ? smartCreateItem : undefined;
    let t16;
    bb0: {
        if (!originalPrimaryActionItem) {
            t16 = undefined;
            break bb0;
        }
        let t17;
        if ($[44] !== handleAnalyticsAndResetStickySearch || $[45] !== isInSmartFolderTree || $[46] !== isSmartFolderCheckPending || $[47] !== originalPrimaryActionItem || $[48] !== setIsOpen || $[49] !== showManagedFolderCreateError) {
            t17 = (event)=>{
                if (isInSmartFolderTree || isSmartFolderCheckPending) {
                    event?.preventDefault?.();
                    handleAnalyticsAndResetStickySearch("createAISmartCreatePopoverItem", {
                        blockedReason: "managedFolderTree"
                    });
                    setIsOpen(false);
                    showManagedFolderCreateError();
                    return;
                }
                originalPrimaryActionItem.onClick?.(event);
            };
            $[44] = handleAnalyticsAndResetStickySearch;
            $[45] = isInSmartFolderTree;
            $[46] = isSmartFolderCheckPending;
            $[47] = originalPrimaryActionItem;
            $[48] = setIsOpen;
            $[49] = showManagedFolderCreateError;
            $[50] = t17;
        } else t17 = $[50];
        let t18;
        if ($[51] !== originalPrimaryActionItem || $[52] !== t17) {
            t18 = {
                ...originalPrimaryActionItem,
                onClick: t17
            };
            $[51] = originalPrimaryActionItem;
            $[52] = t17;
            $[53] = t18;
        } else t18 = $[53];
        t16 = t18;
    }
    const primaryActionItem = t16;
    let t17;
    if ($[54] !== experimentSpotlightEnabled || $[55] !== isOpen || $[56] !== onClose || $[57] !== onCreateClick || $[58] !== primaryActionItem) {
        t17 = {
            enabled: experimentSpotlightEnabled,
            isMenuOpen: isOpen,
            onCloseMenu: onClose,
            onClick: onCreateClick,
            primaryActionItem: primaryActionItem
        };
        $[54] = experimentSpotlightEnabled;
        $[55] = isOpen;
        $[56] = onClose;
        $[57] = onCreateClick;
        $[58] = primaryActionItem;
        $[59] = t17;
    } else t17 = $[59];
    const { onClick: createOnClick, onCloseMenu: createOnCloseMenu, primaryActionItem: createPrimaryActionItem, spotlight: spotlight } = (0, $d6b7fe885cb9ec2d$export$98e75a504ceeacc2)(t17);
    const t18 = createOnClick ?? onCreateClick;
    let t19;
    if ($[60] !== createPrimaryActionItem) {
        t19 = createPrimaryActionItem ? {
            primaryActionItem: createPrimaryActionItem
        } : {};
        $[60] = createPrimaryActionItem;
        $[61] = t19;
    } else t19 = $[61];
    let t20;
    if ($[62] !== formatMessage) {
        t20 = formatMessage($f44feda85e5453ef$var$messages.create);
        $[62] = formatMessage;
        $[63] = t20;
    } else t20 = $[63];
    let t21;
    if ($[64] !== buttonTheme || $[65] !== createOnCloseMenu || $[66] !== isOpen || $[67] !== menuItems || $[68] !== onTriggerMouseEnter || $[69] !== t18 || $[70] !== t19 || $[71] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7039f178a77e2273$export$5c89068caaa33f77), {
            sections: menuItems,
            crossAppCreationConfig: crossAppCreationConfig,
            onMouseEnter: onTriggerMouseEnter,
            triggerButtonSpotlightTarget: "top-nav-create",
            enableTriggerPulse: false,
            isOpen: isOpen,
            onClose: createOnCloseMenu,
            onClick: t18,
            product: "confluence",
            buttonTheme: buttonTheme,
            testId: "create-content-popover-button",
            shouldRenderToParent: true,
            ...t19
        }, t20);
        $[64] = buttonTheme;
        $[65] = createOnCloseMenu;
        $[66] = isOpen;
        $[67] = menuItems;
        $[68] = onTriggerMouseEnter;
        $[69] = t18;
        $[70] = t19;
        $[71] = t20;
        $[72] = t21;
    } else t21 = $[72];
    let t22;
    if ($[73] !== spotlight || $[74] !== t21) {
        t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t21, spotlight);
        $[73] = spotlight;
        $[74] = t21;
        $[75] = t22;
    } else t22 = $[75];
    return t22;
};
const $f44feda85e5453ef$var$CreateWithFlags = (0, $7aRa9.withFlags)($f44feda85e5453ef$var$Create);
function $f44feda85e5453ef$export$b8b0dfc3e3d56c92() {
    const $ = (0, $bDgLe.c)(1);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).NAVX
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f44feda85e5453ef$var$CreateWithFlags, null));
        $[0] = t0;
    } else t0 = $[0];
    return t0;
}






var $jqe2L = parcelRequire("jqe2L");








var $5cryL = parcelRequire("5cryL");





var $fywGr = parcelRequire("fywGr");





var $7yn0t = parcelRequire("7yn0t");


var $6MlZq = parcelRequire("6MlZq");







var $luv00 = parcelRequire("luv00");











var $7DERG = parcelRequire("7DERG");





const $14f8b7ba4c44a126$export$96098f07afe80f94 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "xXIQx",
    name: "EngagementInlineDialogLoader",
    loader: async ()=>(await (parcelRequire("cwptp"))).EngagementInlineDialogWrapper
});


'use no memo';
const $433f7c954f8755e5$var$containerStyles = null;

const $433f7c954f8755e5$var$CreateButton = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZXF2b",
    name: "CreateButton",
    loader: async ()=>(await (parcelRequire("30o6e"))).CreateButton
});
const $433f7c954f8755e5$var$LIVE_DOCS_LINK = 'https://support.atlassian.com/confluence-cloud/docs/create-and-collaborate-in-real-time-with-live-docs/';
const $433f7c954f8755e5$var$CreateComponentContent = ({ flags: flags })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    const { setQueryParams: setQueryParams, match: match, push: push } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isCreationDropdownEnabled = (0, $6MlZq.useIsCreationDropdownEnabled)();
    const { enforceStorageLimit: enforceStorageLimit } = (0, $lqy4C.useHardStorageEnforcement)({
        source: 'create-component'
    });
    const [areKeyboardShortcutsEnabled] = (0, $fZAJP.useKeyboardShortcutsEnabled)();
    const [{ isEditMode: isLiveEditMode }] = (0, $efvKr.useLivePageMode)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const { isCreateLiveDocEnabled: isCreateLiveDocEnabled } = (0, $7EIq6.useSpaceEnabledContentTypes)(spaceKey);
    const { setEditSource: setEditSource } = (0, $4ri4I.useEditSourceActions)();
    const { data: data } = (0, $ivb8S.useGetOnboardingState)(Object.values({
        ...(0, $5cryL.EDITOR_ONBOARDING_STATE_KEYS)
    }), !(0, $9wGTI.fg)('cc_onboarding_experience'));
    const { editorOnboardingEligiblity: editorOnboardingEligiblity } = (0, $ivb8S.deserializeState)(data);
    const fireAnalytics = (additionalAttributes = {})=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: 'globalNavigation',
                action: 'clicked',
                actionSubject: 'navigationItem',
                actionSubjectId: 'create',
                attributes: {
                    selectedItemPageContext: match ? match.name : undefined,
                    navigationLayer: 'global',
                    navVersion: '4',
                    navdexPointType: (0, $56QzY.START_TOUCH),
                    ...additionalAttributes
                }
            }
        }).fire();
    };
    const openCreateDialog = ()=>{
        fireAnalytics();
        setQueryParams({
            createDialog: true
        });
    };
    const shouldCreateBlankFabricPage = ()=>{
        if (data && editorOnboardingEligiblity) (0, $fywGr.preloadEditorOnboardingState)();
        return true;
    };
    const createPageHref = (0, $bZSO8.buildCreationLink)({
        contentType: 'page',
        source: 'createBlankFabricPage',
        withFallback: true,
        spaceKey: spaceKey,
        parentPageId: contentId
    });
    const handleCreatePageShortcut = ()=>{
        setEditSource((0, $7NoF3.CREATE_PAGE_SHORTCUT));
        fireAnalytics({
            keyboardShortcut: true
        });
        const shouldCreate = shouldCreateBlankFabricPage();
        if (shouldCreate) push(createPageHref);
    };
    const handleCreatePageButtonClick = (e)=>{
        fireAnalytics();
        const shouldCreate_0 = shouldCreateBlankFabricPage();
        if (shouldCreate_0) {
            if (e.metaKey || e.ctrlKey) window.open(createPageHref, '_blank', 'noreferrer');
            else push(createPageHref);
        } else // creation is handled by href for button click
        e.preventDefault();
    };
    const createBlog = ()=>{
        const createBlogLink = (0, $bZSO8.buildCreationLink)({
            contentType: 'blog',
            source: 'globalCreateBlogShortcut',
            spaceKey: spaceKey
        });
        push(createBlogLink);
    };
    const createLiveDoc = ()=>{
        const createLiveDocLink = (0, $bZSO8.buildCreationLink)({
            contentType: 'page',
            subType: (0, $dkIiA.ConfluencePageSubType).LIVE,
            parentPageId: contentId,
            withFallback: true,
            source: 'globalCreateLiveDocShortcut',
            spaceKey: spaceKey
        });
        push(createLiveDocLink);
    };
    const showLiveDocNotEnabledFlag = ()=>{
        flags.showErrorFlag({
            id: 'live-doc-not-enabled-shortcut-flag',
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledTitle),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledDescription),
            isAutoDismiss: true,
            actions: [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $433f7c954f8755e5$var$i18n.liveDocsNotEnabledAction),
                    onClick: ()=>{
                        window.open($433f7c954f8755e5$var$LIVE_DOCS_LINK, '_blank');
                    }
                }
            ]
        });
    };
    const [createPageClickListener, createPageShortcutListener] = (0, $jqe2L.isCreateBlankFabricPageEnabled)() ? [
        handleCreatePageButtonClick,
        handleCreatePageShortcut
    ] : [
        openCreateDialog,
        openCreateDialog
    ];
    const universalGlobalCreateShortcut = (0, $4tOXV.isMac)() ? (0, $gnkil.UNIVERSAL_GLOBAL_CREATE_SHORTCUT_MAC) : (0, $gnkil.UNIVERSAL_GLOBAL_CREATE_SHORTCUT_WIN);
    const handlePreload = ()=>{
        // preload smart creation
        (0, $7DERG.ConfluenceSmartCreationModalLoader).preload();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "app-navigation-create",
        "data-pendo-id": "con-*/wiki/home-create",
        "data-vc": "create-component",
        ...ssrPlaceholderIdProp,
        onMouseEnter: handlePreload,
        onFocus: handlePreload,
        className: (0, $hekY6.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $14f8b7ba4c44a126$export$96098f07afe80f94), {
        engagementId: "createComponentButton",
        dataVC: "app-navigation-create-engagement-inline-dialog"
    }, isCreationDropdownEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f44feda85e5453ef$export$b8b0dfc3e3d56c92), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: areKeyboardShortcutsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
            shortcut: universalGlobalCreateShortcut,
            isTooltip: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7yn0t.CreateContentButtonPreloader), {
        editSource: (0, $7NoF3.CREATE_NAV_BUTTON_CLICK)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($433f7c954f8755e5$var$CreateButton, {
        onClick: enforceStorageLimit(createPageClickListener)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $433f7c954f8755e5$var$i18n.create))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.GLOBAL_CREATE_SHORTCUT) : undefined,
        accelerator: universalGlobalCreateShortcut,
        listener: enforceStorageLimit(createPageShortcutListener),
        isAppNavigationShortcut: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        deprecatedAccelerator: !(isLiveEditMode || isOnEditRoute) ? (0, $gnkil.BLOG_SHORTCUT) : undefined,
        accelerator: (0, $gnkil.UNIVERSAL_BLOG_SHORTCUT),
        listener: enforceStorageLimit(createBlog),
        isAppNavigationShortcut: true
    }), isCreateLiveDocEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT),
        listener: enforceStorageLimit(createLiveDoc),
        isAppNavigationShortcut: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6GD8y.GeneralShortcutListener), {
        accelerator: (0, $gnkil.UNIVERSAL_CREATE_LIVE_DOC_SHORTCUT),
        listener: enforceStorageLimit(showLiveDocNotEnabledFlag),
        isAppNavigationShortcut: true
    }));
};
const $433f7c954f8755e5$var$i18n = (0, $kSwu1.defineMessages)({
    create: {
        id: "app-navigation.top-navigation.create",
        defaultMessage: "Create"
    },
    liveDocsNotEnabledTitle: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.title",
        defaultMessage: "Live docs aren\u2019t enabled in this space"
    },
    liveDocsNotEnabledDescription: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.description",
        defaultMessage: "To use this shortcut, your space admin will need to enable live docs."
    },
    liveDocsNotEnabledAction: {
        id: "app-navigation.shortcuts.flags.liveDocsNotEnabled.action",
        defaultMessage: "Find out more"
    }
});
const $433f7c954f8755e5$export$a9a76753cd947d5c = (0, $7aRa9.withFlags)(/*#__PURE__*/ (0, $cozmU.memo)($433f7c954f8755e5$var$CreateComponentContent));



var $eDVeb = parcelRequire("eDVeb");


var $cAMBp = parcelRequire("cAMBp");

const $d7fa51f310118f21$var$TopNavigationQuery = (0, $hAiCi.default);
const $d7fa51f310118f21$var$CRITERION_BOTS_CONFIG_KEY = 'cc_criterion_bots';
const $d7fa51f310118f21$export$8a421bddecb2bf5b = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { defaultCollapsed: defaultCollapsed, customTheme: customTheme, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, isLimitedNav: isLimitedNav } = t0;
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($d7fa51f310118f21$var$TopNavigationQuery, {
        __callerPackage__: "app-navigation"
    });
    if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    if (loading) return null;
    let t1;
    if ($[0] !== customTheme || $[1] !== data || $[2] !== defaultCollapsed || $[3] !== isLimitedNav || $[4] !== isNav4CollapseReminderSpotlightActive || $[5] !== setIsNav4CollapseReminderSpotlightActive) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($d7fa51f310118f21$var$TopNavigationInner, {
            data: data,
            defaultCollapsed: defaultCollapsed,
            customTheme: customTheme,
            isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive,
            isLimitedNav: isLimitedNav
        });
        $[0] = customTheme;
        $[1] = data;
        $[2] = defaultCollapsed;
        $[3] = isLimitedNav;
        $[4] = isNav4CollapseReminderSpotlightActive;
        $[5] = setIsNav4CollapseReminderSpotlightActive;
        $[6] = t1;
    } else t1 = $[6];
    let t2;
    if ($[7] !== error) {
        t2 = error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        });
        $[7] = error;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== t1 || $[10] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t1, t2);
        $[9] = t1;
        $[10] = t2;
        $[11] = t3;
    } else t3 = $[11];
    return t3;
};
const $d7fa51f310118f21$var$isAtlassianStaff = (data)=>{
    const criterionBots = (0, $1xpoY.default).getStringList($d7fa51f310118f21$var$CRITERION_BOTS_CONFIG_KEY, []);
    return data?.user?.emails?.some((email)=>email?.value && (email.value.endsWith('@atlassian.com') || email.value.endsWith('@atlassian.com.invalid') || email.value.endsWith('@usersinbuckets.com') || criterionBots.includes(email.value))) || false;
};
const $d7fa51f310118f21$var$TopNavigationInner = (t0)=>{
    const $ = (0, $bDgLe.c)(91);
    const { data: data, defaultCollapsed: defaultCollapsed, customTheme: customTheme, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, isLimitedNav: isLimitedNav } = t0;
    const isFhsEnabled = (0, $1fHIr.useIsFhsEnabled)();
    const { isLoggedIn: isLoggedIn, cloudId: cloudId, isLicensed: isLicensed } = (0, $bQm3c.useSessionData)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    let t1;
    if ($[0] !== data) {
        t1 = $d7fa51f310118f21$var$isAtlassianStaff(data);
        $[0] = data;
        $[1] = t1;
    } else t1 = $[1];
    const isAtlassianStaffMemoized = t1;
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $78QFu.getUniquePageLoadId)();
        $[2] = t2;
    } else t2 = $[2];
    const { uuid: uuid, isInitial: isInitial } = t2;
    const hasCustomTheme = !!customTheme?.highlightColor || !!customTheme?.backgroundColor;
    const [customLogoSize, setCustomLogoSize] = (0, $cozmU.useState)(null);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (event)=>{
            const { naturalWidth: naturalWidth, naturalHeight: naturalHeight } = event.currentTarget;
            setCustomLogoSize({
                width: naturalWidth,
                height: naturalHeight
            });
        };
        $[3] = t3;
    } else t3 = $[3];
    const handleOnLoadCustomLogo = t3;
    let t4;
    if ($[4] !== cloudId || $[5] !== createAnalyticsEvent || $[6] !== customLogoSize || $[7] !== customTheme?.backgroundColor || $[8] !== customTheme?.highlightColor || $[9] !== data) {
        t4 = ()=>{
            if (data && isInitial && uuid) {
                const hasCustomSiteTitle = !!data.siteSettings?.showApplicationTitle && !!data.siteSettings?.siteTitle;
                const hasCustomLogo = !!data.siteConfiguration?.customSiteLogo && !!data.siteDescription?.logoUrl;
                if (hasCustomLogo && !customLogoSize) return;
                createAnalyticsEvent({
                    type: "sendUIEvent",
                    data: {
                        source: "globalNavigation",
                        action: "viewed",
                        actionSubject: "topNav",
                        actionSubjectId: "customTheme",
                        attributes: {
                            cloudId: cloudId,
                            hasCustomLogo: hasCustomLogo,
                            hasCustomSiteTitle: hasCustomSiteTitle,
                            hasCustomHighlightColor: !!customTheme?.highlightColor,
                            hasCustomBGColor: !!customTheme?.backgroundColor,
                            ...hasCustomLogo && customLogoSize ? customLogoSize : undefined,
                            ...hasCustomSiteTitle && {
                                customSiteTitleLength: data.siteSettings?.siteTitle.length
                            }
                        }
                    }
                }).fire();
            }
        };
        $[4] = cloudId;
        $[5] = createAnalyticsEvent;
        $[6] = customLogoSize;
        $[7] = customTheme?.backgroundColor;
        $[8] = customTheme?.highlightColor;
        $[9] = data;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== cloudId || $[12] !== createAnalyticsEvent || $[13] !== customLogoSize || $[14] !== customTheme || $[15] !== data) {
        t5 = [
            cloudId,
            createAnalyticsEvent,
            customLogoSize,
            data,
            isInitial,
            customTheme,
            uuid
        ];
        $[11] = cloudId;
        $[12] = createAnalyticsEvent;
        $[13] = customLogoSize;
        $[14] = customTheme;
        $[15] = data;
        $[16] = t5;
    } else t5 = $[16];
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[17] !== isOnEditRoute) {
        t6 = (label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4tOXV.ShortcutVisualizer), {
                contentBefore: label,
                shortcut: (0, $gnkil.UNIVERSAL_SIDE_NAVIGATION_SHORTCUT),
                isEditorShortcut: isOnEditRoute,
                isTooltip: true
            });
        $[17] = isOnEditRoute;
        $[18] = t6;
    } else t6 = $[18];
    const getShortcutVisualizer = t6;
    const { exitMultiSelect: exitMultiSelect } = (0, $bwL2u.useContentTreeSelectionActions)();
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    let t7;
    if ($[19] !== createAnalyticsEvent || $[20] !== exitMultiSelect || $[21] !== isMultiSelectActive) {
        t7 = ()=>{
            if (isMultiSelectActive) {
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        source: "globalNavigation",
                        action: "closed",
                        actionSubject: "bulkActionsMenu",
                        attributes: {
                            method: "collapseSideNavButton"
                        }
                    }
                }).fire();
                exitMultiSelect();
            }
        };
        $[19] = createAnalyticsEvent;
        $[20] = exitMultiSelect;
        $[21] = isMultiSelectActive;
        $[22] = t7;
    } else t7 = $[22];
    const handleMultiSelectOnCollapse = t7;
    const t8 = isFhsEnabled ? undefined : defaultCollapsed;
    let t9;
    if ($[23] !== formatMessage || $[24] !== getShortcutVisualizer || $[25] !== isFhsEnabled) {
        t9 = isFhsEnabled ? formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonCollapseLabel) : getShortcutVisualizer(formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonCollapseLabel));
        $[23] = formatMessage;
        $[24] = getShortcutVisualizer;
        $[25] = isFhsEnabled;
        $[26] = t9;
    } else t9 = $[26];
    let t10;
    if ($[27] !== formatMessage || $[28] !== getShortcutVisualizer || $[29] !== isFhsEnabled) {
        t10 = isFhsEnabled ? formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonExpandLabel) : getShortcutVisualizer(formatMessage($d7fa51f310118f21$var$i18n.sideNavToggleButtonExpandLabel));
        $[27] = formatMessage;
        $[28] = getShortcutVisualizer;
        $[29] = isFhsEnabled;
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== handleMultiSelectOnCollapse || $[32] !== t10 || $[33] !== t8 || $[34] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYwSK.SideNavToggleButton), {
            defaultCollapsed: t8,
            collapseLabel: t9,
            expandLabel: t10,
            onClick: handleMultiSelectOnCollapse
        });
        $[31] = handleMultiSelectOnCollapse;
        $[32] = t10;
        $[33] = t8;
        $[34] = t9;
        $[35] = t11;
    } else t11 = $[35];
    const sideNavToggleButtonComponent = t11;
    let t12;
    if ($[36] !== isNav4CollapseReminderSpotlightActive) {
        t12 = isNav4CollapseReminderSpotlightActive && (0, $9wGTI.fg)("confluence_frontend_spotlight_ads_migration");
        $[36] = isNav4CollapseReminderSpotlightActive;
        $[37] = t12;
    } else t12 = $[37];
    const shouldShowNewSpotlight = t12;
    let t13;
    if ($[38] !== isNav4CollapseReminderSpotlightActive || $[39] !== setIsNav4CollapseReminderSpotlightActive || $[40] !== shouldShowNewSpotlight || $[41] !== sideNavToggleButtonComponent) {
        t13 = shouldShowNewSpotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e0356f01208b13d1$export$6cddb4d20889bca4), {
            isVisible: !!isNav4CollapseReminderSpotlightActive,
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive
        }, sideNavToggleButtonComponent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8Iwqw.default), {
            name: "nav4-spotlight-1"
        }, sideNavToggleButtonComponent);
        $[38] = isNav4CollapseReminderSpotlightActive;
        $[39] = setIsNav4CollapseReminderSpotlightActive;
        $[40] = shouldShowNewSpotlight;
        $[41] = sideNavToggleButtonComponent;
        $[42] = t13;
    } else t13 = $[42];
    const sideNavToggleButton = t13;
    let t14;
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eBBZq.AppSwitcherButton), null);
        $[43] = t14;
    } else t14 = $[43];
    let t15;
    if ($[44] !== isAtlassianStaffMemoized) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1B659.DeveloperButtons), {
            isAtlassianStaff: isAtlassianStaffMemoized
        });
        $[44] = isAtlassianStaffMemoized;
        $[45] = t15;
    } else t15 = $[45];
    const t16 = data?.siteConfiguration;
    const t17 = data?.siteSettings;
    const t18 = data?.siteDescription;
    let t19;
    if ($[46] !== t16 || $[47] !== t17 || $[48] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $760ef9e13b699b30$export$48df75a983e1f3fb), {
            siteConfiguration: t16,
            siteSettings: t17,
            siteDescription: t18,
            onLoadCustomLogo: handleOnLoadCustomLogo
        });
        $[46] = t16;
        $[47] = t17;
        $[48] = t18;
        $[49] = t19;
    } else t19 = $[49];
    let t20;
    if ($[50] !== data?.siteSettings) {
        t20 = data?.siteSettings?.showApplicationTitle ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ldb5c.CustomTitle), null, data?.siteSettings.siteTitle) : null;
        $[50] = data?.siteSettings;
        $[51] = t20;
    } else t20 = $[51];
    let t21;
    if ($[52] !== sideNavToggleButton || $[53] !== t15 || $[54] !== t19 || $[55] !== t20) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $anG8x.TopNavStart), {
            sideNavToggleButton: sideNavToggleButton
        }, t14, t15, t19, t20);
        $[52] = sideNavToggleButton;
        $[53] = t15;
        $[54] = t19;
        $[55] = t20;
        $[56] = t21;
    } else t21 = $[56];
    let t22;
    if ($[57] !== isLimitedNav) {
        t22 = !isLimitedNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eDVeb.SearchBar), null);
        $[57] = isLimitedNav;
        $[58] = t22;
    } else t22 = $[58];
    let t23;
    if ($[59] !== isLimitedNav) {
        t23 = !isLimitedNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $433f7c954f8755e5$export$a9a76753cd947d5c), null);
        $[59] = isLimitedNav;
        $[60] = t23;
    } else t23 = $[60];
    let t24;
    if ($[61] !== t22 || $[62] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kGTRV.TopNavMiddle), null, t22, t23);
        $[61] = t22;
        $[62] = t23;
        $[63] = t24;
    } else t24 = $[63];
    let t25;
    let t26;
    if ($[64] === Symbol.for("react.memo_cache_sentinel")) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1e0f0aa871cc51c1$export$a55b02efe3d62583), null);
        t26 = (0, $9wGTI.fg)("edition_awareness_standard_upsell_confluence_ab_fg") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ce6cbe4a9370c72f$export$f255ec0f3619af65), {
            navVersion: "nav4"
        });
        $[64] = t25;
        $[65] = t26;
    } else {
        t25 = $[64];
        t26 = $[65];
    }
    let t27;
    if ($[66] !== isLimitedNav) {
        t27 = !isLimitedNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cAMBp.RovoButton), null);
        $[66] = isLimitedNav;
        $[67] = t27;
    } else t27 = $[67];
    let t28;
    if ($[68] !== isLimitedNav) {
        t28 = !isLimitedNav && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9MAeh.NotificationsButton), null);
        $[68] = isLimitedNav;
        $[69] = t28;
    } else t28 = $[69];
    let t29;
    let t30;
    if ($[70] === Symbol.for("react.memo_cache_sentinel")) {
        t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $48d2632049a03f8d$export$78bddedbcf2939ac), null);
        t30 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5f8faa2e47e4a6d0$export$e2457e1974c298c3), null);
        $[70] = t29;
        $[71] = t30;
    } else {
        t29 = $[70];
        t30 = $[71];
    }
    let t31;
    if ($[72] !== data || $[73] !== isLoggedIn) {
        t31 = isLoggedIn && data?.user ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e40e4f4e333d3274$export$6d6e8f8ac62271dd), {
            user: data.user
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3yPEN.LoginButton), null);
        $[72] = data;
        $[73] = isLoggedIn;
        $[74] = t31;
    } else t31 = $[74];
    let t32;
    if ($[75] !== t27 || $[76] !== t28 || $[77] !== t31) {
        t32 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Y4qw.TopNavEnd), null, t25, t26, t27, t28, t29, t30, t31);
        $[75] = t27;
        $[76] = t28;
        $[77] = t31;
        $[78] = t32;
    } else t32 = $[78];
    let t33;
    if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
        t33 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
            name: (0, $irVI7.APP_NAV_GLOBAL_EXPERIENCE),
            attributes: {
                navVersion: "4"
            }
        });
        $[79] = t33;
    } else t33 = $[79];
    const t34 = !isLoggedIn;
    let t35;
    if ($[80] !== hasCustomTheme || $[81] !== isLicensed || $[82] !== t34) {
        t35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            metric: (0, $8w1c1.APP_NAVIGATION_METRIC),
            customData: {
                isAnonymous: t34,
                isLicensed: isLicensed,
                hasCustomTheme: hasCustomTheme
            }
        });
        $[80] = hasCustomTheme;
        $[81] = isLicensed;
        $[82] = t34;
        $[83] = t35;
    } else t35 = $[83];
    let t36;
    let t37;
    if ($[84] === Symbol.for("react.memo_cache_sentinel")) {
        t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NX9d.PerformanceEnd), {
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigation),
            subjectId: "NavigationLoading",
            includeFeatureFlags: true,
            details: $d7fa51f310118f21$var$nav4Details
        });
        t37 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4NX9d.PerformanceEnd), {
            subject: (0, $kVysQ.PERFORMANCE_SUBJECT_navigationFMP),
            subjectId: "NavigationFMP",
            includeFeatureFlags: true,
            details: $d7fa51f310118f21$var$nav4Details
        });
        $[84] = t36;
        $[85] = t37;
    } else {
        t36 = $[84];
        t37 = $[85];
    }
    let t38;
    if ($[86] !== t21 || $[87] !== t24 || $[88] !== t32 || $[89] !== t35) {
        t38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t21, t24, t32, t33, t35, t36, t37);
        $[86] = t21;
        $[87] = t24;
        $[88] = t32;
        $[89] = t35;
        $[90] = t38;
    } else t38 = $[90];
    return t38;
};
const $d7fa51f310118f21$var$i18n = (0, $kSwu1.defineMessages)({
    sideNavToggleButtonCollapseLabel: {
        id: "app-navigation.top-navigation.side-nav-toggle-button-collapse-label",
        defaultMessage: "Collapse sidebar"
    },
    sideNavToggleButtonExpandLabel: {
        id: "app-navigation.top-navigation.side-nav-toggle-button-expand-label",
        defaultMessage: "Expand sidebar"
    }
});
const $d7fa51f310118f21$var$nav4Details = {
    navVersion: '4'
};


const $d782f4c4ad49c391$export$eff75454f2208b30 = (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { defaultCollapsed: defaultCollapsed, customTheme: customTheme, isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive, setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive, isLimitedNav: isLimitedNav } = t0;
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            errorBoundaryId: "TopNavigation"
        };
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            metric: (0, $8w1c1.APP_NAVIGATION_METRIC)
        });
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    let t3;
    if ($[2] !== customTheme || $[3] !== defaultCollapsed || $[4] !== isLimitedNav || $[5] !== isNav4CollapseReminderSpotlightActive || $[6] !== setIsNav4CollapseReminderSpotlightActive) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).DISCO,
            attributes: t1
        }, t2, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7fa51f310118f21$export$8a421bddecb2bf5b), {
            defaultCollapsed: defaultCollapsed,
            customTheme: customTheme,
            isNav4CollapseReminderSpotlightActive: isNav4CollapseReminderSpotlightActive,
            setIsNav4CollapseReminderSpotlightActive: setIsNav4CollapseReminderSpotlightActive,
            isLimitedNav: isLimitedNav
        }));
        $[2] = customTheme;
        $[3] = defaultCollapsed;
        $[4] = isLimitedNav;
        $[5] = isNav4CollapseReminderSpotlightActive;
        $[6] = setIsNav4CollapseReminderSpotlightActive;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};
module.exports["TopNavigationBase"] = $d782f4c4ad49c391$export$eff75454f2208b30;

});

parcelRegister("3KaC3", function(module, exports) {

let $2b9de66eb16151ba$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2b9de66eb16151ba$var$load("efxfD"),
    $2b9de66eb16151ba$var$load("52ZTT"),
    $2b9de66eb16151ba$var$load("bjimZ"),
    $2b9de66eb16151ba$var$load("kUfAt"),
    $2b9de66eb16151ba$var$load("6wr18"),
    $2b9de66eb16151ba$var$load("6jjGk"),
    $2b9de66eb16151ba$var$load("cWiKr"),
    $2b9de66eb16151ba$var$load("iSM6Z"),
    $2b9de66eb16151ba$var$load("1GCFv"),
    $2b9de66eb16151ba$var$load("89Jkv"),
    $2b9de66eb16151ba$var$load("j99ao"),
    $2b9de66eb16151ba$var$load("Wowvf"),
    $2b9de66eb16151ba$var$load("4Pq08"),
    $2b9de66eb16151ba$var$load("7EorR"),
    $2b9de66eb16151ba$var$load("ffEVr"),
    $2b9de66eb16151ba$var$load("8H6xE")
]).then(()=>parcelRequire('lw7p7'));

});

parcelRegister("4wf0z", function(module, exports) {

let $34a5cae1e1e2795e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $34a5cae1e1e2795e$var$load("6wr18"),
    $34a5cae1e1e2795e$var$load("cWiKr"),
    $34a5cae1e1e2795e$var$load("89Jkv"),
    $34a5cae1e1e2795e$var$load("j99ao"),
    $34a5cae1e1e2795e$var$load("ffEVr"),
    $34a5cae1e1e2795e$var$load("lz2pE")
]).then(()=>parcelRequire('7Bwbp'));

});

parcelRegister("eNWR0", function(module, exports) {

let $ac734b754071bd04$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ac734b754071bd04$var$load("60m6Z").then(()=>parcelRequire('1FDBc'));

});

parcelRegister("fMDig", function(module, exports) {

let $b7d9d19d6b4e832d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b7d9d19d6b4e832d$var$load("dJC82").then(()=>parcelRequire('kM0Bh'));

});

parcelRegister("jPTYm", function(module, exports) {

let $e70e32bd415f8350$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e70e32bd415f8350$var$load("4ukY5").then(()=>parcelRequire('ea6sq'));

});

parcelRegister("7cRcO", function(module, exports) {

let $53f2ecf062716763$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $53f2ecf062716763$var$load("kHXvF"),
    $53f2ecf062716763$var$load("hhss7"),
    $53f2ecf062716763$var$load("6wPv6")
]).then(()=>parcelRequire('hEuLk'));

});

parcelRegister("8r4wU", function(module, exports) {

let $62445bd84ef3c605$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $62445bd84ef3c605$var$load("943D1").then(()=>parcelRequire('ddp7n'));

});

parcelRegister("jN02e", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9EOlJ = parcelRequire("9EOlJ");


var $cN3xQ = parcelRequire("cN3xQ");


var $eSVwn = parcelRequire("eSVwn");


var $8s4b7 = parcelRequire("8s4b7");

const $091423a1615fa460$export$9e9b5b3f9c08ce57 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function GenericErrorBoundary(t0) {
    const $ = (0, $bDgLe.c)(16);
    const { children: children, name: name, interactionId: t1, fallback: t2, onError: t3, app: t4 } = t0;
    const interactionId = t1 === undefined ? undefined : t1;
    const fallback = t2 === undefined ? null : t2;
    const onError = t3 === undefined ? undefined : t3;
    const app = t4 === undefined ? undefined : t4;
    const { product: product, subProduct: subProduct } = (0, $8s4b7.useMenuStateContext)();
    const { product: productV1, subProduct: subProductV1 } = (0, $8s4b7.useUniversalCreateState)();
    const t5 = subProduct || subProductV1;
    let t6;
    if ($[0] !== t5) {
        t6 = {
            component: (0, $eSVwn.PACKAGE_PREFIX),
            subProduct: t5
        };
        $[0] = t5;
        $[1] = t6;
    } else t6 = $[1];
    const tags = t6;
    const t7 = app || product || productV1;
    let t8;
    if ($[2] !== t7) {
        t8 = {
            product: t7
        };
        $[2] = t7;
        $[3] = t8;
    } else t8 = $[3];
    let t9;
    if ($[4] !== interactionId || $[5] !== name || $[6] !== onError || $[7] !== t8 || $[8] !== tags) {
        t9 = {
            location: name,
            disableSentry: false,
            disableAnalytics: true,
            onError: onError,
            sentryConfig: t8,
            interactionId: interactionId,
            tags: tags
        };
        $[4] = interactionId;
        $[5] = name;
        $[6] = onError;
        $[7] = t8;
        $[8] = tags;
        $[9] = t9;
    } else t9 = $[9];
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)(t9);
    let t10;
    if ($[10] !== handleError) {
        t10 = async (error)=>{
            handleError(error);
        };
        $[10] = handleError;
        $[11] = t10;
    } else t10 = $[11];
    const handleOnError = t10;
    let t11;
    if ($[12] !== children || $[13] !== fallback || $[14] !== handleOnError) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
            fallback: fallback,
            onError: handleOnError
        }, children);
        $[12] = children;
        $[13] = fallback;
        $[14] = handleOnError;
        $[15] = t11;
    } else t11 = $[15];
    return t11;
} : function GenericErrorBoundary({ children: children, name: name, interactionId: interactionId, fallback: fallback = null, onError: onError, app: app }) {
    const { product: product, subProduct: subProduct } = (0, $8s4b7.useMenuStateContext)();
    const { product: productV1, subProduct: subProductV1 } = (0, $8s4b7.useUniversalCreateState)();
    const tags = {
        component: (0, $eSVwn.PACKAGE_PREFIX),
        subProduct: subProduct || subProductV1
    };
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)({
        location: name,
        disableSentry: false,
        disableAnalytics: true,
        onError: onError,
        sentryConfig: {
            product: app || product || productV1
        },
        interactionId: interactionId,
        tags: tags
    });
    const handleOnError = (0, $cozmU.useCallback)(async (error)=>{
        handleError(error);
    }, [
        handleError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        fallback: fallback,
        onError: handleOnError
    }, children);
};
module.exports["GenericErrorBoundary"] = $091423a1615fa460$export$9e9b5b3f9c08ce57;

});

parcelRegister("eSVwn", function(module, exports) {
const $fdd5362b9bc1f9cb$export$373682275c03fc63 = 'universal-create';
const $fdd5362b9bc1f9cb$export$3f4cc858c0cb6e84 = `${$fdd5362b9bc1f9cb$export$373682275c03fc63}-trigger-button`;
const $fdd5362b9bc1f9cb$export$85183a312807388d = 'navigation';
const $fdd5362b9bc1f9cb$export$4e49778ae689b92a = 3;
const $fdd5362b9bc1f9cb$export$c2ae99333adf8094 = 'universal-create';
const $fdd5362b9bc1f9cb$export$4c7df19e787d8989 = [
    'ati:cloud:townsquare:team',
    'ati:cloud:townsquare:goal'
];
const $fdd5362b9bc1f9cb$export$441df76988f6d01 = 430;
const $fdd5362b9bc1f9cb$export$d268f31a83479f83 = 'sm';
const $fdd5362b9bc1f9cb$export$bc385bb37fb17e9c = 767;
const $fdd5362b9bc1f9cb$export$f8e186cd2da1abff = 100;
const $fdd5362b9bc1f9cb$export$aca7035f4c6a6c0b = -1;
module.exports["PACKAGE_PREFIX"] = $fdd5362b9bc1f9cb$export$373682275c03fc63;
module.exports["TRIGGER_BUTTON_TEST_ID"] = $fdd5362b9bc1f9cb$export$3f4cc858c0cb6e84;
module.exports["MAX_ALLOWED_SECTIONS"] = $fdd5362b9bc1f9cb$export$4e49778ae689b92a;
module.exports["SOURCE_LOCATION"] = $fdd5362b9bc1f9cb$export$c2ae99333adf8094;
module.exports["REQUIRED_USER_ITEMS"] = $fdd5362b9bc1f9cb$export$4c7df19e787d8989;
module.exports["MAX_MENU_HEIGHT"] = $fdd5362b9bc1f9cb$export$441df76988f6d01;
module.exports["RESPONSIVE_BREAKPOINT"] = $fdd5362b9bc1f9cb$export$d268f31a83479f83;
module.exports["MOBILE_WIDTH_BREAKPOINT"] = $fdd5362b9bc1f9cb$export$bc385bb37fb17e9c;
module.exports["RESIZING_DEBOUNCED"] = $fdd5362b9bc1f9cb$export$f8e186cd2da1abff;
module.exports["PRIMARY_ACTION_ITEM_INDEX"] = $fdd5362b9bc1f9cb$export$aca7035f4c6a6c0b;

});

parcelRegister("8s4b7", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $9e32c3b0b4e1883c$var$defaultSectionExpansionContext = {
    sectionExpansionState: {},
    setSectionExpansionState: function() {}
};
const $9e32c3b0b4e1883c$export$fc9ae5c4169099cb = (0, $cozmU.createContext)($9e32c3b0b4e1883c$var$defaultSectionExpansionContext);
const $9e32c3b0b4e1883c$export$b316af36f410c3ff = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useSectionExpansionContext() {
    return (0, $cozmU.useContext)($9e32c3b0b4e1883c$export$fc9ae5c4169099cb);
} : function useSectionExpansionContext() {
    return (0, $cozmU.useContext)($9e32c3b0b4e1883c$export$fc9ae5c4169099cb);
};
const $9e32c3b0b4e1883c$var$defaultFormControls = {
    load: function() {},
    reset: function() {},
    close: function() {}
};
const $9e32c3b0b4e1883c$export$39aa3c8950714d79 = (0, $cozmU.createContext)($9e32c3b0b4e1883c$var$defaultFormControls);
const $9e32c3b0b4e1883c$export$56d95dc846453c64 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMenuControl() {
    return (0, $cozmU.useContext)($9e32c3b0b4e1883c$export$39aa3c8950714d79);
} : function useMenuControl() {
    return (0, $cozmU.useContext)($9e32c3b0b4e1883c$export$39aa3c8950714d79);
};
const $9e32c3b0b4e1883c$export$24aad8519b95b41b = (0, $cozmU.createContext)({
    items: [],
    product: 'unknown',
    subProduct: undefined,
    growthRecommendationsSessionId: undefined,
    setGrowthRecommendationsSessionId: undefined,
    crossAppCreationConfig: {
        enabled: false
    },
    sections: [],
    suggestionConfig: {
        enabled: false
    },
    isNav4Enabled: true,
    preventClose: undefined
});
const $9e32c3b0b4e1883c$export$efa3856fc0e85e7f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useMenuStateContext() {
    return (0, $cozmU.useContext)($9e32c3b0b4e1883c$export$24aad8519b95b41b);
} : function useMenuStateContext() {
    return (0, $cozmU.useContext)($9e32c3b0b4e1883c$export$24aad8519b95b41b);
};
const $9e32c3b0b4e1883c$export$c7381b2490bb4d36 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUniversalCreateState() {
    return (0, $cozmU.useContext)($9e32c3b0b4e1883c$export$24aad8519b95b41b);
} : function useUniversalCreateState() {
    return (0, $cozmU.useContext)($9e32c3b0b4e1883c$export$24aad8519b95b41b);
};
const $9e32c3b0b4e1883c$export$2cd627eaf555af8f = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUniversalCreateControl() {
    return (0, $cozmU.useContext)($9e32c3b0b4e1883c$export$39aa3c8950714d79);
} : function useUniversalCreateControl() {
    return (0, $cozmU.useContext)($9e32c3b0b4e1883c$export$39aa3c8950714d79);
};
module.exports["SectionExpansionContext"] = $9e32c3b0b4e1883c$export$fc9ae5c4169099cb;
module.exports["useSectionExpansionContext"] = $9e32c3b0b4e1883c$export$b316af36f410c3ff;
module.exports["MenuControlContext"] = $9e32c3b0b4e1883c$export$39aa3c8950714d79;
module.exports["MenuStateContext"] = $9e32c3b0b4e1883c$export$24aad8519b95b41b;
module.exports["useMenuStateContext"] = $9e32c3b0b4e1883c$export$efa3856fc0e85e7f;
module.exports["useUniversalCreateState"] = $9e32c3b0b4e1883c$export$c7381b2490bb4d36;
module.exports["useUniversalCreateControl"] = $9e32c3b0b4e1883c$export$2cd627eaf555af8f;

});

parcelRegister("2Po8s", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cbY7C = parcelRequire("cbY7C");


var $3AVOh = parcelRequire("3AVOh");


var $5Sv3D = parcelRequire("5Sv3D");


var $eSVwn = parcelRequire("eSVwn");

function $442ba0dd392b6794$export$5a8ab32aeea5694f(sections, selectedItem) {
    for (const section of sections)// Only app-defined sections have items at definition time
    if (section.type === 'appDefinedSection') {
        for (const menuItem of section.items)// Check if item has ati property (both NativeMenuItem and CrossAppMenuItem have it)
        if ('ati' in menuItem && menuItem.ati.toString() === selectedItem.toString()) {
            // For cross-app items, we need to return null as they don't have onClick/loadCreateContent
            // Only native items can be "selected" in the traditional sense
            if ('onClick' in menuItem || 'loadCreateContent' in menuItem) return menuItem;
        }
    }
    return null;
}
function $442ba0dd392b6794$export$911e33c48adcec1b(mixedItems) {
    return mixedItems.flatMap((namedItem)=>namedItem.items).map((menuItem)=>menuItem.ati.toString());
}
const $442ba0dd392b6794$export$2a50c0408cf3ddb8 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useIsResponsiveView() {
    const $ = (0, $bDgLe.c)(4);
    const [isResponsiveMode, setIsResponsiveMode] = (0, $cozmU.useState)(typeof window !== "undefined" && window.innerWidth <= (0, $eSVwn.MOBILE_WIDTH_BREAKPOINT));
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = ()=>{
            const isCurrentlyMobile = window.innerWidth <= (0, $eSVwn.MOBILE_WIDTH_BREAKPOINT);
            setIsResponsiveMode((prev)=>prev !== isCurrentlyMobile ? isCurrentlyMobile : prev);
        };
        $[0] = t0;
    } else t0 = $[0];
    const [handleResizeDebounced] = (0, $5Sv3D.default)(t0, (0, $eSVwn.RESIZING_DEBOUNCED));
    let t1;
    let t2;
    if ($[1] !== handleResizeDebounced) {
        t1 = ()=>{
            const unbind = (0, $cbY7C.bindAll)(window, [
                {
                    type: "resize",
                    listener: handleResizeDebounced
                }
            ]);
            return unbind;
        };
        t2 = [
            handleResizeDebounced
        ];
        $[1] = handleResizeDebounced;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    (0, $cozmU.useEffect)(t1, t2);
    return isResponsiveMode;
} : function useIsResponsiveView() {
    const [isResponsiveMode, setIsResponsiveMode] = (0, $cozmU.useState)(typeof window !== 'undefined' && window.innerWidth <= (0, $eSVwn.MOBILE_WIDTH_BREAKPOINT));
    const [handleResizeDebounced] = (0, $5Sv3D.default)(()=>{
        const isCurrentlyMobile = window.innerWidth <= (0, $eSVwn.MOBILE_WIDTH_BREAKPOINT);
        setIsResponsiveMode((prev)=>prev !== isCurrentlyMobile ? isCurrentlyMobile : prev);
    }, (0, $eSVwn.RESIZING_DEBOUNCED));
    (0, $cozmU.useEffect)(()=>{
        const unbind = (0, $cbY7C.bindAll)(window, [
            {
                type: 'resize',
                listener: handleResizeDebounced
            }
        ]);
        return unbind;
    }, [
        handleResizeDebounced
    ]);
    return isResponsiveMode;
};
const $442ba0dd392b6794$export$d6eadbd047ebd460 = (item, ...properties)=>(0, (/*@__PURE__*/$parcel$interopDefault($3AVOh)))(item, ...properties);
const $442ba0dd392b6794$export$fdd2c0ba94025c3c = (contextConfig)=>contextConfig.enabled ? contextConfig.cloudId : '';
const $442ba0dd392b6794$export$5a762450d50ca901 = (contextConfig)=>contextConfig.enabled ? contextConfig.orgId : undefined;
module.exports["findSelectedItem"] = $442ba0dd392b6794$export$5a8ab32aeea5694f;
module.exports["useIsResponsiveView"] = $442ba0dd392b6794$export$2a50c0408cf3ddb8;
module.exports["omitSafely"] = $442ba0dd392b6794$export$d6eadbd047ebd460;
module.exports["getCloudId"] = $442ba0dd392b6794$export$fdd2c0ba94025c3c;
module.exports["getOrgId"] = $442ba0dd392b6794$export$5a762450d50ca901;

});

parcelRegister("57EeW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $a9eQA = parcelRequire("a9eQA");


var $8s4b7 = parcelRequire("8s4b7");

const $c9d55890fc65592f$export$eebe354ebe67c94c = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUniversalCreateAnalytics() {
    const $ = (0, $bDgLe.c)(69);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { growthRecommendationsSessionId: growthRecommendationsSessionId, product: product, subProduct: subProduct } = (0, $8s4b7.useUniversalCreateState)();
    const safeProduct = product || "unknown";
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = (0, $iDrrr.fg)("navx-3810-re-instrument-growth-session-id");
        $[0] = t0;
    } else t0 = $[0];
    const includeGrowthSessionInAnalytics = t0;
    let t1;
    if ($[1] !== growthRecommendationsSessionId) {
        t1 = includeGrowthSessionInAnalytics && growthRecommendationsSessionId !== undefined && {
            recommendationSessionId: growthRecommendationsSessionId
        };
        $[1] = growthRecommendationsSessionId;
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] !== safeProduct || $[4] !== subProduct || $[5] !== t1) {
        t2 = {
            navLayer: (0, $a9eQA.NAV_LAYER),
            navContainer: (0, $a9eQA.NAV_CONTAINER),
            navVersion: (0, $a9eQA.NAV_VERSION),
            product: safeProduct,
            subProduct: subProduct,
            ...t1
        };
        $[3] = safeProduct;
        $[4] = subProduct;
        $[5] = t1;
        $[6] = t2;
    } else t2 = $[6];
    const baseAttributes = t2;
    let t3;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = {
            actionSubject: "universalCreate",
            eventType: "ui",
            source: (0, $a9eQA.ANALYTICS_SOURCE),
            tags: [
                (0, $a9eQA.ANALYTICS_TAG)
            ]
        };
        $[7] = t3;
    } else t3 = $[7];
    const topLevelAttributes = t3;
    let t4;
    if ($[8] !== baseAttributes || $[9] !== createAnalyticsEvent) {
        t4 = (attributes)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                action: "clicked",
                actionSubjectId: "universalCreateButton",
                attributes: {
                    ...baseAttributes,
                    ...attributes
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[8] = baseAttributes;
        $[9] = createAnalyticsEvent;
        $[10] = t4;
    } else t4 = $[10];
    const fireCreateButtonClicked = t4;
    let t5;
    if ($[11] !== baseAttributes || $[12] !== createAnalyticsEvent) {
        t5 = (attributes_0)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                action: "viewed",
                actionSubjectId: "universalCreateButton",
                attributes: {
                    ...baseAttributes,
                    ...attributes_0
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[11] = baseAttributes;
        $[12] = createAnalyticsEvent;
        $[13] = t5;
    } else t5 = $[13];
    const fireCreateButtonViewed = t5;
    let t6;
    if ($[14] !== baseAttributes || $[15] !== createAnalyticsEvent) {
        t6 = (attributes_1)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                action: "hovered",
                actionSubjectId: "universalCreateButton",
                attributes: {
                    ...baseAttributes,
                    ...attributes_1
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[14] = baseAttributes;
        $[15] = createAnalyticsEvent;
        $[16] = t6;
    } else t6 = $[16];
    const fireCreateButtonHovered = t6;
    let t7;
    if ($[17] !== baseAttributes || $[18] !== createAnalyticsEvent) {
        t7 = (attributes_2)=>{
            createAnalyticsEvent({
                actionSubject: "universalCreateEntryPointLoad",
                action: "triggered",
                eventType: "track",
                source: (0, $a9eQA.ANALYTICS_SOURCE),
                tags: [
                    (0, $a9eQA.ANALYTICS_TAG)
                ],
                attributes: {
                    ...baseAttributes,
                    ...attributes_2
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[17] = baseAttributes;
        $[18] = createAnalyticsEvent;
        $[19] = t7;
    } else t7 = $[19];
    const fireEntryPointLoadTriggered = t7;
    let t8;
    if ($[20] !== baseAttributes || $[21] !== createAnalyticsEvent) {
        t8 = (attributes_3)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                action: "clicked",
                actionSubjectId: "universalCreateNativeMenuItem",
                attributes: {
                    group: "native",
                    ...baseAttributes,
                    ...attributes_3
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[20] = baseAttributes;
        $[21] = createAnalyticsEvent;
        $[22] = t8;
    } else t8 = $[22];
    const fireNativeMenuItemClicked = t8;
    let t9;
    if ($[23] !== baseAttributes || $[24] !== createAnalyticsEvent) {
        t9 = (attributes_4)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                action: "clicked",
                actionSubjectId: "universalCreateSuggestionsMenuItem",
                attributes: {
                    group: "suggestions",
                    ...baseAttributes,
                    ...attributes_4
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[23] = baseAttributes;
        $[24] = createAnalyticsEvent;
        $[25] = t9;
    } else t9 = $[25];
    const fireSuggestionsMenuItemClicked = t9;
    let t10;
    if ($[26] !== baseAttributes || $[27] !== createAnalyticsEvent) {
        t10 = (attributes_5)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                action: "clicked",
                actionSubjectId: "universalCreateMenuItem",
                attributes: {
                    ...baseAttributes,
                    ...attributes_5
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[26] = baseAttributes;
        $[27] = createAnalyticsEvent;
        $[28] = t10;
    } else t10 = $[28];
    const fireMenuItemClicked = t10;
    let t11;
    if ($[29] !== baseAttributes || $[30] !== createAnalyticsEvent) {
        t11 = (attributes_6)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                action: "viewed",
                actionSubjectId: "universalCreateNativeMenu",
                attributes: {
                    ...baseAttributes,
                    ...attributes_6
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[29] = baseAttributes;
        $[30] = createAnalyticsEvent;
        $[31] = t11;
    } else t11 = $[31];
    const fireNativeMenuViewed = t11;
    let t12;
    if ($[32] !== baseAttributes || $[33] !== createAnalyticsEvent) {
        t12 = (attributes_7)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                action: "viewed",
                actionSubjectId: "universalCreateSuggestionsMenu",
                attributes: {
                    ...baseAttributes,
                    ...attributes_7
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[32] = baseAttributes;
        $[33] = createAnalyticsEvent;
        $[34] = t12;
    } else t12 = $[34];
    const fireSuggestionsMenuViewed = t12;
    let t13;
    if ($[35] !== baseAttributes || $[36] !== createAnalyticsEvent) {
        t13 = (attributes_8)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                action: "viewed",
                actionSubjectId: "universalCreateMenuSection",
                attributes: {
                    ...baseAttributes,
                    ...attributes_8
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[35] = baseAttributes;
        $[36] = createAnalyticsEvent;
        $[37] = t13;
    } else t13 = $[37];
    const fireMenuItemsViewed = t13;
    let t14;
    if ($[38] !== baseAttributes || $[39] !== createAnalyticsEvent) {
        t14 = ()=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                action: "closed",
                actionSubjectId: "universalCreateMenuContent",
                attributes: {
                    ...baseAttributes
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[38] = baseAttributes;
        $[39] = createAnalyticsEvent;
        $[40] = t14;
    } else t14 = $[40];
    const fireMenuContentClosed = t14;
    let t15;
    if ($[41] !== baseAttributes || $[42] !== createAnalyticsEvent) {
        t15 = (attributes_9)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                action: "changed",
                actionSubjectId: "universalCreateMenuState",
                attributes: {
                    ...baseAttributes,
                    ...attributes_9
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[41] = baseAttributes;
        $[42] = createAnalyticsEvent;
        $[43] = t15;
    } else t15 = $[43];
    const fireMenuStateChanged = t15;
    let t16;
    if ($[44] !== baseAttributes || $[45] !== createAnalyticsEvent) {
        t16 = (t17)=>{
            const { actionSubjectId: actionSubjectId, action: t18, ...attributes_10 } = t17;
            const action = t18 === undefined ? "clicked" : t18;
            createAnalyticsEvent({
                ...topLevelAttributes,
                actionSubject: "universalCreate",
                action: action,
                actionSubjectId: actionSubjectId,
                attributes: {
                    ...baseAttributes,
                    ...attributes_10
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[44] = baseAttributes;
        $[45] = createAnalyticsEvent;
        $[46] = t16;
    } else t16 = $[46];
    const fireFormControlAttributes = t16;
    let t17;
    if ($[47] !== baseAttributes || $[48] !== createAnalyticsEvent) {
        t17 = (attributes_11)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                action: "clicked",
                actionSubjectId: "universalCreateShowMoreButton",
                attributes: {
                    ...baseAttributes,
                    ...attributes_11
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[47] = baseAttributes;
        $[48] = createAnalyticsEvent;
        $[49] = t17;
    } else t17 = $[49];
    const fireShowMoreButtonClicked = t17;
    let t18;
    if ($[50] !== baseAttributes || $[51] !== createAnalyticsEvent) {
        t18 = (attributes_12)=>{
            createAnalyticsEvent({
                ...topLevelAttributes,
                action: "loaded",
                actionSubject: "universalCreateJSChunkLoad",
                actionSubjectId: "universalCreateJSChunkLoad",
                eventType: "operational",
                attributes: {
                    ...baseAttributes,
                    ...attributes_12
                }
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        $[50] = baseAttributes;
        $[51] = createAnalyticsEvent;
        $[52] = t18;
    } else t18 = $[52];
    const fireJSChunkLoadTime = t18;
    let t19;
    if ($[53] !== fireCreateButtonClicked || $[54] !== fireCreateButtonHovered || $[55] !== fireCreateButtonViewed || $[56] !== fireEntryPointLoadTriggered || $[57] !== fireFormControlAttributes || $[58] !== fireJSChunkLoadTime || $[59] !== fireMenuContentClosed || $[60] !== fireMenuItemClicked || $[61] !== fireMenuItemsViewed || $[62] !== fireMenuStateChanged || $[63] !== fireNativeMenuItemClicked || $[64] !== fireNativeMenuViewed || $[65] !== fireShowMoreButtonClicked || $[66] !== fireSuggestionsMenuItemClicked || $[67] !== fireSuggestionsMenuViewed) {
        t19 = {
            fireCreateButtonClicked: fireCreateButtonClicked,
            fireCreateButtonHovered: fireCreateButtonHovered,
            fireCreateButtonViewed: fireCreateButtonViewed,
            fireEntryPointLoadTriggered: fireEntryPointLoadTriggered,
            fireNativeMenuItemClicked: fireNativeMenuItemClicked,
            fireSuggestionsMenuItemClicked: fireSuggestionsMenuItemClicked,
            fireMenuItemClicked: fireMenuItemClicked,
            fireNativeMenuViewed: fireNativeMenuViewed,
            fireSuggestionsMenuViewed: fireSuggestionsMenuViewed,
            fireMenuItemsViewed: fireMenuItemsViewed,
            fireMenuContentClosed: fireMenuContentClosed,
            fireMenuStateChanged: fireMenuStateChanged,
            fireFormControlAttributes: fireFormControlAttributes,
            fireShowMoreButtonClicked: fireShowMoreButtonClicked,
            fireJSChunkLoadTime: fireJSChunkLoadTime
        };
        $[53] = fireCreateButtonClicked;
        $[54] = fireCreateButtonHovered;
        $[55] = fireCreateButtonViewed;
        $[56] = fireEntryPointLoadTriggered;
        $[57] = fireFormControlAttributes;
        $[58] = fireJSChunkLoadTime;
        $[59] = fireMenuContentClosed;
        $[60] = fireMenuItemClicked;
        $[61] = fireMenuItemsViewed;
        $[62] = fireMenuStateChanged;
        $[63] = fireNativeMenuItemClicked;
        $[64] = fireNativeMenuViewed;
        $[65] = fireShowMoreButtonClicked;
        $[66] = fireSuggestionsMenuItemClicked;
        $[67] = fireSuggestionsMenuViewed;
        $[68] = t19;
    } else t19 = $[68];
    return t19;
} : function useUniversalCreateAnalytics() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { growthRecommendationsSessionId: growthRecommendationsSessionId, product: product, subProduct: subProduct } = (0, $8s4b7.useUniversalCreateState)();
    // Provide fallback for product if undefined
    const safeProduct = product || 'unknown';
    const includeGrowthSessionInAnalytics = (0, $iDrrr.fg)('navx-3810-re-instrument-growth-session-id');
    const baseAttributes = (0, $cozmU.useMemo)(()=>({
            navLayer: (0, $a9eQA.NAV_LAYER),
            navContainer: (0, $a9eQA.NAV_CONTAINER),
            navVersion: (0, $a9eQA.NAV_VERSION),
            product: safeProduct,
            subProduct: subProduct,
            ...includeGrowthSessionInAnalytics && growthRecommendationsSessionId !== undefined && {
                recommendationSessionId: growthRecommendationsSessionId
            }
        }), [
        growthRecommendationsSessionId,
        includeGrowthSessionInAnalytics,
        safeProduct,
        subProduct
    ]);
    const topLevelAttributes = (0, $cozmU.useMemo)(()=>({
            actionSubject: 'universalCreate',
            eventType: 'ui',
            source: (0, $a9eQA.ANALYTICS_SOURCE),
            tags: [
                (0, $a9eQA.ANALYTICS_TAG)
            ]
        }), []);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88038
    const fireCreateButtonClicked = (0, $cozmU.useCallback)((attributes)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireCreateButtonViewed = (0, $cozmU.useCallback)((attributes_0)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes_0
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireCreateButtonHovered = (0, $cozmU.useCallback)((attributes_1)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'hovered',
            actionSubjectId: 'universalCreateButton',
            attributes: {
                ...baseAttributes,
                ...attributes_1
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    const fireEntryPointLoadTriggered = (0, $cozmU.useCallback)((attributes_2)=>{
        createAnalyticsEvent({
            actionSubject: 'universalCreateEntryPointLoad',
            action: 'triggered',
            eventType: 'track',
            source: (0, $a9eQA.ANALYTICS_SOURCE),
            tags: [
                (0, $a9eQA.ANALYTICS_TAG)
            ],
            attributes: {
                ...baseAttributes,
                ...attributes_2
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88332
    const fireNativeMenuItemClicked = (0, $cozmU.useCallback)((attributes_3)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateNativeMenuItem',
            attributes: {
                group: 'native',
                ...baseAttributes,
                ...attributes_3
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88486
    const fireSuggestionsMenuItemClicked = (0, $cozmU.useCallback)((attributes_4)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateSuggestionsMenuItem',
            attributes: {
                group: 'suggestions',
                ...baseAttributes,
                ...attributes_4
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88295
    const fireMenuItemClicked = (0, $cozmU.useCallback)((attributes_5)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateMenuItem',
            attributes: {
                ...baseAttributes,
                ...attributes_5
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88599
    const fireNativeMenuViewed = (0, $cozmU.useCallback)((attributes_6)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateNativeMenu',
            attributes: {
                ...baseAttributes,
                ...attributes_6
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/88724
    const fireSuggestionsMenuViewed = (0, $cozmU.useCallback)((attributes_7)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateSuggestionsMenu',
            attributes: {
                ...baseAttributes,
                ...attributes_7
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92169
    const fireMenuItemsViewed = (0, $cozmU.useCallback)((attributes_8)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'viewed',
            actionSubjectId: 'universalCreateMenuSection',
            attributes: {
                ...baseAttributes,
                ...attributes_8
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/100116
    const fireMenuContentClosed = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'closed',
            actionSubjectId: 'universalCreateMenuContent',
            attributes: {
                ...baseAttributes
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/89698
    const fireMenuStateChanged = (0, $cozmU.useCallback)((attributes_9)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'changed',
            actionSubjectId: 'universalCreateMenuState',
            attributes: {
                ...baseAttributes,
                ...attributes_9
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        topLevelAttributes,
        baseAttributes
    ]);
    // createModal viewed Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90539
    // createModalBackButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90540
    // createModalCancelButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90541
    // createModalCreateButton clicked Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/90542
    const fireFormControlAttributes = (0, $cozmU.useCallback)(({ actionSubjectId: actionSubjectId, action: action = 'clicked', ...attributes_10 })=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            actionSubject: 'universalCreate',
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...baseAttributes,
                ...attributes_10
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/92730
    const fireShowMoreButtonClicked = (0, $cozmU.useCallback)((attributes_11)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'clicked',
            actionSubjectId: 'universalCreateShowMoreButton',
            attributes: {
                ...baseAttributes,
                ...attributes_11
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    // Data portal link: https://data-portal.internal.atlassian.com/analytics/registry/96626
    const fireJSChunkLoadTime = (0, $cozmU.useCallback)((attributes_12)=>{
        createAnalyticsEvent({
            ...topLevelAttributes,
            action: 'loaded',
            actionSubject: 'universalCreateJSChunkLoad',
            actionSubjectId: 'universalCreateJSChunkLoad',
            eventType: 'operational',
            attributes: {
                ...baseAttributes,
                ...attributes_12
            }
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        baseAttributes,
        topLevelAttributes
    ]);
    return {
        fireCreateButtonClicked: fireCreateButtonClicked,
        fireCreateButtonHovered: fireCreateButtonHovered,
        fireCreateButtonViewed: fireCreateButtonViewed,
        fireEntryPointLoadTriggered: fireEntryPointLoadTriggered,
        fireNativeMenuItemClicked: fireNativeMenuItemClicked,
        fireSuggestionsMenuItemClicked: // merging
        fireSuggestionsMenuItemClicked,
        fireMenuItemClicked: // merging
        fireMenuItemClicked,
        fireNativeMenuViewed: // new ==> (merging) combining native and suggestions
        fireNativeMenuViewed,
        fireSuggestionsMenuViewed: // new + updated
        fireSuggestionsMenuViewed,
        fireMenuItemsViewed: // new + updated
        fireMenuItemsViewed,
        fireMenuContentClosed: fireMenuContentClosed,
        fireMenuStateChanged: fireMenuStateChanged,
        fireFormControlAttributes: fireFormControlAttributes,
        fireShowMoreButtonClicked: fireShowMoreButtonClicked,
        fireJSChunkLoadTime: fireJSChunkLoadTime
    };
};
module.exports["useUniversalCreateAnalytics"] = $c9d55890fc65592f$export$eebe354ebe67c94c;

});

parcelRegister("a9eQA", function(module, exports) {
const $85afdb21ba0b3585$export$85183a312807388d = 'navigation';
const $85afdb21ba0b3585$export$1f0ede2864ffece6 = 'navigationExperiences';
const $85afdb21ba0b3585$export$40fae459cb78b698 = 'global';
const $85afdb21ba0b3585$export$2ee98aa1b18a8f41 = 'top';
const $85afdb21ba0b3585$export$b4ed8a331b8fd4cc = 4;
const $85afdb21ba0b3585$export$f7109619a5e9e0d6 = 'topNav';
const $85afdb21ba0b3585$export$c091fab9d8f83000 = {
    PAGE: 'ati:cloud:confluence:page',
    WHITEBOARD: 'ati:cloud:confluence:whiteboard',
    GOAL: 'ati:cloud:townsquare:goal',
    WORK_ITEM: 'ati:cloud:jira:issue',
    LOOM: 'ati:cloud:loom:video',
    PROJECT: 'ati:cloud:townsquare:project',
    TEAM: 'ati:cloud:townsquare:team',
    TRELLO_BOARD: 'ati:cloud:trello:board'
};
const $85afdb21ba0b3585$export$9449803ae25a1ccd = $85afdb21ba0b3585$export$c091fab9d8f83000.LOOM;
module.exports["ANALYTICS_CHANNEL"] = $85afdb21ba0b3585$export$85183a312807388d;
module.exports["ANALYTICS_TAG"] = $85afdb21ba0b3585$export$1f0ede2864ffece6;
module.exports["NAV_LAYER"] = $85afdb21ba0b3585$export$40fae459cb78b698;
module.exports["NAV_CONTAINER"] = $85afdb21ba0b3585$export$2ee98aa1b18a8f41;
module.exports["NAV_VERSION"] = $85afdb21ba0b3585$export$b4ed8a331b8fd4cc;
module.exports["ANALYTICS_SOURCE"] = $85afdb21ba0b3585$export$f7109619a5e9e0d6;
module.exports["ATI_PRESETS"] = $85afdb21ba0b3585$export$c091fab9d8f83000;

});

parcelRegister("6pXoc", function(module, exports) {
// ===============================
// UC Menu Items V2 API Communication
// ===============================

var $cozmU = parcelRequire("cozmU");


var $5D2Vi = parcelRequire("5D2Vi");

var $cN3xQ = parcelRequire("cN3xQ");


var $cQUD5 = parcelRequire("cQUD5");

/**
 * Encode configuration to binary format with query parameters
 */ /**
 * Encode ATI string to binary representation
 */ /**
 * Utility functions for parsing and constructing ATI strings
 * Uses @atlassian/ari package for ATI parsing
 */ 
var $59jY5 = parcelRequire("59jY5");

function $9802c64f4069a264$export$5597e67f4dded1e6(ati) {
    try {
        const parsed = (0, $59jY5.Ati).parse(ati);
        return {
            prefix: parsed.platformQualifier,
            owner: parsed.resourceOwner,
            type: parsed.resourceType
        };
    } catch  {
        throw new Error(`Invalid ATI format: expected "ati:<prefix>:<owner>:<type>", got "${ati}"`);
    }
}
function $9802c64f4069a264$export$9acdaf42ad16ae47({ prefix: prefix, owner: owner, type: type }) {
    if (!prefix || !owner || !type) throw new Error('All ATI components (prefix, owner, type) must be non-empty');
    try {
        const ati = (0, $59jY5.Ati).create({
            platformQualifier: prefix,
            resourceOwner: owner,
            resourceType: type
        });
        return ati.toString();
    } catch  {
        throw new Error('Failed to construct ATI from components');
    }
}
function $9802c64f4069a264$export$9039e3b1770c6b8(ati) {
    if (typeof ati !== 'string') return false;
    try {
        (0, $59jY5.Ati).parse(ati);
        return true;
    } catch  {
        return false;
    }
}
function $9802c64f4069a264$export$912bb685303c4ec7(items) {
    return Object.fromEntries(items.map((item, index)=>[
            item,
            index
        ]));
}


/**
 * Binary Encoding Constants for Universal Create Menu (V2 API)
 *
 * This module defines the constants used for encoding/decoding ATI configurations
 * into a compact binary format for URL transmission.
 *
 * These constants are shared across frontend and backend for binary encoding/decoding operations.
 */ 
const $3a235add8c2fdaf7$export$3167453beff01750 = 2;
const $3a235add8c2fdaf7$export$b2144c689c2ff042 = [
    'cloud',
    'third-party'
];
const $3a235add8c2fdaf7$export$61beacecbf214ae6 = (0, $9802c64f4069a264$export$912bb685303c4ec7)($3a235add8c2fdaf7$export$b2144c689c2ff042);
const $3a235add8c2fdaf7$export$89e1a37ecee09500 = [
    // ALL NEW RESOURCE OWNERS MUST BE ADDED AT THE END OF THIS LIST
    'jira',
    'confluence',
    'loom',
    'townsquare',
    'trello',
    'bitbucket',
    'opsgenie',
    'compass',
    'statuspage',
    'atlas'
];
const $3a235add8c2fdaf7$export$83dfff18be6bef06 = (0, $9802c64f4069a264$export$912bb685303c4ec7)($3a235add8c2fdaf7$export$89e1a37ecee09500);
const $3a235add8c2fdaf7$export$9dd62a2b56d5462d = [
    // ALL NEW RESOURCE TYPES MUST BE ADDED AT THE END OF THIS LIST
    'issue',
    'page',
    'blogpost',
    'whiteboard',
    'database',
    'space',
    'video',
    'goal',
    'project',
    'team',
    'post',
    'board',
    'repository',
    'workspace',
    'component',
    'embed',
    'livedoc',
    'chat',
    'agent'
];
const $3a235add8c2fdaf7$export$38830b2321100ef2 = (0, $9802c64f4069a264$export$912bb685303c4ec7)($3a235add8c2fdaf7$export$9dd62a2b56d5462d);
const $3a235add8c2fdaf7$export$b1e8f8dc54861a99 = 3;
const $3a235add8c2fdaf7$export$21d9e5eeb6ffaecd = 1;
const $3a235add8c2fdaf7$export$19409b356a31bc6d = {
    // Byte 0 masks
    PREFIX_FLAG_MASK: 128,
    OWNER_FLAG_MASK: 64,
    TYPE_FLAG_MASK: 32,
    PREFIX_VALUE_MASK: 16,
    OWNER_UPPER_MASK: 15,
    // Byte 1 masks
    OWNER_LOWER_MASK: 240,
    TYPE_UPPER_MASK: 15,
    // Byte 2 masks
    TYPE_LOWER_MASK: 255
};
const $3a235add8c2fdaf7$export$4c68bfc8c9124205 = {
    PREFIX_FLAG_SHIFT: 7,
    OWNER_FLAG_SHIFT: 6,
    TYPE_FLAG_SHIFT: 5,
    PREFIX_VALUE_SHIFT: 4,
    OWNER_LOWER_SHIFT: 4,
    OWNER_UPPER_BITS: 4,
    TYPE_UPPER_SHIFT: 4,
    TYPE_UPPER_BITS: 8
};
const $3a235add8c2fdaf7$export$597234ac346c7ad8 = 256;
const $3a235add8c2fdaf7$export$8c22d9b338278eca = 4096;
const $3a235add8c2fdaf7$export$3010378ceda42048 = 256;
const $3a235add8c2fdaf7$export$6048538928ea261a = 4096;
const $3a235add8c2fdaf7$export$fd3a5bd85e4c7caa = 2;
const $3a235add8c2fdaf7$export$4030221cfc1fb63c = 5;
const $3a235add8c2fdaf7$export$ece7c64a85a33d85 = 255;
const $3a235add8c2fdaf7$export$6747badc61b8e57b = 512;
const $3a235add8c2fdaf7$export$48ffef5fac2e11a = 10;
const $3a235add8c2fdaf7$export$c38e76af505e38a1 = [
    'native',
    'link',
    'platform'
];
const $3a235add8c2fdaf7$export$3dcfc8418d714114 = (0, $9802c64f4069a264$export$912bb685303c4ec7)($3a235add8c2fdaf7$export$c38e76af505e38a1);
const $3a235add8c2fdaf7$export$c89f8194e7716284 = [
    'off',
    'full',
    'overflow',
    'growthRecommendations'
];
const $3a235add8c2fdaf7$export$6cabc9b146da4ac8 = (0, $9802c64f4069a264$export$912bb685303c4ec7)($3a235add8c2fdaf7$export$c89f8194e7716284);
const $3a235add8c2fdaf7$export$9c3e0a77c247e0c = [
    'appDefinedSection',
    'suggestionSection'
];
const $3a235add8c2fdaf7$export$1e5c4f2c7d35f342 = (0, $9802c64f4069a264$export$912bb685303c4ec7)($3a235add8c2fdaf7$export$9c3e0a77c247e0c);
const $3a235add8c2fdaf7$export$dab292c7293b69ae = [
    '~',
    '|',
    ',',
    ':'
];


/**
 * Get configuration for a specific component kind
 */ function $6191b53ab8f8e537$var$getComponentConfig(unknowns, kind) {
    switch(kind){
        case 'prefix':
            return {
                array: unknowns.prefixes,
                maxLimit: (0, $3a235add8c2fdaf7$export$fd3a5bd85e4c7caa),
                errorMessage: `Too many unknown ATI prefixes (max ${0, $3a235add8c2fdaf7$export$fd3a5bd85e4c7caa})`
            };
        case 'owner':
            return {
                array: unknowns.owners,
                maxLimit: (0, $3a235add8c2fdaf7$export$3010378ceda42048),
                errorMessage: `Too many unknown resource owners (max ${0, $3a235add8c2fdaf7$export$3010378ceda42048})`
            };
        case 'type':
            return {
                array: unknowns.types,
                maxLimit: (0, $3a235add8c2fdaf7$export$6048538928ea261a),
                errorMessage: `Too many unknown resource types (max ${0, $3a235add8c2fdaf7$export$6048538928ea261a})`
            };
    }
}
/**
 * Ensure capacity for a component kind
 * @throws Error if capacity limit is exceeded
 */ function $6191b53ab8f8e537$var$ensureCapacity(unknowns, kind) {
    const config = $6191b53ab8f8e537$var$getComponentConfig(unknowns, kind);
    if (config.array.length >= config.maxLimit) throw new Error(config.errorMessage);
}
/**
 * Track unknown component value and return its index
 * Reuses existing index if value already tracked
 */ function $6191b53ab8f8e537$var$trackUnknown({ unknowns: unknowns, kind: kind, value: value }) {
    const config = $6191b53ab8f8e537$var$getComponentConfig(unknowns, kind);
    const existing = config.array.indexOf(value);
    if (existing !== -1) return existing;
    $6191b53ab8f8e537$var$ensureCapacity(unknowns, kind);
    config.array.push(value);
    return config.array.length - 1;
}
/**
 * Encode a component (prefix/owner/type) to its code
 * Returns code and unknown flag
 */ function $6191b53ab8f8e537$var$encodeComponent({ unknowns: unknowns, kind: kind, value: value, knownMap: knownMap }) {
    const knownCode = knownMap[value];
    const isUnknown = knownCode === undefined;
    const code = isUnknown ? $6191b53ab8f8e537$var$trackUnknown({
        unknowns: unknowns,
        kind: kind,
        value: value
    }) : knownCode;
    return {
        code: code,
        isUnknown: isUnknown
    };
}
function $6191b53ab8f8e537$export$4b052fcb66ebb451(ati, unknowns) {
    const { prefix: prefix, owner: owner, type: type } = (0, $9802c64f4069a264$export$5597e67f4dded1e6)(ati);
    const { code: prefixCode, isUnknown: prefixIsUnknown } = $6191b53ab8f8e537$var$encodeComponent({
        unknowns: unknowns,
        kind: 'prefix',
        value: prefix,
        knownMap: (0, $3a235add8c2fdaf7$export$61beacecbf214ae6)
    });
    const { code: ownerCode, isUnknown: ownerIsUnknown } = $6191b53ab8f8e537$var$encodeComponent({
        unknowns: unknowns,
        kind: 'owner',
        value: owner,
        knownMap: (0, $3a235add8c2fdaf7$export$83dfff18be6bef06)
    });
    const { code: typeCode, isUnknown: typeIsUnknown } = $6191b53ab8f8e537$var$encodeComponent({
        unknowns: unknowns,
        kind: 'type',
        value: type,
        knownMap: (0, $3a235add8c2fdaf7$export$38830b2321100ef2)
    });
    return {
        prefixCode: prefixCode,
        prefixIsUnknown: prefixIsUnknown,
        ownerCode: ownerCode,
        ownerIsUnknown: ownerIsUnknown,
        typeCode: typeCode,
        typeIsUnknown: typeIsUnknown
    };
}
function $6191b53ab8f8e537$export$9fa514be131db9ec({ encoded: encoded, buffer: buffer, offset: offset }) {
    const { prefixCode: prefixCode, prefixIsUnknown: prefixIsUnknown, ownerIsUnknown: ownerIsUnknown, typeIsUnknown: typeIsUnknown, ownerCode: ownerCode, typeCode: typeCode } = encoded;
    // Byte 0: [P|O|T|P|OOOO]
    const ownerUpper = ownerCode >> (0, $3a235add8c2fdaf7$export$4c68bfc8c9124205).OWNER_UPPER_BITS & 0x0f;
    const byte0 = (prefixIsUnknown ? 1 : 0) << (0, $3a235add8c2fdaf7$export$4c68bfc8c9124205).PREFIX_FLAG_SHIFT | (ownerIsUnknown ? 1 : 0) << (0, $3a235add8c2fdaf7$export$4c68bfc8c9124205).OWNER_FLAG_SHIFT | (typeIsUnknown ? 1 : 0) << (0, $3a235add8c2fdaf7$export$4c68bfc8c9124205).TYPE_FLAG_SHIFT | (prefixCode & 0x01) << (0, $3a235add8c2fdaf7$export$4c68bfc8c9124205).PREFIX_VALUE_SHIFT | ownerUpper;
    // Byte 1: [OOOO|TTTT]
    const ownerLower = ownerCode & 0x0f;
    const typeUpper = typeCode >> 8 & 0x0f;
    const byte1 = ownerLower << (0, $3a235add8c2fdaf7$export$4c68bfc8c9124205).OWNER_LOWER_SHIFT | typeUpper;
    // Byte 2: [TTTTTTTT]
    const byte2 = typeCode & 0xff;
    // Write bytes directly (inline writeUInt8)
    buffer[offset] = byte0 & 0xff;
    buffer[offset + 1] = byte1 & 0xff;
    buffer[offset + 2] = byte2 & 0xff;
}


/**
 * Platform-agnostic buffer utilities for binary encoding/decoding
 * Works in both browser and Node.js environments
 */ /**
 * Encode Uint8Array to base64url string (without padding)
 *
 * @param bytes - Uint8Array to encode
 * @returns Base64URL-encoded string
 */ 
var $e9nC3 = parcelRequire("e9nC3");

var $b49b5e5e2cba018c$require$Buffer = $e9nC3.Buffer;
function $b49b5e5e2cba018c$export$b0ffcdf8b133e63c(bytes) {
    if (bytes.length === 0) return '';
    if (btoa === undefined) return $b49b5e5e2cba018c$require$Buffer.from(bytes).toString('base64url');
    else {
        // Browser: convert to binary string using Array.from (safe for large arrays and null bytes)
        const binaryString = Array.from(bytes, (byte)=>String.fromCharCode(byte)).join('');
        return btoa(binaryString).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    }
}



// =============================================================================
// Configuration Validation
// =============================================================================
const $26854ecd95ac108e$var$MAX_SECTIONS = 15;
function $26854ecd95ac108e$var$validateConfig(config) {
    if (!config || typeof config !== 'object') throw new Error('Config must be an object');
    if (!Array.isArray(config.appMenuConfig)) throw new Error('Config sections must be an array');
    if (config.appMenuConfig.length === 0) throw new Error('Cannot encode empty sections array');
    if (config.appMenuConfig.length > $26854ecd95ac108e$var$MAX_SECTIONS) throw new Error(`Too many sections (max ${$26854ecd95ac108e$var$MAX_SECTIONS})`);
}
// =============================================================================
// ATI Encoding
// =============================================================================
/**
 * Encode a single ATI string to 3-byte binary format, then Base64URL
 *
 * @param ati - ATI string to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Base64URL-encoded ATI (4 characters)
 */ function $26854ecd95ac108e$var$encodeATIToBase64(ati, unknowns) {
    const encoded = (0, $6191b53ab8f8e537$export$4b052fcb66ebb451)(ati, unknowns);
    const buffer = new Uint8Array(3);
    (0, $6191b53ab8f8e537$export$9fa514be131db9ec)({
        encoded: encoded,
        buffer: buffer,
        offset: 0
    });
    return (0, $b49b5e5e2cba018c$export$b0ffcdf8b133e63c)(buffer);
}
/**
 * Encode a list of ATI strings to comma-separated Base64URL format
 *
 * @param atiList - Array of ATI strings (optional)
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Comma-separated Base64URL-encoded ATIs, or empty string if no ATIs
 */ function $26854ecd95ac108e$var$encodeATIList(atiList, unknowns) {
    if (!atiList || atiList.length === 0) return '';
    return atiList.map((ati)=>$26854ecd95ac108e$var$encodeATIToBase64(ati, unknowns)).join(',');
}
// =============================================================================
// Encoding Utilities
// =============================================================================
/**
 * Join array parts with hierarchical delimiter, truncating trailing empty/undefined values
 *
 * This utility implements a common pattern across encoding functions:
 * 1. Construct an array with known data
 * 2. Truncate array at last non-empty item
 * 3. Join array as string with delimiter at specified hierarchy level
 *
 * @param parts - Array of values to join (string | number | undefined)
 * @param delimiterLevel - Hierarchy level of delimiter to use (0=~, 1=|, 2=,, 3=:)
 * @returns Joined string with trailing empties removed
 *
 * @example
 * joinWithTruncation(['a', 'b', ''], 3) // 'a:b' (level 3 = ':')
 * joinWithTruncation(['a', '', ''], 2) // 'a' (level 2 = ',')
 * joinWithTruncation([1, 2, undefined], 1) // '1|2' (level 1 = '|')
 */ function $26854ecd95ac108e$var$joinWithTruncation(parts, delimiterLevel) {
    // When delimiter level is out of bounds, default to '~'
    const delimiter = (0, $3a235add8c2fdaf7$export$dab292c7293b69ae)[delimiterLevel] ?? '~';
    // Find last index where value is not empty string or undefined
    let lastIndex = parts.length - 1;
    while(lastIndex >= 0 && (parts[lastIndex] === '' || parts[lastIndex] === undefined))lastIndex--;
    // Slice to last non-empty index + 1, convert all to string, and join
    return parts.slice(0, lastIndex + 1).map(String).join(delimiter);
}
// =============================================================================
// Menu Item Encoding
// =============================================================================
const $26854ecd95ac108e$var$PROMOTED_FLAG = '1';
/**
 * Encode a single menu item
 *
 * Format: atiBase64:itemType[:promoted]
 * - The promoted flag is only included when true
 *
 * @param item - Menu item to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded menu item string
 * @throws Error if item type is unknown
 */ function $26854ecd95ac108e$var$encodeMenuItem(item, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const typeCode = item.type !== undefined ? $26854ecd95ac108e$var$getCodeByType(item) : undefined;
    const atiBase64 = $26854ecd95ac108e$var$encodeATIToBase64(item.ati, unknowns);
    const isPromoted = item.promoted === true;
    const promotedFlag = isPromoted ? $26854ecd95ac108e$var$PROMOTED_FLAG : undefined;
    return $26854ecd95ac108e$var$joinWithTruncation([
        atiBase64,
        typeCode,
        promotedFlag
    ], 3); // Level 3: ':' (item properties)
}
/**
 * Get the numeric type code for a menu item
 *
 * @param item - Menu item
 * @returns Numeric type code
 * @throws Error if item type is unknown or undefined
 */ function $26854ecd95ac108e$var$getCodeByType(item) {
    // If go down the path of getting code, type should not be undefined
    if (item.type === undefined) throw new Error('Item type is undefined');
    const typeCode = (0, $3a235add8c2fdaf7$export$3dcfc8418d714114)[item.type];
    if (typeCode === undefined) throw new Error(`Unknown item type: ${item.type}`);
    return typeCode;
}
/**
 * Get the numeric code for a menu section
 *
 * @param sectionType - Section type MenuSection['type']
 * @returns String type code number
 */ function $26854ecd95ac108e$var$sectionTypeToCode(sectionType) {
    const typeCode = (0, $3a235add8c2fdaf7$export$1e5c4f2c7d35f342)[sectionType];
    if (typeCode === undefined) throw new Error(`Unknown section type: ${String(sectionType)}`);
    return typeCode;
}
// =============================================================================
// Section Encoding
// =============================================================================
/**
 * Get the numeric code for a personalize mode
 *
 * @param mode - Personalize mode
 * @returns Numeric code for the mode
 * @throws Error if mode is unknown
 */ function $26854ecd95ac108e$var$personalizeCodeByMode(mode) {
    const code = (0, $3a235add8c2fdaf7$export$6cabc9b146da4ac8)[mode];
    if (code === undefined) throw new Error(`Unknown personalize mode: ${mode}`);
    return code;
}
/**
 * Encode an overflow threshold
 *
 * @param overflowThreshold - Overflow threshold
 * @returns Encoded overflow threshold string
 */ function $26854ecd95ac108e$var$encodeOverflowThreshold(overflowThreshold) {
    if (overflowThreshold < 0) throw new Error('Overflow threshold must be positive');
    return overflowThreshold.toString();
}
/**
 * Encode an app-defined section
 *
 * Format: 0|item1,item2,...|personalizeCode
 * - Trailing default values are truncated (personalize='0' / 'off' can be omitted)
 * - personalizeCode: 0=off, 1=full, 2=overflow
 *
 * @private
 * @param section - App-defined section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 */ function $26854ecd95ac108e$var$encodeAppDefinedSection(section, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const sectionType = $26854ecd95ac108e$var$sectionTypeToCode('appDefinedSection');
    const encodedItems = section.items.map((item)=>$26854ecd95ac108e$var$encodeMenuItem(item, unknowns)).join(',');
    const personalizeCode = section.personalize && section.personalize !== 'off' ? $26854ecd95ac108e$var$personalizeCodeByMode(section.personalize) : undefined;
    const overflowThreshold = personalizeCode !== undefined && section.personalize === 'overflow' && section.overflowThreshold !== undefined ? $26854ecd95ac108e$var$encodeOverflowThreshold(section.overflowThreshold) : undefined;
    return $26854ecd95ac108e$var$joinWithTruncation([
        sectionType,
        encodedItems,
        personalizeCode,
        overflowThreshold
    ], 1); // Level 1: '|' (section fields)
}
/**
 * Encode a suggestion section
 *
 * Format: 1|limit|excludeAti1,excludeAti2,...|preferredAti1,preferredAti2,...
 * - Trailing empty values are truncated (empty excludeAtis/preferredAtis can be omitted)
 * - Default limit (5) is included explicitly for clarity
 *
 * @private
 * @param section - Suggestion section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 */ function $26854ecd95ac108e$var$encodeSuggestionSection(section, unknowns) {
    // Note: order of fields is important, do not change it without updating the decode function
    const sectionType = $26854ecd95ac108e$var$sectionTypeToCode('suggestionSection');
    const limit = section.limit;
    const excludeAtis = $26854ecd95ac108e$var$encodeATIList(section.excludeAtis, unknowns);
    const preferredAtis = $26854ecd95ac108e$var$encodeATIList(section.preferredAtis, unknowns);
    return $26854ecd95ac108e$var$joinWithTruncation([
        sectionType,
        limit,
        excludeAtis,
        preferredAtis
    ], 1); // Level 1: '|' (section fields)
}
/**
 * Encode a single menu section based on its type
 *
 * @param section - Menu section to encode
 * @param unknowns - Accumulator for unknown ATI components
 * @returns Encoded section string
 * @throws Error if section type is unknown
 */ function $26854ecd95ac108e$var$encodeSection(section, unknowns) {
    switch(section.type){
        case 'appDefinedSection':
            return $26854ecd95ac108e$var$encodeAppDefinedSection(section, unknowns);
        case 'suggestionSection':
            return $26854ecd95ac108e$var$encodeSuggestionSection(section, unknowns);
        default:
            // TypeScript exhaustiveness check - this should never happen
            throw new Error(`Unknown section type: ${String(section)}`);
    }
}
// =============================================================================
// Final Assembly
// =============================================================================
/**
 * Build the raw configuration string from encoded sections
 *
 * Format: v{SCHEMA_VERSION}~section1~section2~...
 *
 * @private
 * @param encodedSections - Array of encoded section strings
 * @returns Raw configuration string with version prefix
 */ function $26854ecd95ac108e$var$buildRawConfigString(encodedSections) {
    return `v${0, $3a235add8c2fdaf7$export$3167453beff01750}~${encodedSections.join('~')}`;
}
/**
 * Attach unknown component query parameters to the encoded result
 *
 * @private
 * @param encodedData - Base64URL-encoded configuration data
 * @param unknowns - Unknown ATI components collected during encoding
 * @returns Encoded configuration with query parameters
 */ function $26854ecd95ac108e$var$attachQueryParameters(encodedData, unknowns) {
    const result = {
        d: encodedData
    };
    if (unknowns.owners.length > 0) result.ro = unknowns.owners.join(',');
    if (unknowns.types.length > 0) result.rt = unknowns.types.join(',');
    if (unknowns.prefixes.length > 0) result.ap = unknowns.prefixes.join(',');
    return result;
}
function $26854ecd95ac108e$export$1282978798683232(config) {
    $26854ecd95ac108e$var$validateConfig(config);
    const unknowns = {
        owners: [],
        types: [],
        prefixes: []
    };
    const encodedSections = config.appMenuConfig.map((section)=>$26854ecd95ac108e$var$encodeSection(section, unknowns));
    const rawConfigString = $26854ecd95ac108e$var$buildRawConfigString(encodedSections);
    // Encode UTF-8 string to bytes, then to base64url
    const utf8Bytes = new TextEncoder().encode(rawConfigString);
    const encodedData = (0, $b49b5e5e2cba018c$export$b0ffcdf8b133e63c)(utf8Bytes);
    return $26854ecd95ac108e$var$attachQueryParameters(encodedData, unknowns);
}



var $3ePvn = parcelRequire("3ePvn");


var $iBJls = parcelRequire("iBJls");


var $cOW5t = parcelRequire("cOW5t");


var $9Kv4c = parcelRequire("9Kv4c");







/**
 * Helper function to create a deterministic cache key from an object
 * by sorting keys and stringifying the result
 */ function $befabd4509befbae$var$createSortedCacheKey(unordered) {
    return JSON.stringify(Object.keys(unordered).sort().reduce((obj, key)=>{
        obj[key] = unordered[key];
        return obj;
    }, {}));
}
function $befabd4509befbae$export$53a1e737d45016e2(props) {
    const { value: { consumer: consumer, cache: cache }, setValue: setValue } = (0, $iBJls.useBFFContext)();
    if (!consumer) throw new Error('BFFContext Consumer is not set');
    // Compute cache key using useMemo with sorted JSON stringification
    const cacheKey = (0, $cozmU.useMemo)(()=>{
        const sortedJsonString = $befabd4509befbae$var$createSortedCacheKey(props);
        return `gc-${consumer}-${sortedJsonString}`;
    }, [
        consumer,
        props
    ]);
    const cachedObject = cache[cacheKey];
    const setCachedObject = (0, $cozmU.useCallback)((objectToCache)=>{
        setValue((prev)=>({
                ...prev,
                cache: {
                    ...prev.cache,
                    [cacheKey]: objectToCache
                }
            }));
    }, [
        cacheKey,
        setValue
    ]);
    const removeCachedObject = (0, $cozmU.useCallback)(()=>{
        setValue((prev_0)=>{
            const { [cacheKey]: removed, ...remainingCache } = prev_0.cache;
            return {
                ...prev_0,
                cache: remainingCache
            };
        });
    }, [
        cacheKey,
        setValue
    ]);
    const getCachedObject = (targetCacheKey)=>cache[targetCacheKey];
    const hasCachedObject = (targetCacheKey_0)=>cache[targetCacheKey_0] !== undefined;
    return {
        cachedObject: cachedObject,
        cacheKey: cacheKey,
        getCachedObject: getCachedObject,
        hasCachedObject: hasCachedObject,
        removeCachedObject: removeCachedObject,
        setCachedObject: setCachedObject
    };
}



var $hrm0L = parcelRequire("hrm0L");


var $2nIbk = parcelRequire("2nIbk");

function $791551c7556c5138$export$23f37315094bc4d3({ cloudId: cloudId, orgId: orgId, product: product, userId: userId, locale: locale, subProduct: subProduct, appMenuConfig: appMenuConfig, skipInitialization: skipInitialization = false }) {
    const { value: value, currentLoadingRequests: currentLoadingRequests } = (0, $iBJls.useBFFContext)();
    const boundaryConfig = (0, $cozmU.useMemo)(()=>({
            location: 'useUCMenuItems',
            disableSentry: false,
            disableAnalytics: true,
            sentryConfig: {
                product: product
            },
            interactionId: 'universalCreatePrefetch',
            tags: {
                component: 'universal-create',
                subProduct: subProduct
            }
        }), [
        product,
        subProduct
    ]);
    const { handleError: handleError } = (0, $cN3xQ.useNavBoundaryContext)(boundaryConfig);
    const { inFlightRequests: inFlightRequests, setInFlightRequests: setInFlightRequests } = (0, $cOW5t.useUniversalCreateBFFContext)();
    const { setStatus: setStatus } = (0, $hrm0L.useStatus)();
    const [data, setData] = (0, $cozmU.useState)(undefined);
    const [hasError, setHasError] = (0, $cozmU.useState)(false);
    const { buildUCMenuItemsURL: buildUCMenuItemsURL } = (0, $2nIbk.useURLBuilder)({
        cloudId: cloudId
    });
    const requestIdRef = (0, $cozmU.useRef)(0);
    /**
   * Helper functions for feature gated inflight request tracking
   */ const isRequestInflight = (0, $cozmU.useCallback)((requestKey)=>{
        return inFlightRequests.has(requestKey);
    }, [
        inFlightRequests
    ]);
    const setRequestInFlight = (0, $cozmU.useCallback)((requestKey_0, value_0)=>{
        return setInFlightRequests(requestKey_0, value_0);
    }, [
        setInFlightRequests
    ]);
    const clearInFlightRequest = (0, $cozmU.useCallback)((requestKey_1)=>{
        return inFlightRequests.delete(requestKey_1);
    }, [
        inFlightRequests
    ]);
    // Encode the config to get binary parameters
    const encodedConfig = (0, $cozmU.useMemo)(()=>{
        if (skipInitialization) return null;
        try {
            return (0, $26854ecd95ac108e$export$1282978798683232)(appMenuConfig);
        } catch  {
            // If encoding fails, we'll handle it in the fetch
            return null;
        }
    }, [
        appMenuConfig,
        skipInitialization
    ]);
    // Generate cache key based on encoded config and metadata
    const { cachedObject: cachedObject, setCachedObject: setCachedObject } = (0, $befabd4509befbae$export$53a1e737d45016e2)({
        cloudId: cloudId,
        productType: product,
        orgId: orgId,
        accountId: userId,
        subProduct: subProduct,
        locale: locale,
        // Include encoded config in cache key to ensure different configs get different cache entries
        ...encodedConfig && {
            encodedConfigD: encodedConfig.d
        }
    });
    // Set data from cache on mount if available
    if (cachedObject && !data) {
        setData(cachedObject);
        setHasError(false);
    }
    const fetchUCMenuItems = (0, $cozmU.useCallback)(async ()=>{
        // Early exit: filter out invalid param requests when required identifiers are missing or skip initialization if requested
        if (!cloudId || !orgId || skipInitialization) return;
        // Early exit: if encoding failed
        if (!encodedConfig) {
            setHasError(true);
            setStatus((0, $3ePvn.RequestStatus).ERROR, (0, $3ePvn.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            return;
        }
        // Return cached data if available (already locale-scoped via cache key)
        if (cachedObject) {
            setStatus((0, $3ePvn.RequestStatus).COMPLETE, (0, $3ePvn.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            return cachedObject;
        }
        // Generate request key to prevent duplicate concurrent requests
        const requestKey_2 = `${product}|${orgId}|${userId}|${locale}|${subProduct}|${encodedConfig.d}`;
        // Skip if an identical request is already in flight
        if (isRequestInflight(requestKey_2)) return;
        // Increment request id for race protection
        requestIdRef.current += 1;
        const scopedId = requestIdRef.current;
        // Create and start experience tracker only when actually making request
        const experience = (0, $cQUD5.createExperienceTracker)('universalCreatePrefetch');
        experience?.start();
        try {
            const url = buildUCMenuItemsURL({
                product: product,
                orgId: orgId,
                userId: userId,
                locale: locale,
                subProduct: subProduct,
                d: encodedConfig.d,
                ro: encodedConfig.ro,
                rt: encodedConfig.rt,
                ap: encodedConfig.ap
            });
            setStatus((0, $3ePvn.RequestStatus).LOADING, (0, $3ePvn.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            // Mark request key as in-flight before fetch fires to prevent race conditions
            setRequestInFlight(requestKey_2, true);
            const response = await (0, $9Kv4c.fetchJSON)(url, {});
            // Ignore if this response is for a stale request
            if (scopedId !== requestIdRef.current) {
                // Clear in-flight key if this was the request that set it
                if (isRequestInflight(requestKey_2)) clearInFlightRequest(requestKey_2);
                return;
            }
            if (response.status === (0, $3ePvn.RequestStatus).ERROR) {
                experience?.failure();
                setHasError(true);
                setData(undefined);
                setStatus((0, $3ePvn.RequestStatus).ERROR, (0, $3ePvn.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
                // Clear in-flight key on error
                clearInFlightRequest(requestKey_2);
                handleError(new (0, $5D2Vi.BFFNetworkError)('Failed to fetch universal create menu items', {
                    url: url,
                    status: response.status,
                    originalError: response.error,
                    additionalContext: {
                        requestKey: requestKey_2
                    }
                }));
                return;
            }
            if (response.status === (0, $3ePvn.RequestStatus).COMPLETE && response.data) {
                experience?.success();
                setData(response.data);
                setHasError(false);
                // Only cache if the data is not partial
                if (!response.data.isPartial) setCachedObject(response.data);
                setStatus((0, $3ePvn.RequestStatus).COMPLETE, (0, $3ePvn.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
                // Clear in-flight key on success
                clearInFlightRequest(requestKey_2);
                return response.data;
            }
        } catch (error) {
            experience?.failure();
            if (scopedId === requestIdRef.current) {
                setHasError(true);
                setData(undefined);
                setStatus((0, $3ePvn.RequestStatus).ERROR, (0, $3ePvn.UC_MENU_ITEMS_REQUEST_STATUS_KEY));
            }
            // Clear in-flight key on exception
            clearInFlightRequest(requestKey_2);
            handleError(new (0, $5D2Vi.BFFError)('Error occurred during fetchUCMenuItems', {
                status: (0, $3ePvn.RequestStatus).ERROR,
                originalError: error,
                additionalContext: {
                    requestKey: requestKey_2
                }
            }));
        }
        return;
    }, [
        cloudId,
        orgId,
        skipInitialization,
        encodedConfig,
        cachedObject,
        product,
        userId,
        locale,
        subProduct,
        isRequestInflight,
        setStatus,
        buildUCMenuItemsURL,
        setRequestInFlight,
        clearInFlightRequest,
        handleError,
        setCachedObject
    ]);
    const isLoading = (0, $cozmU.useMemo)(()=>{
        if (skipInitialization) return false;
        // We check if the current loading requests include UC menu items rather than the BFF status directly
        // to ensure that it only returns true for UC menu items and not other BFF requests.
        const isBffLoadingOurStuff = currentLoadingRequests?.includes((0, $3ePvn.UC_MENU_ITEMS_REQUEST_STATUS_KEY)) ?? false;
        // That said, if the BFF is in loading state but data has been returned, we want to wait for things to complete
        // before running things like onResultChange, so that we don't do those things an unnecessary extra time
        // during the brief moment when data is present but loading is still true, or an error has occurred and loading is still true.
        const hasMenuItemDataBeenReturned = data !== undefined || hasError;
        return isBffLoadingOurStuff && !hasMenuItemDataBeenReturned;
    }, [
        currentLoadingRequests,
        data,
        hasError,
        skipInitialization
    ]);
    return {
        data: data,
        isLoading: isLoading,
        hasError: hasError,
        status: value.status,
        fetchUCMenuItems: fetchUCMenuItems
    };
}
module.exports["useUCMenuItems"] = $791551c7556c5138$export$23f37315094bc4d3;

});

parcelRegister("gSwt1", function(module, exports) {
const $42d527fa4c4251b4$export$e5a5b1df38d9e289 = 4;



var $52cLa = parcelRequire("52cLa");

const $f80eba2d4e220c7b$export$20ae29efbf02e075 = (item)=>({
        type: (0, $52cLa.isNativeMenuItem)(item) ? 'native' : item.type,
        ati: item.ati.toString(),
        promoted: item?.promoted
    });
const $f80eba2d4e220c7b$export$95539883fd80ce6 = (section)=>{
    if (section.type === 'suggestionSection') return {
        type: 'suggestionSection',
        limit: section.limit ?? 5,
        ...section.excludeAtis && {
            excludeAtis: section.excludeAtis.map((ati)=>ati.toString())
        },
        ...section.preferredAtis && {
            preferredAtis: section.preferredAtis.map((ati)=>ati.toString())
        }
    };
    if (section.type === 'appDefinedSection') {
        const overflowThreshold = Boolean(section.foldable) ? typeof section.foldable === 'number' ? section.foldable : (0, $42d527fa4c4251b4$export$e5a5b1df38d9e289) : undefined;
        return {
            type: 'appDefinedSection',
            items: section.items.map($f80eba2d4e220c7b$export$20ae29efbf02e075),
            personalize: section.personalize,
            ...overflowThreshold && {
                overflowThreshold: overflowThreshold
            }
        };
    }
    // Assert that we have handled all possible section types
    const exhaustive = section;
    return exhaustive;
};
const $f80eba2d4e220c7b$export$c9ba238fd04e08d2 = (sections)=>({
        appMenuConfig: sections.map($f80eba2d4e220c7b$export$95539883fd80ce6)
    });
module.exports["sectionsToAppMenuConfig"] = $f80eba2d4e220c7b$export$c9ba238fd04e08d2;

});

parcelRegister("52cLa", function(module, exports) {
const $15bdb22f1383a1af$export$68f958d92a17ef71 = (item)=>{
    return 'children' in item && !('type' in item);
};
module.exports["isNativeMenuItem"] = $15bdb22f1383a1af$export$68f958d92a17ef71;

});

parcelRegister("fhY2W", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

const $0dc833900e243a87$export$61de563e38fe014d = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useFetchUser() {
    const $ = (0, $bDgLe.c)(1);
    const fetchUser = $0dc833900e243a87$var$_temp;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            fetchUser: fetchUser
        };
        $[0] = t0;
    } else t0 = $[0];
    return t0;
} : function useFetchUser() {
    const fetchUser = (0, $cozmU.useCallback)(async ()=>{
        try {
            const response = await fetch('/gateway/api/me', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (!response.ok) return undefined;
            const userData = await response.json();
            return userData;
        } catch (err) {
            return undefined;
        }
    }, []);
    return {
        fetchUser: fetchUser
    };
};
async function $0dc833900e243a87$var$_temp() {
    try {
        const response = await fetch("/gateway/api/me", {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (!response.ok) return;
        const userData = await response.json();
        return userData;
    } catch (t0) {
        return;
    }
}
module.exports["useFetchUser"] = $0dc833900e243a87$export$61de563e38fe014d;

});

parcelRegister("8xBhK", function(module, exports) {

let $637e53dd9b95605e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $637e53dd9b95605e$var$load("jK9II").then(()=>parcelRequire('l4KZP'));

});

parcelRegister("9Mf9v", function(module, exports) {

let $71e459afd5bbb1f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $71e459afd5bbb1f3$var$load("1uLVv"),
    $71e459afd5bbb1f3$var$load("jK9II"),
    $71e459afd5bbb1f3$var$load("bFpjR")
]).then(()=>parcelRequire('dGDfT'));

});

parcelRegister("cJDAh", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $iMnC5 = parcelRequire("iMnC5");


var $a9eQA = parcelRequire("a9eQA");


var $iRNcR = parcelRequire("iRNcR");

const $bf9ba2ad2880a6c5$var$styles = {
    wrapper: "_1ul91dhz",
    wrapperWithPadding: "_1ul91dhz _ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi"
};
const $bf9ba2ad2880a6c5$export$dab1248df0cdf0ab = (0, $gtMdU.isReactCompilerActivePlatform)() ? function LoadingMenu(t0) {
    const $ = (0, $bDgLe.c)(6);
    const { padded: t1 } = t0;
    const padded = t1 === undefined ? false : t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    let t3;
    if ($[0] !== createAnalyticsEvent) {
        t2 = ()=>{
            createAnalyticsEvent({
                actionSubject: "universalCreate",
                eventType: "ui",
                source: (0, $a9eQA.ANALYTICS_SOURCE),
                tags: [
                    (0, $a9eQA.ANALYTICS_TAG)
                ],
                action: "viewed",
                actionSubjectId: "universalCreateLoadingMenu",
                attributes: {}
            }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
        };
        t3 = [
            createAnalyticsEvent
        ];
        $[0] = createAnalyticsEvent;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = padded ? $bf9ba2ad2880a6c5$var$styles.wrapperWithPadding : $bf9ba2ad2880a6c5$var$styles.wrapper;
    let t5;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = Array.from({
            length: 6
        }, $bf9ba2ad2880a6c5$var$_temp);
        $[3] = t5;
    } else t5 = $[3];
    let t6;
    if ($[4] !== t4) {
        t6 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            testId: "global-create-content-loading-menu",
            xcss: t4
        }, t5);
        $[4] = t4;
        $[5] = t6;
    } else t6 = $[5];
    return t6;
} : function LoadingMenu({ padded: padded = false }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, $cozmU.useEffect)(()=>{
        // Intentional inline this analytics events due to
        // loading menu component can be used outside of context
        createAnalyticsEvent({
            actionSubject: 'universalCreate',
            eventType: 'ui',
            source: (0, $a9eQA.ANALYTICS_SOURCE),
            tags: [
                (0, $a9eQA.ANALYTICS_TAG)
            ],
            action: 'viewed',
            actionSubjectId: 'universalCreateLoadingMenu',
            attributes: {}
        }).fire((0, $a9eQA.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        testId: "global-create-content-loading-menu",
        xcss: padded ? $bf9ba2ad2880a6c5$var$styles.wrapperWithPadding : $bf9ba2ad2880a6c5$var$styles.wrapper
    }, Array.from({
        length: 6
    }, (_, index)=>/*#__PURE__*/ $cozmU.createElement((0, $iRNcR.SkeletonItem), {
            key: `loading-skeleton-item-${index}`,
            contentHeight: 8
        })));
};
function $bf9ba2ad2880a6c5$var$_temp(_, index) {
    return /*#__PURE__*/ $cozmU.createElement((0, $iRNcR.SkeletonItem), {
        key: `loading-skeleton-item-${index}`,
        contentHeight: 8
    });
}
module.exports["LoadingMenu"] = $bf9ba2ad2880a6c5$export$dab1248df0cdf0ab;

});

parcelRegister("iRNcR", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");











var $kSwu1 = parcelRequire("kSwu1");


var $4ez2K = parcelRequire("4ez2K");

var $dinVW = parcelRequire("dinVW");


var $a9aSv = parcelRequire("a9aSv");


var $9GVkD = parcelRequire("9GVkD");




const $427471ff219af96a$var$messages = (0, $kSwu1.defineMessages)({
    menuItemLoading: {
        id: "navigation.universal-create.menuItemLoading",
        defaultMessage: "Menu item is loading"
    }
});
var $427471ff219af96a$export$2e2bcd8739ae039 = $427471ff219af96a$var$messages;


const $ab0941114a4b9cd6$var$DEFAULT_CONTENT_HEIGHT = 8;
const $ab0941114a4b9cd6$var$menuSkeletonStyles = {
    wrapper: "_4t3izwfg _1bsb1osq _19bv1b66 _u5f31b66"
};
const $ab0941114a4b9cd6$export$cde35cc9e1359709 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { testId: testId, contentHeight: t1 } = t0;
    const contentHeight = t1 === undefined ? $ab0941114a4b9cd6$var$DEFAULT_CONTENT_HEIGHT : t1;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    let t2;
    if ($[0] !== contentHeight) {
        t2 = /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
            alignItems: "center"
        }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
            testId: "skeleton-item-v2",
            width: "100%",
            height: contentHeight,
            isShimmering: true
        }));
        $[0] = contentHeight;
        $[1] = t2;
    } else t2 = $[1];
    let t3;
    if ($[2] !== formatMessage) {
        t3 = formatMessage((0, $427471ff219af96a$export$2e2bcd8739ae039).menuItemLoading);
        $[2] = formatMessage;
        $[3] = t3;
    } else t3 = $[3];
    let t4;
    if ($[4] !== t3) {
        t4 = /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, t3);
        $[4] = t3;
        $[5] = t4;
    } else t4 = $[5];
    let t5;
    if ($[6] !== t2 || $[7] !== t4 || $[8] !== testId) {
        t5 = /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
            xcss: $ab0941114a4b9cd6$var$menuSkeletonStyles.wrapper,
            alignBlock: "center",
            testId: testId
        }, t2, t4);
        $[6] = t2;
        $[7] = t4;
        $[8] = testId;
        $[9] = t5;
    } else t5 = $[9];
    return t5;
} : ({ testId: testId, contentHeight: contentHeight = $ab0941114a4b9cd6$var$DEFAULT_CONTENT_HEIGHT })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ $cozmU.createElement((0, $dinVW.Stack), {
        xcss: $ab0941114a4b9cd6$var$menuSkeletonStyles.wrapper,
        alignBlock: "center",
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, $4ez2K.Flex), {
        alignItems: "center"
    }, /*#__PURE__*/ $cozmU.createElement((0, $a9aSv.default), {
        testId: "skeleton-item-v2",
        width: "100%",
        height: contentHeight,
        isShimmering: true
    })), /*#__PURE__*/ $cozmU.createElement((0, $9GVkD.default), null, formatMessage((0, $427471ff219af96a$export$2e2bcd8739ae039).menuItemLoading)));
};


const $d458ae0939f347dd$export$fbc0ea7debdb77e = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ab0941114a4b9cd6$export$cde35cc9e1359709), props);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ab0941114a4b9cd6$export$cde35cc9e1359709), props);
};
module.exports["SkeletonItem"] = $d458ae0939f347dd$export$fbc0ea7debdb77e;

});

parcelRegister("6cTr1", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $64VTj = parcelRequire("64VTj");


var $9gH00 = parcelRequire("9gH00");

function $a0f98cf9aea3672c$export$bca6b946a784e234(locale) {
    if ([
        'en-GB',
        'en-ZZ',
        'pt-PT',
        'zh-TW'
    ].includes(locale)) return locale;
    else if (locale === 'zh-HK') return 'zh-TW';
    return locale.split('-')[0];
}

























function $a0f98cf9aea3672c$var$fetchLanguageFile(code) {
    switch(code){
        case 'cs':
            return (parcelRequire("gem2B"));
        case 'da':
            return (parcelRequire("75FbR"));
        case 'de':
            return (parcelRequire("b3wRc"));
        case 'en-GB':
            return (parcelRequire("99ic2"));
        case 'en-ZZ':
            return (parcelRequire("jCHpZ"));
        case 'en':
            return Promise.resolve((parcelRequire("9gH00")));
        case 'es':
            return (parcelRequire("1CVDY"));
        case 'fi':
            return (parcelRequire("5AQSt"));
        case 'fr':
            return (parcelRequire("60rKd"));
        case 'hu':
            return (parcelRequire("4qaun"));
        case 'it':
            return (parcelRequire("5QNxT"));
        case 'ja':
            return (parcelRequire("6BbXK"));
        case 'ko':
            return (parcelRequire("4CchL"));
        case 'nb':
            return (parcelRequire("geyH4"));
        case 'nl':
            return (parcelRequire("6aSQ5"));
        case 'pl':
            return (parcelRequire("goutA"));
        case 'pt':
            return (parcelRequire("akk7P"));
        case 'ru':
            return (parcelRequire("1rjns"));
        case 'sv':
            return (parcelRequire("7shzM"));
        case 'th':
            return (parcelRequire("eTJVW"));
        case 'tr':
            return (parcelRequire("4LsW3"));
        case 'uk':
            return (parcelRequire("iuquM"));
        case 'vi':
            return (parcelRequire("7g9Pq"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("fjTV9"));
        case 'zh':
            return (parcelRequire("epPv9"));
        default:
            throw new Error(`Unable to find translation for locale ${code}`);
    }
}
const $a0f98cf9aea3672c$export$12346a674644c156 = 'operational';
const $a0f98cf9aea3672c$export$515664faa1398f37 = 'navigation';
const $a0f98cf9aea3672c$var$Provider = (0, $gtMdU.isReactCompilerActivePlatform)() ? function Provider(t0) {
    const $ = (0, $bDgLe.c)(5);
    const { children: children } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = async (locale)=>{
            const intlLocale = new Intl.Locale(locale.replace("_", "-"));
            try {
                const module = await $a0f98cf9aea3672c$var$fetchLanguageFile($a0f98cf9aea3672c$export$bca6b946a784e234(intlLocale.toString()));
                return module.default;
            } catch (t2) {
                createAnalyticsEvent({
                    eventType: $a0f98cf9aea3672c$export$12346a674644c156,
                    action: "not_loaded",
                    actionSubject: "uc_i18n",
                    attributes: {
                        locale: locale
                    }
                }).fire($a0f98cf9aea3672c$export$515664faa1398f37);
            }
        };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const loaderFn = t1;
    let t2;
    if ($[2] !== children || $[3] !== loaderFn) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
            loaderFn: loaderFn,
            defaultMessages: (0, $9gH00.default)
        }, children);
        $[2] = children;
        $[3] = loaderFn;
        $[4] = t2;
    } else t2 = $[4];
    return t2;
} : function Provider({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const loaderFn = async (locale)=>{
        const intlLocale = new Intl.Locale(locale.replace('_', '-'));
        try {
            const module = await $a0f98cf9aea3672c$var$fetchLanguageFile($a0f98cf9aea3672c$export$bca6b946a784e234(intlLocale.toString()));
            return module.default;
        } catch (e) {
            createAnalyticsEvent({
                eventType: $a0f98cf9aea3672c$export$12346a674644c156,
                action: 'not_loaded',
                actionSubject: 'uc_i18n',
                attributes: {
                    locale: locale
                }
            }).fire($a0f98cf9aea3672c$export$515664faa1398f37);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $64VTj.default), {
        loaderFn: loaderFn,
        defaultMessages: (0, $9gH00.default)
    }, children);
};
const $a0f98cf9aea3672c$export$a5d940130f33be3f = (WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($a0f98cf9aea3672c$var$Provider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(WrappedComponent, props));
module.exports["withIntlProvider"] = $a0f98cf9aea3672c$export$a5d940130f33be3f;

});

parcelRegister("9gH00", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $45880b3f88e47285$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $45880b3f88e47285$export$2e2bcd8739ae039 = {
    VzzYJk: 'Create',
    'goal-create-success-flag-action': 'Go to goal',
    'goal-create-success-flag-title': 'Goal has been created',
    'navigation.universal-create.menuItemLoading': 'Menu item is loading',
    'platform.navigation-experiences.universal-create.area-label': 'Toggle for {text}{heading} options',
    'platform.navigation-experiences.universal-create.integrations.form-loading': 'Loading',
    'platform.navigation-experiences.universal-create.integrations.team.create-error-flag-title': 'Sorry, something went wrong',
    'platform.navigation-experiences.universal-create.integrations.team.create-success-flag-go-to-team': 'View team',
    'platform.navigation-experiences.universal-create.integrations.team.create-success-flag-title': 'Team has been created',
    'platform.navigation-experiences.universal-create.menu-group.aria-label': 'Create menu',
    'platform.navigation-experiences.universal-create.menu-section.aria-label': 'Create menu section',
    'platform.navigation-experiences.universal-create.project.create-error-flag-description': 'There was an error while creating your project. Please try again.',
    'platform.navigation-experiences.universal-create.project.create-error-flag-title': "We couldn't create your project",
    'platform.navigation-experiences.universal-create.project.create-success-flag-content': 'Go to project',
    'platform.navigation-experiences.universal-create.project.create-success-flag-title': 'Project has been created',
    'platform.navigation-experiences.universal-create.secondary-tooltip-text': 'More create options',
    'platform.navigation-experiences.universal-create.show-less': 'Less',
    'platform.navigation-experiences.universal-create.show-more': 'More',
    'platform.navigation-experiences.universal-create.show-more.area-label': 'Show {text} {heading} options'
};

});

parcelRegister("gem2B", function(module, exports) {

let $bd0f0d0a3ba81695$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd0f0d0a3ba81695$var$load("lm3cv").then(()=>parcelRequire('iGeIC'));

});

parcelRegister("75FbR", function(module, exports) {

let $5298f39430389087$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5298f39430389087$var$load("lvU5y").then(()=>parcelRequire('k4gg2'));

});

parcelRegister("b3wRc", function(module, exports) {

let $80c976410e9a0d01$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $80c976410e9a0d01$var$load("aENwg").then(()=>parcelRequire('aQuqs'));

});

parcelRegister("99ic2", function(module, exports) {

let $6a93111d0794ccfe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6a93111d0794ccfe$var$load("1vUU1").then(()=>parcelRequire('lIfBm'));

});

parcelRegister("jCHpZ", function(module, exports) {

let $e4933edd0feedb0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e4933edd0feedb0b$var$load("h9r0o").then(()=>parcelRequire('ir68X'));

});

parcelRegister("1CVDY", function(module, exports) {

let $12f60de44eb7d870$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $12f60de44eb7d870$var$load("b2MMn").then(()=>parcelRequire('lBvXA'));

});

parcelRegister("5AQSt", function(module, exports) {

let $412954eb4012c775$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $412954eb4012c775$var$load("2A9YS").then(()=>parcelRequire('c6uS9'));

});

parcelRegister("60rKd", function(module, exports) {

let $45f843a551f7daa3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $45f843a551f7daa3$var$load("5D6DG").then(()=>parcelRequire('10G4Y'));

});

parcelRegister("4qaun", function(module, exports) {

let $3381ba085074e719$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3381ba085074e719$var$load("l1s4W").then(()=>parcelRequire('lhijj'));

});

parcelRegister("5QNxT", function(module, exports) {

let $44283dd1c3999ec0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $44283dd1c3999ec0$var$load("b3g87").then(()=>parcelRequire('c5sE7'));

});

parcelRegister("6BbXK", function(module, exports) {

let $4cdf7a4d31ea0609$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4cdf7a4d31ea0609$var$load("wmcUG").then(()=>parcelRequire('8qzJg'));

});

parcelRegister("4CchL", function(module, exports) {

let $35c43dac50ff4523$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $35c43dac50ff4523$var$load("5suvf").then(()=>parcelRequire('iR3TD'));

});

parcelRegister("geyH4", function(module, exports) {

let $bd18dd9ab86cae32$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd18dd9ab86cae32$var$load("eTZYO").then(()=>parcelRequire('1xwdX'));

});

parcelRegister("6aSQ5", function(module, exports) {

let $47ee3727f878f33f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $47ee3727f878f33f$var$load("6dj8L").then(()=>parcelRequire('gQoJL'));

});

parcelRegister("goutA", function(module, exports) {

let $bef6872bb4201637$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bef6872bb4201637$var$load("gpsLd").then(()=>parcelRequire('9n9C9'));

});

parcelRegister("akk7P", function(module, exports) {

let $784b621cbcf93941$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $784b621cbcf93941$var$load("7AZ2S").then(()=>parcelRequire('7GoQq'));

});

parcelRegister("1rjns", function(module, exports) {

let $10c758024a638043$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $10c758024a638043$var$load("e6tsu").then(()=>parcelRequire('8CsAy'));

});

parcelRegister("7shzM", function(module, exports) {

let $56d8c82901703d93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56d8c82901703d93$var$load("3B2Y0").then(()=>parcelRequire('cHSP1'));

});

parcelRegister("eTJVW", function(module, exports) {

let $ad89d52bae7a601b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ad89d52bae7a601b$var$load("6oieg").then(()=>parcelRequire('3Y3el'));

});

parcelRegister("4LsW3", function(module, exports) {

let $3781ff2be3db56f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3781ff2be3db56f1$var$load("fGuf0").then(()=>parcelRequire('DVgYI'));

});

parcelRegister("iuquM", function(module, exports) {

let $d75f94c5fb883d95$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d75f94c5fb883d95$var$load("7yzZQ").then(()=>parcelRequire('eZxgV'));

});

parcelRegister("7g9Pq", function(module, exports) {

let $5491a6bb641e604f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5491a6bb641e604f$var$load("blfy1").then(()=>parcelRequire('1LQ4q'));

});

parcelRegister("fjTV9", function(module, exports) {

let $b274020e7153a11a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b274020e7153a11a$var$load("i3Y9Z").then(()=>parcelRequire('5AoTn'));

});

parcelRegister("epPv9", function(module, exports) {

let $a7eb59966d28bf67$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a7eb59966d28bf67$var$load("laEWp").then(()=>parcelRequire('cRJ5T'));

});

parcelRegister("7dznL", function(module, exports) {

let $54153176825eb178$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $54153176825eb178$var$load("jgdmG"),
    $54153176825eb178$var$load("gXe43"),
    $54153176825eb178$var$load("1uLVv"),
    $54153176825eb178$var$load("jK9II"),
    $54153176825eb178$var$load("8MhR0")
]).then(()=>parcelRequire('7SDpq'));

});

parcelRegister("a23yL", function(module, exports) {
module.exports = new URL("Racecar.f378b1ee.svg", import.meta.url).toString();

});

parcelRegister("cwptp", function(module, exports) {

let $91dc3bb15d48e3bf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91dc3bb15d48e3bf$var$load("b8oHe").then(()=>parcelRequire('1Q21q'));

});

parcelRegister("30o6e", function(module, exports) {

let $230410dad24dc8ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $230410dad24dc8ec$var$load("6Sqrl"),
    $230410dad24dc8ec$var$load("6wr18"),
    $230410dad24dc8ec$var$load("hohnS"),
    $230410dad24dc8ec$var$load("kUuw5"),
    $230410dad24dc8ec$var$load("dnVmf"),
    $230410dad24dc8ec$var$load("85Ack"),
    $230410dad24dc8ec$var$load("hhss7"),
    $230410dad24dc8ec$var$load("ffEVr"),
    $230410dad24dc8ec$var$load("7EorR"),
    $230410dad24dc8ec$var$load("o11D5")
]).then(()=>parcelRequire('3OJ5n'));

});

parcelRegister("cOW5t", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");

const $7a8538c5744b2f4d$export$c037b66df971b916 = /*#__PURE__*/ (0, $cozmU.createContext)({
    inFlightRequests: new Map(),
    setInFlightRequests: ()=>{}
});
const $7a8538c5744b2f4d$export$1bb2b4064846aef2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useUniversalCreateBFFContext() {
    return (0, $cozmU.useContext)($7a8538c5744b2f4d$export$c037b66df971b916);
} : function useUniversalCreateBFFContext() {
    return (0, $cozmU.useContext)($7a8538c5744b2f4d$export$c037b66df971b916);
};
function $7a8538c5744b2f4d$export$afffe3cb36bf5e6e({ children: children }) {
    const inFlightRequestsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(new Map());
    const setInFlightRequests = (0, $cozmU.useCallback)((requestKey, value)=>{
        inFlightRequestsRef.current.set(requestKey, value);
    }, []);
    const contextValue = (0, $cozmU.useMemo)(()=>({
            inFlightRequests: inFlightRequestsRef.current,
            setInFlightRequests: setInFlightRequests
        }), [
        setInFlightRequests
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7a8538c5744b2f4d$export$c037b66df971b916.Provider, {
        value: contextValue
    }, children);
}
module.exports["useUniversalCreateBFFContext"] = $7a8538c5744b2f4d$export$1bb2b4064846aef2;
module.exports["UniversalCreateBFFProvider"] = $7a8538c5744b2f4d$export$afffe3cb36bf5e6e;

});


//# sourceMappingURL=PageLayout.3da0dce8.js.map
